import RestClientSdk, { AbstractClient as AbstractClient$1, ClassMetadata, Attribute, Relation, Serializer, Mapping as Mapping$1 } from 'rest-client-sdk';
import URI from 'urijs';
import { List, Record, Map as Map$1, fromJS, is } from 'immutable';
import clone from 'clone';
import moment from 'moment';

var ERROR_CODE__EVENT_DATE__TOTAL_STOCK_LOWER_SOLD_TICKETS = 11001;
var ERROR_CODE__EVENT_DATE__UPDATE_SEATCONFIG_ALREADY_SOLD = 11002;
var ERROR_CODE__EVENT_DATE__UPDATE_SEATCONFIG_WITH_SEAT_RESERVED = 11003;

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _assertClassBrand(e, t, n) {
  if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _checkPrivateRedeclaration(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _classPrivateFieldGet2(s, a) {
  return s.get(_assertClassBrand(s, a));
}
function _classPrivateFieldInitSpec(e, t, a) {
  _checkPrivateRedeclaration(e, t), t.set(e, a);
}
function _classPrivateFieldSet2(s, a, r) {
  return s.set(_assertClassBrand(s, a), r), r;
}
function _classPrivateMethodInitSpec(e, a) {
  _checkPrivateRedeclaration(e, a), a.add(e);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = false,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function (t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = true, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), true), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function () {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function (e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(t.prototype ), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (String )(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function (t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

var MomentInstance = /*#__PURE__*/function () {
  function MomentInstance() {
    _classCallCheck(this, MomentInstance);
  }
  return _createClass(MomentInstance, null, [{
    key: "setMoment",
    value: function setMoment(momentInstance) {
      MomentInstance.momentInstance = momentInstance;
    }
  }, {
    key: "moment",
    get: function get() {
      return MomentInstance.momentInstance;
    }

    /** @deprecated */
  }, {
    key: "getMoment",
    value: function getMoment() {
      return MomentInstance.momentInstance;
    }
  }]);
}();

// type FieldsParameter = string | Fields | { fields: Fields };

/**
 * Parse an object or and array into a string
 * of comma separated fields, with {} to
 * represent nesting.
 *
 * format ex: [
 *  'firstname',
 *  'lastname',
 *  {
 *    address: [
 *      'streetNumber',
 *      'city',
 *    ],
 *  },
 * ]
 *
 * It will be parsed likewise: "firstname,lastname,address{streetNumber,city}"
 *
 * It is also possible to pass an object with a root field
 *
 * format ex: {
 *  fields: [
 *    'firstname',
 *    'lastname',
 *    ...
 *  ],
 * }
 */
function getFieldsString(fields) {
  if (typeof fields === 'undefined') {
    return '';
  }
  if (typeof fields === 'string') {
    return fields;
  }
  var newFields = fields;
  if (newFields instanceof Object && !(newFields instanceof Array)) {
    var keys = Object.keys(newFields);
    var fieldsArrayKey = keys[0];
    if (keys.length > 1) {
      // eslint-disable-next-line no-console
      console.warn('Using a Fields with more than one key return incertain results and may return unexpected results');
    }
    newFields = newFields[fieldsArrayKey];
  }

  // convert SubFields to string
  var fieldsStr = newFields.map(function (newField) {
    if (typeof newField === 'string') {
      return newField;
    }

    // eslint-disable-next-line no-use-before-define
    return getSubFieldString(newField);
  }).join(',');
  return fieldsStr;
}
function getSubFieldString(subfield) {
  var key = Object.keys(subfield)[0];
  return "".concat(key, "{").concat(getFieldsString(subfield[key]), "}");
}
function isEmptyArrayOrList(prop) {
  if (Array.isArray(prop)) {
    return prop.length === 0;
  }
  if (List.isList(prop)) {
    return prop.size === 0;
  }
  return false;
}
function extractPageNumber(url) {
  var urlSearchParams = new URLSearchParams(url);
  var page = urlSearchParams.get('page');
  return page ? parseInt(page, 10) : null;
}

var _excluded$1 = ["headers"];

/** @deprecated */

var USER_TYPE = /*#__PURE__*/function (USER_TYPE) {
  USER_TYPE["ME"] = "me";
  USER_TYPE["CUSTOMER"] = "customer";
  return USER_TYPE;
}({});

/**
 * When calling API with fields, we should know the value of the properties, according to the fields
 * and the non-null props of the entity.
 * WithValue is a helper for that:
 * ```
 * const t = await sdk.getRepository('ticketing').find(1, ['@id', 'title', 'description'] as const);
 * expectType<string>(t['@id']); // asked field and non-null prop
 * expectType<string>(t.title); // asked field and non-null prop
 * expectType<string | null>(t.description); // asked field and null prop
 * expectType<null>(t.slug); // not asked field
 * ```
 */

// finally, we are still on an entity, so all other properties are still available

/**
 * Allow a subset of `string` ('foo' | 'bar'), but not the global `string`
 * It is used to force "ExtractLevelFields" to be the smallest string possible, if we are not on a "const"
 */

/**
 * If T is never (unable to extract the fields from parameter), then consider that '@id' is still a knwon field
 * @see https://github.com/Microsoft/TypeScript/issues/23182#issuecomment-379091887 for the array trick
 */

/**
 * This helper will extract values from Fields:
 * ExtractValueFields<['@id', 'title', { eventDate: ['@id'] }]> = '@id' | 'title' | 'eventDate'
 */
var _AbstractClient_brand = /*#__PURE__*/new WeakSet();
var AbstractClient = /*#__PURE__*/function (_BaseClient) {
  function AbstractClient() {
    var _this;
    _classCallCheck(this, AbstractClient);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AbstractClient, [].concat(args));
    _classPrivateMethodInitSpec(_this, _AbstractClient_brand);
    return _this;
  }
  _inherits(AbstractClient, _BaseClient);
  return _createClass(AbstractClient, [{
    key: "withUnitOfWork",
    value: /** @ts-expect-error -- method signature is not identical to BaseClient */
    function withUnitOfWork(enabled) {
      /** @ts-expect-error -- method signature is not identical to BaseClient */
      return _superPropGet(AbstractClient, "withUnitOfWork", this, 3)([enabled]);
    }

    /** @ts-expect-error -- method signature is not identical to BaseClient */
  }, {
    key: "find",
    value: function find(id, fields) {
      var queryParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var pathParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var requestParams = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var params = this._mergeFieldsIntoParams(queryParam, fields);

      // @ts-expect-error Type 'Promise<D["entity"]>' is not assignable to type 'Promise<WithValue<D["entity"]>>', but it does work at runtime
      return _superPropGet(AbstractClient, "find", this, 3)([id, params, pathParameters, _assertClassBrand(_AbstractClient_brand, this, _addDefaultRequestParams).call(this, requestParams)]);
    }

    /** @ts-expect-error -- method signature is not identical to BaseClient */
  }, {
    key: "findBy",
    value: function findBy(criteria, fields) {
      var pathParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var requestParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var params = this._mergeFieldsIntoParams(criteria, fields);

      // @ts-expect-error ListWithValue is not assignable to D['list'], but it does work at runtime
      return _superPropGet(AbstractClient, "findBy", this, 3)([params, pathParameters, _assertClassBrand(_AbstractClient_brand, this, _addDefaultRequestParams).call(this, requestParams)]);
    }

    /** @ts-expect-error -- method signature is not identical to BaseClient */
  }, {
    key: "findAll",
    value: function findAll(fields) {
      var pathParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var queryParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var requestParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var params = this._mergeFieldsIntoParams(queryParam, fields);

      // @ts-expect-error ListWithValue is not assignable to D['list'], but it does work at runtime
      return _superPropGet(AbstractClient, "findBy", this, 3)([params, pathParameters, _assertClassBrand(_AbstractClient_brand, this, _addDefaultRequestParams).call(this, requestParams)]);
    }
  }, {
    key: "create",
    value: function create(entity, queryParam) {
      var pathParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var requestParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var innerQueryParams = queryParam;
      innerQueryParams.fields = getFieldsString(innerQueryParams.fields);

      // @ts-expect-error Type 'Promise<D["entity"]>' is not assignable to type 'Promise<WithValue<D["entity"]>>', but it does work at runtime
      return _superPropGet(AbstractClient, "create", this, 3)([entity, innerQueryParams, pathParameters, _assertClassBrand(_AbstractClient_brand, this, _addDefaultRequestParams).call(this, requestParams)]);
    }
  }, {
    key: "update",
    value: function update(entity, queryParam) {
      var requestParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var innerQueryParams = queryParam;
      innerQueryParams.fields = getFieldsString(innerQueryParams.fields);

      // @ts-expect-error Type 'Promise<D["entity"]>' is not assignable to type 'Promise<WithId<D["entity"]>>', but it does work at runtime
      return _superPropGet(AbstractClient, "update", this, 3)([entity, innerQueryParams, _assertClassBrand(_AbstractClient_brand, this, _addDefaultRequestParams).call(this, requestParams)]);
    }
  }, {
    key: "delete",
    value: function _delete(entity) {
      var requestParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _superPropGet(AbstractClient, "delete", this, 3)([entity, _assertClassBrand(_AbstractClient_brand, this, _addDefaultRequestParams).call(this, requestParams)]);
    }
  }, {
    key: "_mergeFieldsIntoParams",
    value: function _mergeFieldsIntoParams(queryParam, fields) {
      return _objectSpread2(_objectSpread2({}, queryParam), {}, {
        fields: getFieldsString(fields)
      });
    }
  }]);
}(AbstractClient$1);
function _addDefaultRequestParams(requestParams) {
  var _window$location;
  var headers = requestParams.headers,
    otherParams = _objectWithoutProperties(requestParams, _excluded$1);
  var requestHeaders = _typeof(headers) === 'object' && headers !== null ? headers : {};
  return _objectSpread2(_objectSpread2({}, otherParams), {}, {
    referrerPolicy: 'no-referrer-when-downgrade',
    headers: _objectSpread2(_objectSpread2({}, requestHeaders), {}, {
      'X-Referer': (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' ? (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.href : undefined // send a specific header to display real referer in sentry, as Firefox does protect referer on cross-origin requests, but we are on the same organization here !
    })
  });
}

var SHOW_HIDDEN_PARAM = /*#__PURE__*/function (SHOW_HIDDEN_PARAM) {
  SHOW_HIDDEN_PARAM["ONLY"] = "only";
  SHOW_HIDDEN_PARAM["INCLUDE"] = "include";
  SHOW_HIDDEN_PARAM["NONE"] = "none";
  return SHOW_HIDDEN_PARAM;
}({});
var _HidableClient_brand = /*#__PURE__*/new WeakSet();
var HidableClient = /*#__PURE__*/function (_AbstractClient) {
  function HidableClient() {
    var _this;
    _classCallCheck(this, HidableClient);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HidableClient, [].concat(args));
    _classPrivateMethodInitSpec(_this, _HidableClient_brand);
    return _this;
  }
  _inherits(HidableClient, _AbstractClient);
  return _createClass(HidableClient, [{
    key: "hide",
    value: function hide(entity) {
      return _assertClassBrand(_HidableClient_brand, this, _toggleVisibility).call(this, entity, 'hide');
    }
  }, {
    key: "show",
    value: function show(entity) {
      return _assertClassBrand(_HidableClient_brand, this, _toggleVisibility).call(this, entity, 'show');
    }
  }]);
}(AbstractClient);
function _toggleVisibility(entity, action) {
  var url = "".concat(this.getEntityURI(entity), "/").concat(action);
  return this.authorizedFetch(url, {
    method: 'PUT'
  });
}

var AccountingClientClient = /*#__PURE__*/function (_HidableClient) {
  function AccountingClientClient() {
    _classCallCheck(this, AccountingClientClient);
    return _callSuper(this, AccountingClientClient, arguments);
  }
  _inherits(AccountingClientClient, _HidableClient);
  return _createClass(AccountingClientClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/accounting_clients';
    }
  }]);
}(HidableClient);

function mapListToEntityList(list, registry) {
  return List(list.map(function (value) {
    return createEntity(value, registry);
  }));
}
function mapEntityRelationShips(entity, baseJson, registry) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  /** @ts-expect-error -- really hard for now */
  return entity.withMutations(function (mutableEntity) {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (var prop in baseJson) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error */
      var val = baseJson[prop];

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- prop does exist, no need to have a default value */
      if (!val || !entity.get(prop)) {
        // eslint-disable-next-line no-continue
        continue;
      }
      if (Array.isArray(val)) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        /** @ts-expect-error */
        mutableEntity.set(prop, mapListToEntityList(val, registry));
      } else if (List.isList(val)) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        /** @ts-expect-error */
        mutableEntity.set(prop, val);
      } else if (val instanceof Record) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        /** @ts-expect-error */
        mutableEntity.set(prop, val);
      } else if (_typeof(val) === 'object' && val !== null) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        /** @ts-expect-error */
        mutableEntity.set(prop, createEntity(val, registry));
      }
    }
  });
}

function parseDate(str, timezone) {
  if (str === null || typeof str === 'undefined') {
    return str;
  }
  if (!str) {
    return null;
  }
  var d = MomentInstance.moment.parseZone(str);
  if (timezone) {
    d = d.tz(timezone);
  }
  return d;
}

// old function without TypeScript, not working
// const NetworkEntity = (defaultValues) =>
//   class extends Record({ responseDate: null, ...defaultValues }) {};

function NetworkEntity(defaultValues) {
  // @ts-expect-error does work at runtime
  return Record(_objectSpread2({
    responseDate: null
  }, defaultValues));
}

// eslint-disable-next-line import/prefer-default-export
function getEntityId$1(entity) {
  if (!entity) {
    return '';
  }
  if (typeof entity === 'string') {
    return entity;
  }

  // @ts-expect-error entity should has a "get" method
  return entity.get('@id') || '';
}
function isNonNullObject(obj) {
  return _typeof(obj) === 'object' && obj !== null;
}
function extractTimezone(data, path) {
  var tz = null;
  var nextObject = data;
  path.forEach(function (key, index) {
    if (isNonNullObject(nextObject) && typeof key === 'string') {
      nextObject = nextObject[key];
    } else if (Array.isArray(nextObject) && typeof key === 'number') {
      nextObject = nextObject[key];
    } else {
      nextObject = null;
    }
    if (index === path.length - 1 && typeof nextObject === 'string') {
      tz = nextObject;
    }
  });
  return tz;
}

var ACCOUNTING_CLIENT_TYPE = /*#__PURE__*/function (ACCOUNTING_CLIENT_TYPE) {
  ACCOUNTING_CLIENT_TYPE["CONTACT"] = "contact";
  ACCOUNTING_CLIENT_TYPE["ORGANIZATION"] = "organization";
  ACCOUNTING_CLIENT_TYPE["NON_NOMINATIVE"] = "non_nominative";
  return ACCOUNTING_CLIENT_TYPE;
}({});
var AccountingClient = /*#__PURE__*/function (_NetworkEntity) {
  function AccountingClient() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'AccountingClient'
    };
    _classCallCheck(this, AccountingClient);
    var data = clone(val);
    var tz = extractTimezone(data, ['contract', 'timezone']);
    data.createdAt = parseDate(data.createdAt, tz);
    data.updatedAt = parseDate(data.updatedAt, tz);
    data.mostRecentAccountingEntryDate = parseDate(data.mostRecentAccountingEntryDate, tz);
    data.hiddenAt = parseDate(data.hiddenAt, tz);
    _this = _callSuper(this, AccountingClient, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(AccountingClient, _NetworkEntity);
  return _createClass(AccountingClient, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/accounting_clients/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'AccountingClient',
  type: undefined,
  firstname: undefined,
  lastname: undefined,
  displayName: undefined,
  zipcode: undefined,
  city: undefined,
  country: undefined,
  contract: undefined,
  siretNumber: undefined,
  vatNumber: undefined,
  reportingAccount: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  crmId: undefined,
  email: undefined,
  phone: undefined,
  address: undefined,
  accountingCode: undefined,
  mostRecentAccountingEntryDate: undefined,
  credit: undefined,
  debit: undefined,
  balance: undefined,
  hiddenAt: undefined,
  isHidden: null,
  overdueAmount: undefined,
  schoolMode: undefined
}));
AccountingClient.classMetadata = new ClassMetadata('accountingClient', 'accounting_clients', /** @ts-expect-error -- method signature are incompatible */
AccountingClientClient);
AccountingClient.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('updatedAt', 'updatedAt', 'datetime'), new Attribute('crmId'), new Attribute('email'), new Attribute('phone'), new Attribute('address'), new Attribute('accountingCode'), new Attribute('type', 'type', 'string'), new Attribute('firstname'), new Attribute('lastname'), new Attribute('displayName'), new Attribute('zipcode'), new Attribute('city'), new Attribute('country'), new Attribute('siretNumber'), new Attribute('vatNumber'), new Attribute('mostRecentAccountingEntryDate', 'mostRecentAccountingEntryDate', 'datetime'), new Attribute('credit', 'credit', 'number'), new Attribute('debit', 'debit', 'number'), new Attribute('balance', 'balance', 'number'), new Attribute('hiddenAt', 'hiddenAt', 'datetime'), new Attribute('isHidden', 'isHidden', 'boolean'), new Attribute('overdueAmount', 'overdueAmount', 'number'), new Attribute('schoolMode', 'schoolMode', 'boolean')]);
AccountingClient.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'reportingAccount', 'reportingAccount')]);

var AuditDocumentClient = /*#__PURE__*/function (_AbstractClient) {
  function AuditDocumentClient() {
    _classCallCheck(this, AuditDocumentClient);
    return _callSuper(this, AuditDocumentClient, arguments);
  }
  _inherits(AuditDocumentClient, _AbstractClient);
  return _createClass(AuditDocumentClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/audit_documents';
    }
  }, {
    key: "getFile",
    value: function getFile(id) {
      var uri = "".concat(this.getPathBase(), "/").concat(id, "/file.pdf");
      return this.authorizedFetch(uri);
    }
  }]);
}(AbstractClient);

var AuditDocument = /*#__PURE__*/function (_NetworkEntity) {
  function AuditDocument() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'AuditDocument'
    };
    _classCallCheck(this, AuditDocument);
    var data = clone(val);
    var tz = extractTimezone(data, ['contract', 'timezone']);

    // TODO Audit document dates are in UTC we may not want to parse them
    data.startDate = parseDate(data.startDate, tz);
    data.endDate = parseDate(data.endDate, tz);
    _this = _callSuper(this, AuditDocument, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(AuditDocument, _NetworkEntity);
  return _createClass(AuditDocument, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/audit_documents/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'AuditDocument',
  startDate: null,
  endDate: null,
  contract: null
}));
AuditDocument.classMetadata = new ClassMetadata('auditDocument', 'audit_documents', /** @ts-expect-error -- method signature are incompatible */
AuditDocumentClient);
AuditDocument.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('startDate'), new Attribute('endDate')]);
AuditDocument.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

function filterBulkRequestBody$1(body) {
  if (!body['hydra:member']) {
    return {};
  }
  return {
    'hydra:member': body['hydra:member'].map(function (member) {
      var _member$Type;
      var out = {
        '@id': member['@id'],
        '@type': (_member$Type = member['@type']) !== null && _member$Type !== void 0 ? _member$Type : 'AvailableSeat',
        seat: member.seat,
        status: member.status,
        ticket: member.ticket,
        cartItem: member.cartItem,
        seatGroup: member.seatGroup
      };
      if (member.manuallyAssigned === true || member.manuallyAssigned === false) {
        out.manuallyAssigned = member.manuallyAssigned;
      }
      return out;
    })
  };
}
var AvailableSeatClient = /*#__PURE__*/function (_AbstractClient) {
  function AvailableSeatClient() {
    _classCallCheck(this, AvailableSeatClient);
    return _callSuper(this, AvailableSeatClient, arguments);
  }
  _inherits(AvailableSeatClient, _AbstractClient);
  return _createClass(AvailableSeatClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/available_seats';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['available_seat_read', 'available_seat_write'];
    }
  }, {
    key: "bulkRequest",
    value: function bulkRequest(method, body, fields) {
      var uri = new URI("".concat(this.getPathBase(), "/bulk"));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.authorizedFetch(uri, {
        method: method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(filterBulkRequestBody$1(body))
      });
    }
  }, {
    key: "putBulk",
    value: function putBulk(body) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return this.bulkRequest('PUT', body, fields);
    }
  }]);
}(AbstractClient);

var STATUS_DISMISSED = 'dismissed';
var STATUS_AVAILABLE = 'available';
var STATUS_BOOKED$1 = 'booked';
var STATUS_PAID = 'payed';
var AVAILABLE_SEAT_BOOKING_STATUS = /*#__PURE__*/function (AVAILABLE_SEAT_BOOKING_STATUS) {
  AVAILABLE_SEAT_BOOKING_STATUS["AVAILABLE"] = "available";
  AVAILABLE_SEAT_BOOKING_STATUS["DISMISSED"] = "dismissed";
  AVAILABLE_SEAT_BOOKING_STATUS["IN_ORDER"] = "in_order";
  AVAILABLE_SEAT_BOOKING_STATUS["IN_CART"] = "in_cart";
  AVAILABLE_SEAT_BOOKING_STATUS["IN_RESERVATION"] = "in_reservation";
  AVAILABLE_SEAT_BOOKING_STATUS["SCANNED"] = "scanned";
  AVAILABLE_SEAT_BOOKING_STATUS["IN_EXTERNAL_PROVIDER_ORDER"] = "in_external_provider_order";
  AVAILABLE_SEAT_BOOKING_STATUS["IN_EXTERNAL_PROVIDER_RESERVATION"] = "in_external_provider_reservation";
  return AVAILABLE_SEAT_BOOKING_STATUS;
}({});

// those fields are mandatory, if "fields" is given, then their values will be a non-nullable string
var AvailableSeat = /*#__PURE__*/function (_NetworkEntity) {
  function AvailableSeat() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'AvailableSeat'
    };
    _classCallCheck(this, AvailableSeat);
    _this = _callSuper(this, AvailableSeat, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(AvailableSeat, _NetworkEntity);
  return _createClass(AvailableSeat, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/available_seats/', '')) || '';
    }
  }, {
    key: "isAvailable",
    value: function isAvailable() {
      return this.status === STATUS_AVAILABLE;
    }
  }, {
    key: "isDismissed",
    value: function isDismissed() {
      return this.status === STATUS_DISMISSED;
    }
  }, {
    key: "isBooked",
    value: function isBooked() {
      return this.status === STATUS_BOOKED$1;
    }
  }, {
    key: "isPaid",
    value: function isPaid() {
      return this.status === STATUS_PAID;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'AvailableSeat',
  seat: null,
  seatConfig: null,
  eventDate: null,
  stockContingent: null,
  ticket: null,
  cartItem: null,
  seatGroup: null,
  status: '',
  bookingStatus: null,
  visible: null,
  manuallyAssigned: null,
  order: null,
  cart: null,
  isLocked: undefined
}));
AvailableSeat.classMetadata = new ClassMetadata('availableSeat', 'available_seats', /** @ts-expect-error -- method signature are incompatible */
AvailableSeatClient);
AvailableSeat.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('status'), new Attribute('bookingStatus'), new Attribute('visible', 'visible', 'bool'), new Attribute('manuallyAssigned', 'manuallyAssigned', 'bool'), new Attribute('isLocked', 'isLocked', 'bool')]);
AvailableSeat.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'seat', 'seat'), new Relation(Relation.MANY_TO_ONE, 'seatConfig', 'seatConfig'), new Relation(Relation.MANY_TO_ONE, 'seatGroup', 'seatGroup'), new Relation(Relation.MANY_TO_ONE, 'eventDate', 'eventDate'), new Relation(Relation.MANY_TO_ONE, 'stockContingent', 'stockContingent'), new Relation(Relation.MANY_TO_ONE, 'ticket', 'ticket'), new Relation(Relation.MANY_TO_ONE, 'cartItem', 'cartItem'), new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.MANY_TO_ONE, 'cart', 'cart')]);

function filterBulkRequestBody(body) {
  if (!body['hydra:member']) {
    return {};
  }
  return {
    'hydra:member': body['hydra:member'].map(function (member) {
      var out = {
        '@id': member['@id'],
        '@type': member['@type'],
        contingent: member.contingent,
        seatGroup: member.seatGroup,
        status: member.status
      };
      return out;
    })
  };
}
var AvailableSeatModelClient = /*#__PURE__*/function (_AbstractClient) {
  function AvailableSeatModelClient() {
    _classCallCheck(this, AvailableSeatModelClient);
    return _callSuper(this, AvailableSeatModelClient, arguments);
  }
  _inherits(AvailableSeatModelClient, _AbstractClient);
  return _createClass(AvailableSeatModelClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/available_seat_models';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['available_seat_model_read', 'available_seat_model_write'];
    }
  }, {
    key: "bulkRequest",
    value: function bulkRequest(method, body, fields) {
      var uri = new URI("".concat(this.getPathBase(), "/bulk"));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.authorizedFetch(uri, {
        method: method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(filterBulkRequestBody(body))
      });
    }
  }, {
    key: "putBulk",
    value: function putBulk(body) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return this.bulkRequest('PUT', body, fields);
    }
  }]);
}(AbstractClient);

var AvailableSeatModel = /*#__PURE__*/function (_NetworkEntity) {
  function AvailableSeatModel() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'AvailableSeatModel'
    };
    _classCallCheck(this, AvailableSeatModel);
    _this = _callSuper(this, AvailableSeatModel, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(AvailableSeatModel, _NetworkEntity);
  return _createClass(AvailableSeatModel, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/available_seat_models/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'AvailableSeatModel',
  seat: null,
  seatGroup: null,
  logicalSeatConfig: null,
  contingent: null,
  position: null,
  status: null
}));
AvailableSeatModel.classMetadata = new ClassMetadata('availableSeatModel', 'available_seat_models', /** @ts-expect-error -- method signature are incompatible */
AvailableSeatModelClient);
AvailableSeatModel.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('position', 'position', 'number'), new Attribute('status')]);
AvailableSeatModel.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'seat', 'seat'), new Relation(Relation.MANY_TO_ONE, 'logicalSeatConfig', 'logicalSeatConfig'), new Relation(Relation.MANY_TO_ONE, 'seatGroup', 'seatGroup'), new Relation(Relation.MANY_TO_ONE, 'contingent', 'contingent')]);

var BankAccountClient = /*#__PURE__*/function (_AbstractClient) {
  function BankAccountClient() {
    _classCallCheck(this, BankAccountClient);
    return _callSuper(this, BankAccountClient, arguments);
  }
  _inherits(BankAccountClient, _AbstractClient);
  return _createClass(BankAccountClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/bank_accounts';
    }
  }, {
    key: "findOneByDefaultAccountAndWallet",
    value: function findOneByDefaultAccountAndWallet(wallet, fields) {
      return this.findBy({
        wallet: wallet.getShortId(),
        defaultAccount: 1
      }, fields);
    }
  }]);
}(AbstractClient);

var BankAccount = /*#__PURE__*/function (_NetworkEntity) {
  function BankAccount() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'BankAccount'
    };
    _classCallCheck(this, BankAccount);
    _this = _callSuper(this, BankAccount, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(BankAccount, _NetworkEntity);
  return _createClass(BankAccount, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/bank_accounts/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'BankAccount',
  tag: null,
  type: null,
  ownerName: null,
  addressLine1: null,
  addressLine2: null,
  city: null,
  region: null,
  postalCode: null,
  addressCountry: null,
  iban: null,
  wallet: null,
  defaultAccount: null
}));
BankAccount.classMetadata = new ClassMetadata('bankAccount', 'bank_accounts', /** @ts-expect-error -- method signature are incompatible */
BankAccountClient);
BankAccount.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('tag'), new Attribute('type'), new Attribute('ownerName'), new Attribute('addressLine1'), new Attribute('addressLine2'), new Attribute('city'), new Attribute('region'), new Attribute('postalCode'), new Attribute('addressCountry'), new Attribute('iban'), new Attribute('wallet'), new Attribute('defaultAccount')]);

/** @deprecated use `BOOKING_ENTITY_STATUS.AWAITING_PAYMENT` instead */
var STATUS_AWAITING_PAYMENT = 'awaiting_payment';
/** @deprecated use `BOOKING_ENTITY_STATUS.INCOMPLETE_PAYMENT` instead */
var STATUS_INCOMPLETE_PAYMENT = 'incomplete_payment';
/** @deprecated use `BOOKING_ENTITY_STATUS.OVERPAID` instead */
var STATUS_OVERPAID = 'overpaid';
/** @deprecated use `BOOKING_ENTITY_STATUS.BOOKED` instead */
var STATUS_BOOKED = 'booked';
var TRANSACTION_NAME_MULTIPLE = 'multiple';
var BOOKING_ENTITY_STATUS = /*#__PURE__*/function (BOOKING_ENTITY_STATUS) {
  BOOKING_ENTITY_STATUS["AWAITING_PAYMENT"] = "awaiting_payment";
  BOOKING_ENTITY_STATUS["INCOMPLETE_PAYMENT"] = "incomplete_payment";
  BOOKING_ENTITY_STATUS["OVERPAID"] = "overpaid";
  BOOKING_ENTITY_STATUS["BOOKED"] = "booked";
  BOOKING_ENTITY_STATUS["OPTION"] = "option";
  return BOOKING_ENTITY_STATUS;
}({});
var BOOKING_ENTITY_TYPE = /*#__PURE__*/function (BOOKING_ENTITY_TYPE) {
  BOOKING_ENTITY_TYPE["OPTION"] = "option";
  BOOKING_ENTITY_TYPE["RESERVATION"] = "reservation";
  BOOKING_ENTITY_TYPE["ORDER"] = "order";
  BOOKING_ENTITY_TYPE["TICKET_IMPORT"] = "ticket_import";
  return BOOKING_ENTITY_TYPE;
}({});
// eslint-disable-next-line no-shadow
var BOOKING_ENTITY_NAME = /*#__PURE__*/function (BOOKING_ENTITY_NAME) {
  BOOKING_ENTITY_NAME["CART"] = "cart";
  BOOKING_ENTITY_NAME["ORDER"] = "order";
  return BOOKING_ENTITY_NAME;
}({});
var Booking = /*#__PURE__*/function (_NetworkEntity) {
  function Booking() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Booking'
    };
    _classCallCheck(this, Booking);
    var data = clone(val);
    data.createdAt = parseDate(data.createdAt, data.createdAtTimezone);
    data.lastScannedDate = parseDate(data.lastScannedDate, data.createdAtTimezone);
    _this = _callSuper(this, Booking, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Booking, _NetworkEntity);
  return _createClass(Booking, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/bookings/', '')) || '';
    }

    /** @deprecated createdAt should already handle timezone */
  }, {
    key: "getLocalCreatedAt",
    value: function getLocalCreatedAt() {
      var tz = this.createdAtTimezone;
      if (tz) {
        var _this$createdAt;
        /** @ts-expect-error -- issue with moment & moment-timezone */
        return (_this$createdAt = this.createdAt) === null || _this$createdAt === void 0 ? void 0 : _this$createdAt.clone().tz(tz);
      }
      return this.createdAt;
    }

    /** @deprecated lastScannedDate should already handle timezone */
  }, {
    key: "getLocalLastScannedDate",
    value: function getLocalLastScannedDate() {
      var tz = this.createdAtTimezone;
      if (tz) {
        var _this$lastScannedDate;
        /** @ts-expect-error -- issue with moment & moment-timezone */
        return (_this$lastScannedDate = this.lastScannedDate) === null || _this$lastScannedDate === void 0 ? void 0 : _this$lastScannedDate.clone().tz(tz);
      }
      return this.lastScannedDate;
    }
  }, {
    key: "getTagList",
    value: function getTagList() {
      var _this$searchContent;
      var tags = (_this$searchContent = this.searchContent) === null || _this$searchContent === void 0 ? void 0 : _this$searchContent.get('tags');
      if (!tags) {
        return List();
      }
      if (typeof tags === 'string') {
        return List(tags);
      }
      if (typeof tags === 'number') {
        throw new Error('searchContent.tags should not be a number');
      }
      if (Map$1.isMap(tags)) {
        throw new Error('searchContent.tags should not be an object');
      }
      return tags.map(function (possibleTag) {
        var _tag$get;
        var tag = possibleTag;
        if (typeof tag === 'string') {
          // @deprecated
          return tag;
        }
        return (_tag$get = tag.get('name')) !== null && _tag$get !== void 0 ? _tag$get : '';
      });
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Booking',
  cart: null,
  order: null,
  customer: null,
  scanned: null,
  lastScannedDate: null,
  nbTickets: 0,
  nbCoupons: 0,
  nbScannedTickets: 0,
  nbValidItems: 0,
  createdAt: null,
  createdAtTimezone: null,
  paymentStatus: null,
  status: null,
  paymentTransactionBalance: 0,
  refundTransactionName: null,
  paymentTransactionName: null,
  facialValue: null,
  retailValue: null,
  currency: null,
  searchContent: null,
  entityId: null,
  entityName: null,
  bookingItemList: List(),
  paymentLink: null,
  isReservation: null,
  ticketingList: null,
  type: null
}));
Booking.classMetadata = new ClassMetadata('booking', 'bookings', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
Booking.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('status'), new Attribute('paymentStatus'), new Attribute('paymentTransactionBalance', 'paymentTransactionBalance', 'integer'), new Attribute('refundTransactionName', 'refundTransactionName', 'integer'), new Attribute('paymentTransactionName', 'paymentTransactionName', 'integer'), new Attribute('facialValue', 'facialValue', 'integer'), new Attribute('retailValue', 'retailValue', 'integer'), new Attribute('currency'), new Attribute('searchContent'), new Attribute('scanned', 'scanned', 'boolean'), new Attribute('nbTickets', 'nbTickets', 'integer'), new Attribute('nbValidItems', 'nbValidItems', 'integer'), new Attribute('nbScannedTickets', 'nbScannedTickets', 'integer'), new Attribute('nbCoupons', 'nbCoupons', 'integer'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('createdAtTimezone', 'createdAtTimezone', 'string'), new Attribute('entityId'), new Attribute('entityName'), new Attribute('paymentLink'), new Attribute('isReservation', 'isReservation', 'boolean'), new Attribute('type')]);
Booking.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'cart', 'cart'), new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.MANY_TO_ONE, 'customer', 'customer'), new Relation(Relation.ONE_TO_MANY, 'ticketing', 'ticketingList')]);

var BookingItem = /*#__PURE__*/function (_NetworkEntity) {
  function BookingItem() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'BookingItem'
    };
    _classCallCheck(this, BookingItem);
    var data = clone(val);
    _this = _callSuper(this, BookingItem, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(BookingItem, _NetworkEntity);
  return _createClass(BookingItem);
}(NetworkEntity({
  '@id': null,
  '@type': 'BookingItem',
  ticketIri: null,
  ticketPriceName: null,
  currency: null,
  ticketPriceFacialValue: null,
  seatId: null,
  seatLabel: null,
  participant: null,
  ticketBarcode: null,
  ticketCurrentValidScanNb: null
}));
BookingItem.classMetadata = new ClassMetadata('BookingItem', 'booking_items', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
BookingItem.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('ticketIri'), new Attribute('ticketPriceName'), new Attribute('currency'), new Attribute('ticketPriceFacialValue', 'ticketPriceFacialValue', 'integer'), new Attribute('seatId', 'seatId', 'integer'), new Attribute('seatLabel'), new Attribute('ticketBarcode'), new Attribute('ticketCurrentValidScanNb')]);
BookingItem.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'customer', 'participant')]);

var CartItemClient = /*#__PURE__*/function (_AbstractClient) {
  function CartItemClient() {
    _classCallCheck(this, CartItemClient);
    return _callSuper(this, CartItemClient, arguments);
  }
  _inherits(CartItemClient, _AbstractClient);
  return _createClass(CartItemClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/cart_items';
    }
  }, {
    key: "bulkUpdate",
    value: function bulkUpdate(cartItemList, fields) {
      var uri = new URI("".concat(this.getPathBase(), "/bulk"));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(uri, {
        method: 'POST',
        body: JSON.stringify({
          'hydra:member': cartItemList
        })
      }), 'list');
    }
  }]);
}(AbstractClient);

/* eslint-disable max-classes-per-file */
var RelationError = /*#__PURE__*/function (_Error) {
  function RelationError(message) {
    var _this;
    _classCallCheck(this, RelationError);
    _this = _callSuper(this, RelationError, [message || 'This should not happen.']);

    // Set the prototype explicitly.
    Object.setPrototypeOf(_this, RelationError.prototype);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, RelationError);
    }
    _this.name = 'RelationError';
    return _this;
  }
  _inherits(RelationError, _Error);
  return _createClass(RelationError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var RelationShouldBeDefinedError = /*#__PURE__*/function (_RelationError) {
  function RelationShouldBeDefinedError(objectName) {
    var _this2;
    _classCallCheck(this, RelationShouldBeDefinedError);
    _this2 = _callSuper(this, RelationShouldBeDefinedError, ["Object ".concat(objectName !== null && objectName !== void 0 ? objectName : '<unnamed>', " should not be null. This should not happen.")]);

    // Set the prototype explicitly.
    Object.setPrototypeOf(_this2, RelationShouldBeDefinedError.prototype);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this2, RelationShouldBeDefinedError);
    }
    _this2.name = 'RelationShouldBeDefinedError';
    return _this2;
  }
  _inherits(RelationShouldBeDefinedError, _RelationError);
  return _createClass(RelationShouldBeDefinedError);
}(RelationError);
var RelationShouldBeStringError = /*#__PURE__*/function (_RelationError2) {
  function RelationShouldBeStringError(relationName) {
    var _this3;
    _classCallCheck(this, RelationShouldBeStringError);
    _this3 = _callSuper(this, RelationShouldBeStringError, ["Relation ".concat(relationName !== null && relationName !== void 0 ? relationName : '<unnamed>', " should be a string. Please check the `fields` that you set for your request.")]);

    // Set the prototype explicitly.
    Object.setPrototypeOf(_this3, RelationShouldBeStringError.prototype);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this3, RelationShouldBeStringError);
    }
    _this3.name = 'RelationShouldBeStringError';
    return _this3;
  }
  _inherits(RelationShouldBeStringError, _RelationError2);
  return _createClass(RelationShouldBeStringError);
}(RelationError);
var RelationShouldBeNullOrStringError = /*#__PURE__*/function (_RelationError3) {
  function RelationShouldBeNullOrStringError(relationName) {
    var _this4;
    _classCallCheck(this, RelationShouldBeNullOrStringError);
    _this4 = _callSuper(this, RelationShouldBeNullOrStringError, ["Relation ".concat(relationName !== null && relationName !== void 0 ? relationName : '<unnamed>', " should be null or a string. Please check the `fields` that you set for your request.")]);

    // Set the prototype explicitly.
    Object.setPrototypeOf(_this4, RelationShouldBeNullOrStringError.prototype);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this4, RelationShouldBeNullOrStringError);
    }
    _this4.name = 'RelationShouldBeNullOrStringError';
    return _this4;
  }
  _inherits(RelationShouldBeNullOrStringError, _RelationError3);
  return _createClass(RelationShouldBeNullOrStringError);
}(RelationError);
var RelationShouldBeObjectError = /*#__PURE__*/function (_RelationError4) {
  function RelationShouldBeObjectError(relationName) {
    var _this5;
    _classCallCheck(this, RelationShouldBeObjectError);
    _this5 = _callSuper(this, RelationShouldBeObjectError, ["Relation ".concat(relationName !== null && relationName !== void 0 ? relationName : '<unnamed>', " should be an object. Please check the `fields` that you set for your request.")]);

    // Set the prototype explicitly.
    Object.setPrototypeOf(_this5, RelationShouldBeObjectError.prototype);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this5, RelationShouldBeObjectError);
    }
    _this5.name = 'RelationShouldBeObjectError';
    return _this5;
  }
  _inherits(RelationShouldBeObjectError, _RelationError4);
  return _createClass(RelationShouldBeObjectError);
}(RelationError);
var RelationShouldBeNullOrObjectError = /*#__PURE__*/function (_RelationError5) {
  function RelationShouldBeNullOrObjectError(relationName) {
    var _this6;
    _classCallCheck(this, RelationShouldBeNullOrObjectError);
    _this6 = _callSuper(this, RelationShouldBeNullOrObjectError, ["Relation ".concat(relationName !== null && relationName !== void 0 ? relationName : '<unnamed>', " should be null or an object. Please check the `fields` that you set for your request.")]);

    // Set the prototype explicitly.
    Object.setPrototypeOf(_this6, RelationShouldBeNullOrObjectError.prototype);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this6, RelationShouldBeNullOrObjectError);
    }
    _this6.name = 'RelationShouldBeNullOrObjectError';
    return _this6;
  }
  _inherits(RelationShouldBeNullOrObjectError, _RelationError5);
  return _createClass(RelationShouldBeNullOrObjectError);
}(RelationError);

function assertRelationIsDefined(object, name) {
  if (object === null) {
    throw new RelationShouldBeDefinedError(name);
  }
  if (typeof object === 'undefined') {
    throw new RelationShouldBeDefinedError(name);
  }
}
function assertRelationIsString(possibleString, name) {
  if (typeof possibleString !== 'string') {
    throw new RelationShouldBeStringError(name);
  }
}
function assertRelationIsNullOrString(possibleNullOrString, name) {
  if (possibleNullOrString !== null && typeof possibleNullOrString !== 'string') {
    throw new RelationShouldBeNullOrStringError(name);
  }
}
function assertRelationIsListOfString(possibleListOfString, name) {
  if (possibleListOfString === null || typeof possibleListOfString === 'undefined') {
    throw new RelationShouldBeDefinedError(name);
  }
  possibleListOfString.forEach(function (possibleString) {
    assertRelationIsString(possibleString, name);
  });
}
function assertRelationIsNullOrListOfString(possibleListOfString, name) /* | null -- activate null when https://github.com/microsoft/TypeScript/issues/49588 is fixed */{
  if (possibleListOfString === null) {
    return;
  }
  possibleListOfString.forEach(function (possibleString) {
    assertRelationIsString(possibleString, name);
  });
}
function assertRelationIsObject(possibleObject, name) {
  if (_typeof(possibleObject) !== 'object' || possibleObject === null) {
    throw new RelationShouldBeObjectError(name);
  }
}
function assertRelationIsNullOrObject(possibleObject, name) {
  if (_typeof(possibleObject) !== 'object' && possibleObject !== null) {
    throw new RelationShouldBeNullOrObjectError(name);
  }
}
function assertRelationIsListOfObject(possibleListOfObject, name) {
  if (possibleListOfObject === null || typeof possibleListOfObject === 'undefined') {
    throw new RelationShouldBeDefinedError(name);
  }
  possibleListOfObject.forEach(function (possibleString) {
    assertRelationIsObject(possibleString, name);
  });
}
function assertRelationIsNullOrListOfObject(possibleListOfObject, name) /* | null -- activate null when https://github.com/microsoft/TypeScript/issues/49588 is fixed */{
  if (possibleListOfObject === null) {
    return;
  }
  possibleListOfObject.forEach(function (possibleString) {
    assertRelationIsObject(possibleString, name);
  });
}

var FIELD_TYPE = /*#__PURE__*/function (FIELD_TYPE) {
  FIELD_TYPE["CRM"] = "crm";
  FIELD_TYPE["FORM"] = "form";
  return FIELD_TYPE;
}({});
var RELATED_TO_TYPE = /*#__PURE__*/function (RELATED_TO_TYPE) {
  RELATED_TO_TYPE["ORGANIZATION"] = "organization";
  RELATED_TO_TYPE["CONTACT"] = "contact";
  RELATED_TO_TYPE["SHOPPING"] = "shopping";
  return RELATED_TO_TYPE;
}({});
var FIELD_PREFIX_SLUG = /*#__PURE__*/function (FIELD_PREFIX_SLUG) {
  FIELD_PREFIX_SLUG["ORGANIZATION"] = "organization.";
  FIELD_PREFIX_SLUG["CONTACT"] = "contact.";
  FIELD_PREFIX_SLUG["SHOPPING"] = "shopping.";
  FIELD_PREFIX_SLUG["CONTACT_DIFFUSION_LIST"] = "contact.diffusionListOK.";
  FIELD_PREFIX_SLUG["ORGANIZATION_DIFFUSION_LIST"] = "organization.diffusionListOK.";
  return FIELD_PREFIX_SLUG;
}({});
var DIFFUSION_LIST_KEY = 'diffusionListOK.';

var CUSTOMER_TYPE = /*#__PURE__*/function (CUSTOMER_TYPE) {
  CUSTOMER_TYPE["CONTACT"] = "contact";
  CUSTOMER_TYPE["ORGANIZATION"] = "organization";
  return CUSTOMER_TYPE;
}({});

function getCustomer(customer) {
  if (!customer) {
    return null;
  }
  if (!customer.type) {
    return null; // ugly hack to handle the fact that Cart class create a new Customer() in its default values
  }
  return customer;
}
function getOrganization(data) {
  var customer = getCustomer(data.customer);
  return (customer === null || customer === void 0 ? void 0 : customer.type) === CUSTOMER_TYPE.ORGANIZATION ? customer : null;
}
function getContact(data) {
  var contact = data.contact;
  if (contact) {
    return contact;
  }
  var customer = getCustomer(data.customer);
  return (customer === null || customer === void 0 ? void 0 : customer.type) === CUSTOMER_TYPE.CONTACT ? customer : null;
}
function getFormData(data) {
  var customerRequiredFields = data.customerRequiredFields;

  // Retrieve the entity organization if exist
  var organization = getOrganization(data);
  var organizationInitialValues = _objectSpread2(_objectSpread2(_objectSpread2({}, organization === null || organization === void 0 ? void 0 : organization.additionnalInformation), organization === null || organization === void 0 ? void 0 : organization.diffusionList), organization);

  // Retrieve the entity contact if exist
  var contact = getContact(data);
  var contactInitialValues = _objectSpread2(_objectSpread2(_objectSpread2({}, contact === null || contact === void 0 ? void 0 : contact.additionnalInformation), contact === null || contact === void 0 ? void 0 : contact.diffusionList), contact);

  // Retrieve the entity customer if exist
  // Used for shoppingData only
  var customer = getCustomer(data.customer);
  var customerInitialValues = _objectSpread2({}, customer === null || customer === void 0 ? void 0 : customer.shoppingData);

  // Parse all entity customerRequiredFields to find fields related to organization, contact or shopping data
  var formData = customerRequiredFields === null || customerRequiredFields === void 0 ? void 0 : customerRequiredFields.reduce(function (acc, _ref) {
    var slug = _ref.slug;
    // add field slugs related to organization as formData keys
    // add entity organizationInitialValues as formData values
    if (slug !== null && slug !== void 0 && slug.startsWith(FIELD_PREFIX_SLUG.ORGANIZATION)) {
      var isDiffusionList = slug === null || slug === void 0 ? void 0 : slug.startsWith(FIELD_PREFIX_SLUG.ORGANIZATION_DIFFUSION_LIST);
      var initialValueKey = isDiffusionList ? slug.substring(FIELD_PREFIX_SLUG.ORGANIZATION_DIFFUSION_LIST.length) : slug.substring(FIELD_PREFIX_SLUG.ORGANIZATION.length);
      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, slug, organizationInitialValues[initialValueKey]));
    }

    // add field slugs related to contact as formData keys
    // add entity contactInitialValues as formData values
    if (slug !== null && slug !== void 0 && slug.startsWith(FIELD_PREFIX_SLUG.CONTACT)) {
      var _isDiffusionList = slug === null || slug === void 0 ? void 0 : slug.startsWith(FIELD_PREFIX_SLUG.CONTACT_DIFFUSION_LIST);
      var _initialValueKey = _isDiffusionList ? slug.substring(FIELD_PREFIX_SLUG.CONTACT_DIFFUSION_LIST.length) : slug.substring(FIELD_PREFIX_SLUG.CONTACT.length);
      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, slug, contactInitialValues[_initialValueKey]));
    }

    // add field slugs related to shopping data as formData keys
    // add customerInitialValues as formData values
    if (slug !== null && slug !== void 0 && slug.startsWith(FIELD_PREFIX_SLUG.SHOPPING)) {
      var customerKey = slug.substring(FIELD_PREFIX_SLUG.SHOPPING.length);
      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, slug, customerInitialValues[customerKey]));
    }
    return acc;
  }, {});
  return formData ? Map$1(formData) : null;
}
function getParticipantFormData(participant, participantRequiredFields) {
  var participantInitialValues = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, participant === null || participant === void 0 ? void 0 : participant.additionnalInformation), participant), participant === null || participant === void 0 ? void 0 : participant.diffusionList), participant === null || participant === void 0 ? void 0 : participant.shoppingData);
  var participantFormData = participantRequiredFields === null || participantRequiredFields === void 0 ? void 0 : participantRequiredFields.reduce(function (acc, _ref2) {
    var slug = _ref2.slug;
    assertRelationIsString(slug);
    var customerKey = Object.values(FIELD_PREFIX_SLUG).reduce(function (currentSlug, prefix) {
      return currentSlug.startsWith(prefix) ? currentSlug.substring(prefix.length) : currentSlug;
    }, slug);
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, slug, participantInitialValues[customerKey]));
  }, {});
  return participantFormData ? Map$1(participantFormData) : null;
}
function getCustomerFormValues(formData, slugType, customerKeys) {
  var formDataKeys = Object.keys(formData).filter(function (key) {
    return key.startsWith(slugType);
  });
  if (!formDataKeys.length) {
    // if formData have no matching keys
    return null;
  }
  var customerFormValues = formDataKeys.reduce(function (acc, formKey) {
    var key = formKey.substring(slugType.length);
    var value = formData[formKey];
    if (key.startsWith(DIFFUSION_LIST_KEY)) {
      var diffusionListKey = key.substring(DIFFUSION_LIST_KEY.length);
      // means it's infos related to diffusionList
      return _objectSpread2(_objectSpread2({}, acc), {}, {
        diffusionList: _objectSpread2(_objectSpread2({}, acc.diffusionList), {}, _defineProperty({}, diffusionListKey, value))
      });
    }
    if (customerKeys.includes(key)) {
      // means it's some basic customer infos
      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, key, value));
    }
    if (key === 'bornAt') {
      // very ugly hack to handle same value with different names depending on multiple APIs
      // crm handle fields 'bornAt' but ticketing customer has birthday prop
      // we keep it in additionnalInformation anyway because crm field handle bornAt and not birthday
      return _objectSpread2(_objectSpread2({}, acc), {}, {
        birthday: value ? moment(value).format('YYYY-MM-DD') : null,
        additionnalInformation: _objectSpread2(_objectSpread2({}, acc.additionnalInformation), {}, _defineProperty({}, key, value))
      });
    }

    // put every others custom form values in additionnalInformation
    return _objectSpread2(_objectSpread2({}, acc), {}, {
      additionnalInformation: _objectSpread2(_objectSpread2({}, acc.additionnalInformation), {}, _defineProperty({}, key, value))
    });
  }, {});
  var hasValues = Object.values(customerFormValues).filter(Boolean).length > 0;
  return hasValues ? customerFormValues : null;
}
function getShoppingValues(formData) {
  var shoppingKeys = Object.keys(formData).filter(function (key) {
    return key.startsWith(FIELD_PREFIX_SLUG.SHOPPING);
  });
  if (!shoppingKeys.length) {
    // if formData have no shopping keys
    return null;
  }
  var shoppingData = shoppingKeys.reduce(function (acc, key) {
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, key.substring(FIELD_PREFIX_SLUG.SHOPPING.length), formData[key]));
  }, {});
  return Object.values(shoppingData).filter(Boolean).length > 0 ? shoppingData : null;
}
function mergeCustomerFormValues(customer, customerValues, shoppingValues) {
  var _customer$merge;
  if (!customerValues && !shoppingValues) {
    return null;
  }
  var values = _objectSpread2(_objectSpread2({}, customerValues), {}, {
    diffusionList: _objectSpread2({}, customerValues === null || customerValues === void 0 ? void 0 : customerValues.diffusionList),
    additionnalInformation: _objectSpread2({}, customerValues === null || customerValues === void 0 ? void 0 : customerValues.additionnalInformation),
    shoppingData: _objectSpread2(_objectSpread2({}, customerValues === null || customerValues === void 0 ? void 0 : customerValues.shoppingData), shoppingValues)
  });
  return (_customer$merge = customer.merge(fromJS(values))) !== null && _customer$merge !== void 0 ? _customer$merge : null;
}
function getNewCustomersIds(entity, newCustomerList) {
  var _newContact$get;
  var newOrganization = newCustomerList.find(function (customer) {
    return customer.type === CUSTOMER_TYPE.ORGANIZATION;
  });
  var newContact = newCustomerList.find(function (customer) {
    return customer.type === CUSTOMER_TYPE.CONTACT;
  });
  var customer = entity.customer,
    contact = entity.contact;
  assertRelationIsNullOrObject(customer);
  assertRelationIsNullOrObject(contact);
  if (newOrganization && (customer === null || customer === void 0 ? void 0 : customer.type) === CUSTOMER_TYPE.CONTACT) {
    var _newOrganization$get, _get, _ref3;
    // if an organization has been created it must become the cart customer
    // if exist, the current contact customer becomes cart.contact
    // if there were no customer, we set the possibly new contact as cart.contact
    return {
      customerId: (_newOrganization$get = newOrganization.get('@id')) !== null && _newOrganization$get !== void 0 ? _newOrganization$get : null,
      contactId: (_get = (_ref3 = customer !== null && customer !== void 0 ? customer : newContact) === null || _ref3 === void 0 ? void 0 : _ref3.get('@id')) !== null && _get !== void 0 ? _get : null
    };
  }
  if (newOrganization || (customer === null || customer === void 0 ? void 0 : customer.type) === CUSTOMER_TYPE.ORGANIZATION) {
    var _get2, _ref4, _get3, _ref5;
    // if an organization has been created it must become the cart customer
    // if no new organization, the organization that was already there stay
    // and set the new or existing contact as cart.contact
    return {
      customerId: (_get2 = (_ref4 = newOrganization !== null && newOrganization !== void 0 ? newOrganization : customer) === null || _ref4 === void 0 ? void 0 : _ref4.get('@id')) !== null && _get2 !== void 0 ? _get2 : null,
      contactId: (_get3 = (_ref5 = newContact !== null && newContact !== void 0 ? newContact : contact) === null || _ref5 === void 0 ? void 0 : _ref5.get('@id')) !== null && _get3 !== void 0 ? _get3 : null
    };
  }

  // otherwise, created contact becomes the cart customer
  return {
    customerId: (_newContact$get = newContact === null || newContact === void 0 ? void 0 : newContact.get('@id')) !== null && _newContact$get !== void 0 ? _newContact$get : null,
    contactId: null
  };
}
function addMissingOptionToFieldOptions(fieldOptions, customerValue) {
  // This is needed because Customer may contains data that doesn't match current customerFieldContract options.
  // This occurs when field options are modified after customer data was originally saved.
  var isInOptions = fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.some(function (option) {
    return option.value === customerValue;
  });
  if (isInOptions || typeof customerValue !== 'string') {
    return fieldOptions;
  }
  var customerOption = {
    value: customerValue,
    labelKey: customerValue,
    icon: null
  };
  return [customerOption].concat(fieldOptions !== null && fieldOptions !== void 0 ? fieldOptions : []);
}

var CustomerClient = /*#__PURE__*/function (_AbstractClient) {
  function CustomerClient() {
    _classCallCheck(this, CustomerClient);
    return _callSuper(this, CustomerClient, arguments);
  }
  _inherits(CustomerClient, _AbstractClient);
  return _createClass(CustomerClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/customers';
    }
  }, {
    key: "bulkUpdate",
    value: function bulkUpdate(customerList, fields) {
      var uri = new URI("".concat(this.getPathBase(), "/bulk"));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(uri, {
        method: 'POST',
        body: JSON.stringify({
          'hydra:member': customerList
        })
      }), 'list');
    }
  }]);
}(AbstractClient);

var Customer = /*#__PURE__*/function (_NetworkEntity) {
  function Customer() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Customer'
    };
    _classCallCheck(this, Customer);
    var data = clone(val);
    data.createdAt = parseDate(data.createdAt, extractTimezone(data, ['contract', 'timezone']));
    _this = _callSuper(this, Customer, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Customer, _NetworkEntity);
  return _createClass(Customer, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/customers/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Customer',
  type: null,
  crmId: null,
  lastname: null,
  firstname: null,
  email: null,
  birthday: null,
  nationality: null,
  countryOfResidence: null,
  civility: null,
  zipcode: null,
  address: null,
  city: null,
  phone: null,
  additionnalInformation: null,
  diffusionList: null,
  shippingData: undefined,
  shoppingData: null,
  gdprInformation: null,
  createdAt: null,
  orderList: List(),
  client: null,
  contract: null
}));
Customer.classMetadata = new ClassMetadata('customer', 'customers', /** @ts-expect-error -- method signature are incompatible */
CustomerClient);
Customer.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type'), new Attribute('crmId'), new Attribute('lastname'), new Attribute('firstname'), new Attribute('email'), new Attribute('birthday'), new Attribute('nationality'), new Attribute('countryOfResidence'), new Attribute('civility'), new Attribute('zipcode'), new Attribute('address'), new Attribute('city'), new Attribute('phone'), new Attribute('additionnalInformation', 'additionnalInformation', 'object'), new Attribute('shippingData', 'shippingData', 'object'), new Attribute('shoppingData', 'shoppingData', 'object'), new Attribute('diffusionList', 'diffusionList', 'object'), new Attribute('gdprInformation', 'gdprInformation', 'object'), new Attribute('createdAt', 'createdAt', 'datetime')]);
Customer.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'order', 'orderList'), new Relation(Relation.MANY_TO_ONE, 'client', 'client'), new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var _FormDataClient_brand = /*#__PURE__*/new WeakSet();
var FormDataClient = /*#__PURE__*/function (_AbstractClient) {
  function FormDataClient() {
    var _this;
    _classCallCheck(this, FormDataClient);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FormDataClient, [].concat(args));
    _classPrivateMethodInitSpec(_this, _FormDataClient_brand);
    return _this;
  }
  _inherits(FormDataClient, _AbstractClient);
  return _createClass(FormDataClient, [{
    key: "updateFormData",
    value: function () {
      var _updateFormData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(formData, entity, queryParam, requestParams) {
        var _this2 = this;
        var customerKeys, shoppingValues, organization, organizationValues, customerType, organizationWithValues, contact, contactValues, contactWithValues, updatePromiseList, createPromiseList, newCustomerList, _getNewCustomersIds, customerId, contactId, fields;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              customerKeys = Map$1(new Customer()).keySeq().toArray(); // Retrieve form values related to entity Cart or Order
              shoppingValues = getShoppingValues(formData); // Retrieve entity organization
              // Then, retrieve all form values related to organization
              // add these values to existing or new organization
              // if no value, organization is null
              organization = getOrganization(entity);
              organizationValues = getCustomerFormValues(formData, FIELD_PREFIX_SLUG.ORGANIZATION, customerKeys);
              customerType = organizationValues ? CUSTOMER_TYPE.ORGANIZATION : CUSTOMER_TYPE.CONTACT;
              organizationWithValues = mergeCustomerFormValues(organization !== null && organization !== void 0 ? organization : new Customer({
                '@id': null,
                type: CUSTOMER_TYPE.ORGANIZATION
              }), organizationValues, customerType === CUSTOMER_TYPE.ORGANIZATION ? shoppingValues : null); // Retrieve entity contact
              // Then, retrieve all form values related to contact
              // add these values to existing or new contact
              // if no value, contactWithValues is null
              contact = getContact(entity);
              contactValues = getCustomerFormValues(formData, FIELD_PREFIX_SLUG.CONTACT, customerKeys);
              contactWithValues = mergeCustomerFormValues(contact !== null && contact !== void 0 ? contact : new Customer({
                '@id': null,
                type: CUSTOMER_TYPE.CONTACT
              }), contactValues, customerType === CUSTOMER_TYPE.CONTACT ? shoppingValues : null); // Update organization and/or contact if exist
              updatePromiseList = [organization ? organizationWithValues : null, contact ? contactWithValues : null].filter(Boolean).map(function (customer) {
                return _this2.sdk.getRepository('customer').update(customer, {
                  fields: customerKeys
                });
              });
              _context.n = 1;
              return Promise.all(updatePromiseList);
            case 1:
              // Create organization and/or contact if does not exist
              createPromiseList = [!organization ? organizationWithValues : null, !contact ? contactWithValues : null].filter(Boolean).map(function (customer) {
                return _this2.sdk.getRepository('customer').create(customer, {
                  fields: customerKeys
                });
              });
              _context.n = 2;
              return Promise.all(createPromiseList);
            case 2:
              newCustomerList = _context.v;
              if (!newCustomerList.length) {
                _context.n = 3;
                break;
              }
              _getNewCustomersIds = getNewCustomersIds(entity, newCustomerList), customerId = _getNewCustomersIds.customerId, contactId = _getNewCustomersIds.contactId;
              return _context.a(2, _assertClassBrand(_FormDataClient_brand, this, _updateCustomersEntity).call(this, entity.getShortId(), customerId, contactId, queryParam, requestParams));
            case 3:
              fields = queryParam.fields;
              return _context.a(2, this.find(entity.getShortId(), fields));
          }
        }, _callee, this);
      }));
      function updateFormData(_x, _x2, _x3, _x4) {
        return _updateFormData.apply(this, arguments);
      }
      return updateFormData;
    }()
  }, {
    key: "updateCustomerContactOwner",
    value: function () {
      var _updateCustomerContactOwner = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(entity, customer, contact, ownerId, queryParam, requestParams) {
        var _createdContact$get;
        var createdCustomer, createdContact, response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.sdk.getRepository('customer').create(customer, {
                fields: ['@id']
              });
            case 1:
              createdCustomer = _context2.v;
              if (!contact) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return this.sdk.getRepository('customer').create(contact, {
                fields: ['@id']
              });
            case 2:
              _t = _context2.v;
              _context2.n = 4;
              break;
            case 3:
              _t = null;
            case 4:
              createdContact = _t;
              _context2.n = 5;
              return this.find(entity.getShortId(), ['customer', 'contact', 'owner']);
            case 5:
              response = _context2.v;
              return _context2.a(2, this.update(response
              /** @ts-expect-error -- method signature are incompatible */.set('customer', createdCustomer.get('@id')).set('contact', (_createdContact$get = createdContact === null || createdContact === void 0 ? void 0 : createdContact.get('@id')) !== null && _createdContact$get !== void 0 ? _createdContact$get : null).set('owner', ownerId), queryParam, requestParams));
          }
        }, _callee2, this);
      }));
      function updateCustomerContactOwner(_x5, _x6, _x7, _x8, _x9, _x0) {
        return _updateCustomerContactOwner.apply(this, arguments);
      }
      return updateCustomerContactOwner;
    }()
  }]);
}(AbstractClient);
function _updateCustomersEntity(_x1, _x10, _x11, _x12, _x13) {
  return _updateCustomersEntity2.apply(this, arguments);
}
function _updateCustomersEntity2() {
  _updateCustomersEntity2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(entityId, customerId, contactId, queryParam, requestParams) {
    var response;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return this.find(entityId, ['customer', 'contact']);
        case 1:
          response = _context3.v;
          return _context3.a(2, this.update(/** @ts-expect-error -- method signature are incompatible */
          response.set('customer', customerId).set('contact', contactId), queryParam, requestParams));
      }
    }, _callee3, this);
  }));
  return _updateCustomersEntity2.apply(this, arguments);
}

var CartClient = /*#__PURE__*/function (_FormDataClient) {
  function CartClient() {
    _classCallCheck(this, CartClient);
    return _callSuper(this, CartClient, arguments);
  }
  _inherits(CartClient, _FormDataClient);
  return _createClass(CartClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      var pathParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (pathParameters.simulate === true) {
        return "".concat(_superPropGet(CartClient, "getPathBase", this, 3)([pathParameters]), "/simulate");
      }
      return _superPropGet(CartClient, "getPathBase", this, 3)([pathParameters]);
    }
  }, {
    key: "simulate",
    value: function simulate(entity, queryParam) {
      return this.create(entity, queryParam, {
        simulate: true
      });
    }
  }, {
    key: "getPdfQuotation",
    value: function getPdfQuotation(id, name, vatNumber, address, customerAdditionalInfo, quotationType) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/quotation.pdf"));
      url.addSearch({
        name: name,
        vat: vatNumber,
        address: address,
        customerAdditionalInfo: customerAdditionalInfo,
        quotationType: quotationType
      });
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "notifyOptions",
    value: function notifyOptions(filters, approvedMessage, rejectedMessage, notifyPendingOptions) {
      var uri = new URI("".concat(this.getPathBase(), "/notify-options"));
      var body = {
        filters: filters.toJS(),
        approvedMessage: approvedMessage,
        rejectedMessage: rejectedMessage,
        notifyPendingOptions: notifyPendingOptions
      };
      return this.authorizedFetch(uri, {
        method: 'POST',
        body: JSON.stringify(body)
      });
    }
  }, {
    key: "getProviderExportedCartData",
    value: function () {
      var _getProviderExportedCartData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id, providerName) {
        var url, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              url = new URI("/".concat(id, "/provider_exported_cart/").concat(providerName));
              _context.n = 1;
              return this.authorizedFetch(url, {
                method: 'GET'
              });
            case 1:
              response = _context.v;
              _t = fromJS;
              _context.n = 2;
              return response.json();
            case 2:
              return _context.a(2, _t(_context.v));
          }
        }, _callee, this);
      }));
      function getProviderExportedCartData(_x, _x2) {
        return _getProviderExportedCartData.apply(this, arguments);
      }
      return getProviderExportedCartData;
    }()
  }, {
    key: "hideByFilter",
    value: function hideByFilter(filters) {
      var uri = new URI("".concat(this.getPathBase(), "/hide"));
      var body = {
        filters: filters.toJS()
      };
      return this.authorizedFetch(uri, {
        method: 'POST',
        body: JSON.stringify(body)
      });
    }
  }, {
    key: "swap",
    value: function swap(swapMap, sellingDeviceId, fields) {
      var url = URI("".concat(this.getPathBase(), "/swap"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify({
          swapMap: swapMap,
          sellingDevice: sellingDeviceId
        })
      }), 'item');
    }
  }]);
}(FormDataClient);

// "@id" and "@type" not defined for this entity, but too much TypeScript brainfuck to avoid only this class
var CartItemWithOffer = /*#__PURE__*/function (_NetworkEntity) {
  function CartItemWithOffer() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'CartItemWithOffer'
    };
    _classCallCheck(this, CartItemWithOffer);
    var data = clone(val);
    data.offer = val.offer && Map$1(val.offer);
    _this = _callSuper(this, CartItemWithOffer, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(CartItemWithOffer, _NetworkEntity);
  return _createClass(CartItemWithOffer, [{
    key: "getKey",
    value: function getKey() {
      var offerName = this.getIn(['offer', 'name']) || '';
      var cartItemId = getEntityId$1(this.get('cartItem'));
      var stockContingent = this.getIn(['cartItem', 'stockContingent']);
      var stockContingentId = stockContingent ? getEntityId$1(stockContingent) : '';
      var ticketPrice = this.get('ticketPrice');
      var clusterId = this.get('clusterId') || '';
      var groupKey = this.get('groupKey') || '';
      var couponCode = this.get('couponCode') || '';
      var buyable = this.get('buyable');
      var buyableKey = '';
      if (buyable !== null) {
        buyableKey = buyable ? '1' : '0';
      }
      return "".concat(ticketPrice || cartItemId, "-").concat(this.facialValue, "-").concat(couponCode, "-").concat(groupKey, "-").concat(offerName, "-").concat(clusterId, "-").concat(buyableKey, "-").concat(stockContingentId);
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'CartItemWithOffer',
  name: null,
  quantity: null,
  facialValue: null,
  facialValueWithoutOffer: null,
  offer: null,
  ticketingTitle: null,
  ticketingTimezone: null,
  date: null,
  endDate: null,
  cartItem: null,
  availableSeatList: null,
  clusterId: null,
  applicationId: null,
  groupKey: null,
  couponCode: null,
  offerRuleUseApplicationIdQuantityMap: List(),
  buyable: null,
  valid: null,
  ticketPrice: null,
  customerPaidAmount: null
}));

var CouponClient = /*#__PURE__*/function (_AbstractClient) {
  function CouponClient() {
    _classCallCheck(this, CouponClient);
    return _callSuper(this, CouponClient, arguments);
  }
  _inherits(CouponClient, _AbstractClient);
  return _createClass(CouponClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/coupons';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['coupon_read', 'coupon_write'];
    }
  }, {
    key: "getCodes",
    value: function getCodes(criteria) {
      var uri = new URI("".concat(this.getPathBase(), "/codes"));
      var params = this._mergeFieldsIntoParams(criteria, []);
      uri.addSearch(params);
      return this.authorizedFetch(uri).then(function (response) {
        return response.json().then(createEntity);
      });
    }
  }, {
    key: "validateCodes",
    value: function validateCodes(ignoredOfferRule, contract, couponCode) {
      var uri = new URI("".concat(this.getPathBase(), "/codes/validate"));
      return this.authorizedFetch(uri, {
        method: 'POST',
        body: JSON.stringify({
          ignoredOfferRule: ignoredOfferRule,
          contract: contract,
          couponCode: couponCode
        })
      });
    }
  }]);
}(AbstractClient);

var COUPON_USAGE = /*#__PURE__*/function (COUPON_USAGE) {
  COUPON_USAGE["CASH"] = "cash";
  COUPON_USAGE["PER_ORDER"] = "per_order";
  COUPON_USAGE["PER_ORDER_ITEM"] = "per_order_item";
  COUPON_USAGE["PER_APPLICATION"] = "per_application";
  return COUPON_USAGE;
}({});
var Coupon = /*#__PURE__*/function (_NetworkEntity) {
  function Coupon() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Coupon'
    };
    _classCallCheck(this, Coupon);
    var data = clone(val);
    var tz = extractTimezone(data, ['creatingOfferRule', 'timezone']);
    data.validFrom = parseDate(val.validFrom, tz);
    data.validUntil = parseDate(val.validUntil, tz);
    _this = _callSuper(this, Coupon, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Coupon, _NetworkEntity);
  return _createClass(Coupon, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/coupons/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Coupon',
  code: null,
  data: null,
  contractKey: '',
  amount: null,
  initialAmount: null,
  usage: null,
  nbUseMax: null,
  nbUseCurrent: 0,
  description: '',
  offerRuleList: List(),
  customerStatusList: null,
  validFrom: null,
  validUntil: null,
  applyingCartItemList: List(),
  applyingOrderItemList: List(),
  applyingOrderList: null,
  creatingOrderItemList: List(),
  creatingCartItemList: List(),
  creatingOrder: null,
  enabled: null,
  season: null,
  isExpired: null,
  creatingOfferRule: null,
  participant: null
}));
/** @ts-expect-error -- method signature are incompatible */
Coupon.classMetadata = new ClassMetadata('coupon', 'coupons', CouponClient);
Coupon.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('data', 'data', 'object'), new Attribute('code'), new Attribute('contractKey'), new Attribute('usage'), new Attribute('description'), new Attribute('amount', 'amount', 'integer'), new Attribute('initialAmount', 'initialAmount', 'integer'), new Attribute('nbUseMax', 'nbUseMax', 'integer'), new Attribute('nbUseCurrent', 'nbUseCurrent', 'integer'), new Attribute('validFrom', 'validFrom', 'datetime'), new Attribute('validUntil', 'validUntil', 'datetime'), new Attribute('enabled', 'enabled', 'boolean'), new Attribute('isExpired', 'isExpired', 'boolean')]);
Coupon.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'offerRule', 'offerRuleList'), new Relation(Relation.ONE_TO_MANY, 'cartItem', 'applyingCartItemList'), new Relation(Relation.ONE_TO_MANY, 'orderItem', 'applyingOrderItemList'), new Relation(Relation.ONE_TO_MANY, 'order', 'applyingOrderList'), new Relation(Relation.ONE_TO_MANY, 'cartItem', 'creatingCartItemList'), new Relation(Relation.ONE_TO_MANY, 'orderItem', 'creatingOrderItemList'), new Relation(Relation.ONE_TO_MANY, 'customerStatus', 'customerStatusList'), new Relation(Relation.MANY_TO_ONE, 'season', 'seasons'), new Relation(Relation.ONE_TO_ONE, 'offerRule', 'creatingOfferRule'), new Relation(Relation.ONE_TO_ONE, 'order', 'creatingOrder'), new Relation(Relation.ONE_TO_ONE, 'customer', 'participant')]);

var EVENT_DATE_ACCOUNTABILITY_FILTER = /*#__PURE__*/function (EVENT_DATE_ACCOUNTABILITY_FILTER) {
  EVENT_DATE_ACCOUNTABILITY_FILTER["TICKETS"] = "tickets";
  EVENT_DATE_ACCOUNTABILITY_FILTER["ITEMS"] = "items";
  return EVENT_DATE_ACCOUNTABILITY_FILTER;
}({});
var EventDateClient = /*#__PURE__*/function (_AbstractClient) {
  function EventDateClient() {
    _classCallCheck(this, EventDateClient);
    return _callSuper(this, EventDateClient, arguments);
  }
  _inherits(EventDateClient, _AbstractClient);
  return _createClass(EventDateClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/event_dates';
    }
  }, {
    key: "getAccountability",
    value: function getAccountability(id, originType) {
      var orderItemFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EVENT_DATE_ACCOUNTABILITY_FILTER.TICKETS;
      var filename = orderItemFilter === EVENT_DATE_ACCOUNTABILITY_FILTER.ITEMS ? 'event_date_items' : 'event_date';
      var url = URI("/v1/accountability/".concat(id, "/").concat(filename, ".pdf?user=me&summary=1&originType=").concat(originType));
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getDownloadListOfParticipantsByEventDate",
    value: function getDownloadListOfParticipantsByEventDate(id, provider, format) {
      var url = URI("/v1/event_dates/".concat(id, "/tickets.").concat(provider, ".").concat(format));
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "putBulk",
    value: function putBulk(id) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/bulk"));
      return this.authorizedFetch(url, {
        method: 'PUT'
      });
    }
  }, {
    key: "clone",
    value: function clone(id, eventDate, fields) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/clone"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(eventDate)
      }), 'item');
    }
  }, {
    key: "cancel",
    value: function cancel(eventDate, fields) {
      var url = URI("".concat(this.getPathBase(), "/").concat(eventDate.getShortId(), "/cancel"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'PUT',
        body: '{}'
      }), 'item');
    }
  }]);
}(AbstractClient);

var EventDatePatternClient = /*#__PURE__*/function (_AbstractClient) {
  function EventDatePatternClient() {
    _classCallCheck(this, EventDatePatternClient);
    return _callSuper(this, EventDatePatternClient, arguments);
  }
  _inherits(EventDatePatternClient, _AbstractClient);
  return _createClass(EventDatePatternClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/event_date_patterns';
    }
  }, {
    key: "preview",
    value: function preview(entity) {
      var url = URI("".concat(this.getPathBase(), "/preview"));
      var method = 'POST';
      if (entity.get('@id')) {
        url = URI("".concat(entity.get('@id'), "/preview"));
        method = 'PUT';
      }
      var oldSerializedModel = this.metadata.getDefaultSerializedModel();
      var newSerializedModel = this.serializer.normalizeItem(entity, this.metadata);
      var diff = this.sdk.unitOfWork.getDirtyData(newSerializedModel, oldSerializedModel, this.metadata);
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: method,
        body: this.serializer.encodeItem(diff, this.metadata)
      }), 'item');
    }
  }]);
}(AbstractClient);

var SeatConfigClient = /*#__PURE__*/function (_HidableClient) {
  function SeatConfigClient() {
    _classCallCheck(this, SeatConfigClient);
    return _callSuper(this, SeatConfigClient, arguments);
  }
  _inherits(SeatConfigClient, _HidableClient);
  return _createClass(SeatConfigClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/seat_configs';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['seat_config_read', 'seat_config_write'];
    }
  }]);
}(HidableClient);

// those fields can not be `null` in the API, so they won't be `null` if the "fields" is given.
var SeatConfig = /*#__PURE__*/function (_NetworkEntity) {
  function SeatConfig() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'SeatConfig'
    };
    _classCallCheck(this, SeatConfig);
    _this = _callSuper(this, SeatConfig, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(SeatConfig, _NetworkEntity);
  return _createClass(SeatConfig, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/seat_configs/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'SeatConfig',
  seatGroupList: List(),
  seatConfigBlockList: List(),
  label: null,
  totalStock: null,
  contract: null,
  eventDateList: List(),
  eventDatePatternList: List(),
  logicalSeatConfigList: null,
  isHidden: null,
  floorList: null,
  zoneList: null
}));
SeatConfig.classMetadata = new ClassMetadata('seatConfig', 'seat_configs', /** @ts-expect-error -- method signature are incompatible */
SeatConfigClient);
SeatConfig.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('label'), new Attribute('totalStock', 'totalStock', 'int'), new Attribute('isHidden', 'isHidden', 'boolean')]);
SeatConfig.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.ONE_TO_MANY, 'seatGroup', 'seatGroupList'), new Relation(Relation.ONE_TO_MANY, 'seatConfigBlock', 'seatConfigBlockList'), new Relation(Relation.ONE_TO_MANY, 'eventDate', 'eventDateList'), new Relation(Relation.ONE_TO_MANY, 'eventDatePattern', 'eventDatePatternList'), new Relation(Relation.ONE_TO_MANY, 'logicalSeatConfig', 'logicalSeatConfigList'), new Relation(Relation.ONE_TO_MANY, 'seatFloor', 'floorList'), new Relation(Relation.ONE_TO_MANY, 'seatZone', 'zoneList')]);

var TicketingClient = /*#__PURE__*/function (_AbstractClient) {
  function TicketingClient() {
    _classCallCheck(this, TicketingClient);
    return _callSuper(this, TicketingClient, arguments);
  }
  _inherits(TicketingClient, _AbstractClient);
  return _createClass(TicketingClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/ticketings';
    }

    /** @deprecated */
  }, {
    key: "findByActivity",
    value: function findByActivity(activityUuid, fields) {
      return this.findBy({
        activityUuid: activityUuid
      }, fields);
    }

    /** @deprecated */
  }, {
    key: "findByActivityUuidList",
    value: function findByActivityUuidList(activityUuidList, fields) {
      var uuidList = activityUuidList.join(',');
      return this.findBy({
        activityUuid: uuidList
      }, fields);
    }
  }, {
    key: "closeSales",
    value: function closeSales(id, fields) {
      var queryParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._massAction('close', id, fields, queryParam);
    }
  }, {
    key: "suspendSales",
    value: function suspendSales(id, fields) {
      var queryParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._massAction('suspend', id, fields, queryParam);
    }
  }, {
    key: "openSales",
    value: function openSales(id, fields) {
      var queryParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._massAction('open', id, fields, queryParam);
    }
  }, {
    key: "_massAction",
    value: function _massAction(action, id, fields) {
      var queryParam = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (['close', 'open', 'suspend'].indexOf(action) === -1) {
        throw new Error('action must be one of close|open|suspend');
      }
      var url = new URI("".concat(this.getPathBase(), "/").concat(id, "/").concat(action, "-sales"));
      url.addSearch(this._mergeFieldsIntoParams(queryParam, fields));
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST'
      }), 'item');
    }
  }]);
}(AbstractClient);

var IMAGE_TYPE_IMAGE = 'image';
var IMAGE_TYPE_POSTER = 'poster';
var ALL_IMAGE_TYPES = [IMAGE_TYPE_POSTER, IMAGE_TYPE_IMAGE];

var MinisiteClient = /*#__PURE__*/function (_AbstractClient) {
  function MinisiteClient() {
    _classCallCheck(this, MinisiteClient);
    return _callSuper(this, MinisiteClient, arguments);
  }
  _inherits(MinisiteClient, _AbstractClient);
  return _createClass(MinisiteClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/minisites';
    }
  }]);
}(AbstractClient);

var MINISITE_HIDE_SEATING_MODE = /*#__PURE__*/function (MINISITE_HIDE_SEATING_MODE) {
  MINISITE_HIDE_SEATING_MODE["ALL"] = "all";
  MINISITE_HIDE_SEATING_MODE["PURCHASE_PLAN"] = "purchase_plan";
  return MINISITE_HIDE_SEATING_MODE;
}({});
var MINISITE_PROVIDER_LIST = /*#__PURE__*/function (MINISITE_PROVIDER_LIST) {
  MINISITE_PROVIDER_LIST["PARIS_CITE"] = "paris_cite";
  return MINISITE_PROVIDER_LIST;
}({});
var MINISITE_INTEGRATIONS = /*#__PURE__*/function (MINISITE_INTEGRATIONS) {
  MINISITE_INTEGRATIONS["COVOITURAGE_SIMPLE"] = "covoiturage-simple";
  MINISITE_INTEGRATIONS["THIRD_PARTY_AUTHENTICATION"] = "third_party_authentication";
  return MINISITE_INTEGRATIONS;
}({});
var MINISITE_SIGN_IN_MODE = /*#__PURE__*/function (MINISITE_SIGN_IN_MODE) {
  MINISITE_SIGN_IN_MODE["ALL"] = "all";
  MINISITE_SIGN_IN_MODE["SIGNIN"] = "sign_in";
  MINISITE_SIGN_IN_MODE["ANONYMOUS"] = "anonymous";
  return MINISITE_SIGN_IN_MODE;
}({});
var Minisite = /*#__PURE__*/function (_NetworkEntity) {
  function Minisite() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Minisite'
    };
    _classCallCheck(this, Minisite);
    _this = _callSuper(this, Minisite, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Minisite, _NetworkEntity);
  return _createClass(Minisite, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/minisites/', '')) || '';
    }
  }, {
    key: "hasSeatingPlanPurchaseHidden",
    value: function hasSeatingPlanPurchaseHidden() {
      var _this$settings;
      var hideSeatingLinks = (_this$settings = this.settings) === null || _this$settings === void 0 ? void 0 : _this$settings.getIn(['options', 'hideSeatingLinks']);
      return hideSeatingLinks === MINISITE_HIDE_SEATING_MODE.PURCHASE_PLAN || hideSeatingLinks === MINISITE_HIDE_SEATING_MODE.ALL;
    }
  }, {
    key: "hasSeatingReplacementHidden",
    value: function hasSeatingReplacementHidden() {
      var _this$settings2;
      return ((_this$settings2 = this.settings) === null || _this$settings2 === void 0 ? void 0 : _this$settings2.getIn(['options', 'hideSeatingLinks'])) === MINISITE_HIDE_SEATING_MODE.ALL;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Minisite',
  slug: null,
  domain: null,
  name: null,
  companyName: null,
  sellingDevice: null,
  mainContract: null,
  backgroundUrl: null,
  logo: null,
  settings: null,
  moduleList: List(),
  isDemoMode: null,
  termsOfSale: null,
  isMultiContract: null,
  integrations: null,
  signInMode: null,
  schoolMode: null
}));
Minisite.classMetadata = new ClassMetadata('minisite', 'minisites', /** @ts-expect-error -- method signature are incompatible */
MinisiteClient);
Minisite.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('slug'), new Attribute('domain'), new Attribute('name'), new Attribute('companyName'), new Attribute('backgroundUrl'), new Attribute('logo'), new Attribute('settings', 'settings', 'object'), new Attribute('isDemoMode', 'isDemoMode', 'boolean'), new Attribute('termsOfSale'), new Attribute('isMultiContract', 'isMultiContract', 'boolean'), new Attribute('integrations', 'integrations', 'object'), new Attribute('signInMode'), new Attribute('schoolMode', 'schoolMode', 'boolean')]);
Minisite.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'sellingDevice', 'sellingDevice'), new Relation(Relation.MANY_TO_ONE, 'contract', 'mainContract'), new Relation(Relation.ONE_TO_MANY, 'module', 'moduleList')]);

var TICKETING_AVAILABILITY_STATUS = /*#__PURE__*/function (TICKETING_AVAILABILITY_STATUS) {
  TICKETING_AVAILABILITY_STATUS["NO_TICKET_PRICE"] = "noTicketPrice";
  TICKETING_AVAILABILITY_STATUS["ON_HOLD"] = "onHold";
  TICKETING_AVAILABILITY_STATUS["ON_SALE"] = "onSale";
  TICKETING_AVAILABILITY_STATUS["OTHER"] = "other";
  TICKETING_AVAILABILITY_STATUS["PAST_OR_CLOSED"] = "pastOrClosed";
  TICKETING_AVAILABILITY_STATUS["SOLD_OUT"] = "soldOut";
  TICKETING_AVAILABILITY_STATUS["SOLD_OUT_ONLINE"] = "soldOutOnline";
  TICKETING_AVAILABILITY_STATUS["SOLD_OUT_NOT_IN_STOCK_CONTINGENT"] = "soldOutNotInStockContingent";
  TICKETING_AVAILABILITY_STATUS["CANCELLED"] = "cancelled";
  return TICKETING_AVAILABILITY_STATUS;
}({});
var TICKETING_TYPE_DATED_EVENTS = 'dated_events';
var TICKETING_TYPE_UNDATED_EVENT = 'undated_event';
var TICKETING_TYPE_OFFER = 'offer';

// those fields are mandatory, if "fields" is given, then their values will be a non-nullable string
var Ticketing = /*#__PURE__*/function (_NetworkEntity) {
  function Ticketing() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Ticketing'
    };
    _classCallCheck(this, Ticketing);
    var data = clone(val);
    if (_typeof(data.contingentBookableStock) === 'object' && data.contingentBookableStock !== null) {
      data.contingentBookableStock = Map$1(data.contingentBookableStock);
    }
    _this = _callSuper(this, Ticketing, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Ticketing, _NetworkEntity);
  return _createClass(Ticketing, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/ticketings/', '')) || '';
    }
  }, {
    key: "getMainImageMedia",
    value: function getMainImageMedia() {
      var _imageMediaList$first;
      if (!this.mediaList) {
        return null;
      }
      var imageMediaList = this.mediaList.filter(function (m) {
        var imageType = m.get('imageType');
        return imageType && ALL_IMAGE_TYPES.includes(imageType);
      });
      return (_imageMediaList$first = imageMediaList.first()) !== null && _imageMediaList$first !== void 0 ? _imageMediaList$first : null;
    }
  }, {
    key: "hasSeatingPlanPurchaseHidden",
    value: function hasSeatingPlanPurchaseHidden() {
      var _this$minisiteParamet;
      var hideSeatingLinks = (_this$minisiteParamet = this.minisiteParameters) === null || _this$minisiteParamet === void 0 ? void 0 : _this$minisiteParamet.get('hideSeatingLinks');
      return hideSeatingLinks === MINISITE_HIDE_SEATING_MODE.PURCHASE_PLAN || hideSeatingLinks === MINISITE_HIDE_SEATING_MODE.ALL;
    }
  }, {
    key: "hasSeatingReplacementHidden",
    value: function hasSeatingReplacementHidden() {
      var _this$minisiteParamet2;
      return ((_this$minisiteParamet2 = this.minisiteParameters) === null || _this$minisiteParamet2 === void 0 ? void 0 : _this$minisiteParamet2.get('hideSeatingLinks')) === MINISITE_HIDE_SEATING_MODE.ALL;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Ticketing',
  contract: null,
  activityUuid: null,
  slug: '',
  city: '',
  citySlug: '',
  countryCode: '',
  activitySlug: '',
  title: '',
  description: '',
  type: null,
  address: '',
  place: '',
  schedule: '',
  sellingDeviceSchedule: null,
  imageList: null,
  mediaList: null,
  timezone: '',
  currency: '',
  hideFees: false,
  permanent: false,
  isOnSale: false,
  wallet: null,
  eventDateList: List(),
  eventDatePatternList: List(),
  minisite: new Minisite(),
  minisiteList: List(),
  sellingDeviceData: List(),
  tagList: List(),
  availabilityStatus: '',
  customerRequiredFields: Map$1(),
  firstFutureEventDate: null,
  firstFutureEventDateStartDate: '',
  venue: null,
  sibilTicketingSpectacle: null,
  position: null,
  templateParameters: Map$1(),
  minisiteParameters: undefined,
  season: null,
  ticketingCategory: null,
  organizationalUnit: null,
  totalEventDateCount: null,
  futureEventDateCount: null,
  moduleList: List(),
  notInStockContingentBookableStock: null,
  unlimitedStock: null,
  contingentBookableStock: null,
  futureEventDatesAvailabilityStatus: undefined,
  color: undefined,
  reportingAccount: undefined
}));
Ticketing.classMetadata = new ClassMetadata('ticketing', 'ticketings', /** @ts-expect-error -- method signature are incompatible */
TicketingClient);
Ticketing.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('activityUuid'), new Attribute('slug'), new Attribute('city'), new Attribute('citySlug'), new Attribute('countryCode'), new Attribute('activitySlug'), new Attribute('title'), new Attribute('description'), new Attribute('type'), new Attribute('address'), new Attribute('place'), new Attribute('schedule'), new Attribute('sellingDeviceSchedule', 'sellingDeviceSchedule', 'object'), new Attribute('imageList', 'imageList', 'array'), new Attribute('mediaList', 'mediaList', 'array'), new Attribute('timezone'), new Attribute('currency'), new Attribute('hideFees', 'hideFees', 'boolean'), new Attribute('permanent', 'permanent', 'boolean'), new Attribute('isOnSale', 'isOnSale', 'boolean'), new Attribute('sellingDeviceData', 'sellingDeviceData', 'array'), new Attribute('availabilityStatus'), new Attribute('futureEventDatesAvailabilityStatus'), new Attribute('customerRequiredFields', 'customerRequiredFields', 'object'), new Attribute('templateParameters', 'templateParameters', 'object'), new Attribute('minisiteParameters', 'minisiteParameters', 'object'), new Attribute('firstFutureEventDateStartDate'), new Attribute('position'), new Attribute('totalEventDateCount', 'totalEventDateCount', 'integer'), new Attribute('futureEventDateCount', 'futureEventDateCount', 'integer'), new Attribute('notInStockContingentBookableStock', 'notInStockContingentBookableStock', 'integer'), new Attribute('unlimitedStock', 'unlimitedStock', 'boolean'), new Attribute('contingentBookableStock', 'contingentBookableStock', 'object'), new Attribute('color')]);
Ticketing.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'eventDate', 'firstFutureEventDate'), new Relation(Relation.MANY_TO_ONE, 'wallet', 'wallet'), new Relation(Relation.ONE_TO_MANY, 'eventDate', 'eventDateList'), new Relation(Relation.ONE_TO_MANY, 'tag', 'tagList'), new Relation(Relation.ONE_TO_MANY, 'eventDatePattern', 'eventDatePatternList'), new Relation(Relation.MANY_TO_ONE, 'minisite', 'minisite'), new Relation(Relation.ONE_TO_MANY, 'minisite', 'minisiteList'), new Relation(Relation.MANY_TO_ONE, 'contract', 'contracts'), new Relation(Relation.MANY_TO_ONE, 'venue', 'venue'), new Relation(Relation.ONE_TO_ONE, 'sibilTicketingSpectacle', 'sibilTicketingSpectacle'), new Relation(Relation.MANY_TO_ONE, 'season', 'season'), new Relation(Relation.MANY_TO_ONE, 'ticketingCategory', 'ticketingCategory'), new Relation(Relation.MANY_TO_ONE, 'organizationalUnit', 'organizationalUnit'), new Relation(Relation.MANY_TO_MANY, 'module', 'moduleList'), new Relation(Relation.MANY_TO_ONE, 'reportingAccount', 'reportingAccount')]);

var EventDatePattern = /*#__PURE__*/function (_NetworkEntity) {
  function EventDatePattern() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'EventDatePattern'
    };
    _classCallCheck(this, EventDatePattern);
    var data = clone(val);
    _this = _callSuper(this, EventDatePattern, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(EventDatePattern, _NetworkEntity);
  return _createClass(EventDatePattern, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/event_date_patterns/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'EventDatePattern',
  seatConfig: new SeatConfig(),
  ticketing: new Ticketing(),
  schedule: List(),
  ticketPriceList: List(),
  relativeSaleStartDate: null,
  relativeSaleEndDate: null,
  totalStock: null,
  status: null,
  type: null
}));
EventDatePattern.classMetadata = new ClassMetadata('eventDatePattern', 'event_date_patterns', /** @ts-expect-error -- method signature are incompatible */
EventDatePatternClient);
EventDatePattern.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('schedule', 'schedule', 'array'), new Attribute('relativeSaleStartDate', 'relativeSaleStartDate', 'datetime'), new Attribute('relativeSaleEndDate', 'relativeSaleEndDate', 'datetime'), new Attribute('totalStock', 'totalStock', 'integer'), new Attribute('status'), new Attribute('type')]);
EventDatePattern.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'seatConfig', 'seatConfig'), new Relation(Relation.MANY_TO_ONE, 'ticketing', 'ticketing'), new Relation(Relation.ONE_TO_MANY, 'ticketPrice', 'ticketPriceList')]);

var TYPE_GENERAL_PUBLIC = 'general_public';
var TYPE_SCHOOL = 'school';
var TYPE_BUSINESS = 'business';
var TYPE_OTHER$1 = 'other';
var EVENT_DATE_STATUS = /*#__PURE__*/function (EVENT_DATE_STATUS) {
  EVENT_DATE_STATUS["CLOSED"] = "closed";
  EVENT_DATE_STATUS["DRAFT"] = "draft";
  EVENT_DATE_STATUS["OPENED"] = "opened";
  EVENT_DATE_STATUS["CANCELLED"] = "cancelled";
  return EVENT_DATE_STATUS;
}({});

// it is not possible to extend enums in Typescript
// we have to create a new enum with the same values
// and the additional ones.
// We could create a type made of the union of the two enums
// but we could not access and use its values as we do with enums
var EVENT_DATE_AVAILABILITY_STATUS = /*#__PURE__*/function (EVENT_DATE_AVAILABILITY_STATUS) {
  EVENT_DATE_AVAILABILITY_STATUS["CLOSED"] = "closed";
  EVENT_DATE_AVAILABILITY_STATUS["DRAFT"] = "draft";
  EVENT_DATE_AVAILABILITY_STATUS["OPENED"] = "opened";
  EVENT_DATE_AVAILABILITY_STATUS["CANCELLED"] = "cancelled";
  EVENT_DATE_AVAILABILITY_STATUS["SALE_SCHEDULED"] = "saleScheduled";
  EVENT_DATE_AVAILABILITY_STATUS["MULTIPLE"] = "multiple";
  return EVENT_DATE_AVAILABILITY_STATUS;
}({});
var EventDate = /*#__PURE__*/function (_NetworkEntity) {
  function EventDate() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'EventDate'
    };
    _classCallCheck(this, EventDate);
    var data = clone(val);
    var tz = _typeof(data.ticketing) === 'object' && data.ticketing !== null ? data.ticketing.timezone : null;
    data.startDate = parseDate(data.startDate, tz);
    data.endDate = parseDate(data.endDate, tz);
    data.startOfEventDay = parseDate(data.startOfEventDay, tz);
    data.endOfEventDay = parseDate(data.endOfEventDay, tz);
    data.saleStartDate = parseDate(data.saleStartDate, tz);
    data.saleEndDate = parseDate(data.saleEndDate, tz);
    data.createdAt = parseDate(data.createdAt, tz);
    data.updatedAt = parseDate(data.updatedAt, tz);
    if (_typeof(data.contingentBookableStock) === 'object' && data.contingentBookableStock !== null) {
      data.contingentBookableStock = Map$1(data.contingentBookableStock);
    }

    // @ts-expect-error -- need to fix the moment converted values from the constructor
    _this = _callSuper(this, EventDate, [data]);

    // @ts-expect-error -- need to fix the moment converted values from the constructor
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(EventDate, _NetworkEntity);
  return _createClass(EventDate, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/event_dates/', '')) || '';
    }
  }, {
    key: "getRemainingStock",
    value: function getRemainingStock() {
      if (this.get('unlimitedStock')) {
        return null;
      }
      return this.get('remainingStock');
    }
  }, {
    key: "getBookableStock",
    value: function getBookableStock() {
      if (this.get('unlimitedStock')) {
        return null;
      }
      return this.get('bookableStock');
    }
  }, {
    key: "isPassed",
    value: function isPassed() {
      if (!this.startDate) {
        return false;
      }
      var tz = this.getIn(['ticketing', 'timezone']);
      if (!tz) {
        return this.startDate < moment();
      }

      /** @ts-expect-error -- conflict between moment and moment-timezone */
      return this.startDate.clone().tz(tz) < moment().tz(tz);
    }

    /**
     * @deprecated
     */
  }, {
    key: "getLocalStartDate",
    value: function getLocalStartDate() {
      if (!this.startDate) {
        return null;
      }
      var tz = this.getIn(['ticketing', 'timezone']);
      if (!tz) {
        return null;
      }

      /** @ts-expect-error -- timezone issue with moment */
      return this.startDate.clone().tz(tz);
    }

    /**
     * @deprecated
     */
  }, {
    key: "getLocalEndDate",
    value: function getLocalEndDate() {
      if (!this.endDate) {
        return null;
      }
      var tz = this.getIn(['ticketing', 'timezone']);
      if (!tz) {
        return null;
      }

      /** @ts-expect-error -- timezone issue with moment */
      return this.endDate.clone().tz(tz);
    }

    /**
     * @deprecated
     */
  }, {
    key: "getLocalStartOfEventDay",
    value: function getLocalStartOfEventDay() {
      if (!this.startOfEventDay) {
        return null;
      }
      var tz = this.getIn(['ticketing', 'timezone']);
      if (!tz) {
        return null;
      }

      /** @ts-expect-error -- timezone issue with moment */
      return this.startOfEventDay.clone().tz(tz);
    }

    /**
     * @deprecated
     */
  }, {
    key: "getLocalEndOfEventDay",
    value: function getLocalEndOfEventDay() {
      if (!this.endOfEventDay) {
        return null;
      }
      var tz = this.getIn(['ticketing', 'timezone']);
      if (!tz) {
        return null;
      }

      /** @ts-expect-error -- timezone issue with moment */
      return this.endOfEventDay.clone().tz(tz);
    }

    /**
     * @deprecated
     */
  }, {
    key: "getLocalSaleStartDate",
    value: function getLocalSaleStartDate() {
      if (!this.saleStartDate) {
        return null;
      }
      var tz = this.getIn(['ticketing', 'timezone']);
      if (!tz) {
        return null;
      }

      /** @ts-expect-error -- timezone issue with moment */
      return this.saleStartDate.clone().tz(tz);
    }

    /**
     * @deprecated
     */
  }, {
    key: "getLocalSaleEndDate",
    value: function getLocalSaleEndDate() {
      if (!this.saleEndDate) {
        return null;
      }
      var tz = this.getIn(['ticketing', 'timezone']);
      if (!tz) {
        return null;
      }

      /** @ts-expect-error -- timezone issue with moment */
      return this.saleEndDate.clone().tz(tz);
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'EventDate',
  unlimitedStock: true,
  totalStock: null,
  baseStock: null,
  overbookingStock: undefined,
  overbookedStock: undefined,
  manuallySetStock: null,
  bookableStock: null,
  occupiedStock: undefined,
  notInStockContingentBookableStock: null,
  contingentBookableStock: null,
  remainingStock: null,
  startDate: null,
  endDate: null,
  startOfEventDay: null,
  endOfEventDay: null,
  saleStartDate: null,
  saleEndDate: null,
  ticketing: new Ticketing(),
  eventDatePattern: new EventDatePattern(),
  ticketPriceList: List(),
  availableSeatList: List(),
  stockContingentList: null,
  status: null,
  type: null,
  logicalSeatConfig: null,
  seatConfig: null,
  seatingName: null,
  createdAt: null,
  updatedAt: null,
  soldTickets: 0,
  bookedTickets: 0,
  importedTickets: 0,
  reservedTickets: 0,
  reservedFreeTickets: undefined,
  refundedTickets: 0,
  soldTicketsExStock: undefined,
  refundedTicketsExStock: undefined,
  issuedTicketsExStock: undefined,
  bookedTicketsExStock: undefined,
  reservedTicketsExStock: undefined,
  bookedItems: undefined,
  reservedItems: undefined,
  bookedItemsExStock: undefined,
  reservedItemsExStock: undefined,
  soldItems: undefined,
  refundedItems: undefined,
  issuedItems: undefined,
  soldItemsExStock: undefined,
  refundedItemsExStock: undefined,
  issuedItemsExStock: undefined,
  nbActiveSeats: null,
  dismissedStockContingentStock: undefined,
  turnover: Map$1(),
  onSale: false,
  hasTicketPriceOnSale: false,
  onSaleDemoMode: false,
  issuedTickets: 0,
  issuedFreeTickets: undefined,
  notOnSaleReasons: List(),
  dynamic: false,
  scannedTicketCount: null,
  isReservableOnline: null,
  isNumberedSeating: null,
  availabilityStatus: undefined,
  representationNumber: null,
  isRepresentationNumberManuallyFixed: null,
  uniqueBookingOriginEntity: null,
  bookingOriginEntityCount: null,
  issuedGroupTickets: null,
  reservedGroupTickets: null,
  pendingOptionTickets: null,
  groupOrderCount: null,
  groupReservationCount: null,
  pendingOptionCount: null,
  hasOrderItems: null,
  orderIncome: undefined,
  reservationIncome: undefined,
  isOverbooked: undefined,
  providerExportedTicketPriceCount: undefined
}));
EventDate.classMetadata = new ClassMetadata('eventDate', 'event_dates', /** @ts-expect-error -- method signature are incompatible */
EventDateClient);
EventDate.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('unlimitedStock', 'unlimitedStock', 'boolean'), new Attribute('totalStock', 'totalStock', 'integer'), new Attribute('baseStock', 'baseStock', 'integer'), new Attribute('overbookingStock', 'overbookingStock', 'integer'), new Attribute('overbookedStock', 'overbookedStock', 'integer'), new Attribute('manuallySetStock', 'manuallySetStock', 'boolean'), new Attribute('bookableStock', 'bookableStock', 'integer'), new Attribute('occupiedStock', 'occupiedStock', 'integer'), new Attribute('notInStockContingentBookableStock', 'notInStockContingentBookableStock', 'integer'), new Attribute('contingentBookableStock', 'contingentBookableStock', 'object'), new Attribute('remainingStock', 'remainingStock', 'integer'), new Attribute('startDate', 'startDate', 'datetime'), new Attribute('endDate', 'endDate', 'datetime'), new Attribute('saleStartDate', 'saleStartDate', 'datetime'), new Attribute('saleEndDate', 'saleEndDate', 'datetime'), new Attribute('status'), new Attribute('availabilityStatus'), new Attribute('type'), new Attribute('seatingName'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('updatedAt', 'updatedAt', 'datetime'), new Attribute('soldTickets', 'soldTickets', 'integer'), new Attribute('refundedTickets', 'refundedTickets', 'integer'), new Attribute('issuedTickets', 'issuedTickets', 'integer'), new Attribute('soldTicketsExStock', 'soldTicketsExStock', 'integer'), new Attribute('refundedTicketsExStock', 'refundedTicketsExStock', 'integer'), new Attribute('issuedTicketsExStock', 'issuedTicketsExStock', 'integer'), new Attribute('bookedTickets', 'bookedTickets', 'integer'), new Attribute('reservedTickets', 'reservedTickets', 'integer'), new Attribute('bookedTicketsExStock', 'bookedTicketsExStock', 'integer'), new Attribute('reservedTicketsExStock', 'reservedTicketsExStock', 'integer'), new Attribute('bookedItems', 'bookedItems', 'integer'), new Attribute('reservedItems', 'reservedItems', 'integer'), new Attribute('bookedItemsExStock', 'bookedItemsExStock', 'integer'), new Attribute('reservedItemsExStock', 'reservedItemsExStock', 'integer'), new Attribute('soldItems', 'soldItems', 'integer'), new Attribute('refundedItems', 'refundedItems', 'integer'), new Attribute('issuedItems', 'issuedItems', 'integer'), new Attribute('soldItemsExStock', 'soldItemsExStock', 'integer'), new Attribute('refundedItemsExStock', 'refundedItemsExStock', 'integer'), new Attribute('issuedItemsExStock', 'issuedItemsExStock', 'integer'), new Attribute('importedTickets', 'importedTickets', 'integer'), new Attribute('nbActiveSeats', 'nbActiveSeats', 'integer'), new Attribute('bookingOriginEntityCount', 'bookingOriginEntityCount', 'integer'), new Attribute('dismissedStockContingentStock', 'dismissedStockContingentStock', 'integer'), new Attribute('onSale', 'onSale', 'boolean'), new Attribute('hasTicketPriceOnSale', 'hasTicketPriceOnSale', 'boolean'), new Attribute('onSaleDemoMode', 'onSaleDemoMode', 'boolean'), new Attribute('issuedTickets', 'issuedTickets', 'integer'), new Attribute('notOnSaleReasons', 'notOnSaleReasons', 'array'), new Attribute('dynamic', 'dynamic', 'boolean'), new Attribute('isReservableOnline', 'isReservableOnline', 'boolean'), new Attribute('isNumberedSeating', 'isNumberedSeating', 'boolean'), new Attribute('scannedTicketCount', 'scannedTicketCount', 'integer'), new Attribute('representationNumber', 'representationNumber', 'integer'), new Attribute('isRepresentationNumberManuallyFixed', 'isRepresentationNumberManuallyFixed', 'boolean'), new Attribute('issuedGroupTickets', 'issuedGroupTickets', 'integer'), new Attribute('reservedGroupTickets', 'reservedGroupTickets', 'integer'), new Attribute('pendingOptionTickets', 'pendingOptionTickets', 'integer'), new Attribute('groupOrderCount', 'groupOrderCount', 'integer'), new Attribute('groupReservationCount', 'groupReservationCount', 'integer'), new Attribute('pendingOptionCount', 'pendingOptionCount', 'integer'), new Attribute('hasOrderItems', 'hasOrderItems', 'boolean'), new Attribute('reservedFreeTickets', 'reservedFreeTickets', 'integer'), new Attribute('issuedFreeTickets', 'issuedFreeTickets', 'integer'), new Attribute('orderIncome', 'orderIncome', 'integer'), new Attribute('reservationIncome', 'reservationIncome', 'integer'), new Attribute('isOverbooked', 'isOverbooked', 'boolean'), new Attribute('providerExportedTicketPriceCount', 'providerExportedTicketPriceCount', 'integer')]);
EventDate.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'availableSeat', 'availableSeatList'), new Relation(Relation.MANY_TO_ONE, 'ticketing', 'ticketing'), new Relation(Relation.MANY_TO_ONE, 'eventDatePattern', 'eventDatePattern'), new Relation(Relation.ONE_TO_MANY, 'ticketPrice', 'ticketPriceList'), new Relation(Relation.MANY_TO_ONE, 'logicalSeatConfig', 'logicalSeatConfig'), new Relation(Relation.MANY_TO_ONE, 'seatConfig', 'seatConfig'), new Relation(Relation.ONE_TO_MANY, 'stockContingent', 'stockContingentList'), new Relation(Relation.MANY_TO_ONE, 'cart', 'uniqueBookingOriginEntity'), new Relation(Relation.MANY_TO_ONE, 'order', 'uniqueBookingOriginEntity')]);

var EVENT_DATE_OPTION_STATUS = /*#__PURE__*/function (EVENT_DATE_OPTION_STATUS) {
  EVENT_DATE_OPTION_STATUS["APPROVED"] = "approved";
  EVENT_DATE_OPTION_STATUS["REJECTED"] = "rejected";
  EVENT_DATE_OPTION_STATUS["PENDING"] = "pending";
  return EVENT_DATE_OPTION_STATUS;
}({});
var EventDateOptionStatus = /*#__PURE__*/function (_Record) {
  function EventDateOptionStatus(val) {
    _classCallCheck(this, EventDateOptionStatus);
    var data = clone(val);
    if (_typeof(data.requestedParticipantNbPerTicketPriceHash) === 'object' && data.requestedParticipantNbPerTicketPriceHash !== null) {
      data.requestedParticipantNbPerTicketPriceHash = Map$1(data.requestedParticipantNbPerTicketPriceHash);
    }
    if (_typeof(data.requestedParticipantNbPerContingent) === 'object' && data.requestedParticipantNbPerContingent !== null) {
      data.requestedParticipantNbPerContingent = Map$1(data.requestedParticipantNbPerContingent);
    }
    if (_typeof(data.requestedEventDate) === 'object' && data.requestedEventDate !== null) {
      data.requestedEventDate = new EventDate(data.requestedEventDate);
    }
    if (_typeof(data.approvedEventDate) === 'object' && data.approvedEventDate !== null) {
      data.approvedEventDate = new EventDate(data.approvedEventDate);
    }
    return _callSuper(this, EventDateOptionStatus, [data]);
  }
  _inherits(EventDateOptionStatus, _Record);
  return _createClass(EventDateOptionStatus);
}(Record({
  status: undefined,
  requestedEventDate: undefined,
  approvedEventDate: undefined,
  requestedParticipantNb: undefined,
  approvedParticipantNb: undefined,
  requestedParticipantNbPerTicketPriceHash: undefined,
  requestedParticipantNbPerContingent: undefined
}));

var Cart = /*#__PURE__*/function (_NetworkEntity) {
  function Cart() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Cart'
    };
    var registry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    _classCallCheck(this, Cart);
    var data = clone(val);
    data.eventDateOptionStatusList = val.eventDateOptionStatusList ? List(val.eventDateOptionStatusList.map(function (eventDateOptionStatus) {
      return new EventDateOptionStatus(eventDateOptionStatus);
    })) : null;
    data.cartItemWithOfferList = val.cartItemWithOfferList && val.cartItemWithOfferList.map(function (ciwo) {
      if (typeof ciwo === 'string') {
        throw new Error('CartItemWithOffer should not be a string. This should not happen.');
      }
      return new CartItemWithOffer(ciwo);
    });

    // TODO : this should be done in mapEntityRelationShips. Please remove this and test it.
    data.cartItemList = val.cartItemList ? List(val.cartItemList.map(function (cartItem) {
      if (typeof cartItem === 'string') {
        return cartItem;
      }
      return new CartItem(cartItem, registry);
    })) : List();
    data.createdAt = parseDate(data.createdAt, null);
    data.updatedAt = parseDate(data.updatedAt, null);
    data.notifiedAt = parseDate(data.notifiedAt, null);
    data.formData = getFormData(data);
    _this = _callSuper(this, Cart, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data, registry));
  }
  _inherits(Cart, _NetworkEntity);
  return _createClass(Cart, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/carts/', '')) || '';
    }
  }, {
    key: "getLocalCreatedAt",
    value: function getLocalCreatedAt() {
      if (this.cartItemList && this.cartItemList.size > 0) {
        var firstCartItem = this.cartItemList.first();
        if (typeof firstCartItem !== 'string') {
          var _this$createdAt;
          var tz = firstCartItem === null || firstCartItem === void 0 ? void 0 : firstCartItem.getIn(['ticketPrice', 'eventDate', 'ticketing', 'timezone']);

          /** @ts-expect-error -- issue with moment & moment-timezone */
          return (_this$createdAt = this.createdAt) === null || _this$createdAt === void 0 ? void 0 : _this$createdAt.clone().tz(tz);
        }
      }

      // if no cartItems, fallback to utc time
      return this.createdAt;
    }
  }, {
    key: "isReservableOnline",
    value: function isReservableOnline() {
      if (!this.cartItemList || this.cartItemList.size === 0) {
        return false;
      }
      return this.cartItemList.every(function (cartItem) {
        if (typeof cartItem === 'string') {
          throw new Error('Unable to know if a cart is reservable online with cart item as string. Check that your cart entity does contain only CartItem instance.');
        }
        return cartItem.getIn(['ticketPrice', 'eventDate', 'isReservableOnline']);
      });
    }
  }, {
    key: "getGdprMessage",
    value: function getGdprMessage() {
      assertRelationIsListOfObject(this.organizationalUnitList);
      var gdprOptinMessage = this.organizationalUnitList.map(function (organizationUnit) {
        return organizationUnit.get('gdprOptinMessage');
      }).filter(function (message) {
        return !!message && message.length > 0;
      }).toSet().join(', ');
      return gdprOptinMessage && gdprOptinMessage.length > 0 ? gdprOptinMessage : null;
    }
  }, {
    key: "getFormCustomerFields",
    value: function getFormCustomerFields() {
      var _this2 = this;
      var disabledFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var optionalFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.customerRequiredFields) {
        throw new Error('CustomerRequiredFields must be defined. Please check your request fields.');
      }
      var customerRequiredFields = this.customerRequiredFields.toJS();
      var formattedFieldList = customerRequiredFields.map(function (field) {
        var _this2$formData, _field$slug;
        var fieldWithFormattedKey = Object.keys(field).reduce(function (acc, key) {
          var formattedKey = key.startsWith('form') ? key.replace('form', '').toLowerCase() : key;
          return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, formattedKey, field[key]));
        }, field);
        var fieldOptions = field.options ? _objectSpread2(_objectSpread2({}, field.options), {}, {
          inputProps: _objectSpread2(_objectSpread2({}, field.options.inputProps), {}, {
            disabled: disabledFields,
            allowCreate: false
          }),
          options: addMissingOptionToFieldOptions(field.options.options, field.slug ? (_this2$formData = _this2.formData) === null || _this2$formData === void 0 ? void 0 : _this2$formData.get(field.slug) : null),
          isRequired: optionalFields ? false : field.required
        }) : {
          inputProps: {
            disabled: disabledFields,
            allowCreate: false
          },
          isRequired: optionalFields ? false : field.required
        };
        return _objectSpread2(_objectSpread2({}, fieldWithFormattedKey), {}, {
          label: (_field$slug = field.slug) !== null && _field$slug !== void 0 && _field$slug.includes('optinEmailInfo') ? _this2.getGdprMessage() : field.label,
          name: field.slug,
          options: fieldOptions
        });
      });
      return formattedFieldList;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Cart',
  comment: null,
  currency: '',
  customer: new Customer(),
  contact: null,
  cartItemList: List(),
  cartItemWithOfferList: null,
  contractList: List(),
  organizationalUnitList: List(),
  ticketList: List(),
  nbTickets: null,
  bookingList: List(),
  createdAt: null,
  updatedAt: null,
  deletedAt: null,
  expiresAt: null,
  notifiedAt: null,
  bookTickets: true,
  orderList: List(),
  originType: '',
  originId: null,
  customerPaidAmount: null,
  customerPaidAmountWithoutOffer: null,
  retailValue: null,
  facialValue: null,
  facialFeeValue: null,
  totalItemNumber: undefined,
  totalTicketNumber: null,
  reservationName: null,
  couponCode: null,
  couponCodeList: null,
  couponValidityMap: Map$1(),
  coupon: new Coupon(),
  couponList: null,
  customerRequiredFields: null,
  walletList: List(),
  tagList: List(),
  sellingDevice: null,
  parent: null,
  type: null,
  isOption: null,
  computedBookingTrack: null,
  option: null,
  reservation: null,
  eventDateOptionStatusList: null,
  status: null,
  appliedCouponList: null,
  createdCouponList: null,
  /**
   * formData is a helper that does not exist in the API, but help the front to handle customer and organization form data
   */
  formData: null,
  providerExportedCartList: null,
  hasMovableSeats: null,
  owner: undefined,
  schoolMode: null,
  shouldCompensateOnSwap: null,
  swapAmount: undefined
}));
/** @ts-expect-error -- method signature are incompatible */
Cart.classMetadata = new ClassMetadata('cart', 'carts', CartClient);
Cart.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('comment'), new Attribute('currency'), new Attribute('cartItemWithOfferList', 'cartItemWithOfferList', 'object'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('updatedAt', 'updatedAt', 'datetime'), new Attribute('deletedAt', 'deletedAt', 'datetime'), new Attribute('expiresAt', 'expiresAt', 'datetime'), new Attribute('notifiedAt', 'notifiedAt', 'datetime'), new Attribute('bookTickets', 'bookTickets', 'boolean'), new Attribute('originType'), new Attribute('originId'), new Attribute('customerPaidAmount', 'customerPaidAmount', 'integer'), new Attribute('customerPaidAmountWithoutOffer', 'customerPaidAmountWithoutOffer', 'integer'), new Attribute('retailValue', 'retailValue', 'integer'), new Attribute('totalItemNumber', 'totalItemNumber', 'integer'), new Attribute('totalTicketNumber', 'totalTicketNumber', 'integer'), new Attribute('reservationName'), new Attribute('couponList', 'couponList', 'object'), new Attribute('couponCode'), new Attribute('couponCodeList', 'couponCodeList', 'object'), new Attribute('couponValidityMap', 'couponValidityMap', 'object'), new Attribute('customerRequiredFields', 'customerRequiredFields', 'object'), new Attribute('parent'), new Attribute('nbTickets', 'nbTickets', 'integer'), new Attribute('type'), new Attribute('isOption', 'isOption', 'boolean'), new Attribute('eventDateOptionStatusList', 'eventDateOptionStatusList', 'array'), new Attribute('status'), new Attribute('providerExportedCartList', 'providerExportedCartList', 'object'), new Attribute('hasMovableSeats', 'hasMovableSeats', 'boolean'), new Attribute('schoolMode', 'schoolMode', 'boolean'), new Attribute('shouldCompensateOnSwap', 'shouldCompensateOnSwap', 'boolean'), new Attribute('swapAmount', 'swapAmount', 'integer')]);
Cart.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'cartItem', 'cartItemList'), new Relation(Relation.ONE_TO_MANY, 'tag', 'tagList'), new Relation(Relation.ONE_TO_MANY, 'ticket', 'ticketList'), new Relation(Relation.ONE_TO_MANY, 'booking', 'bookingList'), new Relation(Relation.ONE_TO_MANY, 'order', 'orderList'), new Relation(Relation.MANY_TO_ONE, 'customer', 'customer'), new Relation(Relation.MANY_TO_ONE, 'customer', 'contact'), new Relation(Relation.MANY_TO_ONE, 'coupon', 'coupon'), new Relation(Relation.MANY_TO_ONE, 'wallet', 'wallet'), new Relation(Relation.ONE_TO_MANY, 'contract', 'contractList'), new Relation(Relation.ONE_TO_MANY, 'organizationalUnit', 'organizationalUnitList'), new Relation(Relation.MANY_TO_ONE, 'sellingDevice', 'sellingDevice'), new Relation(Relation.MANY_TO_ONE, 'bookingTrack', 'bookingTrack'), new Relation(Relation.ONE_TO_ONE, 'cart', 'option'), new Relation(Relation.ONE_TO_ONE, 'cart', 'reservation'), new Relation(Relation.ONE_TO_MANY, 'coupon', 'appliedCouponList'), new Relation(Relation.ONE_TO_MANY, 'coupon', 'createdCouponList'), new Relation(Relation.ONE_TO_MANY, 'providerExportedCart', 'providerExportedCartList'), new Relation(Relation.MANY_TO_ONE, 'ticketingUser', 'owner')]);

var TicketPriceClient = /*#__PURE__*/function (_HidableClient) {
  function TicketPriceClient() {
    _classCallCheck(this, TicketPriceClient);
    return _callSuper(this, TicketPriceClient, arguments);
  }
  _inherits(TicketPriceClient, _HidableClient);
  return _createClass(TicketPriceClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/ticket_prices';
    }
  }, {
    key: "updateManualSort",
    value: function updateManualSort(ticketPrice, fields) {
      var uri = new URI("".concat(this.getPathBase(), "/").concat(ticketPrice.getShortId()));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.authorizedFetch(uri, {
        method: 'PUT',
        body: JSON.stringify({
          '@id': ticketPrice.get('@id'),
          manualSort: ticketPrice.manualSort
        })
      }).then(function (response) {
        return response.json();
      }).then(function (tp) {
        return createEntity(tp);
      });
    }
  }, {
    key: "checkVatRate",
    value: function checkVatRate(ticketPrice) {
      var uri;
      var method;
      if (ticketPrice.get('@id')) {
        uri = new URI("".concat(this.getPathBase(), "/").concat(ticketPrice.getShortId(), "/check-vat-rate"));
        method = 'PUT';
      } else {
        uri = new URI("".concat(this.getPathBase(), "/check-vat-rate"));
        method = 'POST';
      }
      var eventDate = ticketPrice.eventDate;
      // eslint-disable-next-line eqeqeq
      if (ticketPrice.getIn(['eventDate', '@id']) != null) {
        eventDate = ticketPrice.getIn(['eventDate', '@id']);
      }
      var eventDatePattern = ticketPrice.eventDatePattern;
      // eslint-disable-next-line eqeqeq
      if (ticketPrice.getIn(['eventDatePattern', '@id']) != null) {
        eventDatePattern = ticketPrice.getIn(['eventDatePattern', '@id']);
      }
      var wallet = ticketPrice.wallet;
      // eslint-disable-next-line eqeqeq
      if (ticketPrice.getIn(['wallet', '@id']) != null) {
        wallet = ticketPrice.getIn(['wallet', '@id']);
      }
      return this.authorizedFetch(uri, {
        method: method,
        body: JSON.stringify({
          '@id': ticketPrice.get('@id'),
          tax: ticketPrice.tax,
          eventDate: eventDate,
          eventDatePattern: eventDatePattern,
          facialValue: ticketPrice.facialValue,
          wallet: wallet
        })
      });
    }
  }, {
    key: "massCreate",
    value: function massCreate(ticketPrice, fields) {
      if (!ticketPrice.eventDate) {
        throw new Error('Unable to call `massCreate` on a ticket price without event date');
      }
      var uri = new URI("".concat(getEntityId$1(ticketPrice.eventDate), "/ticket_prices/multiple?ticketPriceId=").concat(ticketPrice.get('@id')));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.authorizedFetch(uri, {
        method: 'POST'
      });
    }
  }, {
    key: "massUpdate",
    value: function massUpdate(ticketPrice, hash, fields) {
      if (!ticketPrice.eventDate) {
        throw new Error('Unable to call `massCreate` on a ticket price without event date');
      }
      var uri = new URI("".concat(getEntityId$1(ticketPrice.eventDate), "/ticket_prices/multiple?hash=").concat(hash, "&ticketPriceId=").concat(ticketPrice.get('@id')));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.authorizedFetch(uri, {
        method: 'PUT'
      });
    }
  }, {
    key: "massUpdateVatRateList",
    value: function massUpdateVatRateList(mapList) {
      var _this = this;
      var promiseList = mapList.map(function (map) {
        var ticketPriceId = map.get('ticketPriceId');
        var taxId = map.get('taxId');
        var hash = map.get('hash');
        if (!hash) {
          throw new Error('Unable to call `massUpdateVatRateList` with an empty hash');
        }
        return _this.authorizedFetch(new URI("".concat(ticketPriceId, "?fields=@id,hash,eventDate{@id},eventDatePattern")), {
          method: 'PUT',
          body: JSON.stringify({
            '@id': ticketPriceId,
            tax: taxId
          })
        }).then(function (response) {
          return response.json();
        }).then(function (tp) {
          return createEntity(tp);
        }).then(function (ticketPrice) {
          var eventDateId = ticketPrice.getIn(['eventDate', '@id']);
          var eventDatePatternId = ticketPrice.get('eventDatePattern');
          if (eventDateId) {
            return _this.massUpdate(ticketPrice, hash, ['@id']);
          }
          if (eventDatePatternId) {
            return Promise.resolve();
          }
        });
      });
      return Promise.all(promiseList);
    }
  }, {
    key: "massDelete",
    value: function massDelete(ticketPrice, fields) {
      if (!ticketPrice.eventDate) {
        throw new Error('Unable to call `massCreate` on a ticket price without event date');
      }
      var uri = new URI("".concat(getEntityId$1(ticketPrice.eventDate), "/ticket_prices/multiple?hash=").concat(ticketPrice.hash));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.authorizedFetch(uri, {
        method: 'DELETE'
      });
    }
  }, {
    key: "findFrequentlyUsed",
    value: function findFrequentlyUsed(criteria, fields) {
      var uri = new URI("".concat(this.getPathBase(), "/frequently-used"));
      var params = this._mergeFieldsIntoParams(criteria, fields);
      uri.addSearch(params);
      return this.deserializeResponse(this.authorizedFetch(uri), 'list');
    }
  }]);
}(HidableClient);

var Tax = /*#__PURE__*/function (_NetworkEntity) {
  function Tax() {
    _classCallCheck(this, Tax);
    return _callSuper(this, Tax, arguments);
  }
  _inherits(Tax, _NetworkEntity);
  return _createClass(Tax, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/taxes/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Tax',
  rate: 0,
  countryCode: ''
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Tax.classMetadata = new ClassMetadata('tax', 'taxes', AbstractClient);
Tax.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('rate', 'rate', 'float'), new Attribute('countryCode')]);

var WalletClient = /*#__PURE__*/function (_AbstractClient) {
  function WalletClient() {
    _classCallCheck(this, WalletClient);
    return _callSuper(this, WalletClient, arguments);
  }
  _inherits(WalletClient, _AbstractClient);
  return _createClass(WalletClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/wallets';
    }
  }, {
    key: "findByContractList",
    value: function findByContractList(contractList, fields) {
      return this.findBy({
        contract: contractList
      }, fields);
    }
  }, {
    key: "getWalletPaylinePdf",
    value: function getWalletPaylinePdf(id) {
      var url = "/v1/wallets/".concat(id, "/payline.pdf");
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "updateWithStripeAuthCode",
    value: function updateWithStripeAuthCode(wallet, authCode, fields) {
      var uri = new URI("".concat(this.getPathBase(), "/").concat(wallet.getShortId(), "/stripe-auth-code/").concat(authCode));
      var params = this._mergeFieldsIntoParams({}, fields);
      uri.addSearch(params);
      return this.deserializeResponse(this.authorizedFetch(uri, {
        method: 'PUT'
      }), 'item');
    }
  }]);
}(AbstractClient);

var ContractClient = /*#__PURE__*/function (_AbstractClient) {
  function ContractClient() {
    _classCallCheck(this, ContractClient);
    return _callSuper(this, ContractClient, arguments);
  }
  _inherits(ContractClient, _AbstractClient);
  return _createClass(ContractClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/contracts';
    }
  }, {
    key: "getContractualDocument",
    value: function getContractualDocument(documentType, id) {
      switch (documentType) {
        case DOCUMENT_GDPR:
          return this.getPdfContractGdpr(id);
        case DOCUMENT_ADDENDUM:
          return this.getPdfContractAddendum(id, null);
        case DOCUMENT_CONFORMITY:
          return this.getPdfConformity(id);
        case DOCUMENT_CONTRACT:
        default:
          return this.getPdfContract(id);
      }
    }
  }, {
    key: "getPdfConformity",
    value: function getPdfConformity(id) {
      var url = "/v1/accountability/conformity-attestation/".concat(id, ".pdf");
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getPdfContract",
    value: function getPdfContract(id) {
      var url = "/v1/contracts/".concat(id, "/contracts.pdf");
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getPdfContractAddendum",
    value: function getPdfContractAddendum(id, idAddendum) {
      var url = "/v1/contracts/".concat(id, "/addendum.pdf");
      if (idAddendum) {
        url = "/v1/contracts/".concat(id, "/addendum-").concat(idAddendum, ".pdf");
      }
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getPdfContractGdpr",
    value: function getPdfContractGdpr(id) {
      var url = "/v1/contracts/".concat(id, "/gdpr.pdf");
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "purgeSchoolMode",
    value: function purgeSchoolMode(id) {
      var url = "/v1/contracts/".concat(id, "/purge-school-mode");
      return this.authorizedFetch(url, {
        method: 'POST'
      });
    }
  }]);
}(AbstractClient);

var DOCUMENT_CONTRACT = 'contract';
var DOCUMENT_GDPR = 'gdpr';
var DOCUMENT_ADDENDUM = 'addendum';
var DOCUMENT_CONFORMITY = 'conformity';
var VAT_EXIGIBILITY = /*#__PURE__*/function (VAT_EXIGIBILITY) {
  VAT_EXIGIBILITY["INVOICE_DATE"] = "invoice_date";
  VAT_EXIGIBILITY["PAYMENT_DATE"] = "payment_date";
  return VAT_EXIGIBILITY;
}({});

// those fields are mandatory, if "fields" is given, then the value of "title" will be a non-nullable string
var Contract = /*#__PURE__*/function (_NetworkEntity) {
  function Contract() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Contract'
    };
    _classCallCheck(this, Contract);
    var data = clone(val);
    data.currentAccountabilityPeriodStartDate = parseDate(data.currentAccountabilityPeriodStartDate, data.timezone);
    data.currentAccountabilityPeriodEndDate = parseDate(data.currentAccountabilityPeriodEndDate, data.timezone);
    _this = _callSuper(this, Contract, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Contract, _NetworkEntity);
  return _createClass(Contract, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/contracts/', '')) || '';
    }
  }, {
    key: "getLocalCurrentAccountabilityPeriodStartDate",
    value: function getLocalCurrentAccountabilityPeriodStartDate() {
      if (!this.currentAccountabilityPeriodStartDate) {
        return null;
      }
      var tz = this.timezone;
      if (!tz) {
        return null;
      }
      return this.currentAccountabilityPeriodStartDate.clone().tz(tz);
    }
  }, {
    key: "getLocalCurrentAccountabilityPeriodEndDate",
    value: function getLocalCurrentAccountabilityPeriodEndDate() {
      if (!this.currentAccountabilityPeriodEndDate) {
        return null;
      }
      var tz = this.timezone;
      if (!tz) {
        return null;
      }
      return this.currentAccountabilityPeriodEndDate.clone().tz(tz);
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Contract',
  status: 'waiting',
  companyName: '',
  defaultCurrency: null,
  companyDisplayName: null,
  publicContactEmail: '',
  companyLegalForm: null,
  companyVatNumber: '',
  companyRecordNumber: '',
  companyRecordPlace: '',
  companyCapital: '',
  companyAddress: '',
  companyCountry: '',
  companyPostalCode: '',
  companyCity: '',
  companyType: null,
  legalRepresentativeLastName: '',
  legalRepresentativeFirstName: '',
  legalRepresentativeStatus: '',
  timezone: null,
  hideFees: undefined,
  notifyOnNewOrderSuccess: false,
  ticketSwapConfig: null,
  isSigned: false,
  offerRuleList: List(),
  seatConfigList: List(),
  logicalSeatConfigList: List(),
  seatGroupList: List(),
  sellingDeviceList: List(),
  walletList: List(),
  minisiteList: List(),
  providerTicketCredentialsList: List(),
  customerRequiredFields: Map$1(),
  gdprOptinMessage: null,
  templateParameters: Map$1(),
  customerFieldContractList: List(),
  deviceStateList: List(),
  deskPaymentMethodList: List(),
  tagList: List(),
  additionalInformation: Map$1(),
  currentAccountabilityPeriodStartDate: null,
  currentAccountabilityPeriodEndDate: null,
  mailAdditionalInformation: null,
  locale: null,
  billingContactEmail: '',
  orderNotificationEmailList: null,
  isOnboarded: null,
  onboardingData: Map$1(),
  paymentFee: null,
  customerStatusList: null,
  ticketingCategoryList: null,
  contractAddendumList: null,
  organizationalUnitList: List(),
  saleSessionEndTime: null,
  features: null,
  isOpeningCashEnabled: null,
  defaultOpeningCash: null,
  accountingParameters: null,
  schoolMode: null
}));
Contract.classMetadata = new ClassMetadata('contract', 'contracts', /** @ts-expect-error -- method signature are incompatible */
ContractClient);
Contract.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('status'), new Attribute('companyName'), new Attribute('defaultCurrency'), new Attribute('companyLegalForm'), new Attribute('companyDisplayName'), new Attribute('companyType'), new Attribute('companyRecordPlace'), new Attribute('companyRecordNumber'), new Attribute('companyCapital'), new Attribute('companyAddress'), new Attribute('companyCountry'), new Attribute('billingContactEmail'), new Attribute('orderNotificationEmailList'), new Attribute('mailAdditionalInformation'), new Attribute('publicContactEmail'), new Attribute('companyPostalCode'), new Attribute('companyCity'), new Attribute('companyVatNumber'), new Attribute('legalRepresentativeLastName'), new Attribute('legalRepresentativeFirstName'), new Attribute('legalRepresentativeStatus'), new Attribute('timezone'), new Attribute('hideFees', 'hideFees', 'boolean'), new Attribute('notifyOnNewOrderSuccess', 'notifyOnNewOrderSuccess', 'boolean'), new Attribute('isSigned', 'isSigned', 'boolean'), new Attribute('customerRequiredFields', 'customerRequiredFields', 'object'), new Attribute('gdprOptinMessage'), new Attribute('templateParameters', 'templateParameters', 'object'), new Attribute('additionalInformation', 'additionalInformation', 'object'), new Attribute('locale'), new Attribute('isOnboarded', 'isOnboarded', 'boolean'), new Attribute('onboardingData', 'onboardingData', 'object'), new Attribute('currentAccountabilityPeriodStartDate', 'currentAccountabilityPeriodStartDate', 'datetime'), new Attribute('currentAccountabilityPeriodEndDate', 'currentAccountabilityPeriodEndDate', 'datetime'), new Attribute('saleSessionEndTime'), new Attribute('isOpeningCashEnabled', 'isOpeningCashEnabled', 'boolean'), new Attribute('defaultOpeningCash', 'defaultOpeningCash', 'integer'), new Attribute('accountingParameters', 'accountingParameters', 'object'), new Attribute('schoolMode', 'schoolMode', 'boolean')]);
Contract.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'offerRule', 'offerRuleList'), new Relation(Relation.ONE_TO_MANY, 'seatConfig', 'seatConfigList'), new Relation(Relation.ONE_TO_MANY, 'logicalSeatConfig', 'logicalSeatConfigList'), new Relation(Relation.ONE_TO_MANY, 'seatGroup', 'seatGroupList'), new Relation(Relation.ONE_TO_MANY, 'sellingDevice', 'sellingDeviceList'), new Relation(Relation.ONE_TO_MANY, 'wallet', 'walletList'), new Relation(Relation.MANY_TO_ONE, 'paymentFee', 'paymentFee'), new Relation(Relation.ONE_TO_MANY, 'customerFieldContract', 'customerFieldContractList'), new Relation(Relation.ONE_TO_MANY, 'deskPaymentMethod', 'deskPaymentMethodList'), new Relation(Relation.ONE_TO_MANY, 'tag', 'tagList'), new Relation(Relation.ONE_TO_MANY, 'minisite', 'minisiteList'), new Relation(Relation.ONE_TO_MANY, 'providerTicketCredentials', 'providerTicketCredentialsList'), new Relation(Relation.ONE_TO_MANY, 'customerStatus', 'customerStatusList'), new Relation(Relation.ONE_TO_MANY, 'deviceState', 'deviceStateList'), new Relation(Relation.ONE_TO_MANY, 'contractAddendum', 'contractAddendumList'), new Relation(Relation.ONE_TO_MANY, 'organizationalUnit', 'organizationalUnitList'), new Relation(Relation.ONE_TO_ONE, 'feature', 'features'), new Relation(Relation.ONE_TO_ONE, 'ticketSwapConfig', 'ticketSwapConfig')]);

var Wallet = /*#__PURE__*/function (_NetworkEntity) {
  function Wallet() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Wallet'
    };
    _classCallCheck(this, Wallet);
    _this = _callSuper(this, Wallet, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Wallet, _NetworkEntity);
  return _createClass(Wallet, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/wallets/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Wallet',
  contract: new Contract(),
  ticketPriceList: List(),
  provider: null,
  providerContractNumber: null,
  providerMetadata: Map$1(),
  currency: null,
  active: null
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Wallet.classMetadata = new ClassMetadata('wallet', 'wallets', WalletClient);
Wallet.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('currency'), new Attribute('provider'), new Attribute('providerContractNumber'), new Attribute('providerMetadata', 'providerMetadata', 'object'), new Attribute('currency'), new Attribute('active', 'active', 'boolean')]);
Wallet.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.ONE_TO_MANY, 'ticketPrice', 'ticketPriceList')]);

var TYPE_FULL_PRICE = 'full_price';
var TYPE_REDUCED = 'reduced';
var TYPE_EXEMPTED = 'exempted';
var TYPE_SUBSCRIPTION = 'subscription';
var TYPE_SUBSCRIPTION_MEMBER_LOYALTY = 'subscriptionMemberLoyalty';
var TYPE_SCHOLAR = 'scholar';
var TYPE_GROUP = 'group';
var TYPE_RESELLER = 'reseller';
var TYPE_OTHER = 'other';

/** @deprecated  - Use PUBLIC_TYPOLOGY_TYPE enum instead */
var TicketPrice = /*#__PURE__*/function (_NetworkEntity) {
  function TicketPrice() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'TicketPrice'
    };
    var registry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    _classCallCheck(this, TicketPrice);
    var data = clone(val);
    var tz = extractTimezone(data, ['eventDate', 'ticketing', 'timezone']) || extractTimezone(data, ['wallet', 'contract', 'timezone']);
    data.saleStartDate = parseDate(data.saleStartDate, tz);
    data.saleEndDate = parseDate(data.saleEndDate, tz);
    data.triggerBuyableAt = parseDate(data.triggerBuyableAt, tz);
    _this = _callSuper(this, TicketPrice, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data, registry));
  }
  _inherits(TicketPrice, _NetworkEntity);
  return _createClass(TicketPrice, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/ticket_prices/', '')) || '';
    }
  }, {
    key: "getRemainingStock",
    value: function getRemainingStock() {
      if (this.get('unlimitedStock')) {
        return null;
      }
      return this.get('remainingStock');
    }
  }, {
    key: "getBookableStock",
    value: function getBookableStock() {
      if (this.get('unlimitedStock')) {
        return null;
      }
      return this.get('bookableStock');
    }
  }, {
    key: "getHasSalePeriod",
    value: function getHasSalePeriod() {
      return !!this.get('saleStartDate') || !!this.get('saleEndDate') || !!this.get('saleStartIntervalBeforeEventDate') || !!this.get('saleEndIntervalBeforeEventDate');
    }

    // types helper
  }, {
    key: "getIn",
    value: function getIn(keyPath) {
      return _superPropGet(TicketPrice, "getIn", this, 3)([keyPath]);
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'TicketPrice',
  type: null,
  hideFees: null,
  name: '',
  description: '',
  hash: '',
  slug: null,
  enabled: true,
  favorite: null,
  saleStartDate: null,
  saleEndDate: null,
  saleStartIntervalBeforeEventDate: undefined,
  saleEndIntervalBeforeEventDate: undefined,
  onSale: false,
  facialValue: null,
  currency: null,
  customerPaidAmountBySellingDevice: Map$1(),
  amountForProBySellingDevice: Map$1(),
  bookableStock: null,
  remainingStock: null,
  totalStock: null,
  manuallySetStock: null,
  unlimitedStock: true,
  soldTickets: 0,
  bookedTickets: 0,
  issuedTickets: 0,
  reservedTickets: 0,
  soldItems: undefined,
  bookedItems: undefined,
  issuedItems: undefined,
  reservedItems: undefined,
  manualSort: null,
  amountForProExvatBySellingDevice: Map$1(),
  eventDate: new EventDate(),
  eventDatePattern: new EventDatePattern(),
  tax: new Tax({}),
  ticketPriceGroup: null,
  ticketPriceSeatGroupList: List(),
  sellingDeviceList: List(),
  notOnSaleReasons: List(),
  wallet: new Wallet(),
  dynamic: false,
  buyable: null,
  visible: null,
  offerRuleList: List(),
  behaviour: null,
  willGenerateTicket: true,
  ticketExpirationInterval: null,
  excludedFromParentStock: null,
  isPriceDisplayed: null,
  bookingTrack: null,
  scanTrack: null,
  defaultStockContingent: null,
  defaultContingent: null,
  onlineMaxQuantityPerCart: undefined,
  isHidden: false,
  imageList: null,
  mediaList: null,
  hasIssuedStock: undefined,
  couponCodeGroup: undefined,
  providerExportedTicketPriceList: undefined,
  providerExportedName: undefined,
  parent: undefined,
  triggerBuyableAt: null,
  publicTypology: undefined
}));
TicketPrice.classMetadata = new ClassMetadata('ticketPrice', 'ticket_prices', /** @ts-expect-error -- method signature are incompatible */
TicketPriceClient);
TicketPrice.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type'), new Attribute('hideFees', 'hideFees', 'boolean'), new Attribute('name'), new Attribute('description'), new Attribute('hash'), new Attribute('slug'), new Attribute('behaviour'), new Attribute('willGenerateTicket'), new Attribute('ticketExpirationInterval'), new Attribute('enabled', 'enabled', 'boolean'), new Attribute('favorite', 'favorite', 'boolean'), new Attribute('saleStartDate', 'saleStartDate', 'datetime'), new Attribute('saleEndDate', 'saleEndDate', 'datetime'), new Attribute('saleStartIntervalBeforeEventDate'), new Attribute('saleEndIntervalBeforeEventDate'), new Attribute('onSale', 'onSale', 'boolean'), new Attribute('facialValue', 'facialValue', 'integer'), new Attribute('currency'), new Attribute('customerPaidAmountBySellingDevice', 'customerPaidAmountBySellingDevice', 'object'), new Attribute('amountForProBySellingDevice', 'amountForProBySellingDevice', 'object'), new Attribute('bookableStock', 'bookableStock', 'integer'), new Attribute('remainingStock', 'remainingStock', 'integer'), new Attribute('totalStock', 'totalStock', 'integer'), new Attribute('manuallySetStock', 'manuallySetStock', 'boolean'), new Attribute('unlimitedStock', 'unlimitedStock', 'boolean'), new Attribute('soldTickets', 'soldTickets', 'integer'), new Attribute('bookedTickets', 'bookedTickets', 'integer'), new Attribute('issuedTickets', 'issuedTickets', 'integer'), new Attribute('reservedTickets', 'reservedTickets', 'integer'), new Attribute('manualSort', 'manualSort', 'integer'), new Attribute('amountForProExvatBySellingDevice', 'amountForProExvatBySellingDevice', 'object'), new Attribute('notOnSaleReasons', 'notOnSaleReasons', 'object'), new Attribute('dynamic', 'dynamic', 'boolean'), new Attribute('buyable', 'buyable', 'boolean'), new Attribute('visible', 'visible', 'boolean'), new Attribute('excludedFromParentStock', 'excludedFromParentStock', 'boolean'), new Attribute('isPriceDisplayed', 'isPriceDisplayed', 'boolean'), new Attribute('onlineMaxQuantityPerCart', 'onlineMaxQuantityPerCart', 'integer'), new Attribute('isHidden', 'isHidden', 'boolean'), new Attribute('imageList', 'imageList', 'array'), new Attribute('mediaList', 'mediaList', 'array'), new Attribute('hasIssuedStock', 'hasIssuedStock', 'boolean'), new Attribute('providerExportedName'), new Attribute('triggerBuyableAt', 'triggerBuyableAt', 'datetime')]);
TicketPrice.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'eventDate', 'eventDate'), new Relation(Relation.MANY_TO_ONE, 'eventDatePattern', 'eventDatePattern'), new Relation(Relation.MANY_TO_ONE, 'tax', 'tax'), new Relation(Relation.MANY_TO_ONE, 'ticketPriceGroup', 'ticketPriceGroup'), new Relation(Relation.ONE_TO_MANY, 'ticketPriceSeatGroup', 'ticketPriceSeatGroupList'), new Relation(Relation.ONE_TO_MANY, 'sellingDevice', 'sellingDeviceList'), new Relation(Relation.MANY_TO_ONE, 'wallet', 'wallet'), new Relation(Relation.MANY_TO_MANY, 'offerRule', 'offerRuleList'), new Relation(Relation.MANY_TO_ONE, 'bookingTrack', 'bookingTrack'), new Relation(Relation.MANY_TO_ONE, 'scanTrack', 'scanTrack'), new Relation(Relation.MANY_TO_ONE, 'stockContingent', 'defaultStockContingent'), new Relation(Relation.MANY_TO_ONE, 'contingent', 'defaultContingent'), new Relation(Relation.MANY_TO_ONE, 'couponCodeGroup', 'couponCodeGroup'), new Relation(Relation.ONE_TO_MANY, 'providerExportedTicketPrice', 'providerExportedTicketPriceList'), new Relation(Relation.MANY_TO_ONE, 'ticketPrice', 'parent'), new Relation(Relation.MANY_TO_ONE, 'publicTypology', 'publicTypology')]);

var CartItem = /*#__PURE__*/function (_NetworkEntity) {
  function CartItem() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'CartItem'
    };
    var registry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    _classCallCheck(this, CartItem);
    var data = clone(val);
    if (isEmptyArrayOrList(data.data)) {
      data.data = {};
    }
    data.participantFormData = getParticipantFormData(
    // @ts-expect-error participantRequiredFields and partitipant type issues
    data.participant, data.participantRequiredFields);
    _this = _callSuper(this, CartItem, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data, registry));
  }
  _inherits(CartItem, _NetworkEntity);
  return _createClass(CartItem, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/cart_items/', '')) || '';
    }
  }, {
    key: "getFormParticipantFields",
    value: function getFormParticipantFields() {
      var _this2 = this;
      var disabledFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var optionalFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.participantRequiredFields) {
        throw new Error('ParticipantRequiredFields must be defined. Please check your request fields.');
      }
      var participantRequiredFields = this.participantRequiredFields.toJS();
      var formattedFieldList = participantRequiredFields.map(function (field) {
        var _this2$participantFor;
        var fieldWithFormattedKey = Object.keys(field).reduce(function (acc, key) {
          var formattedKey = key.startsWith('form') ? key.replace('form', '').toLowerCase() : key;
          return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, formattedKey, field[key]));
        }, field);
        var fieldOptions = field.options ? _objectSpread2(_objectSpread2({}, field.options), {}, {
          inputProps: _objectSpread2(_objectSpread2({}, field.options.inputProps), {}, {
            disabled: disabledFields,
            allowCreate: false
          }),
          options: addMissingOptionToFieldOptions(field.options.options, field.slug ? (_this2$participantFor = _this2.participantFormData) === null || _this2$participantFor === void 0 ? void 0 : _this2$participantFor.get(field.slug) : null),
          isRequired: optionalFields ? false : field.required
        }) : {
          inputProps: {
            disabled: disabledFields,
            allowCreate: false
          },
          isRequired: optionalFields ? false : field.required
        };
        return _objectSpread2(_objectSpread2({}, fieldWithFormattedKey), {}, {
          name: field.slug,
          options: fieldOptions
        });
      });
      return formattedFieldList;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'CartItem',
  amountForPro: null,
  data: null,
  cart: new Cart(),
  customerPaidAmount: null,
  facialValue: null,
  quantity: 0,
  valid: null,
  ticketPrice: new TicketPrice(),
  ticketList: List(),
  seatList: List(),
  ticketPriceValid: false,
  totalFees: null,
  groupKey: null,
  stockContingent: null,
  availableSeatList: null,
  couponCode: undefined,
  participantRequiredFields: null,
  participant: null,
  participantFormData: null,
  swapAmount: null
}));
CartItem.classMetadata = new ClassMetadata('cartItem', 'cart_items', /** @ts-expect-error -- method signature are incompatible */
CartItemClient);
CartItem.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('amountForPro', 'amountForPro', 'integer'), new Attribute('data', 'data', 'object'), new Attribute('customerPaidAmount', 'customerPaidAmount', 'integer'), new Attribute('facialValue', 'facialValue', 'integer'), new Attribute('quantity', 'quantity', 'integer'), new Attribute('valid', 'valid', 'boolean'), new Attribute('ticketPriceValid', 'ticketPriceValid', 'boolean'), new Attribute('totalFees', 'totalFees', 'integer'), new Attribute('groupKey'), new Attribute('couponCode'), new Attribute('participantRequiredFields', 'participantRequiredFields', 'object'), new Attribute('swapAmount', 'swapAmount', 'integer')]);
CartItem.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'cart', 'cart'), new Relation(Relation.ONE_TO_MANY, 'seat', 'seatList'), new Relation(Relation.MANY_TO_ONE, 'ticketPrice', 'ticketPrice'), new Relation(Relation.ONE_TO_MANY, 'ticket', 'ticketList'), new Relation(Relation.ONE_TO_MANY, 'availableSeat', 'availableSeatList'), new Relation(Relation.MANY_TO_ONE, 'stockContingent', 'stockContingent'), new Relation(Relation.MANY_TO_ONE, 'customer', 'participant')]);

var Client = /*#__PURE__*/function (_NetworkEntity) {
  function Client() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Client'
    };
    _classCallCheck(this, Client);
    var data = clone(val);
    var tz = extractTimezone(data, ['contract', 'timezone']);
    data.createdAt = parseDate(data.createdAt, tz);
    data.mostRecentTransactionValueDate = parseDate(data.mostRecentTransactionValueDate, tz);
    if (isEmptyArrayOrList(data.creditByCurrencyMap)) {
      data.creditByCurrencyMap = {};
    }
    if (isEmptyArrayOrList(data.debitByCurrencyMap)) {
      data.debitByCurrencyMap = {};
    }
    if (isEmptyArrayOrList(data.balanceByCurrencyMap)) {
      data.balanceByCurrencyMap = {};
    }
    if (isEmptyArrayOrList(data.cashCouponCreditByCurrencyMap)) {
      data.cashCouponCreditByCurrencyMap = {};
    }
    if (isEmptyArrayOrList(data.cashCouponDebitByCurrencyMap)) {
      data.cashCouponDebitByCurrencyMap = {};
    }
    if (isEmptyArrayOrList(data.cashCouponBalanceByCurrencyMap)) {
      data.cashCouponBalanceByCurrencyMap = {};
    }
    _this = _callSuper(this, Client, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Client, _NetworkEntity);
  return _createClass(Client, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/clients/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Client',
  name: null,
  email: null,
  phone: null,
  corporateName: null,
  accountingNumber: null,
  origin: null,
  issuerName: null,
  issuerBankName: null,
  ticketingData: null,
  crmData: null,
  crmId: null,
  creditByCurrencyMap: null,
  debitByCurrencyMap: null,
  balanceByCurrencyMap: null,
  cashCouponCreditByCurrencyMap: null,
  cashCouponDebitByCurrencyMap: null,
  cashCouponBalanceByCurrencyMap: null,
  mostRecentTransactionValueDate: null,
  active: null,
  contract: new Contract(),
  createdAt: null,
  reportingAccount: undefined
}));
/** @ts-expect-error -- method signature are incompatible */
Client.classMetadata = new ClassMetadata('client', 'clients', AbstractClient);
Client.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('corporateName'), new Attribute('accountingNumber'), new Attribute('origin'), new Attribute('issuerName'), new Attribute('issuerBankName'), new Attribute('name'), new Attribute('email'), new Attribute('phone'), new Attribute('ticketingData', 'ticketingData', 'object'), new Attribute('crmData', 'crmData', 'object'), new Attribute('crmId', 'crmId', 'integer'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('debit', 'debitByCurrencyMap', 'object'), new Attribute('credit', 'creditByCurrencyMap', 'object'), new Attribute('balance', 'balanceByCurrencyMap', 'object'), new Attribute('debit', 'cashCouponCreditByCurrencyMap', 'object'), new Attribute('credit', 'cashCouponDebitByCurrencyMap', 'object'), new Attribute('balance', 'cashCouponBalanceByCurrencyMap', 'object'), new Attribute('mostRecentTransactionValueDate', 'mostRecentTransactionValueDate', 'datetime'), new Attribute('active', 'active', 'boolean')]);
Client.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'reportingAccount', 'reportingAccount')]);

var SwapValidateRepresentationClient = /*#__PURE__*/function (_AbstractClient) {
  function SwapValidateRepresentationClient() {
    _classCallCheck(this, SwapValidateRepresentationClient);
    return _callSuper(this, SwapValidateRepresentationClient, arguments);
  }
  _inherits(SwapValidateRepresentationClient, _AbstractClient);
  return _createClass(SwapValidateRepresentationClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/carts/swap/validate';
    }
  }, {
    key: "swapValidate",
    value: function swapValidate(swapMap, sellingDeviceId, fields) {
      var url = URI("".concat(this.getPathBase()));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify({
          swapMap: swapMap,
          sellingDevice: sellingDeviceId
        })
      }), 'item');
    }
  }]);
}(AbstractClient);

var SwapValidateRepresentation = /*#__PURE__*/function (_NetworkEntity) {
  function SwapValidateRepresentation() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'SwapValidateRepresentation'
    };
    _classCallCheck(this, SwapValidateRepresentation);
    _this = _callSuper(this, SwapValidateRepresentation, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(SwapValidateRepresentation, _NetworkEntity);
  return _createClass(SwapValidateRepresentation);
}(NetworkEntity({
  '@id': null,
  '@type': 'SwapValidateRepresentation',
  isValid: undefined,
  swapFacialValue: undefined,
  shouldCreateCashCoupon: undefined,
  validationError: undefined
}));
SwapValidateRepresentation.classMetadata = new ClassMetadata('swapValidateRepresentation', 'cart/swap/validate', /** @ts-expect-error -- method signature are incompatible */
SwapValidateRepresentationClient);
SwapValidateRepresentation.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('isValid', 'isValid', 'boolean'), new Attribute('swapFacialValue', 'swapFacialValue', 'integer'), new Attribute('shouldCreateCashCoupon', 'shouldCreateCashCoupon', 'boolean'), new Attribute('validationError', 'validationError', 'string')]);

var defaultValues$4 = {
  '@id': null,
  '@type': 'hydra:Collection',
  'hydra:member': List()
};
var CollectionFactory = NetworkEntity(defaultValues$4);
var Collection = /*#__PURE__*/function (_CollectionFactory) {
  function Collection(val) {
    var _this;
    _classCallCheck(this, Collection);
    var data = clone(val);
    data['hydra:member'] = List(data['hydra:member'].map(function (member) {
      return createEntity(member);
    }));
    var out = _this = _callSuper(this, Collection, [data]);
    _this.index = 0;

    // TODO remove this useless return ? (See https://www.bennadel.com/blog/2522-providing-a-return-value-in-a-javascript-constructor.htm)
    /** @ts-expect-error -- to remove ? */
    return _possibleConstructorReturn(_this, out);
  }
  _inherits(Collection, _CollectionFactory);
  return _createClass(Collection, [{
    key: Symbol.iterator,
    value: function value() {
      var _this2 = this;
      return {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        next: function next() {
          if (_this2.index < _this2.getMembers().size) {
            return {
              // eslint-disable-next-line no-plusplus
              value: _this2.getMembers().get(_this2.index++),
              done: false
            };
          }
          _this2.index = 0; // If we would like to iterate over this again without forcing manual update of the index

          return {
            done: true,
            value: undefined
          };
        }
      };
    }
  }, {
    key: "getMembers",
    value: function getMembers() {
      return this['hydra:member'];
    }

    /** @ts-expect-error -- possible conflict with immutable */
  }, {
    key: "merge",
    value: function merge(newCollection) {
      var newMembers = this.getMembers()
      // concat the two lists
      .concat(newCollection.getMembers())
      // group by id to reduce duplicates
      /** @ts-expect-error -- the @id is defined for all our entities */.groupBy(function (m) {
        return m.get('@id');
      })
      // reduce duplicate using `merge` function or the Record
      /** @ts-expect-error -- hard to work on that, working for now */.map(function (memberList) {
        return memberList.reduce(function (prev, curr) {
          return prev.merge(curr);
        });
      });
      var newMembersSize = newMembers.size;
      var updatedCollection = this.set('hydra:member', newMembers.valueSeq().toList());
      if (newMembersSize !== this.getMembers().size || !is(updatedCollection, this)) {
        return updatedCollection;
      }
      return this;
    }
  }]);
}(CollectionFactory);

var ContingentClient = /*#__PURE__*/function (_HidableClient) {
  function ContingentClient() {
    _classCallCheck(this, ContingentClient);
    return _callSuper(this, ContingentClient, arguments);
  }
  _inherits(ContingentClient, _HidableClient);
  return _createClass(ContingentClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/contingents';
    }
  }]);
}(HidableClient);

var CONTINGENT_AVAILABLE_ACTIONS = /*#__PURE__*/function (CONTINGENT_AVAILABLE_ACTIONS) {
  CONTINGENT_AVAILABLE_ACTIONS["RENAME"] = "rename";
  CONTINGENT_AVAILABLE_ACTIONS["DELETE"] = "delete";
  CONTINGENT_AVAILABLE_ACTIONS["SELL_TICKETS"] = "sellTickets";
  return CONTINGENT_AVAILABLE_ACTIONS;
}({});
var Contingent = /*#__PURE__*/function (_NetworkEntity) {
  function Contingent() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Contingent'
    };
    _classCallCheck(this, Contingent);
    var data = clone(val);
    _this = _callSuper(this, Contingent, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Contingent, _NetworkEntity);
  return _createClass(Contingent, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/contingents/', '')) || '';
    }
  }, {
    key: "isActionAvailable",
    value: function isActionAvailable(action) {
      if (Map$1.isMap(this.availableActions)) {
        return this.availableActions.get(action) !== false;
      }
      return true;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Contingent',
  contract: null,
  name: null,
  sanitizedName: null,
  color: null,
  isHidden: null,
  availableActions: undefined
}));
Contingent.classMetadata = new ClassMetadata('contingent', 'contingents', /** @ts-expect-error -- method signature are incompatible */
ContingentClient);
Contingent.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('sanitizedName'), new Attribute('color')]);
Contingent.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var ContractAddendumClient = /*#__PURE__*/function (_AbstractClient) {
  function ContractAddendumClient() {
    _classCallCheck(this, ContractAddendumClient);
    return _callSuper(this, ContractAddendumClient, arguments);
  }
  _inherits(ContractAddendumClient, _AbstractClient);
  return _createClass(ContractAddendumClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/contract_addendums';
    }
  }]);
}(AbstractClient);

var ContractAddendum = /*#__PURE__*/function (_NetworkEntity) {
  function ContractAddendum(val) {
    var _this;
    _classCallCheck(this, ContractAddendum);
    _this = _callSuper(this, ContractAddendum, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ContractAddendum, _NetworkEntity);
  return _createClass(ContractAddendum, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/contract_addendums/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ContractAddendum',
  summary: null,
  content: null,
  signatureDate: null,
  contract: null
}));
ContractAddendum.classMetadata = new ClassMetadata('contractAddendum', 'contract_addendums', /** @ts-expect-error -- method signature are incompatible */
ContractAddendumClient);
ContractAddendum.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('summary'), new Attribute('content'), new Attribute('signatureDate')]);
ContractAddendum.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var CouponCodeGroupClient = /*#__PURE__*/function (_AbstractClient) {
  function CouponCodeGroupClient() {
    _classCallCheck(this, CouponCodeGroupClient);
    return _callSuper(this, CouponCodeGroupClient, arguments);
  }
  _inherits(CouponCodeGroupClient, _AbstractClient);
  return _createClass(CouponCodeGroupClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/coupon_code_groups';
    }
  }]);
}(AbstractClient);

var CouponCodeGroup = /*#__PURE__*/function (_NetworkEntity) {
  function CouponCodeGroup(val) {
    var _this;
    _classCallCheck(this, CouponCodeGroup);
    _this = _callSuper(this, CouponCodeGroup, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(CouponCodeGroup, _NetworkEntity);
  return _createClass(CouponCodeGroup, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/coupon_code_groups/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'CouponCodeGroup',
  contract: null,
  name: null
}));
CouponCodeGroup.classMetadata = new ClassMetadata('couponCodeGroup', 'coupon_code_groups', /** @ts-expect-error -- method signature are incompatible */
CouponCodeGroupClient);
CouponCodeGroup.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name')]);
CouponCodeGroup.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var CustomerField = /*#__PURE__*/function (_NetworkEntity) {
  function CustomerField() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'CustomerField'
    };
    _classCallCheck(this, CustomerField);
    _this = _callSuper(this, CustomerField, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(CustomerField, _NetworkEntity);
  return _createClass(CustomerField, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/customer_fields/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'CustomerField',
  slug: null,
  isGeneric: null
}));
CustomerField.classMetadata = new ClassMetadata('customerField', 'customer_fields', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
CustomerField.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('isGeneric', 'isGeneric', 'boolean')]);

var CustomerFieldContract = /*#__PURE__*/function (_NetworkEntity) {
  function CustomerFieldContract() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'CustomerFieldContract'
    };
    _classCallCheck(this, CustomerFieldContract);
    var data = clone(val);
    if (isEmptyArrayOrList(data.options)) {
      data.options = {};
    }
    if (isEmptyArrayOrList(data.formOptions)) {
      data.formOptions = {};
    }
    if (isEmptyArrayOrList(data.searchOptions)) {
      data.searchOptions = {};
    }
    _this = _callSuper(this, CustomerFieldContract, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(CustomerFieldContract, _NetworkEntity);
  return _createClass(CustomerFieldContract, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/customer_field_contracts/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'CustomerFieldContract',
  type: null,
  inputType: null,
  slug: null,
  searchType: null,
  searchOptions: null,
  options: null,
  isDeleteable: null,
  label: null,
  description: null,
  noList: false,
  formType: null,
  formIsMultiple: false,
  formOptions: null,
  position: null,
  contract: null,
  customerField: null,
  dataTarget: undefined,
  relatedTo: undefined,
  customerFieldContractParent: undefined,
  required: undefined,
  readOnly: undefined,
  form: undefined
}));
CustomerFieldContract.classMetadata = new ClassMetadata('customerFieldContract', 'customer_field_contracts', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
CustomerFieldContract.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type'), new Attribute('inputType'), new Attribute('searchType'), new Attribute('slug'), new Attribute('options', 'options', 'object'), new Attribute('isDeleteable', 'isDeleteable', 'boolean'), new Attribute('label'), new Attribute('description'), new Attribute('noList', 'noList', 'boolean'), new Attribute('formType'), new Attribute('formIsMultiple', 'formIsMultiple', 'boolean'), new Attribute('searchOptions', 'searchOptions', 'object'), new Attribute('formOptions', 'formOptions', 'object'), new Attribute('position'), new Attribute('dataTarget'), new Attribute('relatedTo'), new Attribute('customerFieldContractParent'), new Attribute('required', 'required', 'boolean'), new Attribute('readOnly', 'readOnly', 'boolean')]);
CustomerFieldContract.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'customerField', 'customerField'), new Relation(Relation.MANY_TO_ONE, 'form', 'form')]);

var CustomerStatusClient = /*#__PURE__*/function (_AbstractClient) {
  function CustomerStatusClient() {
    _classCallCheck(this, CustomerStatusClient);
    return _callSuper(this, CustomerStatusClient, arguments);
  }
  _inherits(CustomerStatusClient, _AbstractClient);
  return _createClass(CustomerStatusClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/customer_statuses';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['customer_status_read', 'customer_status_write'];
    }
  }]);
}(AbstractClient);

var CustomerStatus = /*#__PURE__*/function (_NetworkEntity) {
  function CustomerStatus() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'CustomerStatus'
    };
    _classCallCheck(this, CustomerStatus);
    var data = clone(val);
    _this = _callSuper(this, CustomerStatus, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(CustomerStatus, _NetworkEntity);
  return _createClass(CustomerStatus, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/customer_statuses/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'CustomerStatus',
  label: null,
  contract: null,
  couponList: null,
  isSubscription: null
}));
CustomerStatus.classMetadata = new ClassMetadata('customerStatus', 'customer_statuses', /** @ts-expect-error -- method signature are incompatible */
CustomerStatusClient);
CustomerStatus.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('label'), new Attribute('isSubscription', 'isSubscription', 'boolean')]);
CustomerStatus.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.ONE_TO_MANY, 'coupon', 'couponList')]);

var Deposit = /*#__PURE__*/function (_NetworkEntity) {
  function Deposit() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Deposit'
    };
    _classCallCheck(this, Deposit);
    var data = clone(val);
    _this = _callSuper(this, Deposit, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Deposit, _NetworkEntity);
  return _createClass(Deposit, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/deposits/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Deposit',
  accountType: null,
  currency: null,
  client: null,
  accountingClient: null,
  transactionList: null,
  sellingDevice: null,
  order: null,
  provider: null,
  providerMetadata: null,
  invoiceList: null
}));
Deposit.classMetadata = new ClassMetadata('deposit', 'deposits', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
Deposit.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('currency'), new Attribute('accountType'), new Attribute('provider'), new Attribute('providerMetadata', 'providerMetadata', 'object')]);
Deposit.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'client', 'client'), new Relation(Relation.MANY_TO_ONE, 'accountingClient', 'accountingClient'), new Relation(Relation.ONE_TO_MANY, 'transaction', 'transactionList'), new Relation(Relation.MANY_TO_ONE, 'sellingDevice', 'sellingDevice'), new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.ONE_TO_MANY, 'invoice', 'invoiceList')]);

var DeskPaymentMethodClient = /*#__PURE__*/function (_HidableClient) {
  function DeskPaymentMethodClient() {
    _classCallCheck(this, DeskPaymentMethodClient);
    return _callSuper(this, DeskPaymentMethodClient, arguments);
  }
  _inherits(DeskPaymentMethodClient, _HidableClient);
  return _createClass(DeskPaymentMethodClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/desk_payment_methods';
    }
  }]);
}(HidableClient);

var DEFAULT_PAYMENT_METHOD_CODE = /*#__PURE__*/function (DEFAULT_PAYMENT_METHOD_CODE) {
  DEFAULT_PAYMENT_METHOD_CODE["CARD"] = "card";
  DEFAULT_PAYMENT_METHOD_CODE["CARD_ONLINE"] = "card_online";
  DEFAULT_PAYMENT_METHOD_CODE["CASH"] = "cash";
  DEFAULT_PAYMENT_METHOD_CODE["CASH_COUPON"] = "cash_coupon";
  DEFAULT_PAYMENT_METHOD_CODE["CHECK"] = "check";
  DEFAULT_PAYMENT_METHOD_CODE["RESCHEDULE"] = "reschedule";
  DEFAULT_PAYMENT_METHOD_CODE["RESCHEDULE_ONLINE"] = "reschedule_online";
  DEFAULT_PAYMENT_METHOD_CODE["SEPA"] = "sepa";
  DEFAULT_PAYMENT_METHOD_CODE["TICKETSWAP"] = "ticketswap";
  DEFAULT_PAYMENT_METHOD_CODE["REELAX_TICKETS"] = "reelax_tickets";
  DEFAULT_PAYMENT_METHOD_CODE["PASSE_TON_BILLET"] = "passe_ton_billet";
  return DEFAULT_PAYMENT_METHOD_CODE;
}({});

// those fields are mandatory, if "fields" is given, then their values will be a non-nullable string
var DeskPaymentMethod = /*#__PURE__*/function (_NetworkEntity) {
  function DeskPaymentMethod() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'DeskPaymentMethod'
    };
    _classCallCheck(this, DeskPaymentMethod);
    _this = _callSuper(this, DeskPaymentMethod, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(DeskPaymentMethod, _NetworkEntity);
  return _createClass(DeskPaymentMethod, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/desk_payment_methods/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'DeskPaymentMethod',
  code: null,
  contract: null,
  enabled: false,
  flexible: false,
  label: null,
  labelTranslationKey: null,
  position: null,
  isDefault: undefined,
  isHidden: null,
  transaction: undefined,
  reportingAccount: undefined
}));
DeskPaymentMethod.classMetadata = new ClassMetadata('deskPaymentMethod', 'desk_payment_methods', /** @ts-expect-error -- method signature are incompatible */
DeskPaymentMethodClient);
DeskPaymentMethod.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('code'), new Attribute('enabled', 'enabled', 'boolean'), new Attribute('flexible', 'flexible', 'boolean'), new Attribute('label'), new Attribute('labelTranslationKey'), new Attribute('position'), new Attribute('isDefault', 'isDefault', 'boolean'), new Attribute('isHidden', 'isHidden', 'boolean')]);
DeskPaymentMethod.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'transaction', 'transaction'), new Relation(Relation.MANY_TO_ONE, 'reportingAccount', 'reportingAccount')]);

var DeskSessionClient = /*#__PURE__*/function (_AbstractClient) {
  function DeskSessionClient() {
    _classCallCheck(this, DeskSessionClient);
    return _callSuper(this, DeskSessionClient, arguments);
  }
  _inherits(DeskSessionClient, _AbstractClient);
  return _createClass(DeskSessionClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/desk_sessions';
    }
  }, {
    key: "getOrCreateCurrent",
    value: function getOrCreateCurrent(fields) {
      var _this = this;
      var creationBody = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.getCurrent(fields).then(function (deskSession) {
        if (deskSession === null) {
          return _this.start(fields, creationBody);
        }
        return deskSession;
      });
    }
  }, {
    key: "getCurrent",
    value: function getCurrent(fields) {
      var uri = new URI("".concat(this.getPathBase(), "?opened=1&user=me&itemsPerPage=1"));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(uri), 'list').then(function (collection) {
        if (collection && collection.get('hydra:member').count() === 1) {
          return collection.get('hydra:member').first();
        }
        return null;
      });
    }
  }, {
    key: "start",
    value: function start(fields) {
      var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var uri = new URI("".concat(this.getPathBase()));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(uri, {
        method: 'POST',
        body: JSON.stringify(body)
      }), 'item');
    }
  }, {
    key: "close",
    value: function close(sessionId, fields) {
      var uri = new URI("".concat(this.getPathBase(), "/").concat(sessionId, "/close"));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.authorizedFetch(uri, {
        method: 'POST'
      }).then(function (response) {
        if (response.status === 204) {
          return null;
        }
        return response.json().then(function (object) {
          return createEntity(object);
        });
      });
    }
  }, {
    key: "getAccountability",
    value: function getAccountability(id, format) {
      var uri = "".concat(this.getPathBase(), "/").concat(id, "/accountability.").concat(format);
      switch (format) {
        case 'json':
          return this.authorizedFetch(uri).then(function (response) {
            return response.json();
          });
        default:
          return this.authorizedFetch(uri);
      }
    }
  }, {
    key: "changeOpeningCash",
    value: function changeOpeningCash(deskSessionId, openingCash) {
      var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var uri = URI("".concat(this.getPathBase(), "/").concat(deskSessionId));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(uri, {
        method: 'PUT',
        body: JSON.stringify({
          openingCash: openingCash
        })
      }), 'item');
    }
  }]);
}(AbstractClient);

var DeskSession = /*#__PURE__*/function (_NetworkEntity) {
  function DeskSession() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'DeskSession'
    };
    _classCallCheck(this, DeskSession);
    var data = clone(val);
    var tz = extractTimezone(data, ['contract', 'timezone']);
    data.startDate = parseDate(data.startDate, tz);
    data.endDate = parseDate(data.endDate, tz);
    _this = _callSuper(this, DeskSession, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(DeskSession, _NetworkEntity);
  return _createClass(DeskSession, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/desk_sessions/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'DeskSession',
  startDate: null,
  endDate: null,
  sessionNumber: null,
  userEmail: null,
  contract: new Contract(),
  openingCash: null,
  schoolMode: null
}));
DeskSession.classMetadata = new ClassMetadata('deskSession', 'desk_sessions', /** @ts-expect-error -- method signature are incompatible */
DeskSessionClient);
DeskSession.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('startDate'), new Attribute('endDate'), new Attribute('sessionNumber', 'sessionNumber', 'number'), new Attribute('userEmail'), new Attribute('openingCash', 'openingCash', 'number'), new Attribute('schoolMode', 'schoolMode', 'boolean')]);
DeskSession.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var DeviceStateClient = /*#__PURE__*/function (_AbstractClient) {
  function DeviceStateClient() {
    _classCallCheck(this, DeviceStateClient);
    return _callSuper(this, DeviceStateClient, arguments);
  }
  _inherits(DeviceStateClient, _AbstractClient);
  return _createClass(DeviceStateClient, [{
    key: "findPhysicalTicketUrl",
    value: function findPhysicalTicketUrl(deviceStateId, ticketId, paperType) {
      var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'png';
      var uri = new URI("".concat(deviceStateId, "/tickets/").concat(ticketId, "/").concat(paperType, ".").concat(format));
      return this.makeUri(uri);
    }
  }, {
    key: "findPhysicalCouponTicketUrl",
    value: function findPhysicalCouponTicketUrl(deviceStateId, orderItemId, paperType) {
      var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'png';
      var uri = new URI("".concat(deviceStateId, "/coupons/").concat(orderItemId, "/").concat(paperType, ".").concat(format));
      return this.makeUri(uri);
    }
  }, {
    key: "findPhysicalTestTicketUrl",
    value: function findPhysicalTestTicketUrl(deviceStateId, entityId, paperType) {
      var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'png';
      var makeRequest = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var entityType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'event_dates';
      var uri = new URI("".concat(deviceStateId, "/tickets/test/").concat(entityType, "/").concat(entityId, "/").concat(paperType, ".").concat(format));
      if (makeRequest) {
        return this.authorizedFetch("/v1/device_states/".concat(uri), {
          method: 'GET'
        });
      }
      return this.makeUri(uri);
    }
  }]);
}(AbstractClient);

var PAPER_TYPE_THERMAL_ROLLER = 'thermal_roller';
var PAPER_TYPE_STOCK_TICKETS = 'stock_tickets';
var PAPER_TYPE_LIST = [PAPER_TYPE_STOCK_TICKETS, PAPER_TYPE_THERMAL_ROLLER];
var DeviceState = /*#__PURE__*/function (_NetworkEntity) {
  function DeviceState() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'DeviceState'
    };
    _classCallCheck(this, DeviceState);
    _this = _callSuper(this, DeviceState, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(DeviceState, _NetworkEntity);
  return _createClass(DeviceState, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/device_states/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'DeviceState',
  contract: null,
  name: null,
  paperTypeTicketParametersMap: Map$1(),
  lastUpdatedTimestamp: null,
  lastHeartbeatTimestamp: null,
  lastHeartbeatLocalTimestamp: null,
  uptime: null,
  ramUsage: null,
  diskUsage: null,
  forwardingMode: false,
  isTokenReadable: null,
  printersState: null,
  publicIpAddress: null,
  networkInterfaces: null,
  pageCutMode: null,
  printSpeed: null,
  configuration: null,
  packageVersion: null,
  createdAt: null,
  updatedAt: null
}));
DeviceState.classMetadata = new ClassMetadata('deviceState', 'device_states', /** @ts-expect-error -- method signature are incompatible */
DeviceStateClient);
DeviceState.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('paperTypeTicketParametersMap', 'paperTypeTicketParametersMap', 'object'), new Attribute('lastUpdatedTimestamp', 'lastUpdatedTimestamp', 'datetime'), new Attribute('lastHeartbeatTimestamp', 'lastHeartbeatTimestamp', 'datetime'), new Attribute('lastHeartbeatLocalTimestamp', 'lastHeartbeatLocalTimestamp', 'datetime'), new Attribute('uptime'), new Attribute('ramUsage'), new Attribute('diskUsage'), new Attribute('forwardingMode', 'forwardingMode', 'boolean'), new Attribute('isTokenReadable', 'isTokenReadable', 'boolean'), new Attribute('printersState'), new Attribute('publicIpAddress'), new Attribute('networkInterfaces', 'networkInterfaces', 'array'), new Attribute('pageCutMode'), new Attribute('printSpeed'), new Attribute('configuration', 'configuration', 'object'), new Attribute('packageVersion'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('updatedAt', 'updatedAt', 'datetime')]);
DeviceState.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var InvoiceClient = /*#__PURE__*/function (_AbstractClient) {
  function InvoiceClient() {
    _classCallCheck(this, InvoiceClient);
    return _callSuper(this, InvoiceClient, arguments);
  }
  _inherits(InvoiceClient, _AbstractClient);
  return _createClass(InvoiceClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/invoices';
    }
  }, {
    key: "getPdf",
    value: function getPdf(id) {
      var url = new URI("".concat(this.getPathBase(), "/").concat(id, "/invoice.pdf"));
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getPdfByDownloadId",
    value: function getPdfByDownloadId(id, downloadId) {
      var url = new URI("".concat(this.getPathBase(), "/").concat(id, "/invoice.pdf?downloadId=").concat(downloadId));
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "sendByMail",
    value: function sendByMail(id, email, fields) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/send_invoice_by_mail"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify({
          email: email
        })
      });
    }
  }, {
    key: "reassignAccountingClient",
    value: function reassignAccountingClient(id, values) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/assign"));
      return this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(values)
      });
    }
  }, {
    key: "findByQuery",
    value: function findByQuery(values, fields) {
      var requestParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = URI("".concat(this.getPathBase(), "/query"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, _objectSpread2({
        method: 'POST',
        body: JSON.stringify(values)
      }, requestParams)), 'list');
    }
  }]);
}(AbstractClient);

var INVOICE_STATUS = /*#__PURE__*/function (INVOICE_STATUS) {
  INVOICE_STATUS["SETTLED"] = "settled";
  INVOICE_STATUS["UNSETTLED"] = "unsettled";
  INVOICE_STATUS["UNDERSETTLED"] = "undersettled";
  INVOICE_STATUS["OVERSETTLED"] = "oversettled";
  return INVOICE_STATUS;
}({});
var INVOICE_TYPE = /*#__PURE__*/function (INVOICE_TYPE) {
  INVOICE_TYPE["INITIAL_PAYMENT"] = "initial_payment";
  INVOICE_TYPE["REFUND_CORRECTION"] = "refund_correction";
  INVOICE_TYPE["TAX_CHANGE_CANCEL_PAYMENT"] = "tax_change_cancel_payment";
  INVOICE_TYPE["TAX_CHANGE_CANCEL_REFUND"] = "tax_change_cancel_refund";
  INVOICE_TYPE["INITIAL_PAYOUT"] = "initial_payout";
  INVOICE_TYPE["TAX_CHANGE_CANCEL_PAYOUT"] = "tax_change_cancel_payout";
  INVOICE_TYPE["CANCEL_PAYMENT"] = "cancel_payment";
  INVOICE_TYPE["CANCEL_REFUND"] = "cancel_refund";
  INVOICE_TYPE["SPLIT_CANCEL_PAYMENT"] = "split_cancel_payment";
  INVOICE_TYPE["SPLIT_CANCEL_REFUND"] = "split_cancel_refund";
  return INVOICE_TYPE;
}({});
var Invoice = /*#__PURE__*/function (_NetworkEntity) {
  function Invoice() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Invoice'
    };
    _classCallCheck(this, Invoice);
    var data = clone(val);
    data.createdAt = parseDate(data.createdAt, null);
    _this = _callSuper(this, Invoice, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Invoice, _NetworkEntity);
  return _createClass(Invoice, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/invoices/', '')) || '';
    }

    /** @deprecated -- use isCreditNote prop instead */
  }, {
    key: "isCredit",
    value: function isCredit() {
      if (typeof this.isCreditNote === 'boolean') {
        return this.isCreditNote;
      }
      return this.get('type') === INVOICE_TYPE.REFUND_CORRECTION || this.get('type') === INVOICE_TYPE.TAX_CHANGE_CANCEL_PAYMENT || this.get('type') === INVOICE_TYPE.TAX_CHANGE_CANCEL_PAYOUT || this.get('type') === INVOICE_TYPE.SPLIT_CANCEL_PAYMENT || this.get('type') === INVOICE_TYPE.CANCEL_PAYMENT;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Invoice',
  invoiceLineList: List(),
  order: null,
  customerName: null,
  customerAddress: null,
  customerAdditionalInfo: null,
  customerVatNumber: null,
  customerSiretNumber: null,
  identifier: null,
  createdAt: null,
  cancelled: null,
  groupLabel: null,
  type: null,
  status: undefined,
  accountingClient: undefined,
  isCreditNote: undefined,
  transactionList: undefined,
  eventDateList: undefined,
  customerPaidAmount: undefined,
  linkedAmount: undefined,
  unlinkedAmount: undefined,
  schoolMode: undefined
}));
/** @ts-expect-error -- method signature are incompatible */
Invoice.classMetadata = new ClassMetadata('invoice', 'invoices', InvoiceClient);
Invoice.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('customerName'), new Attribute('customerAddress'), new Attribute('customerVatNumber'), new Attribute('customerSiretNumber'), new Attribute('customerAdditionalInfo'), new Attribute('identifier'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('groupLabel'), new Attribute('type'), new Attribute('cancelled', 'cancelled', 'boolean'), new Attribute('status'), new Attribute('isCreditNote', 'isCreditNote', 'boolean'), new Attribute('customerPaidAmount', 'customerPaidAmount', 'integer'), new Attribute('linkedAmount', 'linkedAmount', 'integer'), new Attribute('unlinkedAmount', 'unlinkedAmount', 'integer'), new Attribute('schoolMode', 'schoolMode', 'boolean')]);
Invoice.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.ONE_TO_MANY, 'invoiceLine', 'invoiceLineList'), new Relation(Relation.MANY_TO_ONE, 'accountingClient', 'accountingClient'), new Relation(Relation.ONE_TO_MANY, 'transaction', 'transactionList'), new Relation(Relation.ONE_TO_MANY, 'eventDate', 'eventDateList')]);

var InvoiceLine = /*#__PURE__*/function (_NetworkEntity) {
  function InvoiceLine() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'InvoiceLine'
    };
    _classCallCheck(this, InvoiceLine);
    _this = _callSuper(this, InvoiceLine, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(InvoiceLine, _NetworkEntity);
  return _createClass(InvoiceLine, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/invoice_lines/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'InvoiceLine',
  invoice: null,
  label: null,
  unitAmount: null,
  feeAmount: null
}));
InvoiceLine.classMetadata = new ClassMetadata('invoiceLine', 'invoice_lines', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
InvoiceLine.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('label'), new Attribute('unitAmount', 'unitAmount', 'integer'), new Attribute('feeAmount', 'feeAmount', 'integer')]);
InvoiceLine.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'invoice', 'invoice')]);

var STATUS = /*#__PURE__*/function (STATUS) {
  STATUS["PENDING"] = "PENDING";
  STATUS["STARTED"] = "STARTED";
  STATUS["SUCCESS"] = "SUCCESS";
  STATUS["FAIL"] = "FAIL";
  STATUS["COMPLETE"] = "COMPLETE";
  return STATUS;
}({});
var NAME = /*#__PURE__*/function (NAME) {
  NAME["TICKETING_STATS"] = "ticketing_stats";
  NAME["MASS_ACTION"] = "mass_action";
  return NAME;
}({});
var ACTION = /*#__PURE__*/function (ACTION) {
  ACTION["CREATE"] = "create";
  ACTION["UPDATE"] = "update";
  ACTION["DELETE"] = "delete";
  ACTION["CLONE"] = "clone";
  ACTION["SCAN"] = "scan";
  ACTION["PAY"] = "pay";
  ACTION["ADD_TO_SELLING_DEVICE"] = "add_to_selling_device";
  ACTION["CREATE_FOR_SELLING_DEVICE"] = "create_for_selling_device";
  ACTION["REMOVE_FROM_SELLING_DEVICE"] = "remove_from_selling_device";
  ACTION["ACTIVATE_PROVIDER_EXPORT"] = "activate_provider_export";
  ACTION["CONFIRM"] = "confirm";
  return ACTION;
}({});
var ENTITY_TYPE = /*#__PURE__*/function (ENTITY_TYPE) {
  ENTITY_TYPE["EVENT_DATE"] = "EventDate";
  ENTITY_TYPE["TICKETING"] = "Ticketing";
  ENTITY_TYPE["TICKET_PRICE"] = "TicketPrice";
  ENTITY_TYPE["TICKET"] = "Ticket";
  ENTITY_TYPE["ORDER"] = "Order";
  ENTITY_TYPE["CART"] = "Cart";
  ENTITY_TYPE["BOOKING"] = "Booking";
  return ENTITY_TYPE;
}({});
var Job = /*#__PURE__*/function (_NetworkEntity) {
  function Job() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Job'
    };
    _classCallCheck(this, Job);
    var data = clone(val);
    data.createdAt = parseDate(data.createdAt, null);
    data.updatedAt = parseDate(data.updatedAt, null);
    _this = _callSuper(this, Job, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Job, _NetworkEntity);
  return _createClass(Job, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/jobs/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Job',
  name: null,
  result: null,
  parameters: null,
  userData: null,
  contract: null,
  userId: null,
  status: null,
  progress: null,
  createdAt: null,
  updatedAt: null
}));
/** @ts-expect-error -- method signature are incompatible */
Job.classMetadata = new ClassMetadata('job', 'jobs', AbstractClient);
Job.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('status'), new Attribute('progress', 'userId', 'float'), new Attribute('userId', 'userId', 'integer'), new Attribute('result', 'result', 'array'), new Attribute('parameters', 'parameters', 'array'), new Attribute('userData', 'userData', 'array'), new Attribute('createdAt', 'createdAt', 'date'), new Attribute('updatedAt', 'updatedAt', 'date')]);
Job.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var Lettering = /*#__PURE__*/function (_NetworkEntity) {
  function Lettering() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Lettering'
    };
    _classCallCheck(this, Lettering);
    var data = clone(val);
    _this = _callSuper(this, Lettering, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Lettering, _NetworkEntity);
  return _createClass(Lettering, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/letterings/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Lettering',
  transactionList: null
}));
Lettering.classMetadata = new ClassMetadata('lettering', 'letterings', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
Lettering.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type')]);
Lettering.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'transaction', 'transactionList')]);

var LogicalSeatConfigClient = /*#__PURE__*/function (_HidableClient) {
  function LogicalSeatConfigClient() {
    _classCallCheck(this, LogicalSeatConfigClient);
    return _callSuper(this, LogicalSeatConfigClient, arguments);
  }
  _inherits(LogicalSeatConfigClient, _HidableClient);
  return _createClass(LogicalSeatConfigClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/logical_seat_configs';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['logical_seat_config_read', 'logical_seat_config_write'];
    }
  }]);
}(HidableClient);

var LogicalSeatConfig = /*#__PURE__*/function (_NetworkEntity) {
  function LogicalSeatConfig() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'LogicalSeatConfig'
    };
    _classCallCheck(this, LogicalSeatConfig);
    _this = _callSuper(this, LogicalSeatConfig, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(LogicalSeatConfig, _NetworkEntity);
  return _createClass(LogicalSeatConfig, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/logical_seat_configs/', '')) || '';
    }
  }, {
    key: "isFreeSeating",
    value: function isFreeSeating() {
      return !this.isNumberedSeating;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'LogicalSeatConfig',
  defaultSeatGroup: null,
  name: null,
  totalStock: null,
  unlimitedStock: null,
  seatConfig: null,
  contract: null,
  eventDateList: null,
  availableSeatModelList: null,
  stockContingentList: null,
  contingentList: null,
  seatGroupList: null,
  isNumberedSeating: null,
  isHidden: null
}));
LogicalSeatConfig.classMetadata = new ClassMetadata('logicalSeatConfig', 'logical_seat_configs', /** @ts-expect-error -- method signature are incompatible */
LogicalSeatConfigClient);
LogicalSeatConfig.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('totalStock', 'totalStock'), new Attribute('unlimitedStock', 'unlimitedStock', 'boolean'), new Attribute('isNumberedSeating', 'isNumberedSeating', 'boolean'), new Attribute('isHidden', 'isHidden', 'boolean')]);
LogicalSeatConfig.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'seatGroup', 'defaultSeatGroup'), new Relation(Relation.MANY_TO_ONE, 'seatConfig', 'seatConfig'), new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.ONE_TO_MANY, 'availableSeatModel', 'availableSeatModelList'), new Relation(Relation.ONE_TO_MANY, 'eventDate', 'eventDateList'), new Relation(Relation.ONE_TO_MANY, 'stockContingent', 'stockContingentList'), new Relation(Relation.ONE_TO_MANY, 'contingent', 'contingentList'), new Relation(Relation.ONE_TO_MANY, 'seatGroup', 'seatGroupList')]);

var MasterTicketClient = /*#__PURE__*/function (_AbstractClient) {
  function MasterTicketClient() {
    _classCallCheck(this, MasterTicketClient);
    return _callSuper(this, MasterTicketClient, arguments);
  }
  _inherits(MasterTicketClient, _AbstractClient);
  return _createClass(MasterTicketClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/master_tickets';
    }
  }, {
    key: "bulkUpdate",
    value: function bulkUpdate(tickets, fields, id, typeId) {
      var uri = new URI("".concat(this.getPathBase(), "/bulk"));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      if (typeId === 'downloadId') {
        uri.addSearch({
          downloadId: id
        });
      } else {
        uri.addSearch({
          payId: id
        });
      }
      var body = JSON.stringify({
        'hydra:member': tickets.toJS()
      });
      return this.authorizedFetch(uri, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: body
      });
    }
  }]);
}(AbstractClient);

var OrderClient = /*#__PURE__*/function (_FormDataClient) {
  function OrderClient() {
    _classCallCheck(this, OrderClient);
    return _callSuper(this, OrderClient, arguments);
  }
  _inherits(OrderClient, _FormDataClient);
  return _createClass(OrderClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/orders';
    }
  }, {
    key: "findByOrigin",
    value: function findByOrigin(originType, originId, fields) {
      return this.findBy({
        originType: originType,
        originId: originId
      }, fields);
    }
  }, {
    key: "createForCart",
    value: function createForCart(cart, fields) {
      var additionalBodyData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = new URI(this.getPathBase());
      url.addSearch({
        fields: getFieldsString(fields)
      });
      var body = Object.assign(additionalBodyData, {
        cart: cart
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(body)
      }), 'item');
    }
  }, {
    key: "reschedule",
    value: function reschedule(id, rescheduleMap, sellingDeviceId, fields) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/reschedule"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify({
          rescheduleMap: rescheduleMap.toJS(),
          sellingDevice: sellingDeviceId
        })
      }), 'item');
    }
  }, {
    key: "sendInvoiceByMail",
    value: function sendInvoiceByMail(id, email, fields) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/send_invoice_by_mail"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify({
          email: email
        })
      });
    }
  }, {
    key: "scan",
    value: function scan(id, fields, values) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/scans"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(values)
      }), 'item');
    }
  }, {
    key: "unscan",
    value: function unscan(id, fields, values) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/unscan"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(values)
      }), 'item');
    }
  }, {
    key: "sendCouponsByMail",
    value: function sendCouponsByMail(id, email, locale, coupons) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/send_coupons_by_mail"));
      return this.authorizedFetch(url, {
        headers: {
          'Accept-Language': locale
        },
        method: 'POST',
        body: JSON.stringify({
          email: email,
          coupons: coupons
        })
      });
    }
  }, {
    key: "sendTicketsByMail",
    value: function sendTicketsByMail(id, email, locale) {
      var downloadId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var tickets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/send_tickets_by_mail"));
      return this.authorizedFetch(url, {
        headers: {
          'Accept-Language': locale
        },
        method: 'POST',
        body: JSON.stringify({
          email: email,
          downloadId: downloadId,
          tickets: tickets
        })
      });
    }
  }, {
    key: "sendTicketsCouponsByMail",
    value: function sendTicketsCouponsByMail(id, email, locale) {
      var downloadId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var tickets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
      var coupons = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
      if (tickets !== null && tickets !== void 0 && tickets.length && !(coupons !== null && coupons !== void 0 && coupons.length)) {
        return this.sendTicketsByMail(id, email, locale, downloadId, tickets);
      }
      if (coupons !== null && coupons !== void 0 && coupons.length && !(tickets !== null && tickets !== void 0 && tickets.length)) {
        return this.sendCouponsByMail(id, email, locale, coupons);
      }
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/send_tickets_coupons_by_mail"));
      return this.authorizedFetch(url, {
        headers: {
          'Accept-Language': locale
        },
        method: 'POST',
        body: JSON.stringify({
          email: email,
          downloadId: downloadId,
          tickets: tickets,
          coupons: coupons
        })
      });
    }
  }, {
    key: "getPdfTickets",
    value: function getPdfTickets(id) {
      var downloadId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tickets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/tickets.pdf"));
      var params = null;
      if (downloadId.length) {
        params = {
          downloadId: downloadId
        };
      }
      if (tickets) {
        params = _objectSpread2(_objectSpread2({}, params), {}, {
          tickets: tickets === null || tickets === void 0 ? void 0 : tickets.join(',')
        });
      }
      if (params) {
        url.addSearch(params);
      }
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getPdfTestTickets",
    value: function getPdfTestTickets(id) {
      var entityType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var url = URI("".concat(this.getPathBase(), "/test/").concat(entityType ? "".concat(entityType, "/") : '').concat(id, "/tickets.pdf"));
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getHtmlTestTickets",
    value: function getHtmlTestTickets(id) {
      var entityType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var url = URI("".concat(this.getPathBase(), "/test/").concat(entityType ? "".concat(entityType, "/") : '').concat(id, "/tickets.html"));
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getPdfTicketsWithEventDate",
    value: function getPdfTicketsWithEventDate(orderId, eventDateId) {
      var downloadId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var url = URI("".concat(this.getPathBase(), "/").concat(orderId, "/event_date/").concat(eventDateId, "/tickets.pdf?downloadId=").concat(downloadId));
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getPdfCoupons",
    value: function getPdfCoupons(id) {
      var downloadId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var coupons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/coupons.pdf"));
      var params = null;
      if (downloadId.length) {
        params = {
          downloadId: downloadId
        };
      }
      if (coupons) {
        params = _objectSpread2(_objectSpread2({}, params), {}, {
          coupons: coupons === null || coupons === void 0 ? void 0 : coupons.join(',')
        });
      }
      if (params) {
        url.addSearch(params);
      }
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getPdfTicketsCoupons",
    value: function getPdfTicketsCoupons(id) {
      var downloadId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tickets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var coupons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      if (tickets !== null && tickets !== void 0 && tickets.length && !(coupons !== null && coupons !== void 0 && coupons.length)) {
        return this.getPdfTickets(id, downloadId, tickets);
      }
      if (coupons !== null && coupons !== void 0 && coupons.length && !(tickets !== null && tickets !== void 0 && tickets.length)) {
        return this.getPdfCoupons(id, downloadId, coupons);
      }
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/tickets_coupons.pdf"));
      var params = null;
      if (downloadId.length) {
        params = {
          downloadId: downloadId
        };
      }
      if (tickets !== null && tickets !== void 0 && tickets.length && coupons !== null && coupons !== void 0 && coupons.length) {
        params = _objectSpread2(_objectSpread2({}, params), {}, {
          tickets: tickets === null || tickets === void 0 ? void 0 : tickets.join(','),
          coupons: coupons === null || coupons === void 0 ? void 0 : coupons.join(',')
        });
      }
      if (params) {
        url.addSearch(params);
      }
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getTestCoupons",
    value: function getTestCoupons(id, format) {
      var offerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var entityType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var url = URI("".concat(this.getPathBase(), "/test/").concat(entityType ? "".concat(entityType, "/") : '').concat(id, "/coupons.").concat(format));
      if (offerId) {
        url = URI("".concat(this.getPathBase(), "/test/").concat(entityType ? "".concat(entityType, "/") : '').concat(id, "/offer-rule/").concat(offerId, "/coupons.").concat(format));
      }
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getPdfInvoices",
    value: function getPdfInvoices(id) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/invoices.pdf"));
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getXlsOrder",
    value: function getXlsOrder(id, locale) {
      var url = URI("/v1/entry_list/".concat(id, "/tickets.xlsx"));
      return this.authorizedFetch(url, {
        method: 'GET',
        headers: {
          'Accept-Language': locale
        }
      });
    }
  }, {
    key: "getFirstRescheduleOrderForOrder",
    value: function getFirstRescheduleOrderForOrder(order, fields) {
      var _this = this;
      if (!order.rescheduledFromOrder) {
        return Promise.resolve(order);
      }
      var mergedFields = ['@id', 'rescheduledFromOrder'];
      if (Array.isArray(fields)) {
        mergedFields = mergedFields.concat(fields);
      } else if (typeof fields === 'string') {
        mergedFields.push(fields);
      }
      var id = typeof order.rescheduledFromOrder === 'string' ? order.rescheduledFromOrder.replace('/v1/orders/', '') : order.rescheduledFromOrder.getShortId();
      return this.find(Number(id), mergedFields).then(function (o) {
        return _this.getFirstRescheduleOrderForOrder(o, fields);
      });
    }
  }, {
    key: "getPaymentProviderInformations",
    value: function getPaymentProviderInformations(order) {
      var url = URI("".concat(this.getEntityURI(order), "/payment-provider-information"));
      url.addSearch({
        downloadId: order.downloadId
      });
      return this.authorizedFetch(url, {
        method: 'GET'
      }).then(function (response) {
        return response.json();
      });
    }
  }, {
    key: "getOrderFromPaymentCallback",
    value: function getOrderFromPaymentCallback(orderId, contentCallback, signature, fields, params) {
      var url = URI("".concat(this.getPathBase(), "/").concat(orderId, "/payment_callback"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      if (params) {
        url.addSearch(params);
      }
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        headers: {
          'X-callback-signature': signature
        },
        body: JSON.stringify(contentCallback)
      }), 'item');
    }
  }]);
}(FormDataClient);

var PaymentClient = /*#__PURE__*/function (_AbstractClient) {
  function PaymentClient() {
    _classCallCheck(this, PaymentClient);
    return _callSuper(this, PaymentClient, arguments);
  }
  _inherits(PaymentClient, _AbstractClient);
  return _createClass(PaymentClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/payments';
    }
  }, {
    key: "checkout",
    value: function checkout(orderId, wallet, metadata, fields) {
      // eslint-disable-next-line no-console
      console.warn('PaymentClient.checkout is deprecated, please use .create instead');
      var url = new URI(this.getPathBase());
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify({
          order: orderId,
          wallet: wallet,
          provider: 'manual',
          providerMetadata: metadata
        })
      }), 'item');
    }
  }, {
    key: "refund",
    value: function refund(paymentId, fields) {
      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = new URI('/v1/refunds');
      url.addSearch({
        fields: getFieldsString(fields)
      });
      var postBody = _objectSpread2({
        payment: "".concat(paymentId)
      }, body);
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(postBody)
      }), 'item');
    }
  }, {
    key: "refundOrderItemList",
    value: function refundOrderItemList(_refundOrderItemList, fields) {
      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = new URI('/v1/refunds');
      url.addSearch({
        fields: getFieldsString(fields)
      });
      var postBody = _objectSpread2({
        refundOrderItemList: _refundOrderItemList
      }, body);

      /** @ts-expect-error -- calling a "response" endpoint in PaymentClient seems weird */
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(postBody)
      }), 'item');
    }
  }, {
    key: "updateProviderMetadata",
    value: function updateProviderMetadata(paymentId, providerMetadata, fields) {
      var url = new URI("".concat(paymentId, "/provider-metadata"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'PUT',
        body: JSON.stringify(providerMetadata)
      }), 'item');
    }
  }, {
    key: "updatePaymentTransactionList",
    value: function updatePaymentTransactionList(payment, fields) {
      var url = new URI("".concat(payment.get('@id')));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'PUT',
        body: JSON.stringify({
          paymentTransactionList: payment.paymentTransactionList
        })
      }), 'item');
    }
  }]);
}(AbstractClient);

/** @deprecated use `PAYMENT_PROVIDER.MANUAL` instead */
var PROVIDER_MANUAL = 'manual';
/** @deprecated use `PAYMENT_PROVIDER.STRIPE` instead */
var PROVIDER_STRIPE = 'stripe';
/** @deprecated use `PAYMENT_PROVIDER.MANGOPAY` instead */
var PROVIDER_MANGOPAY = 'mangopay';
/** @deprecated use `PAYMENT_PROVIDER.PAYLINE` instead */
var PROVIDER_PAYLINE = 'payline';
/** @deprecated use `PAYMENT_PROVIDER.PAYZONE` instead */
var PROVIDER_PAYZONE = 'payzone';
/** @deprecated use `PAYMENT_PROVIDER.PAYREXX` instead */
var PROVIDER_PAYREXX = 'payrexx';
/** @deprecated use `PAYMENT_PROVIDER.NONE` instead */
var NO_PROVIDER = 'none';
var PAYMENT_PROVIDER = /*#__PURE__*/function (PAYMENT_PROVIDER) {
  PAYMENT_PROVIDER["MANUAL"] = "manual";
  PAYMENT_PROVIDER["STRIPE"] = "stripe";
  PAYMENT_PROVIDER["MANGOPAY"] = "mangopay";
  PAYMENT_PROVIDER["PAYLINE"] = "payline";
  PAYMENT_PROVIDER["PAYZONE"] = "payzone";
  PAYMENT_PROVIDER["PAYREXX"] = "payrexx";
  PAYMENT_PROVIDER["NONE"] = "none";
  return PAYMENT_PROVIDER;
}({});
var EXTERNAL_PROVIDER_LIST$1 = [PAYMENT_PROVIDER.MANGOPAY, PAYMENT_PROVIDER.PAYLINE, PAYMENT_PROVIDER.STRIPE, PAYMENT_PROVIDER.PAYZONE, PAYMENT_PROVIDER.PAYREXX];
var DISTINCT_PAYMENT_MULTI_WALLET_PROVIDER_LIST = [PAYMENT_PROVIDER.PAYLINE, PAYMENT_PROVIDER.STRIPE, PAYMENT_PROVIDER.PAYZONE, PAYMENT_PROVIDER.PAYREXX];
var Payment = /*#__PURE__*/function (_NetworkEntity) {
  function Payment() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Payment'
    };
    _classCallCheck(this, Payment);
    _this = _callSuper(this, Payment, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Payment, _NetworkEntity);
  return _createClass(Payment, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/payments/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Payment',
  createdAt: null,
  customerPaidAmount: 0,
  orderStatus: '',
  statusDescription: '',
  order: null,
  paymentTransactionList: List(),
  provider: '',
  providerMetadata: Map$1(),
  originType: null,
  originId: null,
  wallet: null
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Payment.classMetadata = new ClassMetadata('payment', 'payments', PaymentClient);
Payment.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('@type'), new Attribute('customerPaidAmount', 'customerPaidAmount', 'integer'), new Attribute('orderStatus'), new Attribute('statusDescription'), new Attribute('provider'), new Attribute('providerMetadata', 'providerMetadata', 'object'), new Attribute('originType'), new Attribute('originId')]);
Payment.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.ONE_TO_MANY, 'transaction', 'paymentTransactionList'), new Relation(Relation.MANY_TO_ONE, 'wallet', 'wallet')]);

var STATUS_PAYED = 'payed';
var STATUS_REFUNDED_TOTALLY = 'refunded_totally';
var STATUS_REFUNDED_PARTIALLY = 'refunded_partially';
var STATUS_DESCRIPTION_CANCELLED = 'ticketing.order.cancelled';
var STATUS_FAILED = 'failed';
var STATUS_WAITING_3DS = 'waiting_3ds';
var Order = /*#__PURE__*/function (_NetworkEntity) {
  function Order() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Order'
    };
    _classCallCheck(this, Order);
    var data = clone(val);
    var tz = extractTimezone(data, ['contract', 'timezone']) || extractTimezone(data, ['orderItemList', 0, 'ticketing', 'timezone']);
    data.createdAt = parseDate(data.createdAt, tz);
    data.updatedAt = parseDate(data.updatedAt, tz);
    data.formData = getFormData(data);
    _this = _callSuper(this, Order, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Order, _NetworkEntity);
  return _createClass(Order, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/orders/', '')) || '';
    }

    /** @deprecated -- use `createdAt` directly */
  }, {
    key: "getLocalCreatedAt",
    value: function getLocalCreatedAt() {
      if (this.orderItemList && this.orderItemList.size > 0) {
        var _this$createdAt;
        var tz = this.orderItemList.getIn([0, 'ticketing', 'timezone']);

        /** @ts-expect-error -- conflict between moment and moment-timezone */
        return (_this$createdAt = this.createdAt) === null || _this$createdAt === void 0 ? void 0 : _this$createdAt.clone().tz(tz);
      }

      // if no orderItems, fallback to utc time
      return this.createdAt;
    }

    /** @deprecated -- use `updatedAt` directly */
  }, {
    key: "getLocalUpdatedAt",
    value: function getLocalUpdatedAt() {
      if (this.orderItemList && this.orderItemList.size > 0) {
        var tz = this.orderItemList.getIn([0, 'ticketing', 'timezone']);

        /** @ts-expect-error -- conflict between moment and moment-timezone */
        return this.updatedAt.clone().tz(tz);
      }

      // if no orderItems, fallback to utc time
      return this.updatedAt;
    }
  }, {
    key: "getSplittedInvoiceCount",
    value: function getSplittedInvoiceCount() {
      if (this.invoiceList && this.invoiceList.size > 0) {
        return this.invoiceList.filter(function (invoice) {
          if (_typeof(invoice) === 'object') {
            assertRelationIsObject(invoice, 'invoice');
            return invoice.type === INVOICE_TYPE.SPLIT_CANCEL_PAYMENT;
          }
          return false;
        }).size;
      }
      return 0;
    }
  }, {
    key: "getGdprMessage",
    value: function getGdprMessage() {
      assertRelationIsListOfObject(this.organizationalUnitList);
      var gdprOptinMessage = this.organizationalUnitList.map(function (organizationUnit) {
        return organizationUnit.get('gdprOptinMessage');
      }).filter(function (message) {
        return !!message && message.length > 0;
      }).toSet().join(', ');
      return gdprOptinMessage && gdprOptinMessage.length > 0 ? gdprOptinMessage : null;
    }
  }, {
    key: "getFormCustomerFields",
    value: function getFormCustomerFields() {
      var _this2 = this;
      var disabledFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var optionalFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.customerRequiredFields) {
        throw new Error('CustomerRequiredFields must be defined. Please check your request fields.');
      }
      var customerRequiredFields = this.customerRequiredFields.toJS();
      var formattedFieldList = customerRequiredFields.map(function (field) {
        var _this2$formData, _field$slug;
        var fieldWithFormattedKey = Object.keys(field).reduce(function (acc, key) {
          var formattedKey = key.startsWith('form') ? key.replace('form', '').toLowerCase() : key;
          return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, formattedKey, field[key]));
        }, field);
        var fieldOptions = field.options ? _objectSpread2(_objectSpread2({}, field.options), {}, {
          inputProps: _objectSpread2(_objectSpread2({}, field.options.inputProps), {}, {
            disabled: disabledFields,
            allowCreate: false
          }),
          options: addMissingOptionToFieldOptions(field.options.options, field.slug ? (_this2$formData = _this2.formData) === null || _this2$formData === void 0 ? void 0 : _this2$formData.get(field.slug) : null),
          isRequired: optionalFields ? false : field.required
        }) : {
          inputProps: {
            disabled: disabledFields,
            allowCreate: false
          },
          isRequired: optionalFields ? false : field.required
        };
        return _objectSpread2(_objectSpread2({}, fieldWithFormattedKey), {}, {
          label: (_field$slug = field.slug) !== null && _field$slug !== void 0 && _field$slug.includes('optinEmailInfo') ? _this2.getGdprMessage() : field.label,
          name: field.slug,
          options: fieldOptions
        });
      });
      return formattedFieldList;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Order',
  comment: null,
  status: '',
  statusDescription: null,
  currency: '',
  downloadId: '',
  payId: null,
  description: '',
  publicData: Map$1(),
  customer: new Customer(),
  contact: null,
  orderItemList: List(),
  orderItemInvoiceGroupList: null,
  organizationalUnitList: null,
  ticketList: List(),
  soldTicketQuantity: 0,
  nbTickets: null,
  nbCoupons: null,
  payment: new Payment(),
  contract: new Contract(),
  updatedAt: null,
  createdAt: null,
  createdCouponList: null,
  cart: new Cart(),
  customerPaidAmount: null,
  invoice: null,
  invoiceList: List(),
  bookingList: List(),
  originType: null,
  originId: null,
  customerRequiredFields: null,
  sellingDevice: null,
  transactionBalance: null,
  bankTransactionBalance: null,
  actionnableTransactionBalance: null,
  bankRefundTransactionBalance: null,
  balance: null,
  externalBalanceForOrder: null,
  retailValue: null,
  currentRetailValue: null,
  autoRefundable: null,
  nonRevertedPaymentTransactionList: null,
  tagList: List(),
  orderOnlyFeeAmount: null,
  paymentStatus: null,
  refundTransactionName: null,
  paymentTransactionName: null,
  rescheduledFromOrder: null,
  isSubscriptionOrder: null,
  subscriptionList: null,
  childrenList: List(),
  parent: null,
  autoGeneratedPaymentTransactionAmount: null,
  isSettled: null,
  isPaymentLinkOrder: null,
  sellingDeviceForPayment: null,
  paymentLink: null,
  paymentLinkList: undefined,
  shipping: null,
  billing: null,
  wallet: null,
  formData: null,
  paymentAttemptList: null,
  hasMovableSeats: null,
  owner: undefined,
  schoolMode: null,
  useAccountingV2Api: undefined
}));
/** @ts-expect-error -- method signature are incompatible */
Order.classMetadata = new ClassMetadata('order', 'orders', OrderClient);
Order.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('status'), new Attribute('paymentStatus'), new Attribute('refundTransactionName'), new Attribute('paymentTransactionName'), new Attribute('statusDescription'), new Attribute('currency'), new Attribute('downloadId'), new Attribute('payId'), new Attribute('description'), new Attribute('comment'), new Attribute('currentRetailValue', 'currentRetailValue', 'integer'), new Attribute('retailValue', 'retailValue', 'integer'), new Attribute('soldTicketQuantity', 'soldTicketQuantity', 'integer'), new Attribute('updatedAt', 'updatedAt', 'datetime'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('customerPaidAmount', 'customerPaidAmount', 'integer'), new Attribute('originType'), new Attribute('originId'), new Attribute('autoGeneratedPaymentTransactionAmount', 'autoGeneratedPaymentTransactionAmount', 'integer'), new Attribute('customerRequiredFields', 'customerRequiredFields', 'object'), new Attribute('publicData', 'publicData', 'object'), new Attribute('balance', 'balance', 'integer'), new Attribute('externalBalanceForOrder', 'externalBalanceForOrder', 'integer'), new Attribute('orderOnlyFeeAmount', 'orderOnlyFeeAmount', 'integer'), new Attribute('transactionBalance', 'transactionBalance', 'integer'), new Attribute('bankTransactionBalance', 'bankTransactionBalance', 'integer'), new Attribute('actionnableTransactionBalance', 'actionnableTransactionBalance', 'integer'), new Attribute('bankRefundTransactionBalance', 'bankRefundTransactionBalance', 'integer'), new Attribute('autoRefundable', 'autoRefundable', 'boolean'), new Attribute('isSubscriptionOrder', 'isSubscriptionOrder', 'boolean'), new Attribute('nbTickets', 'nbTickets', 'integer'), new Attribute('nbCoupons', 'nbCoupons', 'integer'), new Attribute('isSettled', 'isSettled', 'boolean'), new Attribute('isPaymentLinkOrder', 'isPaymentLinkOrder', 'boolean'), new Attribute('paymentLink'), new Attribute('hasMovableSeats', 'hasMovableSeats', 'boolean'), new Attribute('schoolMode', 'schoolMode', 'boolean'), new Attribute('useAccountingV2Api', 'useAccountingV2Api', 'boolean')]);
Order.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'customer', 'customer'), new Relation(Relation.MANY_TO_ONE, 'customer', 'contact'), new Relation(Relation.ONE_TO_MANY, 'orderItem', 'orderItemList'), new Relation(Relation.ONE_TO_MANY, 'orderItemInvoiceGroup', 'orderItemInvoiceGroupList'), new Relation(Relation.ONE_TO_MANY, 'ticket', 'ticketList'), new Relation(Relation.ONE_TO_MANY, 'booking', 'bookingList'), new Relation(Relation.ONE_TO_MANY, 'tag', 'tagList'), new Relation(Relation.MANY_TO_ONE, 'payment', 'payment'), new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'cart', 'cart'), new Relation(Relation.ONE_TO_ONE, 'order', 'parent'), new Relation(Relation.MANY_TO_ONE, 'invoice', 'invoice'), new Relation(Relation.ONE_TO_MANY, 'invoice', 'invoiceList'), new Relation(Relation.ONE_TO_MANY, 'subscription', 'subscriptionList'), new Relation(Relation.MANY_TO_ONE, 'sellingDevice', 'sellingDevice'), new Relation(Relation.MANY_TO_ONE, 'sellingDevice', 'sellingDeviceForPayment'), new Relation(Relation.ONE_TO_MANY, 'order', 'childrenList'), new Relation(Relation.ONE_TO_MANY, 'transaction', 'nonRevertedPaymentTransactionList'), new Relation(Relation.MANY_TO_ONE, 'order', 'rescheduledFromOrder'), new Relation(Relation.MANY_TO_ONE, 'shipping', 'shipping'), new Relation(Relation.MANY_TO_ONE, 'billing', 'billing'), new Relation(Relation.ONE_TO_MANY, 'coupon', 'createdCouponList'), new Relation(Relation.MANY_TO_ONE, 'wallet', 'wallet'), new Relation(Relation.ONE_TO_MANY, 'organizationalUnit', 'organizationalUnitList'), new Relation(Relation.ONE_TO_MANY, 'paymentAttempt', 'paymentAttemptList'), new Relation(Relation.MANY_TO_ONE, 'ticketingUser', 'owner'), new Relation(Relation.ONE_TO_MANY, 'paymentLink', 'paymentLinkList')]);

var MasterTicket = /*#__PURE__*/function (_NetworkEntity) {
  function MasterTicket(val) {
    var _this;
    _classCallCheck(this, MasterTicket);
    _this = _callSuper(this, MasterTicket, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(MasterTicket, _NetworkEntity);
  return _createClass(MasterTicket, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/master_tickets/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'MasterTicket',
  barcode: null,
  order: new Order(),
  data: null,
  ticketList: List(),
  participant: undefined
}));
MasterTicket.classMetadata = new ClassMetadata('masterTicket', 'master_tickets', /** @ts-expect-error -- method signature are incompatible */
MasterTicketClient);
MasterTicket.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('data', 'data', 'object'), new Attribute('barcode')]);
MasterTicket.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.ONE_TO_MANY, 'ticket', 'ticketList'), new Relation(Relation.MANY_TO_ONE, 'customer', 'participant')]);

var ModuleClient = /*#__PURE__*/function (_AbstractClient) {
  function ModuleClient() {
    _classCallCheck(this, ModuleClient);
    return _callSuper(this, ModuleClient, arguments);
  }
  _inherits(ModuleClient, _AbstractClient);
  return _createClass(ModuleClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/modules';
    }
  }]);
}(AbstractClient);

var PAGE_TYPE_HOME = 'home';
var PAGE_TYPE_EVENT = 'event';
var PAGE_TYPE_CART = 'cart';
var MODULE_TYPE = /*#__PURE__*/function (MODULE_TYPE) {
  MODULE_TYPE["PROGRAMME"] = "programme";
  MODULE_TYPE["INFORMATION"] = "information";
  MODULE_TYPE["RECOMMENDATION"] = "recommendation";
  MODULE_TYPE["PROMOTE"] = "promote";
  MODULE_TYPE["OFFER_PAGES"] = "offer_pages";
  MODULE_TYPE["TICKET_PRICES"] = "ticket_prices";
  MODULE_TYPE["EVENT_DATE_OFFERS"] = "event_date_offers";
  MODULE_TYPE["UPSELL"] = "upsell";
  return MODULE_TYPE;
}({});
var Module = /*#__PURE__*/function (_NetworkEntity) {
  function Module() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Module'
    };
    _classCallCheck(this, Module);
    _this = _callSuper(this, Module, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Module, _NetworkEntity);
  return _createClass(Module, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/modules/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Module',
  type: null,
  pageType: null,
  minisite: new Minisite(),
  configuration: Map$1(),
  position: null,
  canBe: null,
  ticketingList: null,
  ticketPriceList: null
}));
Module.classMetadata = new ClassMetadata('module', 'modules', /** @ts-expect-error -- method signature are incompatible */
ModuleClient);
Module.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type'), new Attribute('pageType'), new Attribute('configuration', 'configuration', 'object'), new Attribute('position', 'position', 'number'), new Attribute('canBe', 'canBe', 'object')]);
Module.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'minisite', 'minisite'), new Relation(Relation.MANY_TO_MANY, 'ticketing', 'ticketingList'), new Relation(Relation.MANY_TO_MANY, 'ticketPrice', 'ticketPriceList')]);

// eslint-disable-next-line no-shadow
var DOWNLOAD_TYPE = /*#__PURE__*/function (DOWNLOAD_TYPE) {
  DOWNLOAD_TYPE["ERROR_REPORT"] = "error-report";
  DOWNLOAD_TYPE["ORIGINAL_FILE"] = "original-file";
  return DOWNLOAD_TYPE;
}({});
var ProviderTicketImportedFileClient = /*#__PURE__*/function (_AbstractClient) {
  function ProviderTicketImportedFileClient() {
    _classCallCheck(this, ProviderTicketImportedFileClient);
    return _callSuper(this, ProviderTicketImportedFileClient, arguments);
  }
  _inherits(ProviderTicketImportedFileClient, _AbstractClient);
  return _createClass(ProviderTicketImportedFileClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/provider_ticket_imported_files';
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file, eventDateId, contractId, fields) {
      var uri = new URI(this.getPathBase());
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      var formData = new FormData();
      formData.append('file', file);
      formData.append('contract', contractId);
      if (eventDateId) {
        formData.append('eventDate', eventDateId);
      }
      return this.deserializeResponse(this.authorizedFetch(uri, {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': undefined // force Content-Type to undefined to avoid setting it to `application/json`. With the FormData, it will be set to `multipart/form-data`
        }
      }), 'item');
    }
  }, {
    key: "triggerMethod",
    value: function triggerMethod(entity, method, fields) {
      var uri = new URI("".concat(entity.get('@id'), "/").concat(method));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      var newSerializedModel = this.sdk.serializer.normalizeItem(entity, this.metadata);
      var mapping = newSerializedModel.mapping,
        externalProvider = newSerializedModel.externalProvider,
        scanTrack = newSerializedModel.scanTrack,
        strategy = newSerializedModel.strategy,
        strategyMode = newSerializedModel.strategyMode;
      var bodyToEncode = method === 'handle' ? {
        mapping: mapping,
        externalProvider: externalProvider,
        scanTrack: scanTrack,
        strategy: strategy,
        strategyMode: strategyMode
      } : {};
      return this.deserializeResponse(this.authorizedFetch(uri, {
        method: 'PUT',
        body: this.serializer.encodeItem(bodyToEncode, this.metadata)
      }), 'item');
    }
  }, {
    key: "handle",
    value: function handle(entity, fields) {
      return this.triggerMethod(entity, 'handle', fields);
    }
  }, {
    key: "retry",
    value: function retry(entity, fields) {
      return this.triggerMethod(entity, 'retry', fields);
    }
  }, {
    key: "download",
    value: function download(entityId, type) {
      var uri = new URI("".concat(this.getPathBase(), "/").concat(entityId, "/download/").concat(type));
      uri.addSearch({
        fields: getFieldsString(['@id'])
      });
      return this.authorizedFetch(uri, {
        method: 'GET'
      });
    }

    /* eslint-disable @typescript-eslint/no-unused-vars */
  }, {
    key: "create",
    value: function create(entity, queryParam, pathParameters) {
      throw new Error('Create method is forbidden on ImportedFileClient. Please use uploadFile method instead.');
    }
  }]);
}(AbstractClient);

// eslint-disable-next-line no-shadow
var DELIMITER = /*#__PURE__*/function (DELIMITER) {
  DELIMITER["COMMA"] = "comma";
  DELIMITER["SEMICOLON"] = "semicolon";
  DELIMITER["PIPE"] = "pipe";
  DELIMITER["TAB"] = "tab";
  return DELIMITER;
}({});
var Context = /*#__PURE__*/function (_Record) {
  function Context() {
    _classCallCheck(this, Context);
    return _callSuper(this, Context, arguments);
  }
  _inherits(Context, _Record);
  return _createClass(Context);
}(Record({
  delimiter: undefined,
  hasHeader: undefined,
  rowsToSkip: 0
}));

var ImportedFile = /*#__PURE__*/function (_NetworkEntity) {
  function ImportedFile() {
    _classCallCheck(this, ImportedFile);
    return _callSuper(this, ImportedFile, arguments);
  }
  _inherits(ImportedFile, _NetworkEntity);
  return _createClass(ImportedFile);
}(NetworkEntity({
  '@id': null,
  '@type': 'ImportedFile',
  fileName: null,
  size: null,
  mimeType: null,
  originalName: null,
  importedAt: null,
  type: null
}));

var Mapping = /*#__PURE__*/function (_Record) {
  function Mapping() {
    _classCallCheck(this, Mapping);
    return _callSuper(this, Mapping, arguments);
  }
  _inherits(Mapping, _Record);
  return _createClass(Mapping);
}(Record({
  columns: Map$1(),
  statuses: Map$1(),
  generateBarcode: undefined
}));

var Sheet = /*#__PURE__*/function (_Record) {
  function Sheet() {
    _classCallCheck(this, Sheet);
    return _callSuper(this, Sheet, arguments);
  }
  _inherits(Sheet, _Record);
  return _createClass(Sheet);
}(Record({
  columns: Map$1(),
  values: List(),
  distinctValues: Map$1(),
  sheetName: '',
  sheetIndex: 0,
  dataToImport: null
}));

var _excluded = ["columns", "values", "distinctValues"];
var STRATEGY = /*#__PURE__*/function (STRATEGY) {
  STRATEGY["FULL"] = "full";
  STRATEGY["CONTROL_ONLY"] = "control_only";
  return STRATEGY;
}({});
var STRATEGY_MODE = /*#__PURE__*/function (STRATEGY_MODE) {
  STRATEGY_MODE["SPLIT"] = "split";
  STRATEGY_MODE["GROUP"] = "group";
  STRATEGY_MODE["NONE"] = "none";
  return STRATEGY_MODE;
}({});
var ProviderTicketImportedFile = /*#__PURE__*/function (_Record) {
  function ProviderTicketImportedFile() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderTicketImportedFile'
    };
    _classCallCheck(this, ProviderTicketImportedFile);
    var data = clone(val);
    if (data.context) {
      data.context = new Context(data.context);
    }
    if (data.sheet) {
      var _data$sheet = data.sheet,
        columns = _data$sheet.columns,
        values = _data$sheet.values,
        distinctValues = _data$sheet.distinctValues,
        rest = _objectWithoutProperties(_data$sheet, _excluded);
      data.sheet = new Sheet(_objectSpread2({
        columns: Map$1(columns),
        values: List(values.map(function (map) {
          return Map$1(map);
        })),
        distinctValues: Map$1(distinctValues)
      }, rest));
    }
    if (data.mapping) {
      var _data$mapping = data.mapping,
        _columns = _data$mapping.columns,
        statuses = _data$mapping.statuses;
      data.mapping = new Mapping({
        columns: Map$1(_columns),
        statuses: Map$1(statuses)
      });
    }
    if (data.importedFile) {
      data.importedFile = new ImportedFile(data.importedFile);
    }
    data.importedAt = parseDate(data.importedAt, null);
    _this = _callSuper(this, ProviderTicketImportedFile, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(ProviderTicketImportedFile, _Record);
  return _createClass(ProviderTicketImportedFile, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/provider_ticket_imported_files/', '')) || '';
    }
  }]);
}(Record({
  '@id': null,
  '@type': 'ProviderTicketImportedFile',
  importedAt: null,
  importToken: null,
  sheet: null,
  mapping: null,
  importStatus: null,
  context: null,
  importedFile: null,
  externalProvider: null,
  eventDate: null,
  scanTrack: null,
  ticketList: null,
  totalTicketsImported: null,
  canBeDeleted: null,
  canBeRetried: null,
  canDownloadErrorReport: null,
  canDownloadOriginalFile: null,
  strategy: undefined,
  strategyMode: undefined,
  allowedProviders: undefined
}));
ProviderTicketImportedFile.classMetadata = new ClassMetadata('providerTicketImportedFile', 'provider_ticket_imported_files', /** @ts-expect-error -- method signature are incompatible */
ProviderTicketImportedFileClient);
ProviderTicketImportedFile.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('importedAt', 'importedAt', 'datetime'), new Attribute('importToken'), new Attribute('importStatus'), new Attribute('externalProvider'), new Attribute('sheet', 'sheet', 'object'), new Attribute('context', 'context', 'object'), new Attribute('mapping', 'mapping', 'object'), new Attribute('totalTicketsImported', 'totalTicketsImported', 'integer'), new Attribute('canBeDeleted', 'canBeDeleted', 'boolean'), new Attribute('canBeRetried', 'canBeRetried', 'boolean'), new Attribute('canDownloadErrorReport', 'canDownloadErrorReport', 'boolean'), new Attribute('canDownloadOriginalFile', 'canDownloadOriginalFile', 'boolean'), new Attribute('allowedProviders', 'allowedProviders', 'array'), new Attribute('strategy', 'strategy', 'string'), new Attribute('strategyMode', 'strategyMode', 'string')]);
ProviderTicketImportedFile.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'ticket', 'ticketList'), new Relation(Relation.MANY_TO_ONE, 'eventDate', 'eventDate'), new Relation(Relation.MANY_TO_ONE, 'scanTrack', 'scanTrack')]);

var SibilParameterClient = /*#__PURE__*/function (_BaseClient) {
  function SibilParameterClient() {
    _classCallCheck(this, SibilParameterClient);
    return _callSuper(this, SibilParameterClient, arguments);
  }
  _inherits(SibilParameterClient, _BaseClient);
  return _createClass(SibilParameterClient, [{
    key: "getPathBase",
    value:
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function getPathBase(pathParameters) {
      return '/v1/module/sibil/parameters';
    }
  }]);
}(AbstractClient$1);

var defaultValues$3 = {
  '@id': null,
  '@type': 'SibilParameter',
  name: null,
  sibilUsername: null,
  sibilPassword: null,
  contract: null
};
var SibilParameterRecordFactory = NetworkEntity(defaultValues$3);
var SibilParameter = /*#__PURE__*/function (_SibilParameterRecord) {
  function SibilParameter(val) {
    var _this;
    _classCallCheck(this, SibilParameter);
    _this = _callSuper(this, SibilParameter, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(SibilParameter, _SibilParameterRecord);
  return _createClass(SibilParameter, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/module/sibil/parameters/', '')) || null;
    }
  }]);
}(SibilParameterRecordFactory);
SibilParameter.classMetadata = new ClassMetadata('sibilParameter', 'module/sibil/parameters', /** @ts-expect-error -- method signature are incompatible */
SibilParameterClient);
SibilParameter.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('sibilUsername'), new Attribute('sibilPassword')]);
SibilParameter.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var SibilTicketingSpectacleClient = /*#__PURE__*/function (_BaseClient) {
  function SibilTicketingSpectacleClient() {
    _classCallCheck(this, SibilTicketingSpectacleClient);
    return _callSuper(this, SibilTicketingSpectacleClient, arguments);
  }
  _inherits(SibilTicketingSpectacleClient, _BaseClient);
  return _createClass(SibilTicketingSpectacleClient, [{
    key: "getPathBase",
    value:
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function getPathBase(pathParameters) {
      return '/v1/module/sibil/ticketing_spectacles';
    }
  }]);
}(AbstractClient$1);

var defaultValues$2 = {
  '@id': null,
  '@type': 'SibilTicketingSpectacle',
  ticketing: null,
  spectacleId: null,
  festivalId: null,
  sibilParameter: null,
  coproduction: null,
  jeunePublic: null
};
var SibilTicketingSpectacle = /*#__PURE__*/function (_NetworkEntity) {
  function SibilTicketingSpectacle(val) {
    var _this;
    _classCallCheck(this, SibilTicketingSpectacle);
    _this = _callSuper(this, SibilTicketingSpectacle, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(SibilTicketingSpectacle, _NetworkEntity);
  return _createClass(SibilTicketingSpectacle, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/module/sibil/ticketing_spectacles/', '')) || null;
    }
  }]);
}(NetworkEntity(defaultValues$2));
SibilTicketingSpectacle.classMetadata = new ClassMetadata('sibilTicketingSpectacle', 'module/sibil/ticketing_spectacles', /** @ts-expect-error -- method signature are incompatible */
SibilTicketingSpectacleClient);
SibilTicketingSpectacle.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('spectacleId', 'spectacleId', 'integer'), new Attribute('festivalId', 'festivalId', 'integer'), new Attribute('coproduction', 'coproduction', 'boolean'), new Attribute('jeunePublic', 'jeunePublic', 'boolean')]);
SibilTicketingSpectacle.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'ticketing', 'ticketing'), new Relation(Relation.MANY_TO_ONE, 'sibilParameter', 'sibilParameter')]);

var ProviderContingentMappingClient = /*#__PURE__*/function (_AbstractClient) {
  function ProviderContingentMappingClient() {
    _classCallCheck(this, ProviderContingentMappingClient);
    return _callSuper(this, ProviderContingentMappingClient, arguments);
  }
  _inherits(ProviderContingentMappingClient, _AbstractClient);
  return _createClass(ProviderContingentMappingClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/provider_contingent_mappings';
    }
  }]);
}(AbstractClient);

var ProviderContingentMapping = /*#__PURE__*/function (_NetworkEntity) {
  function ProviderContingentMapping() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderContingentMapping'
    };
    _classCallCheck(this, ProviderContingentMapping);
    _this = _callSuper(this, ProviderContingentMapping, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ProviderContingentMapping, _NetworkEntity);
  return _createClass(ProviderContingentMapping, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/provider_contingent_mappings/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ProviderContingentMapping',
  contract: undefined,
  contingent: undefined,
  label: undefined,
  isMapped: undefined,
  isDefault: undefined,
  isIgnored: undefined,
  nbProviderAutoImportedTicketToProcess: undefined,
  nbProviderAutoImportedTicketProcessed: undefined,
  nbProviderAutoImportedTicket: undefined
}));
ProviderContingentMapping.classMetadata = new ClassMetadata('providerContingentMapping', 'provider_contingent_mappings', /** @ts-expect-error -- method signature are incompatible */
ProviderContingentMappingClient);
ProviderContingentMapping.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('provider'), new Attribute('label'), new Attribute('isMapped', 'isMapped', 'boolean'), new Attribute('isDefault', 'isDefault', 'boolean'), new Attribute('isIgnored', 'isIgnored', 'boolean'), new Attribute('nbProviderAutoImportedTicketToProcess', 'nbProviderAutoImportedTicketToProcess', 'integer'), new Attribute('nbProviderAutoImportedTicketProcessed', 'nbProviderAutoImportedTicketProcessed', 'integer'), new Attribute('nbProviderAutoImportedTicket', 'nbProviderAutoImportedTicket', 'integer')]);
ProviderContingentMapping.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'contingent', 'contingent')]);

var ProviderSeatMappingClient = /*#__PURE__*/function (_AbstractClient) {
  function ProviderSeatMappingClient() {
    _classCallCheck(this, ProviderSeatMappingClient);
    return _callSuper(this, ProviderSeatMappingClient, arguments);
  }
  _inherits(ProviderSeatMappingClient, _AbstractClient);
  return _createClass(ProviderSeatMappingClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/provider_seat_mappings';
    }
  }]);
}(AbstractClient);

var ProviderSeatMapping = /*#__PURE__*/function (_NetworkEntity) {
  function ProviderSeatMapping() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderSeatMapping'
    };
    _classCallCheck(this, ProviderSeatMapping);
    _this = _callSuper(this, ProviderSeatMapping, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ProviderSeatMapping, _NetworkEntity);
  return _createClass(ProviderSeatMapping, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/provider_seat_mappings/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ProviderSeatMapping',
  contract: undefined,
  provider: undefined,
  seat: undefined,
  label: undefined,
  isMapped: undefined,
  nbProviderAutoImportedTicketToProcess: undefined,
  nbProviderAutoImportedTicketProcessed: undefined,
  nbProviderAutoImportedTicket: undefined
}));
ProviderSeatMapping.classMetadata = new ClassMetadata('providerSeatMapping', 'provider_seat_mappings', /** @ts-expect-error -- method signature are incompatible */
ProviderSeatMappingClient);
ProviderSeatMapping.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('provider'), new Attribute('label'), new Attribute('isMapped', 'isMapped', 'boolean'), new Attribute('nbProviderAutoImportedTicketToProcess', 'nbProviderAutoImportedTicketToProcess', 'integer'), new Attribute('nbProviderAutoImportedTicketProcessed', 'nbProviderAutoImportedTicketProcessed', 'integer'), new Attribute('nbProviderAutoImportedTicket', 'nbProviderAutoImportedTicket', 'integer')]);
ProviderSeatMapping.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'seat', 'seat')]);

var ProviderSeatConfigMappingClient = /*#__PURE__*/function (_AbstractClient) {
  function ProviderSeatConfigMappingClient() {
    _classCallCheck(this, ProviderSeatConfigMappingClient);
    return _callSuper(this, ProviderSeatConfigMappingClient, arguments);
  }
  _inherits(ProviderSeatConfigMappingClient, _AbstractClient);
  return _createClass(ProviderSeatConfigMappingClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/provider_seat_config_mappings';
    }
  }]);
}(AbstractClient);

var ProviderSeatConfigMapping = /*#__PURE__*/function (_NetworkEntity) {
  function ProviderSeatConfigMapping() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderSeatConfigMapping'
    };
    _classCallCheck(this, ProviderSeatConfigMapping);
    _this = _callSuper(this, ProviderSeatConfigMapping, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ProviderSeatConfigMapping, _NetworkEntity);
  return _createClass(ProviderSeatConfigMapping, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/provider_seat_config_mappings/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ProviderSeatConfigMapping',
  contract: undefined,
  provider: undefined,
  seatConfigName: undefined,
  seatConfig: undefined,
  label: undefined,
  isMapped: undefined,
  providerSeatMappingList: undefined,
  isIgnored: undefined,
  isFreeSeating: undefined,
  nbProviderAutoImportedTicketToProcess: undefined,
  nbProviderAutoImportedTicketProcessed: undefined,
  nbProviderAutoImportedTicket: undefined
}));
ProviderSeatConfigMapping.classMetadata = new ClassMetadata('providerSeatConfigMapping', 'provider_seat_config_mappings', /** @ts-expect-error -- method signature are incompatible */
ProviderSeatConfigMappingClient);
ProviderSeatConfigMapping.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('provider'), new Attribute('label'), new Attribute('seatConfigName'), new Attribute('isMapped', 'isMapped', 'boolean'), new Attribute('isIgnored', 'isIgnored', 'boolean'), new Attribute('isFreeSeating', 'isFreeSeating', 'boolean'), new Attribute('nbProviderAutoImportedTicketToProcess', 'nbProviderAutoImportedTicketToProcess', 'integer'), new Attribute('nbProviderAutoImportedTicketProcessed', 'nbProviderAutoImportedTicketProcessed', 'integer'), new Attribute('nbProviderAutoImportedTicket', 'nbProviderAutoImportedTicket', 'integer')]);
ProviderSeatConfigMapping.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'seatConfig', 'seatConfig'), new Relation(Relation.ONE_TO_MANY, 'providerSeatMapping', 'providerSeatMappingList')]);

var ProviderTicketPriceMappingClient = /*#__PURE__*/function (_AbstractClient) {
  function ProviderTicketPriceMappingClient() {
    _classCallCheck(this, ProviderTicketPriceMappingClient);
    return _callSuper(this, ProviderTicketPriceMappingClient, arguments);
  }
  _inherits(ProviderTicketPriceMappingClient, _AbstractClient);
  return _createClass(ProviderTicketPriceMappingClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/provider_ticket_price_mappings';
    }
  }]);
}(AbstractClient);

var ProviderTicketPriceMapping = /*#__PURE__*/function (_NetworkEntity) {
  function ProviderTicketPriceMapping() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderTicketPriceMapping'
    };
    _classCallCheck(this, ProviderTicketPriceMapping);
    _this = _callSuper(this, ProviderTicketPriceMapping, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ProviderTicketPriceMapping, _NetworkEntity);
  return _createClass(ProviderTicketPriceMapping, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/provider_ticket_price_mappings/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ProviderTicketPriceMapping',
  contract: undefined,
  provider: undefined,
  ticketPrice: undefined,
  label: undefined,
  isMapped: undefined,
  eventName: undefined,
  isIgnored: undefined,
  nbProviderAutoImportedTicketToProcess: undefined,
  nbProviderAutoImportedTicketProcessed: undefined,
  nbProviderAutoImportedTicket: undefined
}));
ProviderTicketPriceMapping.classMetadata = new ClassMetadata('providerTicketPriceMapping', 'provider_ticket_price_mappings', /** @ts-expect-error -- method signature are incompatible */
ProviderTicketPriceMappingClient);
ProviderTicketPriceMapping.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('provider'), new Attribute('label'), new Attribute('isMapped', 'isMapped', 'boolean'), new Attribute('eventName'), new Attribute('isIgnored', 'isIgnored', 'boolean'), new Attribute('nbProviderAutoImportedTicketToProcess', 'nbProviderAutoImportedTicketToProcess', 'integer'), new Attribute('nbProviderAutoImportedTicketProcessed', 'nbProviderAutoImportedTicketProcessed', 'integer'), new Attribute('nbProviderAutoImportedTicket', 'nbProviderAutoImportedTicket', 'integer')]);
ProviderTicketPriceMapping.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'ticketPrice', 'ticketPrice')]);

var ProviderTicketingMappingClient = /*#__PURE__*/function (_AbstractClient) {
  function ProviderTicketingMappingClient() {
    _classCallCheck(this, ProviderTicketingMappingClient);
    return _callSuper(this, ProviderTicketingMappingClient, arguments);
  }
  _inherits(ProviderTicketingMappingClient, _AbstractClient);
  return _createClass(ProviderTicketingMappingClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/provider_ticketing_mappings';
    }
  }]);
}(AbstractClient);

var ProviderTicketingMapping = /*#__PURE__*/function (_NetworkEntity) {
  function ProviderTicketingMapping() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderTicketingMapping'
    };
    _classCallCheck(this, ProviderTicketingMapping);
    _this = _callSuper(this, ProviderTicketingMapping, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ProviderTicketingMapping, _NetworkEntity);
  return _createClass(ProviderTicketingMapping, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/provider_ticketing_mappings/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ProviderTicketingMapping',
  contract: undefined,
  provider: undefined,
  ticketing: undefined,
  label: undefined,
  eventCode: undefined,
  isMapped: undefined,
  providerTicketPriceMappingList: undefined,
  isIgnored: undefined,
  nbProviderAutoImportedTicketToProcess: undefined,
  nbProviderAutoImportedTicketProcessed: undefined,
  nbProviderAutoImportedTicket: undefined
}));
ProviderTicketingMapping.classMetadata = new ClassMetadata('providerTicketingMapping', 'provider_ticketing_mappings', /** @ts-expect-error -- method signature are incompatible */
ProviderTicketingMappingClient);
ProviderTicketingMapping.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('provider'), new Attribute('label'), new Attribute('eventCode'), new Attribute('isMapped', 'isMapped', 'boolean'), new Attribute('isIgnored', 'isIgnored', 'boolean'), new Attribute('nbProviderAutoImportedTicketToProcess', 'nbProviderAutoImportedTicketToProcess', 'integer'), new Attribute('nbProviderAutoImportedTicketProcessed', 'nbProviderAutoImportedTicketProcessed', 'integer'), new Attribute('nbProviderAutoImportedTicket', 'nbProviderAutoImportedTicket', 'integer')]);
ProviderTicketingMapping.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'ticketing', 'ticketing'), new Relation(Relation.ONE_TO_MANY, 'providerTicketPriceMapping', 'providerTicketPriceMappingList')]);

var ProviderMappingNotificationClient = /*#__PURE__*/function (_AbstractClient) {
  function ProviderMappingNotificationClient() {
    _classCallCheck(this, ProviderMappingNotificationClient);
    return _callSuper(this, ProviderMappingNotificationClient, arguments);
  }
  _inherits(ProviderMappingNotificationClient, _AbstractClient);
  return _createClass(ProviderMappingNotificationClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/provider_mapping_notifications';
    }
  }]);
}(AbstractClient);

var PROVIDER_MAPPING_NOTIFICATION_TYPE = /*#__PURE__*/function (PROVIDER_MAPPING_NOTIFICATION_TYPE) {
  PROVIDER_MAPPING_NOTIFICATION_TYPE["ERROR"] = "error";
  PROVIDER_MAPPING_NOTIFICATION_TYPE["MISSING"] = "missing";
  return PROVIDER_MAPPING_NOTIFICATION_TYPE;
}({});
var PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE = /*#__PURE__*/function (PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE) {
  PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE["TICKET_PRICE"] = "ticket_price";
  PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE["TICKETING"] = "ticketing";
  PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE["CONTINGENT"] = "contingent";
  PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE["STOCK_CONTINGENT"] = "stock_contingent";
  PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE["SEAT_CONFIG"] = "seat_config";
  PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE["SEAT"] = "seat";
  PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE["EVENT_DATE"] = "event_date";
  PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE["AVAILABLE_SEAT"] = "available_seat";
  return PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE;
}({});
var ProviderMappingNotification = /*#__PURE__*/function (_NetworkEntity) {
  function ProviderMappingNotification() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderMappingNotification'
    };
    _classCallCheck(this, ProviderMappingNotification);
    var data = clone(val);
    data.createdAt = parseDate(data.createdAt, null);
    _this = _callSuper(this, ProviderMappingNotification, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(ProviderMappingNotification, _NetworkEntity);
  return _createClass(ProviderMappingNotification, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/provider_mapping_notifications/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ProviderMappingNotification',
  type: undefined,
  mappingType: undefined,
  message: undefined,
  barCode: undefined,
  provider: undefined,
  createdAt: undefined,
  normalizedData: undefined,
  providerTicketImportedFile: undefined
}));
ProviderMappingNotification.classMetadata = new ClassMetadata('providerMappingNotification', 'provider_mapping_notifications', /** @ts-expect-error -- method signature are incompatible */
ProviderMappingNotificationClient);
ProviderMappingNotification.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type'), new Attribute('mappingType'), new Attribute('message'), new Attribute('barCode'), new Attribute('provider'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('normalizedData', 'normalizedData', 'object')]);
ProviderMappingNotification.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'providerTicketImportedFile', 'providerTicketImportedFile')]);

var SibilVenueLieuClient = /*#__PURE__*/function (_BaseClient) {
  function SibilVenueLieuClient() {
    _classCallCheck(this, SibilVenueLieuClient);
    return _callSuper(this, SibilVenueLieuClient, arguments);
  }
  _inherits(SibilVenueLieuClient, _BaseClient);
  return _createClass(SibilVenueLieuClient, [{
    key: "getPathBase",
    value:
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function getPathBase(pathParameters) {
      return '/v1/module/sibil/venue_lieux';
    }
  }]);
}(AbstractClient$1);

var defaultValues$1 = {
  '@id': null,
  '@type': 'SibilVenueLieu',
  venue: null,
  lieuId: null
};
var SibilVenueLieu = /*#__PURE__*/function (_NetworkEntity) {
  function SibilVenueLieu(val) {
    var _this;
    _classCallCheck(this, SibilVenueLieu);
    _this = _callSuper(this, SibilVenueLieu, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(SibilVenueLieu, _NetworkEntity);
  return _createClass(SibilVenueLieu, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/module/sibil/venue_lieux/', '')) || null;
    }
  }]);
}(NetworkEntity(defaultValues$1));
SibilVenueLieu.classMetadata = new ClassMetadata('sibilVenueLieu', 'module/sibil/venue_lieux', /** @ts-expect-error -- method signature are incompatible */
SibilVenueLieuClient);
SibilVenueLieu.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('lieuId', 'lieuId', 'integer')]);
SibilVenueLieu.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'venue', 'venue')]);

var NotificationClient = /*#__PURE__*/function (_AbstractClient) {
  function NotificationClient() {
    _classCallCheck(this, NotificationClient);
    return _callSuper(this, NotificationClient, arguments);
  }
  _inherits(NotificationClient, _AbstractClient);
  return _createClass(NotificationClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/notifications';
    }
  }]);
}(AbstractClient);

var Notification = /*#__PURE__*/function (_NetworkEntity) {
  function Notification(val) {
    var _this;
    _classCallCheck(this, Notification);
    _this = _callSuper(this, Notification, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Notification, _NetworkEntity);
  return _createClass(Notification, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/notifications/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Notification',
  active: false,
  contract: null,
  createdAt: null,
  message: null,
  displayStyle: null
}));
Notification.classMetadata = new ClassMetadata('notification', 'notifications', /** @ts-expect-error -- method signature are incompatible */
NotificationClient);
Notification.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('active'), new Attribute('createdAt'), new Attribute('message'), new Attribute('displayStyle')]);
Notification.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var OfferRuleClient = /*#__PURE__*/function (_AbstractClient) {
  function OfferRuleClient() {
    _classCallCheck(this, OfferRuleClient);
    return _callSuper(this, OfferRuleClient, arguments);
  }
  _inherits(OfferRuleClient, _AbstractClient);
  return _createClass(OfferRuleClient);
}(AbstractClient);

var OfferRule = /*#__PURE__*/function (_NetworkEntity) {
  function OfferRule() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'OfferRule'
    };
    _classCallCheck(this, OfferRule);
    var data = clone(val);
    data.validStartDate = parseDate(data.validStartDate, data.timezone);
    data.validEndDate = parseDate(data.validEndDate, data.timezone);
    _this = _callSuper(this, OfferRule, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(OfferRule, _NetworkEntity);
  return _createClass(OfferRule, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/offer_rules/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'OfferRule',
  contract: new Contract(),
  couponList: List(),
  title: '',
  description: null,
  color: null,
  image: '',
  message: null,
  conditionsText: '',
  enabled: false,
  archived: false,
  draft: true,
  validStartDate: null,
  validEndDate: null,
  timezone: '',
  hasApplier: false,
  handcrafted: false,
  triggerList: null,
  exchangeData: null,
  combinable: true,
  position: null,
  applicationData: null,
  applicationDataList: null,
  ticketPriceList: null,
  contractList: null,
  generateMasterTicket: false,
  isNominative: null,
  schemaVersion: null,
  isListed: null,
  hasCashCoupon: null,
  customerRequiredFields: Map$1(),
  templateParameters: Map$1(),
  bookingTrack: null,
  isGenericCashCoupon: null
}));
OfferRule.classMetadata = new ClassMetadata('offerRule', 'offer_rules', /** @ts-expect-error -- method signature are incompatible */
OfferRuleClient);
OfferRule.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('title'), new Attribute('description'), new Attribute('color'), new Attribute('image', 'image'), new Attribute('message', 'message', 'object'), new Attribute('conditionsText'), new Attribute('enabled', 'enabled', 'boolean'), new Attribute('draft', 'draft', 'boolean'), new Attribute('archived', 'archived', 'boolean'), new Attribute('validStartDate', 'validStartDate', 'datetime'), new Attribute('validEndDate', 'validEndDate', 'datetime'), new Attribute('timezone'), new Attribute('hasApplier', 'hasApplier', 'boolean'), new Attribute('handcrafted', 'handcrafted', 'boolean'), new Attribute('triggerList', 'triggerList', 'array'), new Attribute('exchangeData', 'exchangeData', 'object'), new Attribute('combinable', 'combinable', 'boolean'), new Attribute('generateMasterTicket', 'generateMasterTicket', 'boolean'), new Attribute('position', 'position', 'integer'), new Attribute('applicationDataList', 'applicationDataList', 'array'), new Attribute('isNominative', 'isNominative', 'boolean'), new Attribute('schemaVersion', 'schemaVersion', 'integer'), new Attribute('isListed', 'isListed', 'boolean'), new Attribute('hasCashCoupon', 'hasCashCoupon', 'boolean'), new Attribute('customerRequiredFields', 'customerRequiredFields', 'object'), new Attribute('templateParameters', 'templateParameters', 'object'), new Attribute('isGenericCashCoupon', 'isGenericCashCoupon', 'boolean')]);
OfferRule.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_MANY, 'ticketPrice', 'ticketPriceList'), new Relation(Relation.ONE_TO_MANY, 'coupon', 'couponList'), new Relation(Relation.MANY_TO_MANY, 'contract', 'contractList'), new Relation(Relation.MANY_TO_ONE, 'bookingTrack', 'bookingTrack')]);

var ORDER_ITEM_TYPE = /*#__PURE__*/function (ORDER_ITEM_TYPE) {
  ORDER_ITEM_TYPE["DEFAULT"] = "default";
  ORDER_ITEM_TYPE["SUBSCRIPTION"] = "subscription";
  ORDER_ITEM_TYPE["FEE"] = "fee";
  return ORDER_ITEM_TYPE;
}({});
var OrderItem = /*#__PURE__*/function (_NetworkEntity) {
  function OrderItem() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'OrderItem'
    };
    _classCallCheck(this, OrderItem);
    var data = clone(val);
    var tz = extractTimezone(data, ['ticketing', 'timezone']);
    data.createdAt = parseDate(data.createdAt, tz);
    data.updatedAt = parseDate(data.updatedAt, tz);
    data.cancelledAt = parseDate(data.cancelledAt, tz);
    _this = _callSuper(this, OrderItem, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(OrderItem, _NetworkEntity);
  return _createClass(OrderItem, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/order_items/', '')) || '';
    }

    /** @deprecated -- use `createdAt` instead */
  }, {
    key: "getLocalCreatedAt",
    value: function getLocalCreatedAt() {
      var tz = this.getIn(['ticketing', 'timezone']);
      if (tz && this.createdAt) {
        /** @ts-expect-error -- conflict between moment and moment-timezone */
        return this.createdAt.clone().tz(tz);
      }

      // if no timezone, fallback to utc time
      return this.createdAt;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'OrderItem',
  applicationId: null,
  data: null,
  customerPaidAmount: null,
  // TODO: remove when the clients are updated
  retailValue: null,
  amountForPro: null,
  feeAmount: null,
  vatRate: null,
  updatedAt: null,
  createdAt: null,
  ticketPrice: new TicketPrice(),
  eventDate: new EventDate(),
  ticketing: new Ticketing(),
  ticketList: List(),
  refundOrderItemList: List(),
  createdCoupon: null,
  appliedCoupon: null,
  order: null,
  refundedTotally: null,
  refunded: null,
  cancelled: null,
  cancelledAt: null,
  rescheduledToOrderItem: null,
  type: null,
  orderFeeItemList: null,
  offerRule: null,
  orderItemCashCouponList: null,
  stockContingent: null,
  facialValue: null,
  availableActions: null,
  swappedFromOrderItem: null,
  swappedToOrderItem: null
}));
OrderItem.classMetadata = new ClassMetadata('orderItem', 'order_items', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
OrderItem.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('applicationId', 'applicationId', 'string'), new Attribute('data', 'data', 'object'), new Attribute('customerPaidAmount', 'customerPaidAmount', 'integer'), new Attribute('retailValue', 'retailValue', 'integer'), new Attribute('amountForPro', 'amountForPro', 'integer'), new Attribute('feeAmount', 'feeAmount', 'integer'), new Attribute('vatRate', 'vatRate', 'integer'), new Attribute('updatedAt', 'updatedAt', 'datetime'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('refundedTotally', 'refundedTotally', 'boolean'), new Attribute('refunded', 'refunded', 'boolean'), new Attribute('cancelled', 'cancelled', 'boolean'), new Attribute('cancelledAt', 'cancelledAt', 'datetime'), new Attribute('type', 'type', 'string'), new Attribute('facialValue', 'facialValue', 'integer'), new Attribute('availableActions', 'availableActions', 'object')]);
OrderItem.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'orderItem', 'rescueduledToOrderItem'), new Relation(Relation.MANY_TO_ONE, 'ticketPrice', 'ticketPrice'), new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.MANY_TO_ONE, 'eventDate', 'eventDate'), new Relation(Relation.MANY_TO_ONE, 'ticketing', 'ticketing'), new Relation(Relation.ONE_TO_MANY, 'ticket', 'ticketList'), new Relation(Relation.ONE_TO_MANY, 'refundOrderItem', 'refundOrderItemList'), new Relation(Relation.MANY_TO_ONE, 'coupon', 'createdCoupon'), new Relation(Relation.MANY_TO_ONE, 'coupon', 'appliedCoupon'), new Relation(Relation.ONE_TO_MANY, 'orderFeeItem', 'orderFeeItemList'), new Relation(Relation.MANY_TO_ONE, 'offerRule', 'offerRule'), new Relation(Relation.ONE_TO_MANY, 'orderItemCashCoupon', 'orderItemCashCouponList'), new Relation(Relation.MANY_TO_ONE, 'stockContingent', 'stockContingent'), new Relation(Relation.MANY_TO_ONE, 'orderItem', 'swappedFromOrderItem'), new Relation(Relation.MANY_TO_ONE, 'orderItem', 'swappedToOrderItem')]);

var OrderItemInvoiceGroup = /*#__PURE__*/function (_NetworkEntity) {
  function OrderItemInvoiceGroup() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'OrderItemInvoiceGroup'
    };
    _classCallCheck(this, OrderItemInvoiceGroup);
    var data = clone(val);
    _this = _callSuper(this, OrderItemInvoiceGroup, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(OrderItemInvoiceGroup, _NetworkEntity);
  return _createClass(OrderItemInvoiceGroup, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/order_item_invoice_groups/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'OrderItemInvoiceGroup',
  orderItemList: null,
  label: null
}));
OrderItemInvoiceGroup.classMetadata = new ClassMetadata('orderItemInvoiceGroup', 'order_item_invoice_groups', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
OrderItemInvoiceGroup.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('label')]);
OrderItemInvoiceGroup.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'orderItem', 'orderItemList')]);

var OrderItemCashCoupon = /*#__PURE__*/function (_NetworkEntity) {
  function OrderItemCashCoupon() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'OrderItemCashCoupon'
    };
    _classCallCheck(this, OrderItemCashCoupon);
    var data = clone(val);
    _this = _callSuper(this, OrderItemCashCoupon, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(OrderItemCashCoupon, _NetworkEntity);
  return _createClass(OrderItemCashCoupon, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/order_item_cash_coupons/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'OrderItemCashCoupon',
  id: null,
  orderItem: null,
  cashCoupon: null,
  amount: null
}));
OrderItemCashCoupon.classMetadata = new ClassMetadata('orderItemCashCoupon', 'order_item_cash_coupons', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
OrderItemCashCoupon.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('id', 'id', 'number'), new Attribute('amount', 'amount', 'number')]);
OrderItemCashCoupon.classMetadata.setRelationList([new Relation(Relation.ONE_TO_ONE, 'orderItem', 'orderItem'), new Relation(Relation.ONE_TO_ONE, 'coupon', 'cashCoupon')]);

var OrganizationalUnitClient = /*#__PURE__*/function (_AbstractClient) {
  function OrganizationalUnitClient() {
    _classCallCheck(this, OrganizationalUnitClient);
    return _callSuper(this, OrganizationalUnitClient, arguments);
  }
  _inherits(OrganizationalUnitClient, _AbstractClient);
  return _createClass(OrganizationalUnitClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/organizational_units';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['organizational_unit_read', 'organizational_unit_write'];
    }
  }]);
}(AbstractClient);

var OrganizationalUnit = /*#__PURE__*/function (_NetworkEntity) {
  function OrganizationalUnit() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'OrganizationalUnit'
    };
    _classCallCheck(this, OrganizationalUnit);
    _this = _callSuper(this, OrganizationalUnit, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(OrganizationalUnit, _NetworkEntity);
  return _createClass(OrganizationalUnit, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/organizational_units/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'OrganizationalUnit',
  name: null,
  isDefault: null,
  contract: null,
  customerRequiredFields: Map$1(),
  hideFees: false,
  gdprOptinMessage: null,
  templateParameters: Map$1(),
  mailAdditionalInformation: null,
  notifyOnNewOrderSuccess: false,
  publicContactEmail: '',
  orderNotificationEmailList: null
}));
OrganizationalUnit.classMetadata = new ClassMetadata('organizationalUnit', 'organizational_units', /** @ts-expect-error -- method signature are incompatible */
OrganizationalUnitClient);
OrganizationalUnit.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('isDefault', 'isDefault', 'boolean'), new Attribute('customerRequiredFields', 'customerRequiredFields', 'object'), new Attribute('hideFees', 'hideFees', 'boolean'), new Attribute('mailAdditionalInformation'), new Attribute('gdprOptinMessage'), new Attribute('publicContactEmail'), new Attribute('templateParameters', 'templateParameters', 'object'), new Attribute('notifyOnNewOrderSuccess', 'notifyOnNewOrderSuccess', 'boolean'), new Attribute('orderNotificationEmailList')]);
OrganizationalUnit.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

// eslint-disable-next-line no-shadow
var ViewType = /*#__PURE__*/function (ViewType) {
  ViewType["current"] = "@id";
  ViewType["first"] = "hydra:first";
  ViewType["last"] = "hydra:last";
  ViewType["next"] = "hydra:next";
  ViewType["previous"] = "hydra:previous";
  return ViewType;
}({});
var defaultValues = {
  '@id': null,
  '@type': 'hydra:PagedCollection',
  'hydra:totalItems': 0,
  'hydra:itemsPerPage': 0,
  'hydra:firstPage': null,
  'hydra:lastPage': null,
  'hydra:member': List(),
  'hydra:view': Map$1(),
  'mapado:filters': null
};
var PagedCollectionFactory = NetworkEntity(defaultValues);
var PagedCollection = /*#__PURE__*/function (_PagedCollectionFacto) {
  function PagedCollection(val) {
    var _this;
    _classCallCheck(this, PagedCollection);
    var data = clone(val);
    var parameters = _objectSpread2(_objectSpread2({}, data), {}, {
      'hydra:member': data['hydra:member'] ? List(data['hydra:member'].map(function (member) {
        return createEntity(member);
      })) : List(),
      'hydra:view': data['hydra:view'] ? fromJS(data['hydra:view']) : Map$1()
    });
    var out = _this = _callSuper(this, PagedCollection, [parameters]);
    _this.index = 0;

    // TODO remove this useless return ? (See https://www.bennadel.com/blog/2522-providing-a-return-value-in-a-javascript-constructor.htm)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /** @ts-expect-error */
    return _possibleConstructorReturn(_this, out);
  }
  _inherits(PagedCollection, _PagedCollectionFacto);
  return _createClass(PagedCollection, [{
    key: Symbol.iterator,
    value: function value() {
      var _this2 = this;
      return {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        next: function next() {
          if (_this2.index < _this2.getMembers().size) {
            return {
              // eslint-disable-next-line no-plusplus
              value: _this2.getMembers().get(_this2.index++),
              done: false
            };
          }
          _this2.index = 0; // If we would like to iterate over this again without forcing manual update of the index
          return {
            done: true,
            value: undefined
          };
        }
      };
    }
  }, {
    key: "getPage",
    value: function getPage(type) {
      return this['hydra:view'].get(type) || null;
    }
  }, {
    key: "getFirstPage",
    value: function getFirstPage() {
      return this.getPage(ViewType.first);
    }
  }, {
    key: "getCurrentPage",
    value: function getCurrentPage() {
      return this.getPage(ViewType.current);
    }
  }, {
    key: "getNextPage",
    value: function getNextPage() {
      return this.getPage(ViewType.next);
    }
  }, {
    key: "getLastPage",
    value: function getLastPage() {
      return this.getPage(ViewType.last);
    }
  }, {
    key: "getPreviousPage",
    value: function getPreviousPage() {
      return this.getPage(ViewType.previous);
    }
  }, {
    key: "getMembers",
    value: function getMembers() {
      return this['hydra:member'];
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /** @ts-expect-error */
  }, {
    key: "merge",
    value: function merge(newPagedCollection) {
      var newMembers = this.getMembers()
      // concat the two lists
      .concat(newPagedCollection.getMembers())
      // group by id to reduce duplicates
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- the @id is defined for all our entities */.groupBy(function (m) {
        return m.get('@id');
      })
      // reduce duplicate using `merge` function or the Record
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- hard to work on that, working for now */.map(function (memberList) {
        return memberList.reduce(function (prev, curr) {
          return prev.merge(curr);
        });
      });
      var newMembersSize = newMembers.size;
      var newCollection = this.set('hydra:member', newMembers.valueSeq().toList()).set('hydra:totalItems', newMembersSize);
      if (newMembersSize !== this.get('hydra:totalItems') || !is(newCollection, this)) {
        return newCollection;
      }
      return this;
    }
  }]);
}(PagedCollectionFactory);

var PaymentFee = /*#__PURE__*/function (_NetworkEntity) {
  function PaymentFee() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'PaymentFee'
    };
    _classCallCheck(this, PaymentFee);
    _this = _callSuper(this, PaymentFee, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(PaymentFee, _NetworkEntity);
  return _createClass(PaymentFee, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/payment_fees/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'PaymentFee',
  isPublic: false,
  comment: null,
  formula: null
}));
PaymentFee.classMetadata = new ClassMetadata('paymentFee', 'payment_fees', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
PaymentFee.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('isPublic'), new Attribute('comment'), new Attribute('formula')]);

var ProviderTicketCredentials = /*#__PURE__*/function (_NetworkEntity) {
  function ProviderTicketCredentials() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderTicketCredentials'
    };
    _classCallCheck(this, ProviderTicketCredentials);
    _this = _callSuper(this, ProviderTicketCredentials, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ProviderTicketCredentials, _NetworkEntity);
  return _createClass(ProviderTicketCredentials, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/provider_ticket_credentials/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ProviderTicketCredentials',
  contract: null,
  param1: null,
  param2: null,
  param3: null,
  providerName: null,
  providerType: null,
  active: 1
}));
ProviderTicketCredentials.classMetadata = new ClassMetadata('providerTicketCredentials', 'provider_ticket_credentials', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
ProviderTicketCredentials.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('param1'), new Attribute('param2'), new Attribute('param3'), new Attribute('providerName'), new Attribute('providerType'), new Attribute('active')]);
ProviderTicketCredentials.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var Refund = /*#__PURE__*/function (_NetworkEntity) {
  function Refund() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Refund'
    };
    _classCallCheck(this, Refund);
    _this = _callSuper(this, Refund, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Refund, _NetworkEntity);
  return _createClass(Refund, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/refunds/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Refund',
  refundOrderItemList: List(),
  refundTransactionList: List()
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Refund.classMetadata = new ClassMetadata('refund', 'refunds', AbstractClient);
Refund.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type')]);
Refund.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'refundOrderItem', 'refundOrderItemList'), new Relation(Relation.ONE_TO_MANY, 'transaction', 'refundTransactionList')]);

var RefundOrderItem = /*#__PURE__*/function (_NetworkEntity) {
  function RefundOrderItem() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'RefundOrderItem'
    };
    _classCallCheck(this, RefundOrderItem);
    _this = _callSuper(this, RefundOrderItem, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(RefundOrderItem, _NetworkEntity);
  return _createClass(RefundOrderItem, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/refund_order_items/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'RefundOrderItem',
  orderItem: null,
  refund: null
}));
RefundOrderItem.classMetadata = new ClassMetadata('refundOrderItem', 'refund_order_items', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
RefundOrderItem.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type')]);
RefundOrderItem.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'orderItem', 'orderItem'), new Relation(Relation.MANY_TO_ONE, 'refund', 'refund')]);

var REPORTING_ACCOUNT_TYPE = /*#__PURE__*/function (REPORTING_ACCOUNT_TYPE) {
  REPORTING_ACCOUNT_TYPE["SALE"] = "sale";
  REPORTING_ACCOUNT_TYPE["BANK"] = "bank";
  REPORTING_ACCOUNT_TYPE["CLIENT"] = "client";
  REPORTING_ACCOUNT_TYPE["SALE_SUSPENSE"] = "sale_suspense";
  REPORTING_ACCOUNT_TYPE["SALE_ORDER_FEE"] = "sale_order_fee";
  REPORTING_ACCOUNT_TYPE["SALE_TICKET_FEE"] = "sale_ticket_fee";
  REPORTING_ACCOUNT_TYPE["SALE_SHIPPING_FEE"] = "sale_shipping_fee";
  REPORTING_ACCOUNT_TYPE["VAT"] = "vat";
  REPORTING_ACCOUNT_TYPE["VAT_SUSPENSE"] = "vat_suspense";
  return REPORTING_ACCOUNT_TYPE;
}({});
var REPORTING_ACCOUNT_ACCOUNTING_MODE = /*#__PURE__*/function (REPORTING_ACCOUNT_ACCOUNTING_MODE) {
  REPORTING_ACCOUNT_ACCOUNTING_MODE["EVENT_END"] = "event_end";
  REPORTING_ACCOUNT_ACCOUNTING_MODE["SALE_DATE"] = "sale_date";
  return REPORTING_ACCOUNT_ACCOUNTING_MODE;
}({});
var ReportingAccount = /*#__PURE__*/function (_NetworkEntity) {
  function ReportingAccount() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ReportingAccount'
    };
    _classCallCheck(this, ReportingAccount);
    var data = clone(val);
    var tz = extractTimezone(data, ['contract', 'timezone']);
    data.updatedAt = parseDate(data.updatedAt, tz);
    data.createdAt = parseDate(data.createdAt, tz);
    _this = _callSuper(this, ReportingAccount, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(ReportingAccount, _NetworkEntity);
  return _createClass(ReportingAccount, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/reporting_accounts/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ReportingAccount',
  name: undefined,
  type: undefined,
  code: undefined,
  label: undefined,
  budgetCode: undefined,
  budgetLabel: undefined,
  accountingMode: undefined,
  isDefault: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  contract: undefined,
  ticketingList: undefined,
  accountingClientList: undefined,
  deskPaymentMethodList: undefined,
  isHidden: null,
  linkedReportingAccount: undefined
}));
ReportingAccount.classMetadata = new ClassMetadata('reportingAccount', 'reporting_accounts', /** @ts-expect-error -- method signature are incompatible */
HidableClient);
ReportingAccount.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('updatedAt', 'updatedAt', 'datetime'), new Attribute('name'), new Attribute('type'), new Attribute('code'), new Attribute('label'), new Attribute('budgetCode'), new Attribute('budgetLabel'), new Attribute('accountingMode'), new Attribute('isDefault', 'isDefault', 'boolean'), new Attribute('isHidden', 'isHidden', 'boolean')]);
ReportingAccount.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.ONE_TO_MANY, 'ticketing', 'ticketingList'), new Relation(Relation.ONE_TO_MANY, 'accountingClient', 'accountingClientList'), new Relation(Relation.ONE_TO_MANY, 'deskPaymentMethod', 'deskPaymentMethodList'), new Relation(Relation.MANY_TO_ONE, 'reportingAccount', 'linkedReportingAccount')]);

var ScanClient = /*#__PURE__*/function (_AbstractClient) {
  function ScanClient() {
    _classCallCheck(this, ScanClient);
    return _callSuper(this, ScanClient, arguments);
  }
  _inherits(ScanClient, _AbstractClient);
  return _createClass(ScanClient, [{
    key: "getPathBase",
    value: function getPathBase(pathParameters) {
      if (!(pathParameters && pathParameters.ticket)) {
        return '/v1/scans';
      }
      var ticket = pathParameters.ticket;
      return "".concat(ticket, "/scans");
    }
  }]);
}(AbstractClient);

// taken (and simplified) from moment definition
var TicketClient = /*#__PURE__*/function (_AbstractClient) {
  function TicketClient() {
    _classCallCheck(this, TicketClient);
    return _callSuper(this, TicketClient, arguments);
  }
  _inherits(TicketClient, _AbstractClient);
  return _createClass(TicketClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/tickets';
    }
  }, {
    key: "findValidOrUpdatedSince",
    value: function findValidOrUpdatedSince(fields, params) {
      var updatedSince = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var updatedParams = params;
      if (updatedSince) {
        updatedParams.updatedSince = MomentInstance.moment.utc(updatedSince).toISOString();
      } else {
        updatedParams.isValid = true;
      }
      return this.findBy(updatedParams, fields);
    }
  }, {
    key: "findValidForToday",
    value: function findValidForToday(fields) {
      var updatedSince = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var statusList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var ticketPriceTypeList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var itemsPerPage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var params = {
        eventStartDate: 'auto'
      };
      if (statusList) {
        params.status = Array.isArray(statusList) ? statusList.join(',') : statusList;
      }
      if (ticketPriceTypeList) {
        params.ticketPriceType = Array.isArray(ticketPriceTypeList) ? ticketPriceTypeList.join(',') : ticketPriceTypeList;
      }
      if (itemsPerPage !== null) {
        params.itemsPerPage = itemsPerPage;
      }
      return this.findValidOrUpdatedSince(fields, params, updatedSince);
    }
  }, {
    key: "findValidByEventDateList",
    value: function findValidByEventDateList(eventDateList, fields) {
      var updatedSince = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var statusList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var ticketPriceTypeList = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var itemsPerPage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var eventDateIdList = eventDateList.map(function (eventDate) {
        return typeof eventDate === 'string' ? eventDate : eventDate.get('@id');
      }).join(',');
      var params = {
        eventDate: eventDateIdList
      };
      if (statusList) {
        params.status = Array.isArray(statusList) ? statusList.join(',') : statusList;
      }
      if (ticketPriceTypeList) {
        params.ticketPriceType = Array.isArray(ticketPriceTypeList) ? ticketPriceTypeList.join(',') : ticketPriceTypeList;
      }
      if (itemsPerPage !== null) {
        params.itemsPerPage = itemsPerPage;
      }
      return this.findValidOrUpdatedSince(fields, params, updatedSince);
    }
  }, {
    key: "findByEventDateList",
    value: function findByEventDateList(eventDateList, fields) {
      var statusList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var ticketPriceTypeList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var itemsPerPage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var eventDateIdList = eventDateList.map(function (eventDate) {
        return typeof eventDate === 'string' ? eventDate : eventDate.get('@id');
      }).join(',');
      var params = {
        eventDate: eventDateIdList
      };
      if (statusList) {
        params.status = Array.isArray(statusList) ? statusList.join(',') : statusList;
      }
      if (ticketPriceTypeList) {
        params.ticketPriceType = Array.isArray(ticketPriceTypeList) ? ticketPriceTypeList.join(',') : ticketPriceTypeList;
      }
      if (itemsPerPage !== null) {
        params.itemsPerPage = itemsPerPage;
      }
      return this.findBy(params, fields);
    }
  }, {
    key: "findUrlForTicketFile",
    value: function findUrlForTicketFile(id, format) {
      return this.makeUri("".concat(this.getPathBase(), "/").concat(id, ".").concat(format));
    }
  }, {
    key: "updateLastScannedDate",
    value: function updateLastScannedDate(ticket, fields) {
      var id = ticket.get('@id');
      if (!id) {
        throw new Error('Unable to get last scan date for a ticket without id');
      }
      var url = new URI(id);
      url.addSearch({
        fields: getFieldsString(fields)
      });
      var body = JSON.stringify({
        lastScannedDate: ticket.lastScannedDate
      });
      return this.authorizedFetch(url, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: body
      });
    }
  }, {
    key: "bulkUpdate",
    value: function bulkUpdate(tickets, fields, id, typeId) {
      var uri = new URI("".concat(this.getPathBase(), "/bulk"));
      uri.addSearch({
        fields: getFieldsString(fields)
      });
      if (typeId === 'downloadId') {
        uri.addSearch({
          downloadId: id
        });
      } else {
        uri.addSearch({
          payId: id
        });
      }
      var body = JSON.stringify({
        'hydra:member': tickets.toJS()
      });
      return this.authorizedFetch(uri, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: body
      });
    }
  }, {
    key: "unscan",
    value: function unscan(ticketId, fields) {
      var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var body = JSON.stringify({});
      var url = new URI("".concat(ticketId, "/unscan"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      Object.entries(queryParams).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        url.addSearch(_defineProperty({}, key, value));
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: body
      }), 'item');
    }
  }]);
}(AbstractClient);

var TICKET_PAYMENT_STATUS = /*#__PURE__*/function (TICKET_PAYMENT_STATUS) {
  TICKET_PAYMENT_STATUS["REFUNDED"] = "refunded";
  TICKET_PAYMENT_STATUS["CANCELLED"] = "cancelled";
  TICKET_PAYMENT_STATUS["PAYED"] = "payed";
  TICKET_PAYMENT_STATUS["BOOKED"] = "booked";
  return TICKET_PAYMENT_STATUS;
}({});
var Ticket = /*#__PURE__*/function (_NetworkEntity) {
  function Ticket() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Ticket'
    };
    _classCallCheck(this, Ticket);
    var data = clone(val);
    if (isEmptyArrayOrList(data.data)) {
      data.data = Map$1({});
    } else {
      data.data = fromJS(data.data);
    }
    var tz = data.ticketingTimezone;
    data.boughtAt = parseDate(data.boughtAt, tz);
    data.lastScannedDate = parseDate(data.lastScannedDate, tz);
    data.firstScannedDate = parseDate(data.firstScannedDate, tz);
    data.updatedAt = parseDate(data.updatedAt, tz);
    data.validStartDate = parseDate(data.validStartDate, tz);
    data.validEndDate = parseDate(data.validEndDate, tz);
    data.eventDateStartDate = parseDate(data.eventDateStartDate, tz);
    data.eventDateEndDate = parseDate(data.eventDateEndDate, tz);
    data.masterTicketList = val.masterTicketList ? val.masterTicketList.map(function (masterTicket) {
      if (typeof masterTicket === 'string') {
        return masterTicket;
      }
      return new MasterTicket(masterTicket);
    }) : List();
    data.participantFormData = getParticipantFormData(
    // @ts-expect-error participantRequiredFields and partitipant type issues
    data.participant, data.participantRequiredFields);
    _this = _callSuper(this, Ticket, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }

  /**
   * @deprecated use `eventDateStartDate` instead
   */
  _inherits(Ticket, _NetworkEntity);
  return _createClass(Ticket, [{
    key: "getLocalEventDateStartDate",
    value: function getLocalEventDateStartDate() {
      if (!this.eventDateStartDate) {
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- issue with moment timezone */
      return this.eventDateStartDate.clone().tz(this.ticketingTimezone);
    }

    /**
     * @deprecated use `eventDateEndDate` instead
     */
  }, {
    key: "getLocalEventDateEndDate",
    value: function getLocalEventDateEndDate() {
      if (!this.eventDateEndDate) {
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- issue with moment timezone */
      return this.eventDateEndDate.clone().tz(this.ticketingTimezone);
    }

    /**
     * @deprecated use `firstScannedDate` instead
     */
  }, {
    key: "getLocalFirstScannedDate",
    value: function getLocalFirstScannedDate() {
      if (!this.firstScannedDate) {
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- issue with moment timezone */
      return this.firstScannedDate.clone().tz(this.ticketingTimezone);
    }

    /**
     * @deprecated use `lastScannedDate` instead
     */
  }, {
    key: "getLocalLastScannedDate",
    value: function getLocalLastScannedDate() {
      if (!this.lastScannedDate) {
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- issue with moment timezone */
      return this.lastScannedDate.clone().tz(this.ticketingTimezone);
    }

    /**
     * @deprecated use `updatedAt` instead
     */
  }, {
    key: "getLocalUpdatedAt",
    value: function getLocalUpdatedAt() {
      if (!this.updatedAt) {
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- issue with moment timezone */
      return this.updatedAt.clone().tz(this.ticketingTimezone);
    }

    /**
     * @deprecated use `validStartDate` instead
     */
  }, {
    key: "getLocalValidStartDate",
    value: function getLocalValidStartDate() {
      if (!this.validStartDate) {
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- issue with moment timezone */
      return this.validStartDate.clone().tz(this.ticketingTimezone);
    }

    /**
     * @deprecated use `validEndDate` instead
     */
  }, {
    key: "getLocalValidEndDate",
    value: function getLocalValidEndDate() {
      if (!this.validEndDate) {
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- issue with moment timezone */
      return this.validEndDate.clone().tz(this.ticketingTimezone);
    }
  }, {
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/tickets/', '')) || '';
    }

    /**
     * user does not exists on ticket
     * @deprecated
     */
  }, {
    key: "getUserId",
    value: function getUserId() {
      return null;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return !!this.get('valid');
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /** @ts-expect-error -- possibly an conflict with Record */
  }, {
    key: "merge",
    value: function merge(newTicket) {
      var _this2 = this;
      var mostRecentTicket = this.updatedAt ? this : null;
      if (newTicket.updatedAt && (!this.updatedAt || newTicket.updatedAt > this.updatedAt)) {
        mostRecentTicket = newTicket;
      }
      if (mostRecentTicket) {
        return mostRecentTicket;
      }

      // fallback for ticketing without updatedAt property
      var newStatus = Object.values(TICKET_PAYMENT_STATUS).find(function (status) {
        return _this2.status === status || newTicket.status === status;
      });
      var newValidity;
      if (this.status === newTicket.status) {
        newValidity = this.valid && newTicket.valid;
      } else {
        newValidity = this.status === newStatus ? this.valid : newTicket.valid;
      }
      return newTicket.set('status', newStatus || null).set('valid', newValidity).set('lastScannedDate', this.lastScannedDate || newTicket.lastScannedDate).set('firstScannedDate', this.firstScannedDate || newTicket.firstScannedDate);
    }

    /** @deprecated  use ticket.participant infos instead */
  }, {
    key: "getFirstname",
    value: function getFirstname() {
      return this.getIn(['data', 'firstname']);
    }

    /** @deprecated  use ticket.participant infos instead */
  }, {
    key: "getLastname",
    value: function getLastname() {
      return this.getIn(['data', 'lastname']);
    }

    /** @deprecated  use ticket.participant infos instead */
  }, {
    key: "getFullname",
    value: function getFullname() {
      var out = '';
      if (this.getLastname()) {
        out += this.getLastname();
        out += ' ';
      }
      if (this.getFirstname()) {
        out += this.getFirstname();
      }
      return out;
    }
  }, {
    key: "getFormParticipantFields",
    value: function getFormParticipantFields() {
      var _this3 = this;
      var disabledFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var optionalFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.participantRequiredFields) {
        throw new Error('ParticipantRequiredFields must be defined. Please check your request fields.');
      }
      var participantRequiredFields = this.participantRequiredFields.toJS();
      var formattedFieldList = participantRequiredFields.map(function (field) {
        var _this3$participantFor;
        var fieldWithFormattedKey = Object.keys(field).reduce(function (acc, key) {
          var formattedKey = key.startsWith('form') ? key.replace('form', '').toLowerCase() : key;
          return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, formattedKey, field[key]));
        }, field);
        var fieldOptions = field.options ? _objectSpread2(_objectSpread2({}, field.options), {}, {
          inputProps: _objectSpread2(_objectSpread2({}, field.options.inputProps), {}, {
            disabled: disabledFields,
            allowCreate: false
          }),
          options: addMissingOptionToFieldOptions(field.options.options, field.slug ? (_this3$participantFor = _this3.participantFormData) === null || _this3$participantFor === void 0 ? void 0 : _this3$participantFor.get(field.slug) : null),
          isRequired: optionalFields ? false : field.required
        }) : {
          inputProps: {
            disabled: disabledFields,
            allowCreate: false
          },
          isRequired: optionalFields ? false : field.required
        };
        return _objectSpread2(_objectSpread2({}, fieldWithFormattedKey), {}, {
          name: field.slug,
          options: fieldOptions
        });
      });
      return formattedFieldList;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Ticket',
  data: null,
  facialValue: null,
  facialFeeValue: 0,
  currency: null,
  ticketPrice: new TicketPrice(),
  order: new Order(),
  orderItem: new OrderItem(),
  barcode: null,
  boughtAt: null,
  status: null,
  tax: null,
  refundedAt: null,
  firstScannedDate: null,
  lastScannedDate: null,
  ticketPriceName: '',
  ticketPriceType: '',
  valid: false,
  isUnlimited: null,
  cartItem: new CartItem(),
  updatedAt: null,
  maxScanNb: null,
  remainingScanNb: null,
  currentScanNb: 0,
  currentValidScanNb: 0,
  validStartDate: null,
  validEndDate: null,
  ticketingTitle: '',
  eventDateStartDate: null,
  eventDateEndDate: null,
  ticketingTimezone: '',
  ticketRequiredFields: null,
  participantRequiredFields: null,
  customerRequiredFields: null,
  eventDate: null,
  masterTicketList: List(),
  availableSeat: null,
  ticketCheckpointList: null,
  participant: null,
  isCustomized: false,
  participantFormData: null
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Ticket.classMetadata = new ClassMetadata('ticket', 'tickets', TicketClient);
Ticket.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('data', 'data', 'object'), new Attribute('facialValue', 'facialValue', 'integer'), new Attribute('currency'), new Attribute('barcode'), new Attribute('boughtAt', 'boughtAt', 'datetime'), new Attribute('status'), new Attribute('refundedAt', 'refundedAt', 'datetime'), new Attribute('firstScannedDate', 'firstScannedDate', 'datetime'), new Attribute('lastScannedDate', 'lastScannedDate', 'datetime'), new Attribute('ticketPriceName'), new Attribute('ticketPriceType'), new Attribute('valid', 'valid', 'boolean'), new Attribute('isUnlimited', 'isUnlimited', 'boolean'), new Attribute('updatedAt', 'updatedAt', 'datetime'), new Attribute('maxScanNb', 'maxScanNb', 'integer'), new Attribute('remainingScanNb', 'remainingScanNb', 'integer'), new Attribute('currentScanNb', 'currentScanNb', 'integer'), new Attribute('currentValidScanNb', 'currentValidScanNb', 'integer'), new Attribute('validStartDate', 'validStartDate', 'datetime'), new Attribute('validEndDate', 'validEndDate', 'datetime'), new Attribute('ticketingTitle'), new Attribute('eventDateStartDate', 'eventDateStartDate', 'datetime'), new Attribute('eventDateEndDate', 'eventDateEndDate', 'datetime'), new Attribute('ticketingTimezone'), new Attribute('ticketRequiredFields', 'ticketRequiredFields', 'object'), new Attribute('participantRequiredFields', 'participantRequiredFields', 'object'), new Attribute('customerRequiredFields', 'customerRequiredFields', 'object'), new Attribute('isCustomized', 'isCustomized', 'boolean')]);
Ticket.classMetadata.setRelationList([new Relation(Relation.MANY_TO_MANY, 'masterTicket', 'masterTicketList'), new Relation(Relation.MANY_TO_ONE, 'ticketPrice', 'ticketPrice'), new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.MANY_TO_ONE, 'orderItem', 'orderItem'), new Relation(Relation.MANY_TO_ONE, 'cartItem', 'cartItem'), new Relation(Relation.MANY_TO_ONE, 'availableSeat', 'availableSeat'), new Relation(Relation.ONE_TO_MANY, 'ticketCheckpoint', 'ticketCheckpointList'), new Relation(Relation.MANY_TO_ONE, 'customer', 'participant')]);

var Scan = /*#__PURE__*/function (_NetworkEntity) {
  function Scan() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Scan'
    };
    _classCallCheck(this, Scan);
    var data = clone(val);
    var tz = extractTimezone(data, ['ticket', 'ticketingTimezone']);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /** @ts-expect-error -- ticket is not converted now */
    data.ticket = data.ticket && createEntity(data.ticket);
    data.scanDate = parseDate(data.scanDate, tz);
    _this = _callSuper(this, Scan, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Scan, _NetworkEntity);
  return _createClass(Scan);
}(NetworkEntity({
  '@id': null,
  '@type': 'Scan',
  ticket: new Ticket(),
  scanDate: null,
  scannedBy: null,
  deviceId: null,
  deviceInfo: null,
  appModel: null,
  appVersion: null,
  status: null,
  eventDate: null,
  checkpoint: null
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Scan.classMetadata = new ClassMetadata('scan', 'scans', ScanClient);
Scan.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('scanDate', 'scanDate', 'datetime'), new Attribute('scannedBy'), new Attribute('deviceId'), new Attribute('deviceInfo'), new Attribute('appModel'), new Attribute('appVersion'), new Attribute('status')]);
Scan.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'ticket', 'ticket'), new Relation(Relation.MANY_TO_ONE, 'checkpoint', 'checkpoint')]);

var ScanConfig = /*#__PURE__*/function (_NetworkEntity) {
  function ScanConfig() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ScanConfig'
    };
    _classCallCheck(this, ScanConfig);
    _this = _callSuper(this, ScanConfig, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ScanConfig, _NetworkEntity);
  return _createClass(ScanConfig, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/scan_configs/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ScanConfig',
  contract: null,
  config: null
}));
ScanConfig.classMetadata = new ClassMetadata('scanConfig', 'scan_configs', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
ScanConfig.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('config', 'config', 'object')]);
ScanConfig.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var SeasonClient = /*#__PURE__*/function (_AbstractClient) {
  function SeasonClient() {
    _classCallCheck(this, SeasonClient);
    return _callSuper(this, SeasonClient, arguments);
  }
  _inherits(SeasonClient, _AbstractClient);
  return _createClass(SeasonClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/seasons';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['season_read', 'season_write'];
    }
  }]);
}(AbstractClient);

var SEASON_TYPE = /*#__PURE__*/function (SEASON_TYPE) {
  SEASON_TYPE["SEASON"] = "season";
  SEASON_TYPE["FESTIVAL"] = "festival";
  return SEASON_TYPE;
}({});
var Season = /*#__PURE__*/function (_NetworkEntity) {
  function Season() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Season'
    };
    _classCallCheck(this, Season);
    var data = clone(val);
    _this = _callSuper(this, Season, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Season, _NetworkEntity);
  return _createClass(Season, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/seasons/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Season',
  name: null,
  startDate: null,
  endDate: null,
  contract: null,
  ticketingList: null,
  type: null
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Season.classMetadata = new ClassMetadata('season', 'seasons', SeasonClient);
Season.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('startDate', 'startDate', 'datetime'), new Attribute('endDate', 'endDate', 'datetime'), new Attribute('type')]);
Season.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.ONE_TO_MANY, 'ticketing', 'ticketingList')]);

var SeatClient = /*#__PURE__*/function (_AbstractClient) {
  function SeatClient() {
    _classCallCheck(this, SeatClient);
    return _callSuper(this, SeatClient, arguments);
  }
  _inherits(SeatClient, _AbstractClient);
  return _createClass(SeatClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/seats';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['seat_read', 'seat_write'];
    }
  }]);
}(AbstractClient);

var SEAT_TYPE = /*#__PURE__*/function (SEAT_TYPE) {
  SEAT_TYPE["NORMAL"] = "normal";
  SEAT_TYPE["FOLDABLE"] = "foldable";
  SEAT_TYPE["STANDING"] = "standing";
  SEAT_TYPE["REDUCED_MOBILITY"] = "reduced_mobility";
  SEAT_TYPE["CHAIR"] = "chair";
  SEAT_TYPE["BENCH"] = "bench";
  SEAT_TYPE["BANQUETTE"] = "banquette";
  return SEAT_TYPE;
}({});
var Seat = /*#__PURE__*/function (_NetworkEntity) {
  function Seat() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Seat'
    };
    _classCallCheck(this, Seat);
    _this = _callSuper(this, Seat, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Seat, _NetworkEntity);
  return _createClass(Seat, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/seats/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Seat',
  seatConfig: undefined,
  seatGroup: undefined,
  position: null,
  info: null,
  stockContingent: null,
  angle: null,
  type: null,
  hasObstructedView: null,
  label: null,
  row: null,
  seatNumber: null,
  zone: null,
  zoneName: undefined,
  floor: undefined,
  coordinates: null
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Seat.classMetadata = new ClassMetadata('seat', 'seats', SeatClient);
Seat.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('position', 'position', 'number'), new Attribute('angle', 'angle', 'number'), new Attribute('type', 'type', 'string'), new Attribute('hasObstructedView', 'hasObstructedView', 'boolean'), new Attribute('info', 'info', 'object'), new Attribute('label', 'label', 'string'), new Attribute('row', 'row', 'string'), new Attribute('seatNumber', 'seatNumber', 'string'), new Attribute('zone', 'zone', 'string'), new Attribute('zoneName', 'zoneName', 'string'), new Attribute('coordinates', 'coordinates', 'object')]);
Seat.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'seatConfig', 'seatConfig'), new Relation(Relation.MANY_TO_ONE, 'seatGroup', 'seatGroup'), new Relation(Relation.MANY_TO_ONE, 'stockContingent', 'stockContingent'), new Relation(Relation.MANY_TO_ONE, 'seatZone', 'zone'), new Relation(Relation.MANY_TO_ONE, 'seatFloor', 'floor')]);

var SeatConfigBlock = /*#__PURE__*/function (_NetworkEntity) {
  function SeatConfigBlock() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'SeatConfigBlock'
    };
    _classCallCheck(this, SeatConfigBlock);
    _this = _callSuper(this, SeatConfigBlock, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(SeatConfigBlock, _NetworkEntity);
  return _createClass(SeatConfigBlock, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/seat_blocks/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'SeatConfigBlock',
  seatConfig: new SeatConfig(),
  info: null,
  x: 0,
  y: 0,
  z: 0,
  width: 0,
  height: 0,
  fontSize: 0
}));
SeatConfigBlock.classMetadata = new ClassMetadata('seatConfigBlock', 'seat_config_blocks', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
SeatConfigBlock.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('info'), new Attribute('x:', 'x', 'integer'), new Attribute('y:', 'y', 'integer'), new Attribute('z:', 'z', 'integer'), new Attribute('width', 'width', 'integer'), new Attribute('height', 'height', 'integer'), new Attribute('fontSize', 'fontSize', 'integer')]);
SeatConfigBlock.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'seatConfig', 'seatConfig')]);

var SeatFloor = /*#__PURE__*/function (_NetworkEntity) {
  function SeatFloor() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'SeatFloor'
    };
    _classCallCheck(this, SeatFloor);
    _this = _callSuper(this, SeatFloor, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(SeatFloor, _NetworkEntity);
  return _createClass(SeatFloor);
}(NetworkEntity({
  '@id': null,
  '@type': 'SeatFloor',
  name: undefined,
  seatConfig: undefined
}));
SeatFloor.classMetadata = new ClassMetadata('seatFloor', 'seat_floors', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
SeatFloor.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name')]);
SeatFloor.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'seatConfig', 'seatConfig')]);

var SeatGroupClient = /*#__PURE__*/function (_HidableClient) {
  function SeatGroupClient() {
    _classCallCheck(this, SeatGroupClient);
    return _callSuper(this, SeatGroupClient, arguments);
  }
  _inherits(SeatGroupClient, _HidableClient);
  return _createClass(SeatGroupClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/seat_groups';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['seat_group_read', 'seat_group_write'];
    }
  }]);
}(HidableClient);

var SeatGroup = /*#__PURE__*/function (_NetworkEntity) {
  function SeatGroup() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'SeatGroup'
    };
    _classCallCheck(this, SeatGroup);
    _this = _callSuper(this, SeatGroup, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(SeatGroup, _NetworkEntity);
  return _createClass(SeatGroup, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/seat_groups/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'SeatGroup',
  contract: null,
  seatColor: null,
  seatList: List(),
  seatConfig: new SeatConfig(),
  ticketPriceList: List(),
  ticketPriceSeatGroupList: List(),
  label: null,
  isHidden: null
}));
SeatGroup.classMetadata = new ClassMetadata('seatGroup', 'seat_groups', /** @ts-expect-error -- method signature are incompatible */
SeatGroupClient);
SeatGroup.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('label'), new Attribute('seatColor'), new Attribute('isHidden', 'isHidden', 'boolean')]);
SeatGroup.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'seat', 'seatList'), new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'seatConfig', 'seatConfig'), new Relation(Relation.ONE_TO_MANY, 'ticketPrice', 'ticketPriceList'), new Relation(Relation.ONE_TO_MANY, 'ticketPriceSeatGroup', 'ticketPriceSeatGroupList')]);

var SeatZone = /*#__PURE__*/function (_NetworkEntity) {
  function SeatZone() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'SeatZone'
    };
    _classCallCheck(this, SeatZone);
    _this = _callSuper(this, SeatZone, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(SeatZone, _NetworkEntity);
  return _createClass(SeatZone);
}(NetworkEntity({
  '@id': null,
  '@type': 'SeatZone',
  name: undefined,
  seatConfig: undefined
}));
SeatZone.classMetadata = new ClassMetadata('seatZone', 'seat_zones', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
SeatZone.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name')]);
SeatZone.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'seatConfig', 'seatConfig')]);

var SELLING_DEVICE_ORIGIN_TYPE = /*#__PURE__*/function (SELLING_DEVICE_ORIGIN_TYPE) {
  SELLING_DEVICE_ORIGIN_TYPE["DESK"] = "DESK";
  SELLING_DEVICE_ORIGIN_TYPE["MINISITE"] = "MINISITE";
  SELLING_DEVICE_ORIGIN_TYPE["RESELLER"] = "RESELLER";
  SELLING_DEVICE_ORIGIN_TYPE["RESELLER_LIVE"] = "RESELLER_LIVE";
  SELLING_DEVICE_ORIGIN_TYPE["RESELLER_SWAP"] = "RESELLER_SWAP";
  return SELLING_DEVICE_ORIGIN_TYPE;
}({});
var SellingDevice = /*#__PURE__*/function (_NetworkEntity) {
  function SellingDevice() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'SellingDevice'
    };
    _classCallCheck(this, SellingDevice);
    _this = _callSuper(this, SellingDevice, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(SellingDevice, _NetworkEntity);
  return _createClass(SellingDevice, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/selling_devices/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'SellingDevice',
  contract: new Contract(),
  name: null,
  type: '',
  originType: null,
  paymentFeeKey: null,
  minisite: null,
  contractList: null,
  hideFees: null,
  isExternalProvider: undefined,
  nbTicketsToGenerate: undefined
}));
SellingDevice.classMetadata = new ClassMetadata('sellingDevice', 'selling_devices', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
SellingDevice.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type'), new Attribute('paymentFeeKey'), new Attribute('originType'), new Attribute('name'), new Attribute('hideFees', 'hideFees', 'boolean'), new Attribute('isExternalProvider', 'isExternalProvider', 'boolean'), new Attribute('nbTicketsToGenerate', 'nbTicketsToGenerate', 'integer')]);
SellingDevice.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'minisite', 'minisite'), new Relation(Relation.ONE_TO_MANY, 'contract', 'contractList')]);

var StickerClient = /*#__PURE__*/function (_AbstractClient) {
  function StickerClient() {
    _classCallCheck(this, StickerClient);
    return _callSuper(this, StickerClient, arguments);
  }
  _inherits(StickerClient, _AbstractClient);
  return _createClass(StickerClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/stickers';
    }
  }]);
}(AbstractClient);

var Sticker = /*#__PURE__*/function (_NetworkEntity) {
  function Sticker() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Sticker'
    };
    _classCallCheck(this, Sticker);
    _this = _callSuper(this, Sticker, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Sticker, _NetworkEntity);
  return _createClass(Sticker, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/stickers/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Sticker',
  contract: new Contract(),
  name: '',
  pageType: '',
  horizontalNb: null,
  verticalNb: null,
  stickerHeight: null,
  stickerWidth: null,
  marginLeft: null,
  marginTop: null,
  horizontalDistance: null,
  verticalDistance: null
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Sticker.classMetadata = new ClassMetadata('sticker', 'stickers', StickerClient);
Sticker.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('pageType'), new Attribute('horizontalNb'), new Attribute('verticalNb'), new Attribute('stickerHeight'), new Attribute('stickerWidth'), new Attribute('marginLeft'), new Attribute('marginTop'), new Attribute('horizontalDistance'), new Attribute('verticalDistance')]);
Sticker.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var StockContingentClient = /*#__PURE__*/function (_HidableClient) {
  function StockContingentClient() {
    _classCallCheck(this, StockContingentClient);
    return _callSuper(this, StockContingentClient, arguments);
  }
  _inherits(StockContingentClient, _HidableClient);
  return _createClass(StockContingentClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/stock_contingents';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['stock_contingent_read', 'stock_contingent_write'];
    }
  }, {
    key: "clone",
    value: function clone(id, eventDateId, fields) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/clone/").concat(eventDateId));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.authorizedFetch(url, {
        method: 'POST',
        body: '{}'
      }).then(function (r) {
        return r.json();
      }).then(function (e) {
        return createEntity(e);
      });
    }
  }]);
}(HidableClient);

var StockContingent = /*#__PURE__*/function (_NetworkEntity) {
  function StockContingent() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'StockContingent'
    };
    _classCallCheck(this, StockContingent);
    _this = _callSuper(this, StockContingent, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(StockContingent, _NetworkEntity);
  return _createClass(StockContingent, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/stock_contingents/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'StockContingent',
  totalStock: null,
  bookableStock: null,
  dismissedStock: null,
  bookedTickets: null,
  soldTickets: null,
  reservedTickets: null,
  draft: null,
  contingent: null,
  seatConfig: null,
  logicalSeatConfig: null,
  eventDate: null,
  childrenList: null,
  availableSeatList: null,
  seatList: null,
  parent: null,
  /** @deprecated use `contingent.name` instead */
  name: null,
  /** @deprecated use `contingent.color` instead */
  color: null,
  /** @deprecated use `contingent.contract` instead */
  contract: null,
  isHidden: null,
  isExportedOnProvider: null
}));
StockContingent.classMetadata = new ClassMetadata('stockContingent', 'stock_contingents', /** @ts-expect-error -- method signature are incompatible */
StockContingentClient);
StockContingent.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('totalStock', 'totalStock', 'int'), new Attribute('bookableStock', 'bookableStock', 'int'), new Attribute('dismissedStock', 'dismissedStock', 'int'), new Attribute('bookedTickets', 'bookedTickets', 'int'), new Attribute('reservedTickets', 'reservedTickets', 'int'), new Attribute('soldTickets', 'soldTickets', 'int'), new Attribute('draft', 'draft', 'boolean'), new Attribute('name'), new Attribute('color'), new Attribute('isHidden', 'isHidden', 'boolean'), new Attribute('isExportedOnProvider', 'isExportedOnProvider', 'boolean')]);
StockContingent.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'contingent', 'contingent'), new Relation(Relation.MANY_TO_ONE, 'seatConfig', 'seatConfig'), new Relation(Relation.MANY_TO_ONE, 'logicalSeatConfig', 'logicalSeatConfig'), new Relation(Relation.MANY_TO_ONE, 'stockContingent', 'parent'), new Relation(Relation.MANY_TO_ONE, 'eventDate', 'eventDate'), new Relation(Relation.MANY_TO_ONE, 'eventDatePattern', 'eventDatePattern'), new Relation(Relation.ONE_TO_MANY, 'stockContingent', 'childrenList'), new Relation(Relation.ONE_TO_MANY, 'seat', 'seatList'), new Relation(Relation.ONE_TO_MANY, 'availableSeat', 'availableSeatList')]);

var SUBSCRIPTION_PAYMENT_TYPE_FILTER = /*#__PURE__*/function (SUBSCRIPTION_PAYMENT_TYPE_FILTER) {
  SUBSCRIPTION_PAYMENT_TYPE_FILTER["SEPA"] = "sepa";
  SUBSCRIPTION_PAYMENT_TYPE_FILTER["CARD"] = "card";
  return SUBSCRIPTION_PAYMENT_TYPE_FILTER;
}({});
var SubscriptionClient = /*#__PURE__*/function (_AbstractClient) {
  function SubscriptionClient() {
    _classCallCheck(this, SubscriptionClient);
    return _callSuper(this, SubscriptionClient, arguments);
  }
  _inherits(SubscriptionClient, _AbstractClient);
  return _createClass(SubscriptionClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/subscriptions';
    }
  }, {
    key: "findByCode",
    value: function findByCode(id, code, fields) {
      var queryParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var uri = URI("".concat(this.getPathBase(), "/").concat(id, "/").concat(code));
      var params = this._mergeFieldsIntoParams(queryParams, fields);
      uri.addSearch(params);
      return this.authorizedFetch(uri).then(function (response) {
        return response.json();
      }).then(function (sub) {
        return createEntity(sub);
      });
    }
  }, {
    key: "getSEPAMandatePDF",
    value: function getSEPAMandatePDF(id) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/sepa_mandate.pdf"));
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }, {
    key: "getPaymentSchedulePDF",
    value: function getPaymentSchedulePDF(id) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/payment_schedule.pdf"));
      return this.authorizedFetch(url, {
        method: 'GET'
      });
    }
  }]);
}(AbstractClient);

// eslint-disable-next-line no-shadow
var SubscriptionStatus = /*#__PURE__*/function (SubscriptionStatus) {
  SubscriptionStatus["ACTIVE"] = "active";
  SubscriptionStatus["PAYMENT_FAILED"] = "payment_failed";
  SubscriptionStatus["MISSING_PROVIDER_METADATA"] = "missing_provider_metadata";
  SubscriptionStatus["DISABLED"] = "disabled";
  SubscriptionStatus["ENDED"] = "ended";
  return SubscriptionStatus;
}({});
var SUBSCRIPTION_PERIODICITY = /*#__PURE__*/function (SUBSCRIPTION_PERIODICITY) {
  SUBSCRIPTION_PERIODICITY["MONTHLY"] = "monthly";
  SUBSCRIPTION_PERIODICITY["BIMONTHLY"] = "bimonthly";
  SUBSCRIPTION_PERIODICITY["QUARTERLY"] = "quarterly";
  return SUBSCRIPTION_PERIODICITY;
}({});
var Subscription = /*#__PURE__*/function (_NetworkEntity) {
  function Subscription() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Subscription'
    };
    _classCallCheck(this, Subscription);
    var data = clone(val);
    var tz = extractTimezone(data, ['wallet', 'contract', 'timezone']);
    data.createdAt = parseDate(data.createdAt, tz);
    data.updatedAt = parseDate(data.updatedAt, tz);
    _this = _callSuper(this, Subscription, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Subscription, _NetworkEntity);
  return _createClass(Subscription, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/subscriptions/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Subscription',
  createdAt: null,
  currency: null,
  description: null,
  name: null,
  provider: null,
  providerMetadata: null,
  status: null,
  updatedAt: null,
  coupon: null,
  customer: null,
  wallet: null,
  payment: null,
  order: null,
  subscriptionMaturityList: null,
  parameters: null,
  sepaMandateUniqueRef: null,
  nextPendingSubscriptionMaturity: null,
  paidSubscriptionMaturityAmount: null,
  pendingSubscriptionMaturityAmount: null
}));
Subscription.classMetadata = new ClassMetadata('subscription', 'subscriptions', /** @ts-expect-error -- method signature are incompatible */
SubscriptionClient);
Subscription.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('currency'), new Attribute('description'), new Attribute('name'), new Attribute('provider'), new Attribute('parameters', 'parameters', 'array'), new Attribute('providerMetadata', 'providerMetadata', 'array'), new Attribute('status'), new Attribute('updatedAt', 'updatedAt', 'datetime'), new Attribute('sepaMandateUniqueRef'), new Attribute('paidSubscriptionMaturityAmount', 'paidSubscriptionMaturityAmount', 'number'), new Attribute('pendingSubscriptionMaturityAmount', 'pendingSubscriptionMaturityAmount', 'number')]);
Subscription.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'coupon', 'coupon'), new Relation(Relation.MANY_TO_ONE, 'customer', 'customer'), new Relation(Relation.MANY_TO_ONE, 'wallet', 'wallet'), new Relation(Relation.MANY_TO_ONE, 'payment', 'payment'), new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.MANY_TO_ONE, 'subscriptionMaturity', 'nextPendingSubscriptionMaturity'), new Relation(Relation.ONE_TO_MANY, 'subscriptionMaturity', 'subscriptionMaturityList')]);

var SubscriptionMaturityClient = /*#__PURE__*/function (_AbstractClient) {
  function SubscriptionMaturityClient() {
    _classCallCheck(this, SubscriptionMaturityClient);
    return _callSuper(this, SubscriptionMaturityClient, arguments);
  }
  _inherits(SubscriptionMaturityClient, _AbstractClient);
  return _createClass(SubscriptionMaturityClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/subscription_maturities';
    }
  }]);
}(AbstractClient);

var SUBSCRIPTION_MATURITY_STATUS = /*#__PURE__*/function (SUBSCRIPTION_MATURITY_STATUS) {
  SUBSCRIPTION_MATURITY_STATUS["PENDING"] = "pending";
  SUBSCRIPTION_MATURITY_STATUS["PAID"] = "paid";
  SUBSCRIPTION_MATURITY_STATUS["FAILED"] = "failed";
  SUBSCRIPTION_MATURITY_STATUS["DISMISSED"] = "dismissed";
  return SUBSCRIPTION_MATURITY_STATUS;
}({});
var SubscriptionMaturity = /*#__PURE__*/function (_NetworkEntity) {
  function SubscriptionMaturity() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'SubscriptionMaturity'
    };
    _classCallCheck(this, SubscriptionMaturity);
    var data = clone(val);
    var tz = extractTimezone(data, ['subscription', 'wallet', 'contract', 'timezone']);
    data.createdAt = parseDate(data.createdAt, tz);
    data.updatedAt = parseDate(data.updatedAt, tz);
    data.dueDate = parseDate(data.dueDate, tz);
    _this = _callSuper(this, SubscriptionMaturity, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(SubscriptionMaturity, _NetworkEntity);
  return _createClass(SubscriptionMaturity, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/subscription_maturities/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'SubscriptionMaturity',
  createdAt: null,
  updatedAt: null,
  currency: null,
  amount: null,
  status: null,
  dueDate: null,
  subscription: null
}));
SubscriptionMaturity.classMetadata = new ClassMetadata('subscriptionMaturity', 'subscription_maturities', /** @ts-expect-error -- method signature are incompatible */
SubscriptionMaturityClient);
SubscriptionMaturity.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('updatedAt', 'updatedAt', 'datetime'), new Attribute('dueDate', 'dueDate', 'datetime'), new Attribute('currency'), new Attribute('status'), new Attribute('amount', 'amount', 'integer')]);
SubscriptionMaturity.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'subscription', 'subscription')]);

var TagClient = /*#__PURE__*/function (_AbstractClient) {
  function TagClient() {
    _classCallCheck(this, TagClient);
    return _callSuper(this, TagClient, arguments);
  }
  _inherits(TagClient, _AbstractClient);
  return _createClass(TagClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/tags';
    }
  }]);
}(AbstractClient);

var Tag = /*#__PURE__*/function (_NetworkEntity) {
  function Tag(val) {
    var _this;
    _classCallCheck(this, Tag);
    _this = _callSuper(this, Tag, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Tag, _NetworkEntity);
  return _createClass(Tag, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/tags/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Tag',
  ticketingList: List(),
  contract: null,
  name: null,
  nameTokenized: null,
  uniqueId: null,
  ticketing: new Ticketing(),
  cart: new Cart(),
  order: new Order(),
  orderList: List(),
  cartList: List()
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Tag.classMetadata = new ClassMetadata('tag', 'tags', TagClient);
Tag.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('nameTokenized'), new Attribute('uniqueId')]);
Tag.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'cart', 'cart'), new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.MANY_TO_ONE, 'ticketing', 'ticketing'), new Relation(Relation.ONE_TO_MANY, 'cart', 'cartList'), new Relation(Relation.ONE_TO_MANY, 'order', 'orderList'), new Relation(Relation.ONE_TO_MANY, 'ticketing', 'ticketingList')]);

var TicketPriceAvailabilityClient = /*#__PURE__*/function (_AbstractClient) {
  function TicketPriceAvailabilityClient() {
    _classCallCheck(this, TicketPriceAvailabilityClient);
    return _callSuper(this, TicketPriceAvailabilityClient, arguments);
  }
  _inherits(TicketPriceAvailabilityClient, _AbstractClient);
  return _createClass(TicketPriceAvailabilityClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/mass_action_aggregates/ticket_price_availability';
    }
  }, {
    key: "getAggregationResult",
    value: function getAggregationResult(values, fields) {
      var requestParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = URI(this.getPathBase());
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, _objectSpread2({
        method: 'POST',
        body: JSON.stringify(values)
      }, requestParams)), 'item');
    }
  }]);
}(AbstractClient);

var MASS_ACTION_AGGREGATE_AVAILABILITY = /*#__PURE__*/function (MASS_ACTION_AGGREGATE_AVAILABILITY) {
  MASS_ACTION_AGGREGATE_AVAILABILITY["ALL"] = "all";
  MASS_ACTION_AGGREGATE_AVAILABILITY["SOME"] = "some";
  return MASS_ACTION_AGGREGATE_AVAILABILITY;
}({});

// The value can be a Map if key is Iri<'TicketPriceGroup'> | 'no-group'
// or directly a string from the enum MASS_ACTION_AGGREGATE_AVAILABILITY if the key is Iri<'OfferRule'>.
// It's impossible to type this correctly with Immutable.js so you can use asserts functions to check the type.

// OfferRule

function assertAggregationValueIsOfferRule(d) {
  if (!Map$1.isMap(d) && Object.values(MASS_ACTION_AGGREGATE_AVAILABILITY).includes(d)) {
    return;
  }
  throw new Error('The value should be exist in MASS_ACTION_AGGREGATE_AVAILABILITY enum. This should not happen.');
}
function assertAggregationValueIsTicketPriceGroup(d) {
  if (Map$1.isMap(d)) {
    return;
  }
  throw new Error('The value should be an Immutable.Map. This should not happen.');
}
var TicketPriceAvailabilityMassActionAggregate = /*#__PURE__*/function (_NetworkEntity) {
  function TicketPriceAvailabilityMassActionAggregate() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'TicketPriceAvailabilityMassActionAggregate'
    };
    _classCallCheck(this, TicketPriceAvailabilityMassActionAggregate);
    _this = _callSuper(this, TicketPriceAvailabilityMassActionAggregate, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(TicketPriceAvailabilityMassActionAggregate, _NetworkEntity);
  return _createClass(TicketPriceAvailabilityMassActionAggregate);
}(NetworkEntity({
  '@id': null,
  '@type': 'TicketPriceAvailabilityMassActionAggregate',
  aggregationResult: undefined
}));
TicketPriceAvailabilityMassActionAggregate.classMetadata = new ClassMetadata('ticketPriceAvailabilityMassActionAggregate', 'mass_action_aggregates/ticket_price_availability', /** @ts-expect-error -- method signature are incompatible */
TicketPriceAvailabilityClient);
TicketPriceAvailabilityMassActionAggregate.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('aggregationResult', 'aggregationResult', 'object')]);

var ReconciliationAmountsClient = /*#__PURE__*/function (_AbstractClient) {
  function ReconciliationAmountsClient() {
    _classCallCheck(this, ReconciliationAmountsClient);
    return _callSuper(this, ReconciliationAmountsClient, arguments);
  }
  _inherits(ReconciliationAmountsClient, _AbstractClient);
  return _createClass(ReconciliationAmountsClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/mass_action_aggregates/reconciliation_amounts';
    }
  }, {
    key: "getAmounts",
    value: function getAmounts(values, fields) {
      var requestParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = URI(this.getPathBase());
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, _objectSpread2({
        method: 'POST',
        body: JSON.stringify(values)
      }, requestParams)), 'item');
    }
  }]);
}(AbstractClient);

var ReconciliationAmountsAggregate = /*#__PURE__*/function (_NetworkEntity) {
  function ReconciliationAmountsAggregate() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ReconciliationAmountsAggregate'
    };
    _classCallCheck(this, ReconciliationAmountsAggregate);
    _this = _callSuper(this, ReconciliationAmountsAggregate, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ReconciliationAmountsAggregate, _NetworkEntity);
  return _createClass(ReconciliationAmountsAggregate);
}(NetworkEntity({
  '@id': null,
  '@type': 'ReconciliationAmountsAggregate',
  totalBalance: undefined,
  invoiceBalance: undefined,
  transactionBalance: undefined
}));
ReconciliationAmountsAggregate.classMetadata = new ClassMetadata('reconciliationAmountsAggregate', 'mass_action_aggregates/reconciliation_amounts', /** @ts-expect-error -- method signature are incompatible */
ReconciliationAmountsClient);
ReconciliationAmountsAggregate.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('totalBalance', 'totalBalance', 'integer'), new Attribute('invoiceBalance', 'invoiceBalance', 'integer'), new Attribute('transactionBalance', 'transactionBalance', 'integer')]);

var ReconciliationAvailableActionsClient = /*#__PURE__*/function (_AbstractClient) {
  function ReconciliationAvailableActionsClient() {
    _classCallCheck(this, ReconciliationAvailableActionsClient);
    return _callSuper(this, ReconciliationAvailableActionsClient, arguments);
  }
  _inherits(ReconciliationAvailableActionsClient, _AbstractClient);
  return _createClass(ReconciliationAvailableActionsClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/mass_action_aggregates/reconciliation_available_actions';
    }
  }, {
    key: "getAvailableActions",
    value: function getAvailableActions(values, fields) {
      var requestParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = new URI(this.getPathBase());
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, _objectSpread2({
        method: 'POST',
        body: JSON.stringify(values)
      }, requestParams)), 'item');
    }
  }]);
}(AbstractClient);

var ReconciliationAvailableActions = /*#__PURE__*/function (_NetworkEntity) {
  function ReconciliationAvailableActions() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ReconciliationAvailableActionsAggregate'
    };
    _classCallCheck(this, ReconciliationAvailableActions);
    _this = _callSuper(this, ReconciliationAvailableActions, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ReconciliationAvailableActions, _NetworkEntity);
  return _createClass(ReconciliationAvailableActions);
}(NetworkEntity({
  '@id': null,
  '@type': 'ReconciliationAvailableActionsAggregate',
  link: undefined,
  unlink: undefined
}));
ReconciliationAvailableActions.classMetadata = new ClassMetadata('reconciliationAvailableActions', 'mass_action_aggregates/reconciliation_available_actions', /** @ts-expect-error -- method signature are incompatible */
ReconciliationAvailableActionsClient);
ReconciliationAvailableActions.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('link', 'link', 'boolean'), new Attribute('unlink', 'unlink', 'boolean')]);

var TicketPriceGroupClient = /*#__PURE__*/function (_HidableClient) {
  function TicketPriceGroupClient() {
    _classCallCheck(this, TicketPriceGroupClient);
    return _callSuper(this, TicketPriceGroupClient, arguments);
  }
  _inherits(TicketPriceGroupClient, _HidableClient);
  return _createClass(TicketPriceGroupClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/ticket_price_groups';
    }
  }]);
}(HidableClient);

var TicketPriceGroup = /*#__PURE__*/function (_NetworkEntity) {
  function TicketPriceGroup() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'TicketPriceGroup'
    };
    _classCallCheck(this, TicketPriceGroup);
    var data = clone(val);
    _this = _callSuper(this, TicketPriceGroup, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(TicketPriceGroup, _NetworkEntity);
  return _createClass(TicketPriceGroup, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/ticket_price_groups/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'TicketPriceGroup',
  groupName: null,
  contract: new Contract(),
  manualSort: null,
  ticketPriceList: List(),
  organizationalUnit: null,
  isHidden: null
}));
TicketPriceGroup.classMetadata = new ClassMetadata('ticketPriceGroup', 'ticket_price_groups', /** @ts-expect-error -- method signature are incompatible */
TicketPriceGroupClient);
TicketPriceGroup.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('manualSort'), new Attribute('groupName'), new Attribute('isHidden', 'isHidden', 'boolean')]);
TicketPriceGroup.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.ONE_TO_MANY, 'ticketPrice', 'ticketPriceList'), new Relation(Relation.MANY_TO_ONE, 'organizationalUnit', 'organizationalUnit')]);

var TicketPriceSeatGroup = /*#__PURE__*/function (_NetworkEntity) {
  function TicketPriceSeatGroup() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'TicketPriceSeatGroup'
    };
    _classCallCheck(this, TicketPriceSeatGroup);
    var data = clone(val);
    _this = _callSuper(this, TicketPriceSeatGroup, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(TicketPriceSeatGroup, _NetworkEntity);
  return _createClass(TicketPriceSeatGroup, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/ticket_price_seat_groups/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'TicketPriceSeatGroup',
  seatGroup: new SeatGroup(),
  ticketPrice: new TicketPrice()
}));
TicketPriceSeatGroup.classMetadata = new ClassMetadata('ticketPriceSeatGroup', 'ticket_price_seat_groups', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
TicketPriceSeatGroup.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type')]);
TicketPriceSeatGroup.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'seatGroup', 'seatGroup'), new Relation(Relation.MANY_TO_ONE, 'ticketPrice', 'ticketPrice')]);

var TicketingCategoryClient = /*#__PURE__*/function (_AbstractClient) {
  function TicketingCategoryClient() {
    _classCallCheck(this, TicketingCategoryClient);
    return _callSuper(this, TicketingCategoryClient, arguments);
  }
  _inherits(TicketingCategoryClient, _AbstractClient);
  return _createClass(TicketingCategoryClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/ticketing_categories';
    }
  }, {
    key: "getDefaultGroups",
    value: function getDefaultGroups() {
      return ['ticketing_category_read', 'ticketing_category_write'];
    }
  }]);
}(AbstractClient);

var TicketingCategory = /*#__PURE__*/function (_NetworkEntity) {
  function TicketingCategory() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'TicketingCategory'
    };
    _classCallCheck(this, TicketingCategory);
    var data = clone(val);
    _this = _callSuper(this, TicketingCategory, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(TicketingCategory, _NetworkEntity);
  return _createClass(TicketingCategory, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/ticketing_categories/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'TicketingCategory',
  name: null,
  position: null,
  contract: null
}));
TicketingCategory.classMetadata = new ClassMetadata('ticketingCategory', 'ticketing_categories', /** @ts-expect-error -- method signature are incompatible */
TicketingCategoryClient);
TicketingCategory.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('position', 'position', 'number')]);
TicketingCategory.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var OptionStress = /*#__PURE__*/function (_Record) {
  function OptionStress() {
    _classCallCheck(this, OptionStress);
    return _callSuper(this, OptionStress, arguments);
  }
  _inherits(OptionStress, _Record);
  return _createClass(OptionStress);
}(Record({
  optionNb: 0,
  score: 0
}));

var EventDateOptionStress = /*#__PURE__*/function (_Record) {
  function EventDateOptionStress(val) {
    _classCallCheck(this, EventDateOptionStress);
    var data = clone(val);
    if (val.optionStress) {
      data.optionStress = new OptionStress(val.optionStress);
    }
    return _callSuper(this, EventDateOptionStress, [data]);
  }
  _inherits(EventDateOptionStress, _Record);
  return _createClass(EventDateOptionStress);
}(Record({
  eventDateId: null,
  optionStress: null
}));

var TicketingOptionStress = /*#__PURE__*/function (_NetworkEntity) {
  function TicketingOptionStress() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'TicketingOptionStress'
    };
    _classCallCheck(this, TicketingOptionStress);
    var data = clone(val);
    if (val.eventDateOptionStressList) {
      data.eventDateOptionStressList = val.eventDateOptionStressList.map(function (optionStress) {
        return new EventDateOptionStress(optionStress);
      });
    }
    if (val.optionStress) {
      data.optionStress = new OptionStress(val.optionStress);
    }
    _this = _callSuper(this, TicketingOptionStress, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(TicketingOptionStress, _NetworkEntity);
  return _createClass(TicketingOptionStress, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/ticketing_option_stresses/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'TicketingOptionStress',
  ticketingId: null,
  optionStress: null,
  eventDateOptionStressList: null
}));
TicketingOptionStress.classMetadata = new ClassMetadata('ticketingOptionStress', 'ticketing_option_stresses', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
TicketingOptionStress.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('ticketingId'), new Attribute('optionStress', 'optionStress', 'object'), new Attribute('eventDateOptionStressList', 'eventDateOptionStressList', 'array')]);

var TicketingSellingDevice = /*#__PURE__*/function (_NetworkEntity) {
  function TicketingSellingDevice() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'TicketingSellingDevice'
    };
    _classCallCheck(this, TicketingSellingDevice);
    _this = _callSuper(this, TicketingSellingDevice, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(TicketingSellingDevice, _NetworkEntity);
  return _createClass(TicketingSellingDevice, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/ticketing_selling_devices/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'TicketingSellingDevice',
  hasTicketPriceEnabled: null,
  sellingDevice: new SellingDevice()
}));
TicketingSellingDevice.classMetadata = new ClassMetadata('ticketingSellingDevite', 'ticketing_selling_devices', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
TicketingSellingDevice.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('hasTicketPriceEnabled', 'hasTicketPriceEnabled', 'boolean')]);
TicketingSellingDevice.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'sellingDevice', 'sellingDevice')]);

var PROVIDER_TYPE = /*#__PURE__*/function (PROVIDER_TYPE) {
  PROVIDER_TYPE["ACCOUNT_MAPADO"] = "accounts.mapado.com";
  return PROVIDER_TYPE;
}({});
var TicketingUser = /*#__PURE__*/function (_NetworkEntity) {
  function TicketingUser() {
    _classCallCheck(this, TicketingUser);
    return _callSuper(this, TicketingUser, arguments);
  }
  _inherits(TicketingUser, _NetworkEntity);
  return _createClass(TicketingUser, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/ticketing_users/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'TicketingUser',
  externalId: undefined,
  provider: undefined
}));
TicketingUser.classMetadata = new ClassMetadata('ticketingUser', 'ticketing_users', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
TicketingUser.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('externalId'), new Attribute('provider')]);

var TransactionClient = /*#__PURE__*/function (_AbstractClient) {
  function TransactionClient() {
    _classCallCheck(this, TransactionClient);
    return _callSuper(this, TransactionClient, arguments);
  }
  _inherits(TransactionClient, _AbstractClient);
  return _createClass(TransactionClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/transactions';
    }
  }, {
    key: "findByQuery",
    value: function findByQuery(values, fields) {
      var requestParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = URI("".concat(this.getPathBase(), "/query"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, _objectSpread2({
        method: 'POST',
        body: JSON.stringify(values)
      }, requestParams)), 'list');
    }
  }]);
}(AbstractClient);

var TRANSACTION_PROVIDER = /*#__PURE__*/function (TRANSACTION_PROVIDER) {
  TRANSACTION_PROVIDER["MANUAL"] = "manual";
  // Online Provider
  TRANSACTION_PROVIDER["STRIPE"] = "stripe";
  TRANSACTION_PROVIDER["MANGOPAY"] = "mangopay";
  TRANSACTION_PROVIDER["PAYLINE"] = "payline";
  TRANSACTION_PROVIDER["PAYZONE"] = "payzone";
  TRANSACTION_PROVIDER["PAYREXX"] = "payrexx";
  // Specific Provider
  TRANSACTION_PROVIDER["CASH_COUPON_BREAKDOWN"] = "cash_coupon_breakdown";
  TRANSACTION_PROVIDER["SEPA"] = "SEPA";
  TRANSACTION_PROVIDER["NONE"] = "none";
  return TRANSACTION_PROVIDER;
}({});
var EXTERNAL_PROVIDER_LIST = [TRANSACTION_PROVIDER.MANGOPAY, TRANSACTION_PROVIDER.PAYLINE, TRANSACTION_PROVIDER.STRIPE, TRANSACTION_PROVIDER.PAYZONE, TRANSACTION_PROVIDER.PAYREXX];
var MULTI_WALLET_PROVIDER_LIST = [TRANSACTION_PROVIDER.PAYLINE, TRANSACTION_PROVIDER.STRIPE, TRANSACTION_PROVIDER.PAYZONE, TRANSACTION_PROVIDER.PAYREXX];
var ACCOUNT_TYPE = /*#__PURE__*/function (ACCOUNT_TYPE) {
  ACCOUNT_TYPE["BANK"] = "bank";
  ACCOUNT_TYPE["CASH_COUPON"] = "cash_coupon";
  return ACCOUNT_TYPE;
}({});
var TRANSACTION_STATUS = /*#__PURE__*/function (TRANSACTION_STATUS) {
  TRANSACTION_STATUS["LINKED"] = "linked";
  TRANSACTION_STATUS["UNLINKED"] = "unlinked";
  TRANSACTION_STATUS["PARTIALLY_LINKED"] = "partially_linked";
  return TRANSACTION_STATUS;
}({});
var Transaction = /*#__PURE__*/function (_NetworkEntity) {
  function Transaction() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Transaction'
    };
    _classCallCheck(this, Transaction);
    var data = clone(val);
    var tz = _typeof(data.contract) === 'object' && data.contract !== null ? data.contract.timezone : null;
    data.valueDate = parseDate(data.valueDate, tz);
    data.createdAt = parseDate(data.createdAt, tz);
    _this = _callSuper(this, Transaction, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(Transaction, _NetworkEntity);
  return _createClass(Transaction, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/transactions/', '')) || '';
    }

    /**
     * @deprecated
     */
  }, {
    key: "getLocalValueDate",
    value: function getLocalValueDate() {
      if (!this.valueDate) {
        return null;
      }
      var tz = this.getIn(['contract', 'timezone']);
      if (!tz) {
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- moment timezone issue */
      return this.valueDate.clone().tz(tz);
    }
  }, {
    key: "getAmount",
    value: function getAmount() {
      var credit = this.credit || 0;
      var debit = this.debit || 0;
      return credit - debit;
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Transaction',
  debit: null,
  credit: null,
  currency: null,
  name: '',
  nameTranslationKey: '',
  operationType: null,
  valueDate: null,
  createdAt: null,
  label: null,
  order: null,
  contract: null,
  accountType: null,
  transactionGroup: null,
  lettering: null,
  deposit: null,
  payment: null,
  refund: null,
  lettered: null,
  hasCouponUseApplication: null,
  otherTransactionGroupTransactionList: null,
  sourceExternalTransaction: null,
  initialSourceExternalTransaction: null,
  rescheduledFromExternalTransaction: null,
  externalAmount: null,
  externalId: null,
  externalProviderBalance: null,
  provider: null,
  cashCoupon: null,
  revertedTransaction: null,
  deskPaymentMethod: undefined,
  status: undefined,
  accountingClient: undefined,
  linkedAmount: undefined,
  unlinkedAmount: undefined,
  signedAmount: undefined,
  eventDateList: undefined,
  invoiceList: undefined,
  isCashIn: undefined,
  isReverted: undefined,
  hasAccountingClientDeposit: undefined,
  schoolMode: undefined
}));
Transaction.classMetadata = new ClassMetadata('transaction', 'transactions', /** @ts-expect-error -- method signature are incompatible */
TransactionClient);
Transaction.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('debit'), new Attribute('credit'), new Attribute('externalAmount', 'externalAmount', 'integer'), new Attribute('externalProviderBalance', 'externalProviderBalance', 'integer'), new Attribute('currency'), new Attribute('externalId'), new Attribute('name'), new Attribute('provider'), new Attribute('nameTranslationKey'), new Attribute('label'), new Attribute('operationType'), new Attribute('accountType'), new Attribute('lettered', 'lettered', 'boolean'), new Attribute('hasCouponUseApplication', 'hasCouponUseApplication', 'boolean'), new Attribute('valueDate', 'valueDate', 'datetime'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('status'), new Attribute('linkedAmount', 'linkedAmount', 'integer'), new Attribute('unlinkedAmount', 'unlinkedAmount', 'integer'), new Attribute('signedAmount', 'signedAmount', 'integer'), new Attribute('isCashIn', 'isCashIn', 'boolean'), new Attribute('isReverted', 'isReverted', 'boolean'), new Attribute('hasAccountingClientDeposit', 'hasAccountingClientDeposit', 'boolean'), new Attribute('schoolMode', 'schoolMode', 'boolean')]);
Transaction.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'transaction', 'sourceExternalTransaction'), new Relation(Relation.MANY_TO_ONE, 'transaction', 'initialSourceExternalTransaction'), new Relation(Relation.MANY_TO_ONE, 'transaction', 'rescheduledFromExternalTransaction'), new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.MANY_TO_ONE, 'lettering', 'lettering'), new Relation(Relation.MANY_TO_ONE, 'deposit', 'deposit'), new Relation(Relation.MANY_TO_ONE, 'payment', 'payment'), new Relation(Relation.MANY_TO_ONE, 'refund', 'refund'), new Relation(Relation.MANY_TO_ONE, 'coupon', 'cashCoupon'), new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'transactionGroup', 'transactionGroup'), new Relation(Relation.ONE_TO_ONE, 'transaction', 'revertedTransaction'), new Relation(Relation.ONE_TO_MANY, 'transaction', 'otherTransactionGroupTransactionList'), new Relation(Relation.MANY_TO_ONE, 'deskPaymentMethod', 'deskPaymentMethod'), new Relation(Relation.MANY_TO_ONE, 'accountingClient', 'accountingClient'), new Relation(Relation.ONE_TO_MANY, 'eventDate', 'eventDateList'), new Relation(Relation.ONE_TO_MANY, 'invoice', 'invoiceList')]);

var TransactionGroupClient = /*#__PURE__*/function (_AbstractClient) {
  function TransactionGroupClient() {
    _classCallCheck(this, TransactionGroupClient);
    return _callSuper(this, TransactionGroupClient, arguments);
  }
  _inherits(TransactionGroupClient, _AbstractClient);
  return _createClass(TransactionGroupClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/transaction_groups';
    }
  }]);
}(AbstractClient);

var TransactionGroup = /*#__PURE__*/function (_NetworkEntity) {
  function TransactionGroup() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'TransactionGroup'
    };
    _classCallCheck(this, TransactionGroup);
    var data = clone(val);
    var tz = extractTimezone(data, ['contract', 'timezone']);
    data.createdAt = parseDate(data.createdAt, tz);
    _this = _callSuper(this, TransactionGroup, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(TransactionGroup, _NetworkEntity);
  return _createClass(TransactionGroup, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/transaction_groups/', '')) || '';
    }

    /**
     * @deprecated use createdAt instead
     */
  }, {
    key: "getLocalCreatedAt",
    value: function getLocalCreatedAt() {
      if (!this.createdAt) {
        return null;
      }
      var tz = this.getIn(['contract', 'timezone']);
      if (!tz) {
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /** @ts-expect-error -- moment timezone issue */
      return this.createdAt.clone().tz(tz);
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'TransactionGroup',
  type: null,
  contract: null,
  transactionList: null,
  clientTransactionCredit: null,
  clientTransactionDebit: null,
  clientTransactionBalance: null,
  createdAt: null,
  order: null,
  deposit: null,
  sellingDevice: null
}));
TransactionGroup.classMetadata = new ClassMetadata('transactionGroup', 'transaction_groups', /** @ts-expect-error -- method signature are incompatible */
TransactionGroupClient);
TransactionGroup.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type'), new Attribute('clientTransactionCredit', 'clientTransactionCredit', 'integer'), new Attribute('clientTransactionDebit', 'clientTransactionDebit', 'integer'), new Attribute('clientTransactionBalance', 'clientTransactionBalance', 'integer')]);
TransactionGroup.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.MANY_TO_ONE, 'deposit', 'deposit'), new Relation(Relation.ONE_TO_MANY, 'transaction', 'transactionList'), new Relation(Relation.MANY_TO_ONE, 'sellingDevice', 'sellingDevice')]);

var BILLING_TYPE = /*#__PURE__*/function (BILLING_TYPE) {
  BILLING_TYPE["IMMEDIATE"] = "immediate";
  BILLING_TYPE["DEFERED"] = "defered";
  BILLING_TYPE["RECURRING"] = "recurring";
  return BILLING_TYPE;
}({});
var BILLING_POLICY = /*#__PURE__*/function (BILLING_POLICY) {
  BILLING_POLICY["ANY"] = "any";
  BILLING_POLICY["ALL"] = "all";
  return BILLING_POLICY;
}({});
var Billing = /*#__PURE__*/function (_NetworkEntity) {
  function Billing() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Billing'
    };
    _classCallCheck(this, Billing);
    _this = _callSuper(this, Billing, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Billing, _NetworkEntity);
  return _createClass(Billing, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/billings/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Billing',
  contract: null,
  type: null,
  policy: null,
  recurringPaymentParameters: null
}));
Billing.classMetadata = new ClassMetadata('billing', 'billings', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
Billing.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type'), new Attribute('policy'), new Attribute('recurringPaymentParameters', 'recurringPaymentParameters', 'object')]);
Billing.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var UserClient = /*#__PURE__*/function (_AbstractClient) {
  function UserClient() {
    _classCallCheck(this, UserClient);
    return _callSuper(this, UserClient, arguments);
  }
  _inherits(UserClient, _AbstractClient);
  return _createClass(UserClient, [{
    key: "getCurrent",
    value: function getCurrent(fields) {
      var url = new URI('/v1/me');
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url), 'item');
    }
  }, {
    key: "getUserSettings",
    value: function getUserSettings(fields) {
      var url = new URI('/v1/me/settings');
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url), 'item');
    }
  }, {
    key: "updateSettings",
    value: function updateSettings(userSettings, fields) {
      var url = new URI("me/settings");
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'PUT',
        body: JSON.stringify(userSettings)
      }), 'item');
    }
  }]);
}(AbstractClient);

var User = /*#__PURE__*/function (_NetworkEntity) {
  function User(val) {
    var _this;
    _classCallCheck(this, User);
    var data = clone(val);
    _this = _callSuper(this, User, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(User, _NetworkEntity);
  return _createClass(User, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/users/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'User',
  firstname: null,
  lastname: null,
  fullName: null,
  email: null,
  realFullName: undefined,
  realEmail: undefined,
  avatar: null,
  address: null,
  phoneNumber: null,
  phoneNumberAsObject: null,
  city: null,
  zipcode: null,
  impersonated: null,
  contractUserList: null,
  isMapadoTeam: null
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
User.classMetadata = new ClassMetadata('user', 'users', UserClient);
User.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('firstname'), new Attribute('lastname'), new Attribute('fullName'), new Attribute('email'), new Attribute('avatar'), new Attribute('address'), new Attribute('phoneNumber'), new Attribute('phoneNumberAsObject', 'phoneNumberAsObject', 'object'), new Attribute('city'), new Attribute('zipcode'), new Attribute('impersonated', 'impersonated', 'boolean'), new Attribute('contractUserList', 'contractUserList', 'array')]);

var VenueClient = /*#__PURE__*/function (_HidableClient) {
  function VenueClient() {
    _classCallCheck(this, VenueClient);
    return _callSuper(this, VenueClient, arguments);
  }
  _inherits(VenueClient, _HidableClient);
  return _createClass(VenueClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/venues';
    }
  }]);
}(HidableClient);

var Venue = /*#__PURE__*/function (_NetworkEntity) {
  function Venue(val) {
    var _this;
    _classCallCheck(this, Venue);
    _this = _callSuper(this, Venue, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Venue, _NetworkEntity);
  return _createClass(Venue, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/venues/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Venue',
  name: null,
  seatingName: null,
  address: null,
  city: null,
  zipCode: null,
  countryCode: null,
  timezone: null,
  contract: null,
  sibilVenueLieu: null,
  isHidden: null
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Venue.classMetadata = new ClassMetadata('venue', 'venues', VenueClient);
Venue.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('name'), new Attribute('seatingName'), new Attribute('address'), new Attribute('city'), new Attribute('zipCode'), new Attribute('countryCode'), new Attribute('timezone')]);
Venue.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'sibilVenueLieu', 'sibilVenueLieu')]);

var VersionClient = /*#__PURE__*/function (_AbstractClient) {
  function VersionClient() {
    _classCallCheck(this, VersionClient);
    return _callSuper(this, VersionClient, arguments);
  }
  _inherits(VersionClient, _AbstractClient);
  return _createClass(VersionClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/versions';
    }
  }, {
    key: "findTicketingApiVersion",
    value: function findTicketingApiVersion() {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.find('ticketing-api', fields);
    }
  }]);
}(AbstractClient);

var Version = /*#__PURE__*/function (_NetworkEntity) {
  function Version() {
    _classCallCheck(this, Version);
    return _callSuper(this, Version, arguments);
  }
  _inherits(Version, _NetworkEntity);
  return _createClass(Version);
}(NetworkEntity({
  '@id': null,
  '@type': 'Version',
  name: null,
  version: null
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
Version.classMetadata = new ClassMetadata('version', 'versions', VersionClient);
Version.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('name'), new Attribute('version')]);

var SHIPPING_TYPE = /*#__PURE__*/function (SHIPPING_TYPE) {
  SHIPPING_TYPE["E_TICKET"] = "eTicket";
  SHIPPING_TYPE["DESK"] = "desk";
  SHIPPING_TYPE["POSTAL_MAIL"] = "postalMail";
  SHIPPING_TYPE["REGISTERED_MAIL"] = "registeredMail";
  return SHIPPING_TYPE;
}({});
var Shipping = /*#__PURE__*/function (_NetworkEntity) {
  function Shipping() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Shipping'
    };
    _classCallCheck(this, Shipping);
    _this = _callSuper(this, Shipping, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Shipping, _NetworkEntity);
  return _createClass(Shipping, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/shippings/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Shipping',
  contract: null,
  type: null,
  fee: null
}));
Shipping.classMetadata = new ClassMetadata('shipping', 'shippings', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
Shipping.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type')]);
Shipping.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'fee', 'fee')]);

var FEE_TYPE = /*#__PURE__*/function (FEE_TYPE) {
  FEE_TYPE["POSTAL_MAIL"] = "postalMail";
  FEE_TYPE["REGISTERED_MAIL"] = "registeredMail";
  return FEE_TYPE;
}({});
var Fee = /*#__PURE__*/function (_NetworkEntity) {
  function Fee() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Fee'
    };
    _classCallCheck(this, Fee);
    _this = _callSuper(this, Fee, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Fee, _NetworkEntity);
  return _createClass(Fee, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/fees/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Fee',
  contract: null,
  type: null,
  amount: null,
  calculatedAmount: null,
  rate: null,
  vatRate: null,
  currency: null
}));
Fee.classMetadata = new ClassMetadata('fee', 'fees', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
Fee.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type'), new Attribute('amount', 'amount', 'integer'), new Attribute('calculatedAmount', 'calculatedAmount', 'integer'), new Attribute('rate', 'rate', 'float'), new Attribute('vatRate', 'vatRate', 'float'), new Attribute('currency')]);
Fee.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var BookingTrackClient = /*#__PURE__*/function (_AbstractClient) {
  function BookingTrackClient() {
    _classCallCheck(this, BookingTrackClient);
    return _callSuper(this, BookingTrackClient, arguments);
  }
  _inherits(BookingTrackClient, _AbstractClient);
  return _createClass(BookingTrackClient, [{
    key: "getPathBase",
    value: function getPathBase(pathParameters) {
      if (pathParameters !== null && pathParameters !== void 0 && pathParameters.iriToClone) {
        return "".concat(pathParameters === null || pathParameters === void 0 ? void 0 : pathParameters.iriToClone, "/clone");
      }
      return '/v1/booking_tracks';
    }
  }, {
    key: "replaceBookingTrack",
    value: function replaceBookingTrack(id, bookingTrack) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/delete-with-new-booking-track"));
      url.addSearch({
        fields: '@id'
      });
      return this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify({
          bookingTrack: bookingTrack
        })
      });
    }
  }, {
    key: "reorderFormList",
    value: function reorderFormList(id, customer, participant, fields) {
      var url = URI("".concat(this.getPathBase(), "/").concat(id, "/forms"));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'PUT',
        body: JSON.stringify({
          customer: customer,
          participant: participant
        })
      }), 'item');
    }
  }, {
    key: "clone",
    value: function clone(clonedBookingTrack, queryParam) {
      var pathParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var requestParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      assertRelationIsString(clonedBookingTrack['@id'], 'bookingTrack.@id');
      var iriToClone = clonedBookingTrack['@id'];
      return this.create(clonedBookingTrack.set('@id', null), queryParam, // add iriToClone to pathParameters, this way, we can only call the `create` method, and all should by handled automatically be the SDK
      _objectSpread2(_objectSpread2({}, pathParameters), {}, {
        iriToClone: iriToClone
      }), requestParams);
    }
  }]);
}(AbstractClient);

var BookingTrack = /*#__PURE__*/function (_NetworkEntity) {
  function BookingTrack() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'BookingTrack'
    };
    _classCallCheck(this, BookingTrack);
    _this = _callSuper(this, BookingTrack, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(BookingTrack, _NetworkEntity);
  return _createClass(BookingTrack, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/booking_tracks/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'BookingTrack',
  name: null,
  contract: null,
  cartType: null,
  bookingOptions: null,
  shippingList: null,
  billingList: null,
  isDefault: null,
  bookingTrackMode: null,
  nbTicketPrices: null,
  nbOfferRules: null,
  ticketPriceList: null,
  offerRuleList: null,
  formList: undefined
}));
BookingTrack.classMetadata = new ClassMetadata('bookingTrack', 'booking_tracks', /** @ts-expect-error -- method signature are incompatible */
BookingTrackClient);
BookingTrack.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('cartType'), new Attribute('bookingOptions', 'bookingOptions', 'object'), new Attribute('isDefault', 'isDefault', 'boolean'), new Attribute('nbTicketPrices', 'nbTicketPrices', 'integer'), new Attribute('nbOfferRules', 'nbOfferRules', 'integer')]);
BookingTrack.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'bookingTrackMode', 'bookingTrackMode'), new Relation(Relation.ONE_TO_MANY, 'shipping', 'shippingList'), new Relation(Relation.ONE_TO_MANY, 'billing', 'billingList'), new Relation(Relation.ONE_TO_MANY, 'ticketPrice', 'ticketPriceList'), new Relation(Relation.ONE_TO_MANY, 'offerRule', 'offerRuleList'), new Relation(Relation.ONE_TO_MANY, 'form', 'formList')]);

var BookingTrackMode = /*#__PURE__*/function (_NetworkEntity) {
  function BookingTrackMode() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'BookingTrackMode'
    };
    _classCallCheck(this, BookingTrackMode);
    _this = _callSuper(this, BookingTrackMode, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(BookingTrackMode, _NetworkEntity);
  return _createClass(BookingTrackMode, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/booking_track_modes/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'BookingTrackMode',
  label: null,
  description: null,
  contract: null,
  cartType: null,
  type: null,
  isDefault: null,
  position: null,
  availableForPaymentProviders: null,
  bookingOptions: null,
  shippingList: null,
  billingList: null,
  bookingTrackList: null
}));
BookingTrackMode.classMetadata = new ClassMetadata('bookingTrackMode', 'booking_track_modes', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
BookingTrackMode.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('label'), new Attribute('description'), new Attribute('cartType'), new Attribute('type'), new Attribute('position'), new Attribute('availableForPaymentProviders', 'availableForPaymentProviders', 'array'), new Attribute('bookingOptions', 'bookingOptions', 'object'), new Attribute('isDefault', 'isDefault', 'boolean')]);
BookingTrackMode.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.ONE_TO_MANY, 'shipping', 'shippingList'), new Relation(Relation.ONE_TO_MANY, 'billing', 'billingList')]);

var ORDER_FEE_ITEM_TYPE = /*#__PURE__*/function (ORDER_FEE_ITEM_TYPE) {
  ORDER_FEE_ITEM_TYPE["RENTAL"] = "rental";
  ORDER_FEE_ITEM_TYPE["POSTAL_MAIL"] = "postalMail";
  ORDER_FEE_ITEM_TYPE["REGISTERED_MAIL"] = "registeredMail";
  return ORDER_FEE_ITEM_TYPE;
}({});
var OrderFeeItem = /*#__PURE__*/function (_NetworkEntity) {
  function OrderFeeItem() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'OrderFeeItem'
    };
    _classCallCheck(this, OrderFeeItem);
    _this = _callSuper(this, OrderFeeItem, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(OrderFeeItem, _NetworkEntity);
  return _createClass(OrderFeeItem, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/order_fee_items/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'OrderFeeItem',
  order: null,
  type: null,
  amount: null,
  rate: null,
  vatRate: null,
  currency: null
}));
OrderFeeItem.classMetadata = new ClassMetadata('orderFeeItem', 'order_fee_items', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
OrderFeeItem.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type'), new Attribute('amount', 'amount', 'integer'), new Attribute('rate', 'rate', 'float'), new Attribute('vatRate', 'vatRate', 'float'), new Attribute('currency')]);
OrderFeeItem.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'order', 'order')]);

var ScanTrack = /*#__PURE__*/function (_NetworkEntity) {
  function ScanTrack() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ScanTrack'
    };
    _classCallCheck(this, ScanTrack);
    _this = _callSuper(this, ScanTrack, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ScanTrack, _NetworkEntity);
  return _createClass(ScanTrack, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/scan_tracks/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ScanTrack',
  contract: new Contract(),
  name: null,
  isDefault: null,
  isDeletable: null,
  isHidable: null,
  maxScanNb: null,
  scanTrackCheckpointList: null,
  isHidden: null
}));
ScanTrack.classMetadata = new ClassMetadata('scanTrack', 'scan_tracks', /** @ts-expect-error -- method signature are incompatible */
HidableClient);
ScanTrack.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('maxScanNb', 'maxScanNb', 'integer'), new Attribute('isDefault', 'isDefault', 'boolean'), new Attribute('isDeletable', 'isDeletable', 'boolean'), new Attribute('isHidable', 'isHidable', 'boolean'), new Attribute('isHidden', 'isHidden', 'boolean')]);
ScanTrack.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.ONE_TO_MANY, 'scanTrackCheckpoint', 'scanTrackCheckpointList')]);

var Checkpoint = /*#__PURE__*/function (_NetworkEntity) {
  function Checkpoint() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Checkpoint'
    };
    _classCallCheck(this, Checkpoint);
    _this = _callSuper(this, Checkpoint, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Checkpoint, _NetworkEntity);
  return _createClass(Checkpoint, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/checkpoints/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'Checkpoint',
  contract: new Contract(),
  name: null,
  scanSuccessCallbackUrl: null,
  isDefault: null,
  scanTrackCheckpointList: null,
  ticketCheckpointList: null,
  seatGroupList: null,
  isDeletable: null,
  isHidable: null,
  isHidden: null
}));
Checkpoint.classMetadata = new ClassMetadata('checkpoint', 'checkpoints', /** @ts-expect-error -- method signature are incompatible */
HidableClient);
Checkpoint.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name'), new Attribute('scanSuccessCallbackUrl'), new Attribute('isDefault', 'isDefault', 'boolean'), new Attribute('isDeletable', 'isDeletable', 'boolean'), new Attribute('isHidable', 'isHidable', 'boolean'), new Attribute('isHidden', 'isHidden', 'boolean')]);
Checkpoint.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.ONE_TO_MANY, 'scanTrackCheckpoint', 'scanTrackCheckpointList'), new Relation(Relation.ONE_TO_MANY, 'ticketCheckpoint', 'ticketCheckpointList'), new Relation(Relation.ONE_TO_MANY, 'seatGroup', 'seatGroupList')]);

var ScanTrackCheckpoint = /*#__PURE__*/function (_NetworkEntity) {
  function ScanTrackCheckpoint() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ScanTrackCheckpoint'
    };
    _classCallCheck(this, ScanTrackCheckpoint);
    _this = _callSuper(this, ScanTrackCheckpoint, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ScanTrackCheckpoint, _NetworkEntity);
  return _createClass(ScanTrackCheckpoint, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/scan_track_checkpoints/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ScanTrackCheckpoint',
  maxScanNb: null,
  scanTrack: null,
  checkpoint: null
}));
ScanTrackCheckpoint.classMetadata = new ClassMetadata('scanTrackCheckpoint', 'scan_track_checkpoints', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
ScanTrackCheckpoint.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('maxScanNb', 'maxScanNb', 'integer')]);
ScanTrackCheckpoint.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'scanTrack', 'scanTrack'), new Relation(Relation.MANY_TO_ONE, 'checkpoint', 'checkpoint')]);

var TicketCheckpoint = /*#__PURE__*/function (_NetworkEntity) {
  function TicketCheckpoint() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'TicketCheckpoint'
    };
    _classCallCheck(this, TicketCheckpoint);
    var data = clone(val);
    var tz = extractTimezone(data, ['ticket', 'ticketingTimezone']);
    data.lastScannedDate = parseDate(data.lastScannedDate, tz);
    data.firstScannedDate = parseDate(data.firstScannedDate, tz);
    data.validStartDate = parseDate(data.validStartDate, tz);
    data.validEndDate = parseDate(data.validEndDate, tz);
    _this = _callSuper(this, TicketCheckpoint, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(TicketCheckpoint, _NetworkEntity);
  return _createClass(TicketCheckpoint, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/ticket_checkpoints/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'TicketCheckpoint',
  checkpoint: null,
  currentScanNb: null,
  currentValidScanNb: null,
  firstScannedDate: null,
  lastScannedDate: null,
  maxScanNb: null,
  isUnlimited: null,
  ticket: null,
  valid: null,
  validEndDate: null,
  validStartDate: null
}));
TicketCheckpoint.classMetadata = new ClassMetadata('ticketCheckpoint', 'ticket_checkpoints', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
TicketCheckpoint.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('maxScanNb', 'maxScanNb', 'integer'), new Attribute('currentScanNb', 'currentScanNb', 'integer'), new Attribute('currentValidScanNb', 'currentValidScanNb', 'integer'), new Attribute('firstScannedDate', 'firstScannedDate', 'datetime'), new Attribute('lastScannedDate', 'lastScannedDate', 'datetime'), new Attribute('isUnlimited', 'isUnlimited', 'boolean'), new Attribute('valid', 'valid', 'boolean'), new Attribute('validStartDate', 'validStartDate', 'datetime'), new Attribute('validEndDate', 'validEndDate', 'datetime')]);
TicketCheckpoint.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'ticket', 'ticket'), new Relation(Relation.MANY_TO_ONE, 'checkpoint', 'checkpoint')]);

var PagedCartCollection = /*#__PURE__*/function (_PagedCollection) {
  function PagedCartCollection(val) {
    _classCallCheck(this, PagedCartCollection);
    var data = clone(val);
    var filters = null;
    if (data['mapado:filters']) {
      var entries = Object.entries(data['mapado:filters']);
      filters = Map$1(entries.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          list = _ref2[1];
        return [key, List(list.map(function (filter) {
          return typeof filter === 'string' ? filter : createEntity(filter);
        }))];
      }));
    }
    var parameters = _objectSpread2(_objectSpread2({}, data), {}, {
      'mapado:filters': filters
    });
    return _callSuper(this, PagedCartCollection, [parameters]);
  }
  _inherits(PagedCartCollection, _PagedCollection);
  return _createClass(PagedCartCollection, [{
    key: "getFilters",
    value: function getFilters() {
      return this['mapado:filters'];
    }
  }, {
    key: "getFilter",
    value: function getFilter(type) {
      var _this$mapadoFilters;
      return (_this$mapadoFilters = this['mapado:filters']) === null || _this$mapadoFilters === void 0 ? void 0 : _this$mapadoFilters.get(type);
    }
  }]);
}(PagedCollection);

var FORM_TYPE = /*#__PURE__*/function (FORM_TYPE) {
  FORM_TYPE["CUSTOMER"] = "customer";
  FORM_TYPE["PARTICIPANT"] = "participant";
  return FORM_TYPE;
}({});
var Form = /*#__PURE__*/function (_NetworkEntity) {
  function Form() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'Form'
    };
    _classCallCheck(this, Form);
    _this = _callSuper(this, Form, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(Form, _NetworkEntity);
  return _createClass(Form);
}(NetworkEntity({
  '@id': null,
  '@type': 'Form',
  customerFieldContractList: undefined,
  type: undefined,
  bookingTrack: undefined
}));
Form.classMetadata = new ClassMetadata('form', 'forms', /** @ts-expect-error -- method signature are incompatible */
AbstractClient);
Form.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('type')]);
Form.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'customerFieldContract', 'customerFieldContractList'), new Relation(Relation.MANY_TO_ONE, 'bookingTrack', 'bookingTrack')]);

var PaymentAttemptClient = /*#__PURE__*/function (_AbstractClient) {
  function PaymentAttemptClient() {
    _classCallCheck(this, PaymentAttemptClient);
    return _callSuper(this, PaymentAttemptClient, arguments);
  }
  _inherits(PaymentAttemptClient, _AbstractClient);
  return _createClass(PaymentAttemptClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/payment_attempts';
    }
  }, {
    key: "getToken",
    value: function getToken(values, fields) {
      var url = URI(this.getPathBase());
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(values)
      }), 'item');
    }
  }]);
}(AbstractClient);

var PaymentAttempt = /*#__PURE__*/function (_NetworkEntity) {
  function PaymentAttempt() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'PaymentAttempt'
    };
    _classCallCheck(this, PaymentAttempt);
    _this = _callSuper(this, PaymentAttempt, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(PaymentAttempt, _NetworkEntity);
  return _createClass(PaymentAttempt);
}(NetworkEntity({
  '@id': null,
  '@type': 'PaymentAttempt',
  providerMetadata: undefined,
  status: undefined,
  order: undefined,
  amount: undefined,
  redirectBaseUrl: undefined,
  cancelBaseUrl: undefined,
  subscriptionMaturityList: undefined,
  paymentLink: undefined
}));
PaymentAttempt.classMetadata = new ClassMetadata('paymentAttempt', 'payment_attempts', /** @ts-expect-error -- method signature are incompatible */
PaymentAttemptClient);
PaymentAttempt.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('providerMetadata'), new Attribute('status'), new Attribute('amount', 'amount', 'integer'), new Attribute('redirectBaseUrl'), new Attribute('cancelBaseUrl')]);
PaymentAttempt.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.MANY_TO_ONE, 'paymentLink', 'paymentLink'), new Relation(Relation.ONE_TO_MANY, 'subscriptionMaturity', 'subscriptionMaturityList')]);

var ProviderAutoImportedTicketClient = /*#__PURE__*/function (_AbstractClient) {
  function ProviderAutoImportedTicketClient() {
    _classCallCheck(this, ProviderAutoImportedTicketClient);
    return _callSuper(this, ProviderAutoImportedTicketClient, arguments);
  }
  _inherits(ProviderAutoImportedTicketClient, _AbstractClient);
  return _createClass(ProviderAutoImportedTicketClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/provider_auto_imported_tickets';
    }
  }, {
    key: "processHandle",
    value: function processHandle(provider, contractIri) {
      var uri = new URI("".concat(this.getPathBase(), "/process/handle"));
      var body = {
        contract: contractIri,
        provider: provider
      };
      return this.authorizedFetch(uri, {
        method: 'POST',
        body: JSON.stringify(body)
      });
    }
  }]);
}(AbstractClient);

var ProviderAutoImportedTicket = /*#__PURE__*/function (_NetworkEntity) {
  function ProviderAutoImportedTicket() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderAutoImportedTicket'
    };
    _classCallCheck(this, ProviderAutoImportedTicket);
    _this = _callSuper(this, ProviderAutoImportedTicket, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ProviderAutoImportedTicket, _NetworkEntity);
  return _createClass(ProviderAutoImportedTicket);
}(NetworkEntity({
  '@id': null,
  '@type': 'ProviderAutoImportedTicket',
  __brand: 'ProviderAutoImportedTicket'
}));
ProviderAutoImportedTicket.classMetadata = new ClassMetadata('providerAutoImportedTicket', 'provider_auto_imported_tickets', /** @ts-expect-error -- method signature are incompatible */
ProviderAutoImportedTicketClient);
ProviderAutoImportedTicket.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type')]);

var ProviderExportedCartClient = /*#__PURE__*/function (_AbstractClient) {
  function ProviderExportedCartClient() {
    _classCallCheck(this, ProviderExportedCartClient);
    return _callSuper(this, ProviderExportedCartClient, arguments);
  }
  _inherits(ProviderExportedCartClient, _AbstractClient);
  return _createClass(ProviderExportedCartClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/provider_exported_carts';
    }
  }, {
    key: "publish",
    value: function publish(contract, providerName, cart, data, fields) {
      var url = new URI(this.getPathBase());
      url.addSearch({
        fields: getFieldsString(fields)
      });
      var body = {
        contract: contract,
        providerName: providerName,
        cart: cart,
        data: data
      };
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(body)
      }), 'item');
    }
  }, {
    key: "republish",
    value: function republish(contract, providerName, cart, data, fields, id) {
      assertRelationIsDefined(id);
      var url = new URI("".concat(this.getPathBase(), "/").concat(id));
      url.addSearch({
        fields: getFieldsString(fields)
      });
      var body = {
        contract: contract,
        providerName: providerName,
        cart: cart,
        data: data
      };
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'PUT',
        body: JSON.stringify(body)
      }), 'item');
    }
  }]);
}(AbstractClient);

var PROVIDER_EXPORTED_CART = /*#__PURE__*/function (PROVIDER_EXPORTED_CART) {
  PROVIDER_EXPORTED_CART["PASS_CULTURE"] = "pass_culture";
  return PROVIDER_EXPORTED_CART;
}({});
var ProviderExportedCart = /*#__PURE__*/function (_NetworkEntity) {
  function ProviderExportedCart() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderExportedCart'
    };
    _classCallCheck(this, ProviderExportedCart);
    _this = _callSuper(this, ProviderExportedCart, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ProviderExportedCart, _NetworkEntity);
  return _createClass(ProviderExportedCart, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/provider_exported_carts/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ProviderExportedCart',
  providerName: null,
  providerExportUrl: null,
  data: null
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
ProviderExportedCart.classMetadata = new ClassMetadata('providerExportedCart', 'provider_exported_carts', /** @ts-expect-error -- method signature are incompatible */
ProviderExportedCartClient);
ProviderExportedCart.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('providerName'), new Attribute('providerExportUrl'), new Attribute('data', 'data', 'object')]);

var ProviderContractClient = /*#__PURE__*/function (_AbstractClient) {
  function ProviderContractClient() {
    _classCallCheck(this, ProviderContractClient);
    return _callSuper(this, ProviderContractClient, arguments);
  }
  _inherits(ProviderContractClient, _AbstractClient);
  return _createClass(ProviderContractClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/provider_contracts';
    }
  }]);
}(AbstractClient);

var PROVIDER_CONTRACT = /*#__PURE__*/function (PROVIDER_CONTRACT) {
  PROVIDER_CONTRACT["TICKETNET"] = "ticketnet";
  return PROVIDER_CONTRACT;
}({});
var PROVIDER_ACTION = /*#__PURE__*/function (PROVIDER_ACTION) {
  PROVIDER_ACTION["EXPORT"] = "export";
  return PROVIDER_ACTION;
}({});
var PROVIDER_STATUS = /*#__PURE__*/function (PROVIDER_STATUS) {
  PROVIDER_STATUS["ACTIVE"] = "active";
  PROVIDER_STATUS["PENDING"] = "pending";
  return PROVIDER_STATUS;
}({});
var ProviderContract = /*#__PURE__*/function (_NetworkEntity) {
  function ProviderContract() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderContract'
    };
    _classCallCheck(this, ProviderContract);
    _this = _callSuper(this, ProviderContract, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ProviderContract, _NetworkEntity);
  return _createClass(ProviderContract, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/provider_contracts/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ProviderContract',
  contract: undefined,
  providerName: undefined,
  action: undefined
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
ProviderContract.classMetadata = new ClassMetadata('providerContract', 'provider_contracts', /** @ts-expect-error -- method signature are incompatible */
ProviderContractClient);
ProviderContract.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('providerName', 'providerName', 'string'), new Attribute('action', 'action', 'string')]);
ProviderContract.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var ProviderExportedTicketPriceClient = /*#__PURE__*/function (_AbstractClient) {
  function ProviderExportedTicketPriceClient() {
    _classCallCheck(this, ProviderExportedTicketPriceClient);
    return _callSuper(this, ProviderExportedTicketPriceClient, arguments);
  }
  _inherits(ProviderExportedTicketPriceClient, _AbstractClient);
  return _createClass(ProviderExportedTicketPriceClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/provider_exported_ticket_prices';
    }

    /** @deprecated Use removeFromTicketPrice method instead */
  }, {
    key: "delete",
    value: function _delete() {
      throw new Error('Use removeFromTicketPrice method instead');
    }
  }, {
    key: "removeFromTicketPrice",
    value: function removeFromTicketPrice(providerExportedTicketPrice, ticketPrice) {
      var url = "".concat(this.getPathBase(), "/").concat(providerExportedTicketPrice.getShortId(), "/ticket_price/").concat(ticketPrice.getShortId());
      return this.authorizedFetch(url, {
        method: 'DELETE'
      });
    }
  }]);
}(AbstractClient);

var ProviderExportedTicketPrice = /*#__PURE__*/function (_NetworkEntity) {
  function ProviderExportedTicketPrice() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ProviderExportedTicketPrice'
    };
    _classCallCheck(this, ProviderExportedTicketPrice);
    _this = _callSuper(this, ProviderExportedTicketPrice, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ProviderExportedTicketPrice, _NetworkEntity);
  return _createClass(ProviderExportedTicketPrice, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/provider_exported_ticket_prices/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ProviderExportedTicketPrice',
  ticketPrice: undefined,
  providerContract: undefined,
  name: undefined
})); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
ProviderExportedTicketPrice.classMetadata = new ClassMetadata('providerExportedTicketPrice', 'provider_exported_ticket_prices', /** @ts-expect-error -- method signature are incompatible */
ProviderExportedTicketPriceClient);
ProviderExportedTicketPrice.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('name')]);
ProviderExportedTicketPrice.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'providerContract', 'providerContract'), new Relation(Relation.MANY_TO_ONE, 'ticketPrice', 'ticketPrice')]);

var PublicTypologyClient = /*#__PURE__*/function (_HidableClient) {
  function PublicTypologyClient() {
    _classCallCheck(this, PublicTypologyClient);
    return _callSuper(this, PublicTypologyClient, arguments);
  }
  _inherits(PublicTypologyClient, _HidableClient);
  return _createClass(PublicTypologyClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/public_typologies';
    }
  }]);
}(HidableClient);

var PUBLIC_TYPOLOGY_TYPE = /*#__PURE__*/function (PUBLIC_TYPOLOGY_TYPE) {
  PUBLIC_TYPOLOGY_TYPE["FULL_PRICE"] = "full_price";
  PUBLIC_TYPOLOGY_TYPE["REDUCED"] = "reduced";
  PUBLIC_TYPOLOGY_TYPE["EXEMPTED"] = "exempted";
  PUBLIC_TYPOLOGY_TYPE["SUBSCRIPTION_MEMBER_LOYALTY"] = "subscriptionMemberLoyalty";
  PUBLIC_TYPOLOGY_TYPE["SCHOLAR"] = "scholar";
  PUBLIC_TYPOLOGY_TYPE["GROUP"] = "group";
  PUBLIC_TYPOLOGY_TYPE["RESELLER"] = "reseller";
  PUBLIC_TYPOLOGY_TYPE["OTHER"] = "other";
  return PUBLIC_TYPOLOGY_TYPE;
}({});
var PublicTypology = /*#__PURE__*/function (_NetworkEntity) {
  function PublicTypology() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'PublicTypology'
    };
    _classCallCheck(this, PublicTypology);
    _this = _callSuper(this, PublicTypology, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(PublicTypology, _NetworkEntity);
  return _createClass(PublicTypology, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/public_typologies/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'PublicTypology',
  label: undefined,
  type: undefined,
  contract: undefined,
  organizationalUnit: undefined,
  ticketPriceList: undefined,
  isHidden: undefined
}));
PublicTypology.classMetadata = new ClassMetadata('publicTypology', 'public_typologies', /** @ts-expect-error -- method signature are incompatible */
PublicTypologyClient);
PublicTypology.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('label'), new Attribute('type'), new Attribute('isHidden', 'isHidden', 'boolean')]);
PublicTypology.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract'), new Relation(Relation.MANY_TO_ONE, 'organizationalUnit', 'organizationalUnit'), new Relation(Relation.ONE_TO_MANY, 'ticketPrice', 'ticketPriceList')]);

var PaymentLinkClient = /*#__PURE__*/function (_HidableClient) {
  function PaymentLinkClient() {
    _classCallCheck(this, PaymentLinkClient);
    return _callSuper(this, PaymentLinkClient, arguments);
  }
  _inherits(PaymentLinkClient, _HidableClient);
  return _createClass(PaymentLinkClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/payment_links';
    }
  }]);
}(HidableClient);

var PaymentLink = /*#__PURE__*/function (_NetworkEntity) {
  function PaymentLink(val) {
    var _this;
    _classCallCheck(this, PaymentLink);
    var data = clone(val);
    var tz = extractTimezone(data, ['order', 'contract', 'timezone']);
    data.createdAt = parseDate(data.createdAt, tz);
    data.updatedAt = parseDate(data.updatedAt, tz);
    data.expiresAt = parseDate(data.expiresAt, tz);
    data.proNotifiedAt = parseDate(data.proNotifiedAt, tz);
    data.buyerNotifiedAt = parseDate(data.buyerNotifiedAt, tz);
    data.settledAt = parseDate(data.settledAt, tz);
    _this = _callSuper(this, PaymentLink, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(PaymentLink, _NetworkEntity);
  return _createClass(PaymentLink, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/payment_links/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'PaymentLink',
  order: undefined,
  sellingDevice: undefined,
  amount: undefined,
  buyerEmail: undefined,
  url: undefined,
  notifyPro: undefined,
  notifyBuyer: undefined,
  messageDisplayedOnPaymentPage: undefined,
  expiresAt: null,
  proNotifiedAt: null,
  buyerNotifiedAt: null,
  settledAt: null,
  createdAt: null,
  updatedAt: null,
  isHidden: null
}));
PaymentLink.classMetadata = new ClassMetadata('paymentLink', 'payment_links', /** @ts-expect-error -- method signature are incompatible */
PaymentLinkClient);
PaymentLink.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('amount', 'amount', 'integer'), new Attribute('buyerEmail', 'buyerEmail', 'string'), new Attribute('url', 'url', 'string'), new Attribute('notifyPro', 'notifyPro', 'boolean'), new Attribute('notifyBuyer', 'notifyBuyer', 'boolean'), new Attribute('messageDisplayedOnPaymentPage', 'messageDisplayedOnPaymentPage', 'string'), new Attribute('expiresAt', 'expiresAt', 'datetime'), new Attribute('proNotifiedAt', 'proNotifiedAt', 'datetime'), new Attribute('buyerNotifiedAt', 'buyerNotifiedAt', 'datetime'), new Attribute('settledAt', 'settledAt', 'datetime'), new Attribute('createdAt', 'createdAt', 'datetime'), new Attribute('updatedAt', 'updatedAt', 'datetime'), new Attribute('isHidden', 'isHidden', 'boolean')]);
PaymentLink.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'order', 'order'), new Relation(Relation.MANY_TO_ONE, 'sellingDevice', 'sellingDevice')]);

var ReconciliationEntryClient = /*#__PURE__*/function (_AbstractClient) {
  function ReconciliationEntryClient() {
    _classCallCheck(this, ReconciliationEntryClient);
    return _callSuper(this, ReconciliationEntryClient, arguments);
  }
  _inherits(ReconciliationEntryClient, _AbstractClient);
  return _createClass(ReconciliationEntryClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/reconciliation_entries';
    }
  }, {
    key: "link",
    value: function link(values) {
      var url = new URI("".concat(this.getPathBase(), "/link"));
      return this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(values)
      });
    }
  }, {
    key: "unlink",
    value: function unlink(values) {
      var url = new URI("".concat(this.getPathBase(), "/unlink"));
      return this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(values)
      });
    }
  }]);
}(AbstractClient);

var ReconciliationEntry = /*#__PURE__*/function (_NetworkEntity) {
  function ReconciliationEntry(val) {
    var _this;
    _classCallCheck(this, ReconciliationEntry);
    var data = clone(val);
    var tz = extractTimezone(data, ['transaction', 'contract', 'timezone']);
    data.createdAt = parseDate(data.createdAt, tz);
    data.updatedAt = parseDate(data.updatedAt, tz);
    _this = _callSuper(this, ReconciliationEntry, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(ReconciliationEntry, _NetworkEntity);
  return _createClass(ReconciliationEntry, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/reconciliation_entries/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'ReconciliationEntry',
  amount: undefined,
  transaction: undefined,
  invoiceLine: undefined,
  createdAt: null,
  updatedAt: null
}));
ReconciliationEntry.classMetadata = new ClassMetadata('reconciliationEntry', 'reconciliation_entries', /** @ts-expect-error -- method signature are incompatible */
ReconciliationEntryClient);
ReconciliationEntry.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('amount', 'amount', 'integer')]);
ReconciliationEntry.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'transaction', 'transaction'), new Relation(Relation.MANY_TO_ONE, 'invoiceLine', 'invoiceLine')]);

var ResolvePinIdsClient = /*#__PURE__*/function (_AbstractClient) {
  function ResolvePinIdsClient() {
    _classCallCheck(this, ResolvePinIdsClient);
    return _callSuper(this, ResolvePinIdsClient, arguments);
  }
  _inherits(ResolvePinIdsClient, _AbstractClient);
  return _createClass(ResolvePinIdsClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/mass_action_aggregates/resolve_pin_ids';
    }
  }, {
    key: "getResolvedPinIds",
    value: function getResolvedPinIds(values, fields) {
      var requestParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = URI(this.getPathBase());
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, _objectSpread2({
        method: 'POST',
        body: JSON.stringify(values)
      }, requestParams)), 'item');
    }
  }]);
}(AbstractClient);

var ResolvePinIdsAggregate = /*#__PURE__*/function (_NetworkEntity) {
  function ResolvePinIdsAggregate() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ResolvePinIdsAggregate'
    };
    _classCallCheck(this, ResolvePinIdsAggregate);
    _this = _callSuper(this, ResolvePinIdsAggregate, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ResolvePinIdsAggregate, _NetworkEntity);
  return _createClass(ResolvePinIdsAggregate);
}(NetworkEntity({
  '@id': null,
  '@type': 'ResolvePinIdsAggregate',
  invoiceList: undefined,
  transactionList: undefined
}));
ResolvePinIdsAggregate.classMetadata = new ClassMetadata('resolvePinIdsAggregate', 'mass_action_aggregates/resolve_pin_ids', /** @ts-expect-error -- method signature are incompatible */
ResolvePinIdsClient);
ResolvePinIdsAggregate.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type')]);
ResolvePinIdsAggregate.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'invoice', 'invoiceList'), new Relation(Relation.ONE_TO_MANY, 'transaction', 'transactionList')]);

var ResolveTicketSwapIdsClient = /*#__PURE__*/function (_AbstractClient) {
  function ResolveTicketSwapIdsClient() {
    _classCallCheck(this, ResolveTicketSwapIdsClient);
    return _callSuper(this, ResolveTicketSwapIdsClient, arguments);
  }
  _inherits(ResolveTicketSwapIdsClient, _AbstractClient);
  return _createClass(ResolveTicketSwapIdsClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/mass_action_aggregates/resolve_ticket_swap_ids';
    }
  }, {
    key: "getResolvedTicketSwapIds",
    value: function getResolvedTicketSwapIds(values, fields) {
      var requestParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = URI(this.getPathBase());
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, _objectSpread2({
        method: 'POST',
        body: JSON.stringify(values)
      }, requestParams)), 'item');
    }
  }]);
}(AbstractClient);

var ResolveTicketSwapIdsAggregate = /*#__PURE__*/function (_NetworkEntity) {
  function ResolveTicketSwapIdsAggregate() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'ResolveTicketSwapIdsAggregate'
    };
    _classCallCheck(this, ResolveTicketSwapIdsAggregate);
    _this = _callSuper(this, ResolveTicketSwapIdsAggregate, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(ResolveTicketSwapIdsAggregate, _NetworkEntity);
  return _createClass(ResolveTicketSwapIdsAggregate);
}(NetworkEntity({
  '@id': null,
  '@type': 'ResolveTicketSwapIdsAggregate',
  ticketingList: undefined,
  ticketPriceList: undefined
}));
ResolveTicketSwapIdsAggregate.classMetadata = new ClassMetadata('resolveTicketSwapIdsAggregate', 'mass_action_aggregates/resolve_ticket_swap_ids', /** @ts-expect-error -- method signature are incompatible */
ResolveTicketSwapIdsClient);
ResolveTicketSwapIdsAggregate.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type')]);
ResolveTicketSwapIdsAggregate.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'ticketing', 'ticketingList'), new Relation(Relation.ONE_TO_MANY, 'ticketPrice', 'ticketPriceList')]);

var TicketSwapConfigClient = /*#__PURE__*/function (_AbstractClient) {
  function TicketSwapConfigClient() {
    _classCallCheck(this, TicketSwapConfigClient);
    return _callSuper(this, TicketSwapConfigClient, arguments);
  }
  _inherits(TicketSwapConfigClient, _AbstractClient);
  return _createClass(TicketSwapConfigClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/ticket_swap_configs';
    }
  }]);
}(AbstractClient);

var TICKET_PRICE_CONSTRAINT = /*#__PURE__*/function (TICKET_PRICE_CONSTRAINT) {
  TICKET_PRICE_CONSTRAINT["NO_CONSTRAINT"] = "no_constraint";
  TICKET_PRICE_CONSTRAINT["SAME_TICKET_PRICE_NAME"] = "same_ticket_price_name";
  TICKET_PRICE_CONSTRAINT["SAME_TICKET_PRICE_GROUP_NAME"] = "same_ticket_price_group_name";
  TICKET_PRICE_CONSTRAINT["SPECIFIC_TICKET_PRICE_GROUP"] = "specific_ticket_price_group";
  return TICKET_PRICE_CONSTRAINT;
}({});
var SWAP_PRICE_CONSTRAINT = /*#__PURE__*/function (SWAP_PRICE_CONSTRAINT) {
  SWAP_PRICE_CONSTRAINT["SAME_PRICE_PER_TICKET"] = "same_price_per_ticket";
  SWAP_PRICE_CONSTRAINT["SAME_OR_GREATER_PRICE_PER_TICKET"] = "same_or_greater_price_per_ticket";
  SWAP_PRICE_CONSTRAINT["ALL_PRICE_PER_TICKET"] = "all_price_per_ticket";
  SWAP_PRICE_CONSTRAINT["ALL_PRICE_PER_TICKET_CASH_COUPON"] = "all_price_per_ticket_cash_coupon";
  SWAP_PRICE_CONSTRAINT["SAME_TOTAL_PRICE"] = "same_total_price";
  SWAP_PRICE_CONSTRAINT["SAME_OR_GREATER_TOTAL_PRICE"] = "same_or_greater_total_price";
  SWAP_PRICE_CONSTRAINT["ALL_PRICE"] = "all_price";
  SWAP_PRICE_CONSTRAINT["TOTAL_CASH_COUPON"] = "total_cash_coupon";
  return SWAP_PRICE_CONSTRAINT;
}({});
var TicketSwapConfig = /*#__PURE__*/function (_NetworkEntity) {
  function TicketSwapConfig(val) {
    var _this;
    _classCallCheck(this, TicketSwapConfig);
    var data = clone(val);
    _this = _callSuper(this, TicketSwapConfig, [data]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, data));
  }
  _inherits(TicketSwapConfig, _NetworkEntity);
  return _createClass(TicketSwapConfig, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/ticket_swap_configs/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'TicketSwapConfig',
  isEnabled: undefined,
  ticketPriceConstraint: undefined,
  swapPriceConstraint: undefined,
  feePerSwap: undefined,
  feePerTicketSwap: undefined,
  sameOrganizationalUnitConstraint: undefined,
  sameTicketingConstraint: undefined,
  sameSeasonConstraint: undefined,
  existingSwapConstraint: undefined,
  refundCashCouponValidity: undefined,
  delayInterval: undefined,
  ticketingList: undefined,
  ticketPriceList: undefined
}));
TicketSwapConfig.classMetadata = new ClassMetadata('ticketSwapConfig', 'ticket_swap_configs', /** @ts-expect-error -- method signature are incompatible */
TicketSwapConfigClient);
TicketSwapConfig.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('isEnabled', 'isEnabled', 'boolean'), new Attribute('ticketPriceConstraint'), new Attribute('swapPriceConstraint'), new Attribute('feePerSwap', 'feePerSwap', 'integer'), new Attribute('feePerTicketSwap', 'feePerTicketSwap', 'integer'), new Attribute('sameOrganizationalUnitConstraint', 'sameOrganizationalUnitConstraint', 'boolean'), new Attribute('sameTicketingConstraint', 'sameTicketingConstraint', 'boolean'), new Attribute('sameSeasonConstraint', 'sameSeasonConstraint', 'boolean'), new Attribute('existingSwapConstraint', 'existingSwapConstraint', 'boolean'), new Attribute('refundCashCouponValidity', 'refundCashCouponValidity', 'integer'), new Attribute('delayInterval')]);
TicketSwapConfig.classMetadata.setRelationList([new Relation(Relation.ONE_TO_MANY, 'ticketing', 'ticketingList'), new Relation(Relation.ONE_TO_MANY, 'ticketPrice', 'ticketPriceList')]);

var OrderTransactionAmountsClient = /*#__PURE__*/function (_AbstractClient) {
  function OrderTransactionAmountsClient() {
    _classCallCheck(this, OrderTransactionAmountsClient);
    return _callSuper(this, OrderTransactionAmountsClient, arguments);
  }
  _inherits(OrderTransactionAmountsClient, _AbstractClient);
  return _createClass(OrderTransactionAmountsClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/mass_action_aggregates/order_transaction_amounts';
    }
  }, {
    key: "getAmounts",
    value: function getAmounts(values) {
      var url = URI(this.getPathBase());
      return this.deserializeResponse(this.authorizedFetch(url, {
        method: 'POST',
        body: JSON.stringify(values)
      }), 'item');
    }
  }]);
}(AbstractClient);

var OrderTransactionAmountsAggregate = /*#__PURE__*/function (_NetworkEntity) {
  function OrderTransactionAmountsAggregate() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'OrderTransactionAmountsAggregate'
    };
    _classCallCheck(this, OrderTransactionAmountsAggregate);
    _this = _callSuper(this, OrderTransactionAmountsAggregate, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(OrderTransactionAmountsAggregate, _NetworkEntity);
  return _createClass(OrderTransactionAmountsAggregate);
}(NetworkEntity({
  '@id': null,
  '@type': 'OrderTransactionAmountsAggregate',
  orderTransactionAmounts: undefined
}));
OrderTransactionAmountsAggregate.classMetadata = new ClassMetadata('orderTransactionAmountsAggregate', 'mass_action_aggregates/order_transaction_amounts', /** @ts-expect-error -- method signature are incompatible */
OrderTransactionAmountsClient);
OrderTransactionAmountsAggregate.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('orderTransactionAmounts', 'orderTransactionAmounts', 'object')]);

var EntityFactory = /*#__PURE__*/function () {
  function EntityFactory() {
    _classCallCheck(this, EntityFactory);
  }
  return _createClass(EntityFactory, null, [{
    key: "createEntity",
    value:
    // export function createEntity(val: Input<string>): Map<string, unknown>;

    function createEntity(val, registry) {
      if (!val) {
        return;
      }
      switch (val['@type']) {
        /** @ts-expect-error -- PagedCollection does exist in API sometimes, but is a collection */
        case 'hydra:PagedCollection':
          if (val['@id'] === '/v1/carts') {
            // @ts-expect-error val should be converted to an entity
            return new PagedCartCollection(val);
          }
          // @ts-expect-error val should be converted to an entity
          return new PagedCollection(val);
        case 'hydra:Collection':
          return new Collection(val);
        case 'AccountingClient':
          return new AccountingClient(val);
        case 'AuditDocument':
          return new AuditDocument(val);
        case 'AvailableSeat':
          return new AvailableSeat(val);
        case 'AvailableSeatModel':
          return new AvailableSeatModel(val);
        case 'BankAccount':
          return new BankAccount(val);
        case 'Booking':
          return new Booking(val);
        case 'BookingItem':
          return new BookingItem(val);
        case 'BookingTrack':
          return new BookingTrack(val);
        case 'BookingTrackMode':
          return new BookingTrackMode(val);
        case 'Cart':
          return new Cart(val, registry);
        case 'CartItem':
          return new CartItem(val, registry);
        case 'SwapValidateRepresentation':
          return new SwapValidateRepresentation(val);
        case 'Checkpoint':
          return new Checkpoint(val);
        case 'Client':
          return new Client(val);
        case 'Contingent':
          return new Contingent(val);
        case 'Contract':
          return new Contract(val);
        case 'ContractAddendum':
          return new ContractAddendum(val);
        case 'Customer':
          return new Customer(val);
        case 'Coupon':
          return new Coupon(val);
        case 'CouponCodeGroup':
          return new CouponCodeGroup(val);
        case 'CustomerField':
          return new CustomerField(val);
        case 'CustomerFieldContract':
          return new CustomerFieldContract(val);
        case 'CustomerStatus':
          return new CustomerStatus(val);
        case 'Deposit':
          return new Deposit(val);
        case 'DeskPaymentMethod':
          return new DeskPaymentMethod(val);
        case 'DeskSession':
          return new DeskSession(val);
        case 'DeviceState':
          return new DeviceState(val);
        case 'EventDate':
          return new EventDate(val);
        case 'EventDatePattern':
          return new EventDatePattern(val);
        case 'Form':
          return new Form(val);
        case 'Fee':
          return new Fee(val);
        case 'Invoice':
          return new Invoice(val);
        case 'InvoiceLine':
          return new InvoiceLine(val);
        case 'Job':
          return new Job(val);
        case 'Lettering':
          return new Lettering(val);
        case 'LogicalSeatConfig':
          return new LogicalSeatConfig(val);
        case 'TicketPriceAvailabilityMassActionAggregate':
          return new TicketPriceAvailabilityMassActionAggregate(val);
        case 'ReconciliationAmountsAggregate':
          return new ReconciliationAmountsAggregate(val);
        case 'ProviderAutoImportedTicket':
          return new ProviderAutoImportedTicket(val);
        case 'ProviderContract':
          return new ProviderContract(val);
        case 'ProviderExportedCart':
          return new ProviderExportedCart(val);
        case 'ProviderSeatMapping':
          return new ProviderSeatMapping(val);
        case 'ProviderSeatConfigMapping':
          return new ProviderSeatConfigMapping(val);
        case 'ProviderContingentMapping':
          return new ProviderContingentMapping(val);
        case 'ProviderTicketPriceMapping':
          return new ProviderTicketPriceMapping(val);
        case 'ProviderTicketingMapping':
          return new ProviderTicketingMapping(val);
        case 'ProviderMappingNotification':
          return new ProviderMappingNotification(val);
        case 'ProviderExportedTicketPrice':
          return new ProviderExportedTicketPrice(val);
        case 'MasterTicket':
          return new MasterTicket(val);
        case 'Minisite':
          return new Minisite(val);
        case 'Module':
          return new Module(val);
        case 'Notification':
          return new Notification(val);
        case 'OfferRule':
          return new OfferRule(val);
        case 'Order':
          return new Order(val);
        case 'OrderFeeItem':
          return new OrderFeeItem(val);
        case 'OrderItem':
          return new OrderItem(val);
        case 'OrderItemCashCoupon':
          return new OrderItemCashCoupon(val);
        case 'OrderItemInvoiceGroup':
          return new OrderItemInvoiceGroup(val);
        case 'OrderTransactionAmountsAggregate':
          return new OrderTransactionAmountsAggregate(val);
        case 'OrganizationalUnit':
          return new OrganizationalUnit(val);
        case 'Payment':
          return new Payment(val);
        case 'PaymentAttempt':
          return new PaymentAttempt(val);
        case 'PaymentFee':
          return new PaymentFee(val);
        case 'PaymentLink':
          return new PaymentLink(val);
        case 'ProviderTicketCredentials':
          return new ProviderTicketCredentials(val);
        case 'PublicTypology':
          return new PublicTypology(val);
        case 'ProviderTicketImportedFile':
          return new ProviderTicketImportedFile(val);
        case 'Refund':
          return new Refund(val);
        case 'RefundOrderItem':
          return new RefundOrderItem(val);
        case 'ReportingAccount':
          return new ReportingAccount(val);
        case 'ResolvePinIdsAggregate':
          return new ResolvePinIdsAggregate(val);
        case 'ResolveTicketSwapIdsAggregate':
          return new ResolveTicketSwapIdsAggregate(val);
        case 'Scan':
          return new Scan(val);
        case 'ScanTrack':
          return new ScanTrack(val);
        case 'ScanTrackCheckpoint':
          return new ScanTrackCheckpoint(val);
        case 'ScanConfig':
          return new ScanConfig(val);
        case 'Season':
          return new Season(val);
        case 'Seat':
          return new Seat(val);
        case 'SeatConfig':
          return new SeatConfig(val);
        case 'SeatConfigBlock':
          return new SeatConfigBlock(val);
        case 'SeatGroup':
          return new SeatGroup(val);
        case 'SeatZone':
          return new SeatZone(val);
        case 'SeatFloor':
          return new SeatFloor(val);
        case 'SellingDevice':
          return new SellingDevice(val);
        case 'Shipping':
          return new Shipping(val);
        case 'Billing':
          return new Billing(val);
        case 'SibilParameter':
          return new SibilParameter(val);
        case 'SibilTicketingSpectacle':
          return new SibilTicketingSpectacle(val);
        case 'SibilVenueLieu':
          return new SibilVenueLieu(val);
        case 'StockContingent':
          return new StockContingent(val);
        case 'Sticker':
          return new Sticker(val);
        case 'Subscription':
          return new Subscription(val);
        case 'SubscriptionMaturity':
          return new SubscriptionMaturity(val);
        case 'User':
          return new User(val);
        case 'Tag':
          return new Tag(val);
        case 'Tax':
          return new Tax(val);
        case 'Ticket':
          return new Ticket(val);
        case 'TicketCheckpoint':
          return new TicketCheckpoint(val);
        case 'Ticketing':
          return new Ticketing(val);
        case 'TicketingCategory':
          return new TicketingCategory(val);
        case 'TicketingOptionStress':
          return new TicketingOptionStress(val);
        case 'TicketingSellingDevice':
          return new TicketingSellingDevice(val);
        case 'TicketingUser':
          return new TicketingUser(val);
        case 'TicketPrice':
          return new TicketPrice(val, registry);
        case 'TicketSwapConfig':
          return new TicketSwapConfig(val);
        case 'TicketPriceGroup':
          return new TicketPriceGroup(val);
        case 'TicketPriceSeatGroup':
          return new TicketPriceSeatGroup(val);
        case 'Transaction':
          return new Transaction(val);
        case 'TransactionGroup':
          return new TransactionGroup(val);
        case 'ReconciliationEntry':
          return new ReconciliationEntry(val);
        case 'ReconciliationAvailableActionsAggregate':
          return new ReconciliationAvailableActions(val);
        case 'Venue':
          return new Venue(val);
        case 'Version':
          return new Version(val);
        case 'Wallet':
          return new Wallet(val);
        default:
          return fromJS(val);
      }
    }
  }]);
}(); // @ts-expect-error -- don't care
var createEntity = function createEntity(val, registry) {
  if (registry) {
    var foundEntity = registry.get(val);
    if (foundEntity) {
      return foundEntity;
    }
  }
  if (!val) {
    return null;
  }

  // @ts-expect-error don't care
  var createdEntity = EntityFactory.createEntity(val, registry);
  if (registry && _typeof(createdEntity) === 'object') {
    registry.register(createdEntity, val);
  }
  return createdEntity;
};

function getEntityId(entity) {
  if (typeof entity === 'string') {
    return entity;
  }
  if (_typeof(entity) === 'object' && entity !== null) {
    if ('@id' in entity) {
      return entity['@id'];
    }
    return entity.get('@id');
  }
  return null;
}
function isMap(object) {
  return Map$1.isMap(object);
}
function normalizeCartCustomer(customerParam) {
  if (!customerParam) {
    return null;
  }
  var customerId = getEntityId(customerParam);
  if (customerId) {
    return customerId;
  }
  var customer = isMap(customerParam) ? customerParam.toJS() : customerParam;
  var customerJS = {
    crmId: customer.crmId,
    lastname: customer.lastname,
    firstname: customer.firstname,
    email: customer.email
  };
  if (customer.type !== null) {
    customerJS.type = customer.type;
  }
  if (customer.birthday !== null) {
    customerJS.birthday = customer.birthday;
  }
  if (customer.nationality !== null) {
    customerJS.nationality = customer.nationality;
  }
  if (customer.countryOfResidence !== null) {
    customerJS.countryOfResidence = customer.countryOfResidence;
  }
  if (customer.civility !== null) {
    customerJS.civility = customer.civility;
  }
  if (customer.zipcode !== null) {
    customerJS.zipcode = customer.zipcode;
  }
  if (customer.address !== null) {
    customerJS.address = customer.address;
  }
  if (customer.city !== null) {
    customerJS.city = customer.city;
  }
  if (customer.phone !== null) {
    customerJS.phone = customer.phone;
  }
  if (customer.additionnalInformation !== null) {
    customerJS.additionnalInformation = customer.additionnalInformation;
  }
  if (customer.shoppingData !== null) {
    customerJS.shoppingData = customer.shoppingData;
  }
  if (customer.gdprInformation !== null) {
    customerJS.gdprInformation = customer.gdprInformation;
  }
  if (customer.client !== null) {
    customerJS.client = customer.client;
  }
  return customerJS;
}
function normalizeCart(cart) {
  var _cart$cartItemList;
  var normalizedCart = {
    '@id': cart.get('@id'),
    '@type': 'Cart',
    /* eslint-disable @typescript-eslint/ban-ts-comment */
    currency: cart.currency,
    /** @ts-expect-error */
    customer: normalizeCartCustomer(cart.customer),
    contact: cart.contact && normalizeCartCustomer(cart.contact),
    status: cart.status,
    type: cart.type,
    option: cart.option ? getEntityId(cart.option) : null,
    reservationName: cart.reservationName,
    comment: cart.comment,
    couponCode: cart.couponCode,
    couponCodeList: cart.couponCodeList,
    tagList: cart.tagList ? cart.tagList.map(getEntityId).toArray().filter(function (a) {
      return a !== null;
    }) : null,
    eventDateOptionStatusList: cart.eventDateOptionStatusList ? cart.eventDateOptionStatusList.map(function (eventDateOptionStatus) {
      return eventDateOptionStatus.toObject();
    }).toArray() : null,
    parent: cart.parent ? getEntityId(cart.parent) : null,
    cartItemList: ((_cart$cartItemList = cart.cartItemList) === null || _cart$cartItemList === void 0 ? void 0 : _cart$cartItemList.map(function (cartItem) {
      if (typeof cartItem === 'string') {
        return cartItem;
      }
      var cartItemJS = {
        '@id': cartItem['@id'],
        '@type': 'CartItem',
        ticketPrice: cartItem.ticketPrice && getEntityId(cartItem.ticketPrice) || '',
        quantity: cartItem.quantity,
        groupKey: cartItem.groupKey,
        couponCode: cartItem.couponCode || null,
        stockContingent: cartItem.stockContingent ? getEntityId(cartItem.stockContingent) : null,
        participant: cartItem.participant ? getEntityId(cartItem.participant) : null
      };
      if (cartItem.availableSeatList) {
        /** @ts-expect-error */
        cartItemJS.availableSeatList = cartItem.availableSeatList.map(function (availableSeat) {
          if (typeof availableSeat === 'string') {
            return availableSeat;
          }
          return availableSeat.get('@id');
        }).filter(function (v) {
          return !!v;
        }).toArray();
      }

      /** @ts-expect-error */
      if (cartItem.facialValue > 0 || cartItem.facialValue === 0) {
        /** @ts-expect-error */
        cartItemJS.facialValue = cartItem.facialValue;
      }
      if (cartItem.data !== null) {
        cartItemJS.data = cartItem.data;
      }
      return cartItemJS;
    }).toArray()) || null,
    appliedCouponList: cart.appliedCouponList,
    createdCouponList: cart.createdCouponList,
    providerExportedCartList: cart.providerExportedCartList,
    owner: cart.owner ? getEntityId(cart.owner) : null
  };
  if (cart.sellingDevice) {
    normalizedCart.sellingDevice = cart.sellingDevice ? getEntityId(cart.sellingDevice) : null;
  } else if (cart.originType) {
    normalizedCart.originType = cart.originType;
  }
  if (cart.originId) {
    normalizedCart.originId = cart.originId;
  }
  /* eslint-enable @typescript-eslint/ban-ts-comment */

  return normalizedCart;
}

var _registry = /*#__PURE__*/new WeakMap();
var EntityRegistry = /*#__PURE__*/function () {
  function EntityRegistry() {
    _classCallCheck(this, EntityRegistry);
    _classPrivateFieldInitSpec(this, _registry, Map$1({}));
  }
  return _createClass(EntityRegistry, [{
    key: "register",
    value: function register(entity, val) {
      var id = entity['@id'];
      if (/** @ts-expect-error -- PagedCollection does exist in API sometimes, but is a collection */
      entity['@type'] === 'hydra:Collection' || /** @ts-expect-error -- PagedCollection does exist in API sometimes, but is a collection */
      entity['@type'] === 'hydra:PagedCollection') {
        // ignore collections
        return;
      }
      if (!id) {
        // no id, unable to register
        return;
      }
      var key = this.getKey(val);
      if (!key) {
        // unable to register
        return;
      }
      _classPrivateFieldSet2(_registry, this, _classPrivateFieldGet2(_registry, this).set(key, entity));
    }
  }, {
    key: "get",
    value: function get(val) {
      var _classPrivateFieldGet2$1;
      var key = this.getKey(val);
      if (!key) {
        return null;
      }
      return (_classPrivateFieldGet2$1 = _classPrivateFieldGet2(_registry, this).get(key)) !== null && _classPrivateFieldGet2$1 !== void 0 ? _classPrivateFieldGet2$1 : null;
    }
  }, {
    key: "getKey",
    value: function getKey(val) {
      if (val === null) {
        return null;
      }
      var keys = Object.keys(val);
      return "".concat(val['@id'], "|").concat(keys.join(','));
    }
  }]);
}();

function addResponseDateToObject(object, response) {
  var _response$headers;
  var responseDate = (response === null || response === void 0 || (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('date')) || null;
  var out = object; // responseDate will be added juste after that
  out.responseDate = responseDate;
  return out;
}
var isEntityCart = function isEntityCart(entity, classMetadata) {
  return classMetadata && classMetadata.key === 'cart';
};

/* eslint-disable @typescript-eslint/no-unused-vars */
var _EntitySerializer_brand = /*#__PURE__*/new WeakSet();
var EntitySerializer = /*#__PURE__*/function (_Serializer) {
  function EntitySerializer() {
    var _this;
    _classCallCheck(this, EntitySerializer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EntitySerializer, [].concat(args));
    _classPrivateMethodInitSpec(_this, _EntitySerializer_brand);
    return _this;
  }
  _inherits(EntitySerializer, _Serializer);
  return _createClass(EntitySerializer, [{
    key: "normalizeItem",
    value: function normalizeItem(entity, classMetadata) {
      if (isEntityCart(entity, classMetadata)) {
        return normalizeCart(entity);
      }
      return entity.toJS();
    }
  }, {
    key: "encodeItem",
    value: function encodeItem(object, classMetadata) {
      return JSON.stringify(object);
    }
  }, {
    key: "decodeItem",
    value: function decodeItem(rawData, classMetadata, response) {
      return rawData ? addResponseDateToObject(JSON.parse(rawData), response) :
      // @ts-expect-error -- should probably be '{}' instead of 'null', but I do not want to change behavior
      null;
    }
  }, {
    key: "denormalizeItem",
    value: function denormalizeItem(object, classMetadata, response) {
      // do stuff with your item input

      if (object) {
        var entityRegistry = _assertClassBrand(_EntitySerializer_brand, this, _hasExperimentalEntitySameInstance).call(this, response) ? new EntityRegistry() : undefined;
        return createEntity(object, entityRegistry);
      }
      throw new Error('Unable to denormalize item.');
    }
  }, {
    key: "decodeList",
    value: function decodeList(rawListData, classMetadata, response) {
      return rawListData ? addResponseDateToObject(JSON.parse(rawListData), response) :
      // @ts-expect-error -- should probably be '{}' instead of 'null', but I do not want to change behavior
      null;
    }
  }, {
    key: "denormalizeList",
    value: function denormalizeList(objectList, classMetadata, response) {
      var entityRegistry = _assertClassBrand(_EntitySerializer_brand, this, _hasExperimentalEntitySameInstance).call(this, response) ? new EntityRegistry() : undefined;

      /** @ts-expect-error -- really really hard / fucked up */
      return createEntity(objectList, entityRegistry);
    }
  }]);
}(Serializer);
function _hasExperimentalEntitySameInstance(response) {
  if (!response.url) {
    // handle manually created response (like in mock library)
    return false;
  }
  var experimentalEntitySameInstance = new URL(response.url).searchParams.has('experimentalEntitySameInstance');
  return experimentalEntitySameInstance;
}

var SibilProxyClient = /*#__PURE__*/function (_BaseClient) {
  function SibilProxyClient() {
    _classCallCheck(this, SibilProxyClient);
    return _callSuper(this, SibilProxyClient, arguments);
  }
  _inherits(SibilProxyClient, _BaseClient);
  return _createClass(SibilProxyClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/module/sibil/proxy';
    }
  }, {
    key: "doSearch",
    value: function doSearch(uri, sibilParameterId) {
      /** @ts-expect-error -- ignore this entity as it has been no entity and is weird */
      return this.authorizedFetch(uri, {
        method: 'GET',
        headers: {
          'X-SibilParameter': sibilParameterId,
          Accept: 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).then(createEntity);
    }
  }, {
    key: "getSpectacles",
    value: function getSpectacles(sibilParameterId, queryParameters) {
      var uri = new URI("".concat(this.getPathBase(), "/spectacles"));
      uri.addSearch(queryParameters);
      return this.doSearch(uri, sibilParameterId);
    }
  }, {
    key: "getFestivals",
    value: function getFestivals(sibilParameterId, queryParameters) {
      var uri = new URI("".concat(this.getPathBase(), "/festivals"));
      uri.addSearch(queryParameters);
      return this.doSearch(uri, sibilParameterId);
    }
  }, {
    key: "searchLieuxFulltext",
    value: function searchLieuxFulltext(sibilParameterId, queryParameters) {
      var uri = new URI("".concat(this.getPathBase(), "/lieux/fulltext"));
      uri.addSearch(queryParameters);
      return this.doSearch(uri, sibilParameterId);
    }
  }, {
    key: "createSpectacle",
    value: function createSpectacle(sibilParameterId, body) {
      var uri = new URI("".concat(this.getPathBase(), "/spectacles"));

      /** @ts-expect-error -- ignore this entity as it has been no entity and is weird */
      return this.authorizedFetch(uri, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-SibilParameter': sibilParameterId
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response.json();
      }).then(createEntity);
    }
  }, {
    key: "createFestival",
    value: function createFestival(sibilParameterId, body) {
      var uri = new URI("".concat(this.getPathBase(), "/festivals"));

      /** @ts-expect-error -- ignore this entity as it has been no entity and is weird */
      return this.authorizedFetch(uri, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-SibilParameter': sibilParameterId
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response.json();
      }).then(createEntity);
    }
  }]);
}(AbstractClient$1);

var Config = {
  ticketing: {
    path: 'ticketing.mapado.net',
    scheme: 'https'
  }};

var CustomReportClient = /*#__PURE__*/function (_AbstractClient) {
  function CustomReportClient() {
    _classCallCheck(this, CustomReportClient);
    return _callSuper(this, CustomReportClient, arguments);
  }
  _inherits(CustomReportClient, _AbstractClient);
  return _createClass(CustomReportClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/custom_reports';
    }
  }]);
}(AbstractClient);

var CustomReport = /*#__PURE__*/function (_NetworkEntity) {
  function CustomReport(val) {
    var _this;
    _classCallCheck(this, CustomReport);
    _this = _callSuper(this, CustomReport, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(CustomReport, _NetworkEntity);
  return _createClass(CustomReport, [{
    key: "getShortId",
    value: function getShortId() {
      var _this$get;
      return ((_this$get = this.get('@id')) === null || _this$get === void 0 ? void 0 : _this$get.replace('/v1/custom_reports/', '')) || '';
    }
  }]);
}(NetworkEntity({
  '@id': null,
  '@type': 'CustomReport',
  contract: null,
  title: null,
  description: null,
  ticketingStatsReportName: null
}));
CustomReport.classMetadata = new ClassMetadata('customReport', 'custom_reports',
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
/** @ts-expect-error -- method signature are incompatible */
CustomReportClient);
CustomReport.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('title'), new Attribute('description'), new Attribute('ticketingStatsReportName')]);
CustomReport.classMetadata.setRelationList([new Relation(Relation.MANY_TO_ONE, 'contract', 'contract')]);

var FeatureClient = /*#__PURE__*/function (_AbstractClient) {
  function FeatureClient() {
    _classCallCheck(this, FeatureClient);
    return _callSuper(this, FeatureClient, arguments);
  }
  _inherits(FeatureClient, _AbstractClient);
  return _createClass(FeatureClient, [{
    key: "getFeatures",
    value: function getFeatures() {
      var url = '/v1/features?fields=';
      return this.deserializeResponse(this.authorizedFetch(url), 'item');
    }
  }, {
    key: "getContractFeatures",
    value: function getContractFeatures(contractId) {
      var url = "/v1/contracts/".concat(contractId, "/features?fields=");
      return this.deserializeResponse(this.authorizedFetch(url), 'item');
    }
  }]);
}(AbstractClient);

// "@id" and "@type" not defined for this entity, but too much TypeScript brainfuck to avoid only this class
var Feature = /*#__PURE__*/function (_NetworkEntity) {
  function Feature() {
    _classCallCheck(this, Feature);
    return _callSuper(this, Feature, arguments);
  }
  _inherits(Feature, _NetworkEntity);
  return _createClass(Feature);
}(NetworkEntity({
  '@id': null,
  '@type': 'Feature',
  'scanner_app-offline_mode': null,
  mapadobox_socket_enabled: null
}));
/** @ts-expect-error -- method signature are incompatible */
Feature.classMetadata = new ClassMetadata('feature', 'features', FeatureClient);
Feature.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('scanner_app-offline_mode'), new Attribute('mapadobox_socket_enabled')]);

var BookingCounterClient = /*#__PURE__*/function (_AbstractClient) {
  function BookingCounterClient() {
    _classCallCheck(this, BookingCounterClient);
    return _callSuper(this, BookingCounterClient, arguments);
  }
  _inherits(BookingCounterClient, _AbstractClient);
  return _createClass(BookingCounterClient, [{
    key: "getPathBase",
    value: function getPathBase() {
      return '/v1/mass_action_aggregates/booking_counter';
    }
  }, {
    key: "getCounter",
    value: function getCounter(values, fields) {
      var requestParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = URI(this.getPathBase());
      url.addSearch({
        fields: getFieldsString(fields)
      });
      return this.deserializeResponse(this.authorizedFetch(url, _objectSpread2({
        method: 'POST',
        body: JSON.stringify(values)
      }, requestParams)), 'item');
    }
  }]);
}(AbstractClient);

var BookingCounterMassActionAggregate = /*#__PURE__*/function (_NetworkEntity) {
  function BookingCounterMassActionAggregate() {
    var _this;
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@id': null,
      '@type': 'BookingCounterMassActionAggregate'
    };
    _classCallCheck(this, BookingCounterMassActionAggregate);
    _this = _callSuper(this, BookingCounterMassActionAggregate, [val]);
    return _possibleConstructorReturn(_this, mapEntityRelationShips(_this, val));
  }
  _inherits(BookingCounterMassActionAggregate, _NetworkEntity);
  return _createClass(BookingCounterMassActionAggregate);
}(NetworkEntity({
  '@id': null,
  '@type': 'BookingCounterMassActionAggregate',
  totalCount: undefined,
  reservationTotalCount: undefined,
  orderTotalCount: undefined,
  reservationOnOtherEventDateTotalCount: undefined
}));
BookingCounterMassActionAggregate.classMetadata = new ClassMetadata('bookingCounterMassActionAggregate', 'mass_action_aggregates/booking_counter', /** @ts-expect-error -- method signature are incompatible */
BookingCounterClient);
BookingCounterMassActionAggregate.classMetadata.setAttributeList([new Attribute('@id', '@id', 'string', true), new Attribute('@type'), new Attribute('totalCount', 'totalCount', 'integer'), new Attribute('reservationTotalCount', 'reservationTotalCount', 'integer'), new Attribute('orderTotalCount', 'orderTotalCount', 'integer'), new Attribute('reservationOnOtherEventDateTotalCount', 'reservationOnOtherEventDateTotalCount', 'integer')]);

var mapping = new Mapping$1('/v1');
var entityList = [AccountingClient, AuditDocument, AvailableSeat, AvailableSeatModel, BankAccount, Booking, BookingItem, BookingTrack, BookingTrackMode, Cart, SwapValidateRepresentation, CartItem, Checkpoint, Client, Contingent, Contract, ContractAddendum, Coupon, CouponCodeGroup, CustomReport, Customer, CustomerFieldContract, CustomerField, CustomerStatus, DeskPaymentMethod, DeskSession, Deposit, DeviceState, EventDate, EventDatePattern, Feature, Fee, Form, Invoice, InvoiceLine, Job, Lettering, LogicalSeatConfig, MasterTicket, Minisite, Module, Notification, OfferRule, Order, OrderFeeItem, OrderItem, OrderItemInvoiceGroup, OrderItemCashCoupon, OrganizationalUnit, Payment, PaymentAttempt, PaymentFee, PaymentLink, Transaction, TransactionGroup, ReconciliationEntry, ProviderContract, ProviderExportedCart, ProviderExportedTicketPrice, ProviderTicketCredentials, ProviderTicketImportedFile, ProviderContingentMapping, ProviderMappingNotification, ProviderTicketingMapping, ProviderTicketPriceMapping, ProviderSeatMapping, ProviderSeatConfigMapping, ProviderAutoImportedTicket, PublicTypology, Refund, RefundOrderItem, ReportingAccount, ResolvePinIdsAggregate, ResolveTicketSwapIdsAggregate, Scan, ScanConfig, ScanTrack, ScanTrackCheckpoint, Season, Seat, SeatConfig, SeatConfigBlock, SeatFloor, SeatGroup, SeatZone, SellingDevice, Shipping, Billing, BookingCounterMassActionAggregate, SibilParameter, SibilTicketingSpectacle, SibilVenueLieu, StockContingent, Sticker, Subscription, SubscriptionMaturity, Tag, Tax, Ticket, TicketCheckpoint, TicketPrice, TicketPriceAvailabilityMassActionAggregate, TicketSwapConfig, OrderTransactionAmountsAggregate, ReconciliationAmountsAggregate, ReconciliationAvailableActions, TicketPriceGroup, Ticketing, TicketingCategory, TicketingOptionStress, TicketingSellingDevice, TicketingUser, TicketPriceSeatGroup, User, Venue, Version, Wallet];
entityList.forEach(function (entity) {
  if (!entity.classMetadata) {
    // eslint-disable-next-line no-console
    console.warn("No metadata found for entity named \"".concat(entity.name, "\""));
  }
});
var classMetadataList = entityList.map(function (entity) {
  return entity.classMetadata;
});
mapping.setMapping(classMetadataList);

var _decoratedSdk = /*#__PURE__*/new WeakMap();
var TicketingSdk = /*#__PURE__*/function () {
  function TicketingSdk(tokenStorage, config, serializer) {
    var _this = this;
    _classCallCheck(this, TicketingSdk);
    _classPrivateFieldInitSpec(this, _decoratedSdk, void 0);
    // keep this assignation here and not in default parameter value as it will break the .d.ts file as a default parameter
    var decoratedSerializer = serializer || new EntitySerializer();
    _classPrivateFieldSet2(_decoratedSdk, this, new RestClientSdk(tokenStorage, _objectSpread2(_objectSpread2({}, Config.ticketing), config), mapping, decoratedSerializer));
    var mappingKeys = _classPrivateFieldGet2(_decoratedSdk, this).mapping.getMappingKeys();
    var toSkip = ['sibilParameter', 'sibilTicketingSpectacle', 'sibilVenueLieu'];
    mappingKeys.forEach(function (key) {
      if (toSkip.indexOf(key) !== -1) {
        return;
      }

      /** @ts-expect-error -- create property dynamically to keep the old way : `ticketingSdk['seat'].find()` */
      _this[key] = _this.getRepository(key);
    });
    this.module = {
      sibil: {
        proxy: new SibilProxyClient(_classPrivateFieldGet2(_decoratedSdk, this), new ClassMetadata('sibilProxy'))
      }
    };
    if (mappingKeys.indexOf('sibilParameter') > -1) {
      this.module.sibil.parameter = this.getRepository('sibilParameter');
    }
    if (mappingKeys.indexOf('sibilTicketingSpectacle') > -1) {
      this.module.sibil.ticketingSpectacle = this.getRepository('sibilTicketingSpectacle');
    }
    if (mappingKeys.indexOf('sibilVenueLieu') > -1) {
      this.module.sibil.venueLieu = this.getRepository('sibilVenueLieu');
    }
  }
  return _createClass(TicketingSdk, [{
    key: "mapping",
    get: function get() {
      return _classPrivateFieldGet2(_decoratedSdk, this).mapping;
    }
  }, {
    key: "tokenStorage",
    get: function get() {
      return _classPrivateFieldGet2(_decoratedSdk, this).tokenStorage;
    }
  }, {
    key: "logger",
    get: function get() {
      return _classPrivateFieldGet2(_decoratedSdk, this).logger;
    }
  }, {
    key: "unitOfWork",
    get: function get() {
      return _classPrivateFieldGet2(_decoratedSdk, this).unitOfWork;
    }
  }, {
    key: "getRepository",
    value: function getRepository(key) {
      return _classPrivateFieldGet2(_decoratedSdk, this).getRepository(key);
    }
  }]);
}();

// eslint-disable-next-line no-shadow, import/prefer-default-export
var IMPORT_STATUS = /*#__PURE__*/function (IMPORT_STATUS) {
  IMPORT_STATUS["UPLOADED"] = "uploaded";
  IMPORT_STATUS["ANALYZING"] = "analyzing";
  IMPORT_STATUS["ANALYZED"] = "analyzed";
  IMPORT_STATUS["PENDING"] = "pending";
  IMPORT_STATUS["IN_PROGRESS"] = "in_progress";
  IMPORT_STATUS["SUCCESS"] = "success";
  IMPORT_STATUS["WITH_ERRORS"] = "with_errors";
  IMPORT_STATUS["FAILED"] = "failed";
  IMPORT_STATUS["DELETING"] = "deleting";
  IMPORT_STATUS["DELETED"] = "deleted";
  IMPORT_STATUS["CANCELLED"] = "cancelled";
  return IMPORT_STATUS;
}({});

// eslint-disable-next-line no-shadow
var PAYMENT_ATTEMPT_STATUS = /*#__PURE__*/function (PAYMENT_ATTEMPT_STATUS) {
  PAYMENT_ATTEMPT_STATUS["PENDING"] = "pending";
  PAYMENT_ATTEMPT_STATUS["SUCCESS"] = "success";
  PAYMENT_ATTEMPT_STATUS["FAILED"] = "failed";
  return PAYMENT_ATTEMPT_STATUS;
}(PAYMENT_ATTEMPT_STATUS || {});

// eslint-disable-next-line no-shadow
var PaymentStatus = /*#__PURE__*/function (PaymentStatus) {
  PaymentStatus["INCOMPLETE_PAYMENT"] = "incomplete_payment";
  PaymentStatus["OVERPAID"] = "overpaid";
  PaymentStatus["BOOKED"] = "booked";
  PaymentStatus["BALANCED"] = "balanced";
  return PaymentStatus;
}(PaymentStatus || {});

var BOOKING_TRACK_MODE_TYPE = /*#__PURE__*/function (BOOKING_TRACK_MODE_TYPE) {
  BOOKING_TRACK_MODE_TYPE["SIMPLE"] = "simple";
  BOOKING_TRACK_MODE_TYPE["NEEDS_VALIDATION"] = "needs_validation";
  BOOKING_TRACK_MODE_TYPE["MORE_CHOICES"] = "more_choices";
  BOOKING_TRACK_MODE_TYPE["OTHER"] = "other";
  return BOOKING_TRACK_MODE_TYPE;
}(BOOKING_TRACK_MODE_TYPE || {});

var CART_TYPE = /*#__PURE__*/function (CART_TYPE) {
  CART_TYPE["CART"] = "cart";
  CART_TYPE["OPTION"] = "option";
  CART_TYPE["RESERVATION"] = "reservation";
  return CART_TYPE;
}({});
var CART_STATUS = /*#__PURE__*/function (CART_STATUS) {
  CART_STATUS["DRAFT"] = "draft";
  CART_STATUS["VALIDATED"] = "validated";
  CART_STATUS["ACCOUNTED_FOR_ORDER"] = "accounted_for_order";
  return CART_STATUS;
}({});

export { ACCOUNTING_CLIENT_TYPE, ACCOUNT_TYPE, AVAILABLE_SEAT_BOOKING_STATUS, STATUS_AVAILABLE as AVAILABLE_SEAT_STATUS_AVAILABLE, STATUS_BOOKED$1 as AVAILABLE_SEAT_STATUS_BOOKED, STATUS_DISMISSED as AVAILABLE_SEAT_STATUS_DISMISSED, STATUS_PAID as AVAILABLE_SEAT_STATUS_PAID, AccountingClient, AuditDocument, AvailableSeat, AvailableSeatModel, BILLING_POLICY, BILLING_TYPE, BOOKING_ENTITY_NAME, BOOKING_ENTITY_STATUS, BOOKING_ENTITY_TYPE, STATUS_AWAITING_PAYMENT as BOOKING_STATUS_AWAITING_PAYMENT, STATUS_BOOKED as BOOKING_STATUS_BOOKED, STATUS_INCOMPLETE_PAYMENT as BOOKING_STATUS_INCOMPLETE_PAYMENT, STATUS_OVERPAID as BOOKING_STATUS_OVERPAID, BOOKING_TRACK_MODE_TYPE, TRANSACTION_NAME_MULTIPLE as BOOKING_TRANSACTION_NAME_MULTIPLE, BankAccount, Billing, Booking, BookingCounterMassActionAggregate, BookingItem, BookingTrack, BookingTrackMode, CART_STATUS, CART_TYPE, CONTINGENT_AVAILABLE_ACTIONS, DOCUMENT_ADDENDUM as CONTRACT_DOCUMENT_ADDENDUM, DOCUMENT_CONFORMITY as CONTRACT_DOCUMENT_CONFORMITY, DOCUMENT_CONTRACT as CONTRACT_DOCUMENT_CONTRACT, DOCUMENT_GDPR as CONTRACT_DOCUMENT_GDPR, COUPON_USAGE, CUSTOMER_TYPE, Cart, CartItem, CartItemWithOffer, Checkpoint, Client, Collection, Contingent, Contract, ContractAddendum, Coupon, CouponCodeGroup, CustomReport, Customer, CustomerField, CustomerFieldContract, CustomerStatus, DEFAULT_PAYMENT_METHOD_CODE, Deposit, DeskPaymentMethod, DeskSession, DeviceState, ERROR_CODE__EVENT_DATE__TOTAL_STOCK_LOWER_SOLD_TICKETS, ERROR_CODE__EVENT_DATE__UPDATE_SEATCONFIG_ALREADY_SOLD, ERROR_CODE__EVENT_DATE__UPDATE_SEATCONFIG_WITH_SEAT_RESERVED, EVENT_DATE_ACCOUNTABILITY_FILTER, EVENT_DATE_AVAILABILITY_STATUS, EVENT_DATE_OPTION_STATUS, EVENT_DATE_STATUS, TYPE_BUSINESS as EVENT_DATE_TYPE_BUSINESS, TYPE_GENERAL_PUBLIC as EVENT_DATE_TYPE_GENERAL_PUBLIC, TYPE_OTHER$1 as EVENT_DATE_TYPE_OTHER, TYPE_SCHOOL as EVENT_DATE_TYPE_SCHOOL, EventDate, EventDateOptionStatus, EventDateOptionStress, EventDatePattern, FEE_TYPE, FIELD_PREFIX_SLUG, FIELD_TYPE, FORM_TYPE, Fee, Form, INVOICE_STATUS, INVOICE_TYPE, Invoice, InvoiceLine, ACTION as JOB_ACTION, ENTITY_TYPE as JOB_ENTITY_TYPE, NAME as JOB_NAME, STATUS as JOB_STATUS, Job, Lettering, LogicalSeatConfig, MASS_ACTION_AGGREGATE_AVAILABILITY, MINISITE_INTEGRATIONS, MINISITE_PROVIDER_LIST, MINISITE_SIGN_IN_MODE, DELIMITER as MODULE_IMPORT_DELIMITER, PAGE_TYPE_CART as MODULE_PAGE_TYPE_CART, PAGE_TYPE_EVENT as MODULE_PAGE_TYPE_EVENT, PAGE_TYPE_HOME as MODULE_PAGE_TYPE_HOME, MODULE_TYPE, MasterTicket, Minisite, Module, MomentInstance, Notification, ORDER_FEE_ITEM_TYPE, ORDER_ITEM_TYPE, STATUS_DESCRIPTION_CANCELLED as ORDER_STATUS_DESCRIPTION_CANCELLED, STATUS_FAILED as ORDER_STATUS_FAILED, STATUS_PAYED as ORDER_STATUS_PAYED, STATUS_REFUNDED_PARTIALLY as ORDER_STATUS_REFUNDED_PARTIALLY, STATUS_REFUNDED_TOTALLY as ORDER_STATUS_REFUNDED_TOTALLY, STATUS_WAITING_3DS as ORDER_STATUS_WAITING_3DS, OfferRule, OptionStress, Order, OrderFeeItem, OrderItem, OrderItemCashCoupon, OrderItemInvoiceGroup, OrderTransactionAmountsAggregate, OrganizationalUnit, PAPER_TYPE_LIST, PAPER_TYPE_STOCK_TICKETS, PAPER_TYPE_THERMAL_ROLLER, PAYMENT_ATTEMPT_STATUS, DISTINCT_PAYMENT_MULTI_WALLET_PROVIDER_LIST as PAYMENT_DISTINCT_PAYMENT_MULTI_WALLET_PROVIDER_LIST, EXTERNAL_PROVIDER_LIST$1 as PAYMENT_EXTERNAL_PROVIDER_LIST, NO_PROVIDER as PAYMENT_NO_PROVIDER, PAYMENT_PROVIDER, PROVIDER_MANGOPAY as PAYMENT_PROVIDER_MANGOPAY, PROVIDER_MANUAL as PAYMENT_PROVIDER_MANUAL, PROVIDER_PAYLINE as PAYMENT_PROVIDER_PAYLINE, PROVIDER_PAYREXX as PAYMENT_PROVIDER_PAYREXX, PROVIDER_PAYZONE as PAYMENT_PROVIDER_PAYZONE, PROVIDER_STRIPE as PAYMENT_PROVIDER_STRIPE, PROVIDER_ACTION, PROVIDER_CONTRACT, PROVIDER_EXPORTED_CART, PROVIDER_MAPPING_NOTIFICATION_MAPPING_TYPE, PROVIDER_MAPPING_NOTIFICATION_TYPE, PROVIDER_STATUS, DOWNLOAD_TYPE as PROVIDER_TICKET_IMPORTED_FILE_DOWNLOAD_TYPE, IMPORT_STATUS as PROVIDER_TICKET_IMPORTED_FILE_STATUS, STRATEGY as PROVIDER_TICKET_IMPORTED_FILE_STRATEGY, STRATEGY_MODE as PROVIDER_TICKET_IMPORTED_FILE_STRATEGY_MODE, PUBLIC_TYPOLOGY_TYPE, PagedCartCollection, PagedCollection, Payment, PaymentAttempt, PaymentFee, PaymentLink, PaymentStatus, Transaction as PaymentTransaction, ProviderContingentMapping, ProviderContract, ProviderExportedCart, ProviderExportedTicketPrice, Context as ProviderImportContext, ProviderMappingNotification, ProviderSeatConfigMapping, ProviderSeatMapping, ProviderTicketCredentials, Mapping as ProviderTicketImportMapping, ProviderTicketImportedFile, ProviderTicketPriceMapping, ProviderTicketingMapping, PublicTypology, RELATED_TO_TYPE, REPORTING_ACCOUNT_ACCOUNTING_MODE, REPORTING_ACCOUNT_TYPE, ReconciliationAmountsAggregate, ReconciliationAvailableActions, ReconciliationEntry, Refund, RefundOrderItem, Transaction as RefundTransaction, RelationShouldBeDefinedError, RelationShouldBeObjectError, RelationShouldBeStringError, ReportingAccount, ResolvePinIdsAggregate, ResolveTicketSwapIdsAggregate, SEASON_TYPE, SEAT_TYPE, SELLING_DEVICE_ORIGIN_TYPE, SHIPPING_TYPE, SHOW_HIDDEN_PARAM, SUBSCRIPTION_MATURITY_STATUS, SUBSCRIPTION_PAYMENT_TYPE_FILTER, SUBSCRIPTION_PERIODICITY, SWAP_PRICE_CONSTRAINT, Scan, ScanConfig, ScanTrack, ScanTrackCheckpoint, Season, Seat, SeatConfig, SeatConfigBlock, SeatFloor, SeatGroup, SeatZone, SellingDevice, EntitySerializer as Serializer, Shipping, SibilParameter, SibilTicketingSpectacle, SibilVenueLieu, Sticker, StockContingent, Subscription, SubscriptionMaturity, SubscriptionStatus, SwapValidateRepresentation, TICKETING_AVAILABILITY_STATUS, TICKETING_TYPE_DATED_EVENTS, TICKETING_TYPE_OFFER, TICKETING_TYPE_UNDATED_EVENT, PROVIDER_TYPE as TICKETING_USER_PROVIDER_TYPE, TICKET_PAYMENT_STATUS, TICKET_PRICE_CONSTRAINT, TYPE_EXEMPTED as TICKET_PRICE_TYPE_EXEMPTED, TYPE_FULL_PRICE as TICKET_PRICE_TYPE_FULL_PRICE, TYPE_GROUP as TICKET_PRICE_TYPE_GROUP, TYPE_OTHER as TICKET_PRICE_TYPE_OTHER, TYPE_REDUCED as TICKET_PRICE_TYPE_REDUCED, TYPE_RESELLER as TICKET_PRICE_TYPE_RESELLER, TYPE_SCHOLAR as TICKET_PRICE_TYPE_SCHOLAR, TYPE_SUBSCRIPTION as TICKET_PRICE_TYPE_SUBSCRIPTION, TYPE_SUBSCRIPTION_MEMBER_LOYALTY as TICKET_PRICE_TYPE_SUBSCRIPTION_MEMBER_LOYALTY, EXTERNAL_PROVIDER_LIST as TRANSACTION_EXTERNAL_PROVIDER_LIST, MULTI_WALLET_PROVIDER_LIST as TRANSACTION_MULTI_WALLET_PROVIDER_LIST, TRANSACTION_PROVIDER, TRANSACTION_STATUS, Tag, Tax, Ticket, TicketCheckpoint, TicketPrice, TicketPriceAvailabilityMassActionAggregate, TicketPriceGroup, TicketPriceSeatGroup, TicketSwapConfig, Ticketing, TicketingCategory, TicketingOptionStress, TicketingSellingDevice, TicketingUser, Transaction, TransactionGroup, USER_TYPE, User, VAT_EXIGIBILITY, Venue, Version, Wallet, assertAggregationValueIsOfferRule, assertAggregationValueIsTicketPriceGroup, assertRelationIsDefined, assertRelationIsListOfObject, assertRelationIsListOfString, assertRelationIsNullOrListOfObject, assertRelationIsNullOrListOfString, assertRelationIsNullOrObject, assertRelationIsNullOrString, assertRelationIsObject, assertRelationIsString, createEntity, TicketingSdk as default, extractPageNumber, getCustomerFormValues, getFormData, getParticipantFormData, getShoppingValues, mergeCustomerFormValues };
//# sourceMappingURL=index.js.map
